// Real data from All_Jobs.csv - excludes only 'inactive' state
// 755 customers, 827 jobs, 31 rounds
// Auto-generated - do not edit manually

export const csvCustomers = [
  {
    "id": "CUS27861086",
    "name": "John Hall",
    "address": "3 Langridge Way, Burgess Hill RH15 8TN, UK",
    "phone": "07749880868",
    "email": "johnehall2529@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "Include velux on side extension",
    "jobCount": 1,
    "totalSpent": 25.3
  },
  {
    "id": "CUS17118657",
    "name": "Carol Mason",
    "address": "41 The Wickets, Burgess Hill, West Sussex, RH15 8TG",
    "phone": "07720 085222",
    "email": "carolmason17@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS8260453",
    "name": "Sami Dawes",
    "address": "117 Icarus Avenue, Burgess Hill, RH15 0UW",
    "phone": "07887875299",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "When you see numbers like 101, 117 is down a path on the left.\n\nPark the van after the low 100 numbers on the left and pull the hose past 117 down to the flats to give you enough to go in the garden",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS86628487",
    "name": "Peter",
    "address": "91 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "phone": "+44 7780 030006",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 76.5
  },
  {
    "id": "CUS38475085",
    "name": "Jo Harris",
    "address": "120 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PH",
    "phone": "07837 002267",
    "email": "johanna_harris@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-03-30",
    "notes": "Text night before.\nInclude 2 x velux. Pay\nby GoCardless",
    "jobCount": 1,
    "totalSpent": 36.0
  },
  {
    "id": "CUS21724915",
    "name": "Mike Fox",
    "address": "24 Sunningdale Road, Hassocks",
    "phone": "07984081510",
    "email": "mj-fox@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS72420019",
    "name": "Jamie Mendoza",
    "address": "1 Capenors, Burgess Hill RH15 9QL, UK",
    "phone": "07876 302804",
    "email": "jepm201@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-02-07",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 128.6
  },
  {
    "id": "CUS51457707",
    "name": "Sarah",
    "address": "4 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "phone": "07799 896455",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Cash",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Inc Con. Cash \u00a330",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS26247199",
    "name": "Lisa",
    "address": "1 London Rd, Hassocks BN6 9NT, UK",
    "phone": "07890 723660",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Cash under the mat by the back door",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS32202600",
    "name": "Sasha OConnor",
    "address": "57 Larkspur Drive, Burgess Hill, West Sussex, RH15 0UL",
    "phone": "07398 279968",
    "email": "so_vpa@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS68436421",
    "name": "Shaun",
    "address": "17 St Andrews Place Hassocks BN6",
    "phone": "07813051477",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS3349883",
    "name": "Warwick Hart",
    "address": "30 Meadow Lane, Burgess Hill, West Sussex, RH15 9JA",
    "phone": "07926 274899",
    "email": "warwick_hart@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Garden through garage",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS2102327",
    "name": "Steve Parish",
    "address": "154 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TD",
    "phone": "07775 800430",
    "email": "steveparish@mac.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Include\nextension and velux on\nextension roof. Pay by\ncard linK",
    "jobCount": 1,
    "totalSpent": 38.33
  },
  {
    "id": "CUS46858439",
    "name": "Sue Taplin",
    "address": "11 The Rowans, Burgess Hill, West Sussex, RH15 8UZ",
    "phone": "07796561743",
    "email": "holsintaplin@virginmedia.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Text night before. Include\nconservatory. Pay by card\nlink.",
    "jobCount": 1,
    "totalSpent": 31.67
  },
  {
    "id": "CUS93559748",
    "name": "Reece Massen",
    "address": "3 Michelbourne Close, Burgess Hill, West Sussex, RH15 9QX",
    "phone": "07773 698031",
    "email": "reece.massen@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS69398698",
    "name": "Rebecca Young",
    "address": "21 The Maltings, Burgess Hill, West Sussex, RH15 9XF",
    "phone": "07827 888026",
    "email": "rebecca.phelan1@btopenworld.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "Text night before.  Knock first to secure dog. Use side gate to right of front door as you're looking at house.  Pay by card link. Please leave leaflet.",
    "jobCount": 1,
    "totalSpent": 21.67
  },
  {
    "id": "CUS59645278",
    "name": "Jacqui Bush",
    "address": "39 The Ridings, Burgess Hill, West Sussex, RH15 0PL",
    "phone": "07977 034567",
    "email": "jacqui.taylor90@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS37465770",
    "name": "Linda Surridge",
    "address": "3 Nuthatch Lane, Hassocks, Sussex, BN6 9LB",
    "phone": "07810239968",
    "email": "lindasurridge@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS5298781",
    "name": "Alex Munn",
    "address": "52 Nightingale Way, Sayers Common, Hassocks, West Sussex, BN6 9HP",
    "phone": "+44 7907 019262",
    "email": "alinunn1994@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS58405955",
    "name": "Becca Egan",
    "address": "28 Nightingale Way, Sayers Common, Hassocks, BN6 9HP",
    "phone": "07794 825834",
    "email": "beccaegan@rocketmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS65868109",
    "name": "Pauline Bruce",
    "address": "22 Mackie Avenue, Hassocks, West Sussex, BN6 8NL",
    "phone": "07485 008753",
    "email": "paulineorion@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Not the \nvelux.",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS21139658",
    "name": "Anthony Bailey",
    "address": "18 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "phone": "07779 118160",
    "email": "anthonyemilybaileyevans@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS12846407",
    "name": "Liz Crews",
    "address": "7 Paynters Way, Newick, Lewes, East Sussex, BN8 4PH",
    "phone": "07765 887366",
    "email": "l_crews@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS4041597",
    "name": "Jayne Carr",
    "address": "1 Shepherds Mead, Burgess Hill, West Sussex, RH15 8AS",
    "phone": "07808 427933",
    "email": "carrjayne@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Facias and Sofitts,Gutter Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-05-21",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 163.34
  },
  {
    "id": "CUS64568892",
    "name": "Karen Keys",
    "address": "46 Marlborough Drive, Burgess Hill, West Sussex, RH15 0EU",
    "phone": "07967 332623",
    "email": "kkeys@rocketmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-03-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS1145995",
    "name": "A. Martinez",
    "address": "57 Noel Rise, Burgess Hill, West Sussex, RH15 8BU",
    "phone": "07531 766938",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "Text night before.\nInclude front porch. Pay\nby cash or cardlink.\nPlease quote for gutters,\nsoffits and fascias",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS60976935",
    "name": "Sarah Herbert",
    "address": "38 Withy Bush, Burgess Hill RH15 8TT, UK",
    "phone": "07979761628",
    "email": "sgherbert73@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 97.6
  },
  {
    "id": "CUS46213489",
    "name": "Mark Salway",
    "address": "18 Beacon Crescent, Burgess Hill, West Sussex, RH15 0ZL",
    "phone": "07756 793765",
    "email": "rocket3power@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Garage Door",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "Text night before.\nInclude garage door\nand window. Pay by\ncard link.",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS57505767",
    "name": "Pauline",
    "address": "34 Stonepound Road, Hassocks, BN6 8PR",
    "phone": "07975617475",
    "email": "",
    "state": "active",
    "balance": 25.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "LONG POLE",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS87170270",
    "name": "Lynda Parr",
    "address": "13 Stonepound Rd, Hassocks BN6 8PN, UK",
    "phone": "07960 115632",
    "email": "lparr72@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS36425723",
    "name": "Lisa Sainty",
    "address": "101 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "phone": "+44 7798 726708",
    "email": "lisamackay00@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean,Facias and Sofitts",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-09-03",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 66.67
  },
  {
    "id": "CUS27887678",
    "name": "Miranda Wilsnagh",
    "address": "112 Avenue De Warenne, Hassocks, West Sussex, BN6 8GE",
    "phone": "\u202a+44\u00a07770\u00a0565211\u202c",
    "email": "Miranda@skyebusinesssolutions.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS32990547",
    "name": "Abbie Holford",
    "address": "11 The Warren, Burgess Hill, RH15 0DU",
    "phone": "07879 337871",
    "email": "abbie.porter@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS25844230",
    "name": "Sue Ford- Jones",
    "address": "9 The Vineries, Burgess Hill, West Sussex, RH15 0ND",
    "phone": "07872 924366",
    "email": "susanfordjones@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS78902188",
    "name": "Susan Thompson",
    "address": "19 Midfields Drive, Burgess Hill, West Sussex, RH15 8EN",
    "phone": "07504 220744",
    "email": "susan.thompson4@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Include\nconservatory (not the\nconservatory roof). Pay\nby card link.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS34429823",
    "name": "Linda Mills",
    "address": "6 Chestnuts Close, Lindfield, Haywards Heath, West Sussex, RH16 2AU",
    "phone": "07479 808450",
    "email": "lindamills06@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Lindfield",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS10179541",
    "name": "Rich",
    "address": "39 Royal George Road, Burgess Hill, West Sussex, RH15 9SB",
    "phone": "07879 282806",
    "email": "moccy@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "In most of the day apart from School drop off",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS93764737",
    "name": "Cathy Burt",
    "address": "40 Woodsland Rd, Hassocks BN6 8HG, UK",
    "phone": "+44 7791 733064",
    "email": "cathy.e.burt@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "You have to extend the small pole a few sections to reach the side of the house above the kitchen",
    "jobCount": 1,
    "totalSpent": 19.8
  },
  {
    "id": "CUS49523215",
    "name": "Joanne Collinson",
    "address": "7d West Street, Burgess Hill, West Sussex, RH15 8NN",
    "phone": "07713 270410",
    "email": "collisonj@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean every 12 weeks,Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-20",
    "nextDue": "2026-04-14",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 36.67
  },
  {
    "id": "CUS18241188",
    "name": "Dee Mackenzie",
    "address": "7 Potters Lane, Burgess Hill, West Sussex, RH15 9HX",
    "phone": "07938 071366",
    "email": "mackenzie.p@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "Not the garden room",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS73333985",
    "name": "Jim Bridger",
    "address": "49 Goldcrest Dr, Hassocks BN6, UK",
    "phone": "07868 445699",
    "email": "gailskeats54@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 32.0
  },
  {
    "id": "CUS88094977",
    "name": "Emanuela Litchfield",
    "address": "79 Larkspur Drive, Burgess Hill, West Sussex, RH15 0UL",
    "phone": "07725\n235170",
    "email": "emanuelalitchfield@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "Text night before. Include 2 dormers and 2 velux. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS80071634",
    "name": "Robin Flynn",
    "address": "110 Mill Road, Burgess Hill, West Sussex, RH15 8BZ",
    "phone": "+44 7725 075268",
    "email": "jessicamann@sunnyvalesupport.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-03-06",
    "notes": "This is a home for disabled people. Knock the door if the gates locked.",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS63170421",
    "name": "Gemma Eaton",
    "address": "2 The Hawthorns, Burgess Hill, West Sussex, RH15 8RL",
    "phone": "07834 206269",
    "email": "eaton_gemma@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS17773448",
    "name": "Jan Wright",
    "address": "47 Bonny Wood Rd, Hassocks BN6 8HP, UK",
    "phone": "07814 025041",
    "email": "janwright133@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "janwright133@gmail.com",
    "jobCount": 2,
    "totalSpent": 96.0
  },
  {
    "id": "CUS69002839",
    "name": "Samantha Hardwick",
    "address": "Little Washbrook Farm  Hurstpierpoint Xx, Brighton Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9EF",
    "phone": "\u202a+44\u00a07554\u00a0455386\u202c",
    "email": "Samhardwick10@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Annex Clean inc all Velux",
    "frequency": "Ad hoc",
    "lastDone": "2025-09-08",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 58.33
  },
  {
    "id": "CUS58075726",
    "name": "Sarah Louise Stenning",
    "address": "11 Pierce Place, Hurstpierpoint, Hassocks, West Sussex, BN6 9YL",
    "phone": "07943 532282",
    "email": "sarah_huggett_89@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS54118",
    "name": "John Ware",
    "address": "25 Stonefield Way, Burgess Hill, West Sussex, RH15 8DW",
    "phone": "07941 174697",
    "email": "johnware177@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Text night before. Side\ngate to side of house. No\nrear. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS57729697",
    "name": "Linda  Richards",
    "address": "1 St. Christophers Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9UX",
    "phone": "07703 279589",
    "email": "lindaot@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Text night before. Not the \nJuliette balcony at the \nfront. Pays cash until he \nknows you better then \nwill do GoCardless. \u00a325",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS42334453",
    "name": "Laura",
    "address": "89 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "phone": "+44 7968 592635",
    "email": "lauram19@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Hey Dan, just to let you know the back gate is unlocked but it gets a bit stiff so you have to give it a bit of a firm shove to open it \u263a\ufe0f",
    "jobCount": 2,
    "totalSpent": 67.6
  },
  {
    "id": "CUS48793146",
    "name": "Johanna Swirski",
    "address": "47 Downsview Drive, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7RN",
    "phone": "07742 101819",
    "email": "johanna.swirski@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Wivelsfield",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "Not conservatory",
    "jobCount": 1,
    "totalSpent": 26.67
  },
  {
    "id": "CUS90018854",
    "name": "Sophia  Untersteggaber",
    "address": "4 Packham Way, Burgess Hill, West Sussex, RH15 8PE",
    "phone": "07599 594046",
    "email": "sophiauntersteggaber@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS9021515",
    "name": "Emily Miller",
    "address": "1 Bishops Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9XU",
    "phone": "07487557459",
    "email": "chalmers.ec@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS64664964",
    "name": "Derek Louw",
    "address": "48 Manor Rd, Burgess Hill RH15 0NL, UK",
    "phone": "07963 739194",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-10-10",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS66812560",
    "name": "Pat Gannon",
    "address": "13 Pierce Place, Hurstpierpoint, Hassocks, BN6 9YL",
    "phone": "07985247069",
    "email": "patgannon.pg@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.2
  },
  {
    "id": "CUS42843630",
    "name": "Connor",
    "address": "13 Hamfield Dr, Hassocks BN6 9ZW, UK",
    "phone": "07463759165",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-04-15",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS93107632",
    "name": "Fiona",
    "address": "12 The Street, Albourne, Hassocks, West Sussex, BN6 9DL",
    "phone": "07766 144539",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Cash",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-08-19",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS35055576",
    "name": "Rebecca Marriner",
    "address": "42 St Andrews Rd, Burgess Hill RH15 0LU, UK",
    "phone": "07920488101",
    "email": "becs_parker@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-10-21",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS26432144",
    "name": "Neale Austin",
    "address": "1 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "phone": "+61 419 992 331",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "",
    "assignee": "",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2022-03-09",
    "nextDue": "",
    "notes": "\u00a335 per sidex4",
    "jobCount": 3,
    "totalSpent": 298.0
  },
  {
    "id": "CUS82287230",
    "name": "Stefan",
    "address": "49 Charlwood Gardens, Burgess Hill, West Sussex, RH15 0RD",
    "phone": "07495 783704",
    "email": "lunac58@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-04-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS52686823",
    "name": "Amy Ciambriello",
    "address": "43 Oak Hall Park, Burgess Hill, West Sussex, RH15 0DH",
    "phone": "07850 488778",
    "email": "amy.a@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS97965570",
    "name": "Annie",
    "address": "4C Stanford Avenue, Hassocks, West Sussex, BN6 8JH",
    "phone": "07711716537",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-04-01",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 15.0
  },
  {
    "id": "CUS44167258",
    "name": "Anna Whitesaid",
    "address": "2 Nuthatch Lane, Sayers Common, Hassocks, BN6 9LB",
    "phone": "07837 084971",
    "email": "anziriksit@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS2761221",
    "name": "Eileen Lawson",
    "address": "174 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "phone": "07846 427598",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS50562943",
    "name": "Jonathan Sinnatt",
    "address": "48 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "phone": "07951 516395",
    "email": "jonathan.sinnatt@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "never",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS52396966",
    "name": "Matthew Parisi",
    "address": "127 Manor Road, Burgess Hill, West Sussex, RH15 0NG",
    "phone": "07818 145685",
    "email": "matt.g.parisi@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "Not the\nconservatory",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS16903790",
    "name": "Caroline Cleaver",
    "address": "12 The Fairway, Hassocks BN6, UK",
    "phone": "07795 634107",
    "email": "cleaver.caroline@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS68654676",
    "name": "Steven Smith",
    "address": "16 Tinchurch Drive, Burgess Hill, West Sussex, RH15 0XJ",
    "phone": "07446 813271",
    "email": "steve25051@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2024-07-17",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 80.0
  },
  {
    "id": "CUS59292240",
    "name": "Andy",
    "address": "51 SUNNINGDALE ROAD HASSOCKS",
    "phone": "07766118860",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "Park outside 29 and do 51 Sunningdale and\n36 Wentworth, 29 the fairway",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS56757894",
    "name": "Peter Raynes",
    "address": "11 Dunstall Farm Road, Burgess Hill, West Sussex, RH15 8AX",
    "phone": "07472 680375",
    "email": "peter.raynes@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS99330001",
    "name": "Pam Manning",
    "address": "18 Culpepper, Burgess Hill RH15 8UB, UK",
    "phone": "07841 753808",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "Leaded windows - orange brush",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS78412920",
    "name": "Joan",
    "address": "16 The Gattons, Burgess Hill, RH15 9SW",
    "phone": "",
    "email": "joan.october.king2@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-11-24",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS67729570",
    "name": "Nikki",
    "address": "43 Chancellors Park, Hassocks, West Sussex, BN6 8EY",
    "phone": "07729 706216",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "All windows. Roof with velux. You may be able to do them from the ground. I never tried because it looked easier to use a ladder.",
    "jobCount": 1,
    "totalSpent": 37.5
  },
  {
    "id": "CUS5694532",
    "name": "Tom Read",
    "address": "22 Chapel Road, Plumpton Green, Lewes, East Sussex, BN7 3DD",
    "phone": "07818441396",
    "email": "tom.read@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before. Pay by card link",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS68051489",
    "name": "Olga Forster",
    "address": "16 Grand Avenue, Hassocks, West Sussex, BN6 8DB",
    "phone": "07869 286608",
    "email": "olga4ster@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-04-03",
    "notes": "Text night before. Not sky\nlight in dining room.\nInclude dormer and 2\nvelux.\n\nCash \u00a345",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS69371947",
    "name": "Eleanor Watson",
    "address": "1 Hurst Wickham Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9AL",
    "phone": "+44 7943 800150",
    "email": "watson_e_j@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "New please give a thorough clean",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS53578590",
    "name": "Grant Foulks",
    "address": "14 Nye Road, Burgess Hill, West Sussex, RH15 0JY",
    "phone": "07984 566435",
    "email": "ogmouse2@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS8370677",
    "name": "John Wilson",
    "address": "58 Friars Oak Road, Hassocks, West Sussex, BN6 8PY",
    "phone": "07596 967976",
    "email": "jnjwilson1@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS73137730",
    "name": "Anne Malkin",
    "address": "82 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07739692215",
    "email": "mitzie3000@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS37881519",
    "name": "Dan Gibbs",
    "address": "12 The Acorns, Burgess Hill RH15 8UW, UK",
    "phone": "+44 7955 643839",
    "email": "Dancgibbs@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-12-16",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 206.17
  },
  {
    "id": "CUS5199779",
    "name": "Sarah Hicking-Botham",
    "address": "4 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "phone": "07733 108982",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "Not window above extension, you can reach the bathroom window from the left side, do the garden office as well, reach over gate to unlock, please do up after \ud83d\udc4d\ud83c\udffb",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS90066056",
    "name": "Kerry Cameron",
    "address": "35 Leigh meadow, Burgess Hill RH15 0YP",
    "phone": "07766 601505",
    "email": "kajcameron@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "Gate Code is 2013, please close on the way out\n\nSmall window round to the left of front door",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS99940122",
    "name": "Kelly Holdstock",
    "address": "64 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07766 948888",
    "email": "kellyholdstock@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS79843999",
    "name": "Matt Tucker",
    "address": "5 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PF",
    "phone": "07770 648649",
    "email": "mothertucker87@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "Text night before.\nInclude 1 x velux.",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS98750489",
    "name": "Ros March",
    "address": "60 Oldaker Road, Newick, Lewes, East Sussex, BN8 4LP",
    "phone": "07710 823351",
    "email": "malandros@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 21.67
  },
  {
    "id": "CUS83928724",
    "name": "John Logan",
    "address": "39 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07511911617",
    "email": "johnlogan897@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS59944558",
    "name": "Karen",
    "address": "19 St Andrews Place Hassocks",
    "phone": "07766541115",
    "email": "kar.sweeney@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.0
  },
  {
    "id": "CUS33982618",
    "name": "Tony Oliver",
    "address": "10 Woodpecker Crescent, Burgess Hill, West Sussex, RH15 9XY",
    "phone": "07766773770",
    "email": "jooliver@rocketmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "**NEW**",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS71940084",
    "name": "Nicki Brooks",
    "address": "2 Stroudley Drive, Burgess Hill, RH15 0ZT",
    "phone": "+44 7796 207444",
    "email": "nicki.brooks007@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS43379086",
    "name": "Victoria Kib",
    "address": "3 Sunningdale Drive Hassocks",
    "phone": "07855573950",
    "email": "victoriakibrya@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-02-06",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 95.0
  },
  {
    "id": "CUS61946561",
    "name": "Michael Vaile",
    "address": "1 Field Villas, Mill Road, Burgess Hill, West Sussex, RH15 8DB",
    "phone": "07961324606",
    "email": "michaeljohnvaile@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "notes": "Include\ncladding above front\nupstairs bay window.\nCharge extra \u00a35 on first\nvisit. Directions: The lane to\nthis property is inbetween\nnumbers 161 and 163 NB\nThere are two properties\nnumbered 1 in this lane and\nneither of them are the first\nhouse. This house is 1 Field\nVillas.",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS15860207",
    "name": "Di Goss",
    "address": "68 Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "phone": "07741 433863",
    "email": "dgoss234@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "Include\nconservatory",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS24804153",
    "name": "David MORECROFT",
    "address": "49 SUNNINGDALE ROAD HASSOCKS",
    "phone": "07783281531",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-04-03",
    "notes": "Include the velux on the extension, do it from the road",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS74900012",
    "name": "Kelly Wilson",
    "address": "62 Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "phone": "07496 273373",
    "email": "k.wilson91@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS31362179",
    "name": "Bryon Todd",
    "address": "10 Penland Close, Haywards Heath, West Sussex, RH16 1PR",
    "phone": "07739 800843",
    "email": "byrontodd71@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS84656736",
    "name": "John Newton",
    "address": "21 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "phone": "07739 036809",
    "email": "johnnewton39@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS92191063",
    "name": "Linda Ashby",
    "address": "20 Dale Ave, Keymer, Hassocks BN6 8LP, UK",
    "phone": "07763 775108",
    "email": "leeashby@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 26.4
  },
  {
    "id": "CUS10673520",
    "name": "Steve Hunt",
    "address": "1 Thistle Place Burgess Hill RH15 0WZ",
    "phone": "+44 7397 311009",
    "email": "hunt.steve@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS1350304",
    "name": "Richard Mills",
    "address": "8 John Wood Crescent, Hassocks, BN6 8FQ",
    "phone": "07720499247",
    "email": "rj54mls@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS50309563",
    "name": "Vanessa Lilley",
    "address": "39 Sycamore Drive, Burgess Hill, West Sussex, RH15 0GG",
    "phone": "07979 085688",
    "email": "ness-lilley@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS17687582",
    "name": "Sam Hinks",
    "address": "109a Keymer Road, Hassocks, West Sussex, BN6 8QL",
    "phone": "07979 250081",
    "email": "shinksey@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Steve, Dan",
    "services": "Window Clean - Flat",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-04",
    "notes": "Main window on the ground to the right of the green front door , down the side of the building the remaining windows are at the back",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS61843464",
    "name": "Amy Rogerson",
    "address": "79 Parklands Road, Hassocks, West Sussex, BN6 8JY",
    "phone": "07557 787797",
    "email": "amy.rogerson@gmx.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "Text night before. Access\nto rear via service path\nfrom Age Concern\ncarpark (via Dale Ave)\n(Age concern have said\nyou can use their car park\nwhilst doing) When asked\nif you can do it from the\nground do the rear\nskylight for additional\n\u00a315. DO NOT GO ONTO\nTHE ROOF. If you cannot\ndo it she will continue\ndoing this skylight from\nher bedroom window. Pay\nby card lin",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS41324630",
    "name": "Dudley Kemp",
    "address": "7 Firtoft Close, Burgess Hill, West Sussex, RH15 8EE",
    "phone": "07732 995858",
    "email": "dudkemp@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "Text night before. Not 2\nrear windows above flat\nroof. Include\nconservatory.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS12455128",
    "name": "Rachel Joyce",
    "address": "12 Grand Avenue, Hassocks, West Sussex, BN6 8DA",
    "phone": "07930 668102",
    "email": "benwellroad@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "Text night before. Include \nextension but not extension \nroof windows. Not the \nvelux",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS42533250",
    "name": "Ross French",
    "address": "62 Dunstall Farm Road, Burgess Hill, West Sussex, RH15 8BJ",
    "phone": "+447702063060",
    "email": "div3rsity83@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS75676050",
    "name": "Theresa Guise",
    "address": "2 The Willows, Burgess Hill, West Sussex, RH15 8HU",
    "phone": "07474 404477",
    "email": "theresaguise@live.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Text night before. Include\nconservatory. The side\nwindows on one side do\nbest you can",
    "jobCount": 1,
    "totalSpent": 38.0
  },
  {
    "id": "CUS99375023",
    "name": "Jenni Jolley",
    "address": "28 Chancellors Park, Hassocks, West Sussex, BN6 8EZ",
    "phone": "01273 845340",
    "email": "jenni.jolley@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS73254533",
    "name": "Stuart Allen",
    "address": "2 Farnlea, Burgess Hill, West Sussex, RH15 0BD",
    "phone": "07793 219924",
    "email": "stuallen@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Text night before. Include\nconservatory, 2 x velux,\nextension and front\nporch. Not the\nconservatory roof. Pay\nby card link.",
    "jobCount": 1,
    "totalSpent": 37.5
  },
  {
    "id": "CUS11167425",
    "name": "Michael  Randell",
    "address": "22 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "phone": "07712 841505",
    "email": "mick.randell@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Not the \nJuliette balcony at the \nfront. Pays cash until he \nknows you better then \nwill do GoCardless. \u00a323",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS76696662",
    "name": "Sarah Jane",
    "address": "9 The Fairway Hassocks",
    "phone": "07710403308",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS80507119",
    "name": "Med Haynes",
    "address": "6 Highfields, Brighton Road, Warninglid, Haywards Heath, West Sussex, RH17 5SY",
    "phone": "07513514215",
    "email": "Medhaynes@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2024-08-22",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 130.0
  },
  {
    "id": "CUS76126318",
    "name": "Jenny Larter",
    "address": "23 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "phone": "07748 104921",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS73912334",
    "name": "John Bayfield",
    "address": "33 Downscroft, Burgess Hill, RH15 0UF",
    "phone": "07876 227153",
    "email": "johnbayfield@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-06-28",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 112.6
  },
  {
    "id": "CUS37020178",
    "name": "Clint Pike",
    "address": "5 Green View, Orchard Road, Burgess Hill, RH15 9PA",
    "phone": "07487782781",
    "email": "clintpike@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS71273094",
    "name": "Adrian Franks",
    "address": "7 Partridge Cl, Burgess Hill RH15 0ZR, UK",
    "phone": "07989501159",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "Small velux on the left side is included",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS36524602",
    "name": "Stacey Jones",
    "address": "6 Heath Close, Sayers Common, Hassocks, West Sussex, BN6 9XL",
    "phone": "+44 7971 622367",
    "email": "Staceyh69@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS810231",
    "name": "Caroline Green",
    "address": "11 Farlington Avenue, Haywards Heath, West Sussex, RH16 3EZ",
    "phone": "07810 698840",
    "email": "carolinefaygreen@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS57316109",
    "name": "Liz Horton",
    "address": "34 Goldcrest Dr, Hassocks BN6, UK",
    "phone": "07860 817103",
    "email": "liz.horton1@btopenworld.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS68071108",
    "name": "Keith",
    "address": "2 Hurst Wickham Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9AL",
    "phone": "07548 627974",
    "email": "",
    "state": "active",
    "balance": 48.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "All windows",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS13106583",
    "name": "Ken Berreen",
    "address": "36 Stirling Court Road, Burgess Hill, West Sussex, RH15 0PT",
    "phone": "07460 903256",
    "email": "ken.berreen@talk21.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS4832401",
    "name": "Ellie Eastwood",
    "address": "17 Ockley Way, Hassocks BN6 8NE, UK",
    "phone": "+447739429617",
    "email": "aelwa@rocketmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS46323373",
    "name": "Katie",
    "address": "11 Chichester Way, Burgess Hill, West Sussex, RH15 0RH",
    "phone": "+44 7867 121128",
    "email": "Kj_6@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "notes": "Park on drive between the two houses",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS57104210",
    "name": "Grant Carter",
    "address": "1 Pierce Place, Hurstpierpoint, Hassocks, BN6 9YL",
    "phone": "07740 341933",
    "email": "grantcarter6@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 40.7
  },
  {
    "id": "CUS40370973",
    "name": "Jonny",
    "address": "2 Stonepound Court, BN6 9NT",
    "phone": "07850036751",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-09-30",
    "nextDue": "2026-02-18",
    "notes": "Pays CASH, knock the door",
    "jobCount": 2,
    "totalSpent": 60.0
  },
  {
    "id": "CUS56089836",
    "name": "Julie Hamilton",
    "address": "25 Shearing Dr, Burgess Hill RH15 0NA, UK",
    "phone": "+44 7899 137591",
    "email": "backtraxinpai@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-07-28",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS32884874",
    "name": "Max Ife",
    "address": "25 Dale Avenue, Hassocks, West Sussex, BN6 8LP",
    "phone": "07375414077",
    "email": "max.ife56@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-11-25",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS15942324",
    "name": "Anne",
    "address": "1 Woodsland Close, Hassocks, West Sussex, BN6 8HF",
    "phone": "07791 880639",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-10-29",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS74597018",
    "name": "Cenk Ozkan",
    "address": "24 St. Lawrence Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9SH",
    "phone": "07985222611",
    "email": "cenk@empyre.org",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-09-25",
    "nextDue": "2026-03-05",
    "notes": "Text night before.\nInclude conservatory.\npay by card link.",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS11040743",
    "name": "Samuel Tucknott",
    "address": "11 Payton Drive, Burgess Hill, West Sussex, RH15 9UU",
    "phone": "07972 758847",
    "email": "stucknott88@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS49129284",
    "name": "Jane Lindsay-Stewart",
    "address": "54 Curf Way, Burgess Hill RH15 0GE, UK",
    "phone": "07816 259050",
    "email": "lindsay.stewart.family@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "You need long pole for 60,58,54",
    "jobCount": 1,
    "totalSpent": 28.6
  },
  {
    "id": "CUS4999992",
    "name": "Katie",
    "address": "14 Five Oaks Way, Hassocks, BN6 9ZU",
    "phone": "07724205162",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-02",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.8
  },
  {
    "id": "CUS71508235",
    "name": "Sandra Palmer",
    "address": "46 Priory Road, Burgess Hill, RH15 9HB",
    "phone": "07811 481691",
    "email": "agiep1@tiscali.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Cash \u00a322, NOT front door just front and back",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS37790078",
    "name": "Alan Lea",
    "address": "30 Poveys Close, Burgess Hill, West Sussex, RH15 9TB",
    "phone": "07950141066",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "Pay by\ncash (under top tile by\nback door). \u00a325",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS52448139",
    "name": "Andrew Sinden",
    "address": "33 Withy Bush, Burgess Hill, West Sussex, RH15 8TT",
    "phone": "07775 827658",
    "email": "a.sinden@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-06-02",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS20849380",
    "name": "Carole Bailey-Carthew",
    "address": "35 Blackthorns, Hurstpierpoint, Hassocks, West Sussex, BN6 9TF",
    "phone": "+44 7950 326496",
    "email": "Workccarthew@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS3939018",
    "name": "Edmund Herbert",
    "address": "3 Weald Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9SR",
    "phone": "+44 7595 395205",
    "email": "Edmund.herbert@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-11",
    "notes": "Text night before. Include\n3 velux. Include dormer.\nNot the lantern. Ladder\nreq. for rear window. Pay\nby card link.",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS26535353",
    "name": "Pippa Dowden",
    "address": "14 Rhea Close, Burgess Hill, West Sussex, RH15 0XR",
    "phone": "07535900954",
    "email": "pippa.dowdenyates@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-11-03",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS60533983",
    "name": "Ignatius Dube",
    "address": "78 Stonefield Way, Burgess Hill, West Sussex, RH15 8SG",
    "phone": "07812 998429",
    "email": "i_dube@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS34142782",
    "name": "Amanda Licks",
    "address": "42 Wentworth Road, Hassocks, BN6 9SQ",
    "phone": "07759 508171",
    "email": "humbertopoliti@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS86818561",
    "name": "Rose",
    "address": "13 The Street, Albourne, Hassocks, West Sussex, BN6 9DN",
    "phone": "07784 208570",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers No Email",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-08-19",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 15.0
  },
  {
    "id": "CUS98702259",
    "name": "Tiff",
    "address": "2 Hassocks Gate, Hassocks, West Sussex, BN6 9ZF",
    "phone": "07377\u00a0883284\u202c",
    "email": "tiffnicholson26@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "This is the daughter of the guy next door who pays cash, give the windows a thorough scrub and rinse down.\n\nInc all velux on the roof and extension",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS918141",
    "name": "Kirsty Innes",
    "address": "16 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RR",
    "phone": "07961 238000",
    "email": "kirstininnes@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-11-04",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 60.0
  },
  {
    "id": "CUS48265612",
    "name": "Peter Benham",
    "address": "48 Dale Avenue, Hassocks, BN6 8LS",
    "phone": "+44 7305 091365",
    "email": "benhamv@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "Not velux. Include conservatory. Text night before.\n\nThere\u2019s a window round the side you have to go on next doors drive and include all sides of conservatory if the bushes have been cut back",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS87124308",
    "name": "John Wise",
    "address": "11 Newick Drive, Newick, Lewes, East Sussex, BN8 4NY",
    "phone": "07791699034",
    "email": "johnandsarahwise@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS50315970",
    "name": "Stacey Ingham",
    "address": "187 Chanctonbury Rd, Burgess Hill RH15 9HF, UK",
    "phone": "07952 319592",
    "email": "stacey-m-ingham@hotmail.co.uk",
    "state": "active",
    "balance": 37.2,
    "zone": "BH Zone 2",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Reach over to unlock gate",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS63227517",
    "name": "Hannah Green",
    "address": "6 Goosefoot Lane, Burgess Hill RH15 0WT",
    "phone": "07960 533415",
    "email": "hlweatherall@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS55437289",
    "name": "Ray Fogwill",
    "address": "39 The Warren, Burgess Hill, West Sussex, RH15 0DU",
    "phone": "07498 665477",
    "email": "raymondfogwill@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "Text night before. Flick the\ncatch to open side gate.\nPay by cardlink",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS95272850",
    "name": "Karen Kilby",
    "address": "46 Nightingale Way, Sayers Common, Hassocks, BN6 9HP",
    "phone": "07474686484",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Cash",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Cash \u00a320",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS39263466",
    "name": "Matt Morgan",
    "address": "55 The Quadrant, Hassocks, BN6 8BS",
    "phone": "+44 7818 091083",
    "email": "mjmorgan6@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "C1478X gate code \n\nDo the window above conservatory and conservatory at the back",
    "jobCount": 1,
    "totalSpent": 29.5
  },
  {
    "id": "CUS81851636",
    "name": "Jess Johnson",
    "address": "Flintstones Annex  Haywards Heath, Cuckfield Road, Ansty, Haywards Heath, West Sussex, RH17 5AL",
    "phone": "\u202a+44\u00a07760\u00a0431319\u202c",
    "email": "Jessicaviolet7898@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hickstead",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS3398733",
    "name": "Weslee",
    "address": "7 Carnoustie Drive Hassocks",
    "phone": "07534 409903",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "notes": "Please knock the door and ask for the gate to be opened",
    "jobCount": 1,
    "totalSpent": 18.0
  },
  {
    "id": "CUS52851475",
    "name": "Sandra Allen",
    "address": "20 Orchard Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9UB",
    "phone": "07765 094550",
    "email": "sandra.d.allen54@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS93604743",
    "name": "Brendan Seymour",
    "address": "24 Junction Road, Burgess Hill, West Sussex, RH15 0JD",
    "phone": "07919 604072",
    "email": "bren80@gmx.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-09",
    "nextDue": "2026-02-04",
    "notes": "Include extension, small dormer and 2 x velux\nNot the extension skylight",
    "jobCount": 1,
    "totalSpent": 34.0
  },
  {
    "id": "CUS55914376",
    "name": "Hannah Page",
    "address": "27 Brougham Lane, Pease Pottage, Crawley, West Sussex, RH11 9GP",
    "phone": "07530 377259",
    "email": "hannahpage87@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Pease Pottage",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS18492278",
    "name": "Sian Scott",
    "address": "35 Fairlea Cl, Burgess Hill RH15 8ND, UK",
    "phone": "07947359970",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS61972678",
    "name": "Joanne Aldridge",
    "address": "10 Cheales Close, Haywards Heath, West Sussex, RH16 4XA",
    "phone": "07709 956422",
    "email": "joanne.aldridge@ymail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS53281854",
    "name": "Steven Kelly",
    "address": "44 Wheelwright Lane, Burgess Hill, West Sussex, RH15 0QL",
    "phone": "07824356467",
    "email": "steven@skjc.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "Text night before,\nPlease do not call\nbefore 9am. Not the\nconservatory.",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS93282510",
    "name": "Sheila Maskell",
    "address": "4 Field Close, Burgess Hill, West Sussex, RH15 8PP",
    "phone": "07376 354786",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Text night before. Park at\nend of row of bungalows\nif safe to do so and\nreach front and then\nback by rear path. Pay\nby card link.",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS77002805",
    "name": "Joseph Mullin",
    "address": "41 St. Marys Road, Burgess Hill, West Sussex, RH15 8NU",
    "phone": "07718 168299",
    "email": "josephmullin1@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-03-19",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 60.0
  },
  {
    "id": "CUS96786262",
    "name": "Salwa",
    "address": "6 Dr Denman Crescent, Hurstpierpoint, Hassocks, BN6 9ZE",
    "phone": "07533331878",
    "email": "Salwa.malik@doctors.org.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2024-02-01",
    "nextDue": "",
    "notes": "Knock and ask to plug extension lead in",
    "jobCount": 3,
    "totalSpent": 202.5
  },
  {
    "id": "CUS45078397",
    "name": "Will Woodward",
    "address": "52 Kemps, Hurstpierpoint, Hassocks, West Sussex, BN6 9UE",
    "phone": "07784 043912",
    "email": "wlm.woodward@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-04-16",
    "notes": "Text night before.\nInclude conservatory.\nThis property has velux\nand balcony windows.\nDo what you can (he\naccepts you cant do\ncertain bits). Pay by\ncard link. Please leave\nleaflet",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS204725",
    "name": "Sally & Terry",
    "address": "8 Carnoustie Drive Hassocks",
    "phone": "07879285628",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS83153882",
    "name": "Patrick",
    "address": "Millway Cottage, Ockley Lane, Hassocks, BN6 8NU",
    "phone": "07977022412",
    "email": "patrick@glithro.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Call the alternative number to open the gate",
    "jobCount": 1,
    "totalSpent": 55.0
  },
  {
    "id": "CUS31323574",
    "name": "Chris Goodwin",
    "address": "14 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BD",
    "phone": "07557 385645",
    "email": "lgw340@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS84759390",
    "name": "Florence Ruby",
    "address": "121 Royal George Road, Burgess Hill, West Sussex, RH15 9SJ",
    "phone": "07570 392142",
    "email": "florence.j.m.ruby@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-12-08",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS11845320",
    "name": "Tom Brooks",
    "address": "47 Charlwood Road, Burgess Hill, West Sussex, RH15 0RJ",
    "phone": "07786 034857",
    "email": "tom@intervivos.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Text night before. Include\nrear door and window of\ngarage.",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS44326110",
    "name": "Caroline Bennet",
    "address": "10 Swallow Rest, Burgess Hill, West Sussex, RH15 9XS",
    "phone": "07837 642645",
    "email": "bennetcaroline@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-08",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 21.67
  },
  {
    "id": "CUS75034664",
    "name": "Chris Currie",
    "address": "70 Iden Hurst, Hurstpierpoint, Hassocks, West Sussex, BN6 9YJ",
    "phone": "07785957470",
    "email": "chris.currie@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS37647424",
    "name": "Des Mellicar- Bowman",
    "address": "121 Mill Road, Burgess Hill, West Sussex, RH15 8AY",
    "phone": "07884 268099",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-11-28",
    "nextDue": "2026-02-19",
    "notes": "night before.\nCustomer advised that\nhe was not happy with\nprev. window cleaner\nbecause they were not\nthere long enough to do\na good job, and didnt do\na good job. Pay by card\nlink",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS26929448",
    "name": "Laurie Tilley",
    "address": "2 Heron Close, Sayers Common, Hassocks, Sussex, BN6 9LF",
    "phone": "07900 825123",
    "email": "lauriiet@mail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS48767381",
    "name": "Steve Thorne- Farrar",
    "address": "2 Fitzalan Mead, Hassocks, West Sussex, BN6 8FY",
    "phone": "07595 469237",
    "email": "steven@thornefarrar.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS19010389",
    "name": "Gemma",
    "address": "11 Wheatsheaf Cl, Burgess Hill RH15 8UT, UK",
    "phone": "07753166735",
    "email": "gemmastanding1992@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-12-16",
    "nextDue": "2026-03-10",
    "notes": "Turn on to wheatshef and its half way down, turn left onto the little road to park by the garages",
    "jobCount": 1,
    "totalSpent": 17.0
  },
  {
    "id": "CUS3021803",
    "name": "Teresa Sayers",
    "address": "50 Priory Road, Burgess Hill, West Sussex, RH15 9HB",
    "phone": "07584 169029",
    "email": "trsayers2@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Text night before. Include\nconservatory (one side\nonly).",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS67188877",
    "name": "Sacha Murray",
    "address": "40 Coulstock Road, Burgess Hill, West Sussex, RH15 9XH",
    "phone": "07775 853148",
    "email": "sachalmurray@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS58045039",
    "name": "Danny Sadd",
    "address": "38 Fairfield Road, Burgess Hill, West Sussex, RH15 8QQ",
    "phone": "07850 344209",
    "email": "mdsadd@mail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS60693572",
    "name": "Sarah",
    "address": "100 Unicorn Way, Burgess Hill, West Sussex, RH15 0WB",
    "phone": "07840 222640",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS61798319",
    "name": "Norma Hurst",
    "address": "Copper Beeches, Keymer Road, Keymer, Hassocks, BN6 8QU",
    "phone": "+44 7749 269314",
    "email": "hurst51@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Facias and Sofitts,Gutter Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-12-10",
    "nextDue": "",
    "notes": "",
    "jobCount": 3,
    "totalSpent": 357.0
  },
  {
    "id": "CUS63060081",
    "name": "Brian Deacon",
    "address": "37 Newick Drive, Newick, Lewes, East Sussex, BN8 4NY",
    "phone": "07525253359",
    "email": "de07con@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Park at the garages at the back of the shops, the house is the last one on the left and gate is by the garages, pull the hose through to the front via the side",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS68295315",
    "name": "Richard Drew",
    "address": "48 Foxglove Close, Burgess Hill, West Sussex, RH15 8UY",
    "phone": "07879454833",
    "email": "richarddrew86@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "Text night before. On the\nside door do glass only.",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS74407753",
    "name": "Indre Speicyte",
    "address": "12 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "phone": "07827 393847",
    "email": "indresp23@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "never",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS78720879",
    "name": "James Phillips",
    "address": "1 Great Park Meadow, Burgess Hill RH15 0YL",
    "phone": "07779 635490",
    "email": "james_phillipsbha@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS99767002",
    "name": "Elaine Mills",
    "address": "2 Ravenswood, Hassocks BN6 8JB, UK",
    "phone": "+44 7507 480631",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS36943106",
    "name": "Gillian Hopkins",
    "address": "29 Charlwood Gardens, Burgess Hill, West Sussex, RH15 0RD",
    "phone": "07904 230870",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Back\ngate is stiff, lift and push.\nAccess rear garden via\npath. Pay by card link",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS63541493",
    "name": "Ian Lundberg",
    "address": "10 Brown Twins Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9XT",
    "phone": "07809 692898",
    "email": "ian_lundberg@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "Gate code 5263",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS16113334",
    "name": "Leslie Plaisted",
    "address": "7 The Fairway, Hassocks, BN6 9JU",
    "phone": "07771908186",
    "email": "leslie.plaisted@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS49569848",
    "name": "Andrew Foster",
    "address": "20 Ockley Way, Hassocks, West Sussex, BN6 8NE",
    "phone": "07962 485459",
    "email": "aj1uk@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Text night before. Include \nconservatory. Access to \nrear via side gate (will give \nyou key code on first visit)\n\n1391 key code and there\u2019s a key for the back gate",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS88730067",
    "name": "Laura Clark",
    "address": "16 The Fairway, Hassocks, BN6 9JU",
    "phone": "07872040669",
    "email": "clarkylc82@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS53844991",
    "name": "Pamela Short",
    "address": "25 The Quadrant, Hassocks, West Sussex, BN6 8BP",
    "phone": "07866 847272",
    "email": "ps25q@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 8 weeks on Tuesday",
    "lastDone": "2025-11-14",
    "nextDue": "2026-03-10",
    "notes": "Text night before. Not the\nconservatory. First clean\npreferably Monday or\nTuesday. Pay by cash.",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS1404711",
    "name": "Chris",
    "address": "40 The Fairway, Hassocks BN6, UK",
    "phone": "07733290023",
    "email": "colblade@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2025-10-24",
    "nextDue": "2026-04-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS59220175",
    "name": "Brady Knight",
    "address": "6 Michelbourne Close, Burgess Hill, West Sussex, RH15 9QX",
    "phone": "07748 834409",
    "email": "bradyknight87@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "Text night before. Not the\nwindows over the cut\nthrough. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS21992919",
    "name": "Louisa",
    "address": "15 Icarus Avenue, Burgess Hill, RH15 0UW",
    "phone": "+44 7931 328134",
    "email": "lulublue@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-01-31",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 117.0
  },
  {
    "id": "CUS57248225",
    "name": "Jacky Hayes",
    "address": "105 Orchard Road, Burgess Hill, West Sussex, RH15 9PH",
    "phone": "07485 427764",
    "email": "mrspeetroot@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS33296406",
    "name": "Lee Panther",
    "address": "35 Kemps, Hurstpierpoint, Hassocks, West Sussex, BN6 9UF",
    "phone": "07904 242688",
    "email": "leepanther22@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-09-24",
    "nextDue": "2026-03-11",
    "notes": "Text night before. Not the\nlarge lean-to on L.H.\nside. Include door and\nwindows inside lean-to if\npractical. Pay by card\nlink.",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS71747749",
    "name": "Karen Yellands",
    "address": "16 Wellman grove, hassocks",
    "phone": "07545 702497",
    "email": "darrenandkarenyelland@yahoo.com",
    "state": "active",
    "balance": 39.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Text night before.\nCustomer advised\nstandard of work of\nprevious window\ncleaner was very poor.",
    "jobCount": 1,
    "totalSpent": 32.5
  },
  {
    "id": "CUS62770327",
    "name": "Christine Cooper",
    "address": "36 Dale Avenue, Hassocks, West Sussex, BN6 8LP",
    "phone": "+44 7756 843352",
    "email": "chrisjcooper60@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS49538570",
    "name": "John Elliott",
    "address": "11 Lamb Lane, Hurstpierpoint, Hassocks, Sussex, BN6 9ZA",
    "phone": "07859003620",
    "email": "john.elliott10@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Text night before.\nCustomer advised last\nwindow cleaner\nunsatisfactory re\ncleaning of sills etc.\nPay by card link.",
    "jobCount": 2,
    "totalSpent": 126.67
  },
  {
    "id": "CUS37666783",
    "name": "Emily Welsh",
    "address": "13 Blackhouse Lane, Burgess Hill, West Sussex, RH15 8BN",
    "phone": "07745 345039",
    "email": "emilywelshn@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "Text night before. Please\nsend text night before\n(as usual) and text in\nmorning with approx.\ntime (within a couple of\nhours). Pay by card link.\nPlease leave leaflet.",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS26236165",
    "name": "Susan Knight",
    "address": "14 Barnside Avenue, Burgess Hill, RH15 0JU",
    "phone": "07926 095578",
    "email": "knighbri@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 3,
    "totalSpent": 248.0
  },
  {
    "id": "CUS61469612",
    "name": "Trina Murishwar",
    "address": "72 Nightingale Lane, Burgess Hill, RH15 9JJ",
    "phone": "07955 096878",
    "email": "trinabelm@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Cladding Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-06-04",
    "nextDue": "",
    "notes": "Cleaning of the white cladding at the front of the property.",
    "jobCount": 2,
    "totalSpent": 57.6
  },
  {
    "id": "CUS72737525",
    "name": "Chris Buckley",
    "address": "5 Carnoustie Drive Hassocks BN6",
    "phone": "07476639337",
    "email": "Chrisbuckley94@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS70502489",
    "name": "Carole Small",
    "address": "36 Mackie Avenue, Hassocks, BN6 8NN",
    "phone": "07851089062",
    "email": "carbrismall@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Not conservatory, orange brush leaded windows",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS92014780",
    "name": "Andy Seamark",
    "address": "57 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "phone": "07798631246",
    "email": "andy.seamark@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS60568941",
    "name": "Citiguard Security Ltd",
    "address": "Citiguard Security (Uk) Ltd, The, 21 Building, 21 Pinner Road, Harrow, Greater London, HA1 4ES",
    "phone": "\u202a+44\u00a07775\u00a0332758\u202c",
    "email": "accounts@citiguardsecurity.com",
    "state": "active",
    "balance": 2719.2,
    "zone": "Citiguard",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-12-31",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 2266.0
  },
  {
    "id": "CUS55916769",
    "name": "Sarita Premley",
    "address": "Oak Tree Cottage Ditton Place, Brantridge Lane, Balcombe, Haywards Heath, West Sussex, RH17 6JR",
    "phone": "07786 044380",
    "email": "prem_sarita@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "Must be at the property starting work at 8",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS57500879",
    "name": "Brian Smith",
    "address": "17 Orchard Way, Burgess Hill, West Sussex, RH15 9PB",
    "phone": "07487 218356",
    "email": "smith.es570@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "CASH",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS83019150",
    "name": "Steve Tingley",
    "address": "2 Carnoustie hassocks",
    "phone": "07814 268507",
    "email": "s.tingley@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "Gardens through the garage",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS80491335",
    "name": "Gareth Harper",
    "address": "6 Leigh Meadow, Burgess Hill",
    "phone": "07814 892652",
    "email": "garethandathena@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-16",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 26.67
  },
  {
    "id": "CUS51024789",
    "name": "Sean Honey",
    "address": "14 Kymer Gardens, Hassocks, West Sussex, BN6 8QZ",
    "phone": "+447708377000",
    "email": "seanhoney11@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 38.0
  },
  {
    "id": "CUS42999449",
    "name": "Paula Pitt",
    "address": "77 Sycamore Drive, Burgess Hill, West Sussex, RH15 0GG",
    "phone": "07796 466986",
    "email": "paula.salsbury2020@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-23",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS17353515",
    "name": "Jonathan Garnham",
    "address": "59 Parklands Road in Hassocks, BN6 8JY",
    "phone": "\u202a+44\u00a07843\u00a0099911\u202c",
    "email": "jonathan_garnham555@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-12-02",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS27318429",
    "name": "Peter Woodhams",
    "address": "135 Manor Road, Burgess Hill, West Sussex, RH15 0NG",
    "phone": "01444 230988",
    "email": "peterlesley.woodhams@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "Text to landline the\nnight before. Lean over\nto unbolt gate. Pay by\nGoCardless. Friendly\ndog in garden",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS29760972",
    "name": "Lloyd",
    "address": "179 Cuckfield Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9RT",
    "phone": "07919 353484",
    "email": "Lloyd.gofton@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-04-16",
    "notes": "Front and side, ground and 1st floor. Flat roof at back 1st and 2nd floor. Ground floor at back plus quick clean office at end of garden.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS28840429",
    "name": "Jonny",
    "address": "4 St Andrews Place Hassocks",
    "phone": "07791032707",
    "email": "",
    "state": "active",
    "balance": 26.4,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 8 weeks on Friday",
    "lastDone": "2025-12-13",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS19251834",
    "name": "Caroline Stark",
    "address": "1 Jack Slaughter Lane, Hassocks, West Sussex, BN6 8GF",
    "phone": "+44 7484 676920",
    "email": "caroline.stark@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS51092120",
    "name": "Julie",
    "address": "39 Birch Way, Hassocks, West Sussex, BN6 8YJ",
    "phone": "+44 7766 011898",
    "email": "juliehoop03@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-10-13",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS71484356",
    "name": "Poppy Friar",
    "address": "128 Western Road, Haywards Heath, West Sussex, RH16 3LN",
    "phone": "07745 183181",
    "email": "poppyfriar31@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "\u00a336",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS66730180",
    "name": "John Southorn",
    "address": "5 Furzeland Way, Sayers Common, Hassocks, West Sussex, BN6 9JB",
    "phone": "07531 569065",
    "email": "j.southorn001@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Cash",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "New** Not garage. Not velux.\nText night before. Happy\nto pay with card but\nwould like a little help to\nset it up. \u00a320 cash",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS4001476",
    "name": "Gill",
    "address": "12 goose",
    "phone": "07809674049",
    "email": "",
    "state": "active",
    "balance": 25.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS638135",
    "name": "Esra Oner",
    "address": "28 Priory Rd, Hassocks BN6 8PS, UK",
    "phone": "07504 749348",
    "email": "esorguven@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 38.5
  },
  {
    "id": "CUS32838676",
    "name": "Andrew Walker",
    "address": "21 The Fairway, Hassocks, BN6 9JU",
    "phone": "07812418287",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS56159851",
    "name": "Richard Harris",
    "address": "24 Leveller Road, Newick, Lewes, East Sussex, BN8 4PL",
    "phone": "07929 307443",
    "email": "rich-harris@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-12-04",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS30948843",
    "name": "Bryan Belton",
    "address": "39 Northway, Burgess Hill, West Sussex, RH15 0PW",
    "phone": "07923 514788",
    "email": "beltonb@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Not before 9am",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS27981203",
    "name": "Elizabeth Johnson",
    "address": "7 Sycamore Way, Hassocks, West Sussex, BN6 8YH",
    "phone": "+447864832658",
    "email": "phoebefrenchie@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS93653726",
    "name": "James Barron",
    "address": "21 Avenue  de  Warenne, Hassocks",
    "phone": "07862 253623",
    "email": "jibarron@virginmedia.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "notes": "Text night before. Include \ndormer and 2 x velux. Pay \nonline. Please knock when \nyou get there so they can \nput dog in if he's out",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS28101471",
    "name": "Dominic Tree",
    "address": "5 Powell Road, Newick, Lewes, East Sussex, BN8 4LS",
    "phone": "07722198464",
    "email": "dominictree@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS33657194",
    "name": "PureGym Ltd",
    "address": "Puregym, 208 London Road, Burgess Hill, RH15 9RD",
    "phone": "",
    "email": "info.burgesshill@puregym.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Signage Clean",
    "frequency": "Ad hoc",
    "lastDone": "2024-01-31",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 199.0
  },
  {
    "id": "CUS61966098",
    "name": "Betty Hills",
    "address": "1 Oldlands Avenue, Hassocks, West Sussex, BN6 8DJ",
    "phone": "07774 921524",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "notes": "Pays cash \u00a325",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS18320231",
    "name": "HELEN GARRETT",
    "address": "17 Bridgers Mill, Haywards Heath, West Sussex, RH16 1TF",
    "phone": "07786 063057",
    "email": "helen@hgaccounting.org",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-05-19",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 66.66
  },
  {
    "id": "CUS7237067",
    "name": "Chris Lisle",
    "address": "187 Maple Drive, Burgess Hill, West Sussex, RH15 8DF",
    "phone": "+447739845255",
    "email": "chrislisle187@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS32449806",
    "name": "Peter King",
    "address": "42 Victoria Close, Burgess Hill, West Sussex, RH15 9QS",
    "phone": "07421\n828567",
    "email": "peterjking213@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-04-20",
    "notes": "Text night before. Include glass porch at rear of house.",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS19062808",
    "name": "Ross",
    "address": "25 Janes Lane, Burgess Hill, West Sussex, RH15 0QJ",
    "phone": "+447398827474",
    "email": "rossmarquis@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Garden Room",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS48927088",
    "name": "Richard Jukes",
    "address": "21 Coulstock Road, Burgess Hill, West Sussex, RH15 9XH",
    "phone": "07539 534265",
    "email": "richard.jukes7@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS74195293",
    "name": "Josephine Messina-Persad",
    "address": "4 Magnolia Court, Albourne, Hassocks, West Sussex, BN6 9FY",
    "phone": "07956 297336",
    "email": "phina.messina@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS69883320",
    "name": "Jan Goddard",
    "address": "9 Gloucester Place, Littlehampton, West Sussex, BN17 7AF",
    "phone": "07970 313350",
    "email": "jbgoddard123@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "",
    "assignee": "",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "never",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS21321500",
    "name": "Mick Bartlett",
    "address": "15 Sylvan Close, Haywards Heath, West Sussex, RH16 3SG",
    "phone": "01444 416934",
    "email": "bartlett-m1@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Saturday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-21",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS27363303",
    "name": "Darren Longley",
    "address": "11 Rastrick Close, Burgess Hill, West Sussex, RH15 9UW",
    "phone": "07515 125302",
    "email": "darrenlongley01@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS26209144",
    "name": "Julie Sadler",
    "address": "9 Newick Drive, Newick, Lewes, East Sussex, BN8 4NY",
    "phone": "07742 513948",
    "email": "juliesadler2205@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-04-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS71592050",
    "name": "Michael",
    "address": "48 Livingstone Road, Burgess Hill, West Sussex, RH15 8QP",
    "phone": "07768594918",
    "email": "Mike.butler.mb1@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Conservatory Roof Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-08-06",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 75.0
  },
  {
    "id": "CUS62050541",
    "name": "Sarah Lawson",
    "address": "26 Leylands Park, Burgess Hill, West Sussex, RH15 8AH",
    "phone": "07455 610159",
    "email": "sarahjj21@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS71673109",
    "name": "Charlotte Kedian",
    "address": "67 Goldcrest Dr, Hassocks BN6, UK",
    "phone": "07548820604",
    "email": "",
    "state": "active",
    "balance": 22.44,
    "zone": "Sayers No Email",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.7
  },
  {
    "id": "CUS89934231",
    "name": "Stacie Skeen-Clark",
    "address": "30 Highlands, Ardingly Road, Cuckfield, Haywards Heath, West Sussex, RH17 5HL",
    "phone": "07507 695475",
    "email": "stacielou123@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS25046450",
    "name": "Simon Marchant",
    "address": "11 Little Copse Rd, Hassocks BN6 8PG, UK",
    "phone": "07787 788813",
    "email": "slymarchant@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS10012866",
    "name": "James Nicholls",
    "address": "3 Talbot Mead, Hurstpierpoint, Hassocks BN6 9TJ, UK",
    "phone": "079056009068",
    "email": "jconicholls@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Knock the door and access to the garden is through the garage \n\nLong pole",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS40381086",
    "name": "Susan Jones",
    "address": "Oakwood Farm, North Common Road, North Chailey, Lewes, East Sussex, BN8 4ED",
    "phone": "01444 471838",
    "email": "oakwoodfarm1@aol.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "",
    "assignee": "",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "never",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 68.33
  },
  {
    "id": "CUS31322107",
    "name": "Diane King",
    "address": "33 The Gattons, Burgess Hill, West Sussex, RH15 9SW",
    "phone": "07784781744",
    "email": "dianekingone@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "**KNOCK BEFORE***Text night before. Not the\nconservatory or the velux.\nDo conservatory for extra\n\u00a39 when asked",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS18130430",
    "name": "Tim Griffiths",
    "address": "30 The Warren, Burgess Hill, West Sussex, RH15 0DZ",
    "phone": "07913206249",
    "email": "timgriffiths52@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-12-01",
    "nextDue": "2026-02-23",
    "notes": "Not the Velux",
    "jobCount": 1,
    "totalSpent": 34.0
  },
  {
    "id": "CUS48911675",
    "name": "Pauline Ratcliffe",
    "address": "57 East View Fields, Plumpton Green, Lewes, East Sussex, BN7 3EF",
    "phone": "07971 870223",
    "email": "paulineratcliffe676@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before.\nCustomer will leave\nwalkway unlocked on\nL.H. side of house on\nreceipt of text if not\nhome. Pay by card link",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS46483870",
    "name": "Gemma",
    "address": "32 Marle Avenue, Burgess Hill, West Sussex, RH15 8JG",
    "phone": "07949670848",
    "email": "Gemmabrucebird@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "notes": "Back gate has little flip lock you can see\n\nInc con",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS60553441",
    "name": "Robbie",
    "address": "4 Carnoustie Drive, Hassocks, BN6 9PB",
    "phone": "07968670728",
    "email": "roby_burns@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean inc Garage Window",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "notes": "CASH \u00a325 inc garage window",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS5637867",
    "name": "Megan Tatum",
    "address": "7, The Birches, Southdowns Park, Haywards Heath, West Sussex, RH16 4XJ",
    "phone": "07774 846222",
    "email": "wordsbymegantatum@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-05-15",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS36257044",
    "name": "Mark Lamber",
    "address": "5 Friars Cl, Hassocks BN6 8PL, UK",
    "phone": "07789 348606",
    "email": "markhassocks@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Orange brush leaded windows",
    "jobCount": 1,
    "totalSpent": 32.0
  },
  {
    "id": "CUS33904967",
    "name": "Marc Edwards",
    "address": "Flat 15, Stockwell Court, London Road, Burgess Hill, West Sussex, RH15 9RS",
    "phone": "07850 481501",
    "email": "mledwards2000@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Flat directly above every care shop, photo attached, will need a good going over",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS22675573",
    "name": "Sue Lamber",
    "address": "58 Freeks Lane, Burgess Hill, West Sussex, RH15 8DG",
    "phone": "07983 965796",
    "email": "thelambertss@uwclub.net",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "notes": "Front only",
    "jobCount": 1,
    "totalSpent": 16.0
  },
  {
    "id": "CUS52258813",
    "name": "Robin Aldridge",
    "address": "22 Haywards Road, Haywards Heath, West Sussex, RH16 4HT",
    "phone": "07711 111111",
    "email": "robinofaldridge@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS90364231",
    "name": "Michael Jenney",
    "address": "32 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07427 076573",
    "email": "mjjenney@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS5521865",
    "name": "Samy",
    "address": "10 The Fairway Hassocks",
    "phone": "+44 7827 616965",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 8 weeks on Friday",
    "lastDone": "2025-12-12",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS16548610",
    "name": "Amanda Murray",
    "address": "1 Bridge Cottages, East Grinstead Road, North Chailey, Lewes, East Sussex, BN8 4DB",
    "phone": "07976 280950",
    "email": "amurrayhiggins@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Chailey",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Not the guest house out the back",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS85687386",
    "name": "Susie",
    "address": "2 Little Copse Road, Hassocks, BN6 8PG",
    "phone": "+44 7515 949409",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-11-24",
    "nextDue": "2026-02-23",
    "notes": "Cash \u00a330",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS75403661",
    "name": "Sue Baldwin",
    "address": "Weald Cottage, Whitemans Green, Cuckfield, Haywards Heath, West Sussex, RH17 5BX",
    "phone": "07811 067742",
    "email": "susanjanebaldwin58@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean every 12 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-11-27",
    "nextDue": "2026-02-17",
    "notes": "she needs to be home on the day of the clean, so is reliant on the text/email night before",
    "jobCount": 1,
    "totalSpent": 34.17
  },
  {
    "id": "CUS65464369",
    "name": "Silvy",
    "address": "90 Avenue De Warenne, Hassocks, West Sussex, BN6 8GE",
    "phone": "\u202a+44\u00a07756\u00a0158645\u202c",
    "email": "Silvy8203@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS6888609",
    "name": "Clare",
    "address": "15 The Fairway, Hassocks, BN6 9JU",
    "phone": "07863105053",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2025-11-28",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS6271420",
    "name": "Lorraine Tracy",
    "address": "11 South Cl, Burgess Hill RH15 9PZ, UK",
    "phone": "07715098780",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS65507860",
    "name": "Tara Edwards",
    "address": "40 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07736 651144",
    "email": "tara19edwards@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-04",
    "notes": "Text night before.\nAccess to rear garden\nvia path on L.H. side.",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS29420240",
    "name": "Catherine Laslett",
    "address": "73 Downs View Rd, Hassocks BN6 8HY, UK",
    "phone": "07913 881108",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Include velux. Not juliet windows. Text night before.",
    "jobCount": 1,
    "totalSpent": 34.1
  },
  {
    "id": "CUS55810021",
    "name": "Denise",
    "address": "41 Woodsland Road, Hassocks, West Sussex, BN6 8HG",
    "phone": "07894 950214",
    "email": "denisemartyr@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "They\u2019re having building work done at the back at the moment. Front only",
    "jobCount": 1,
    "totalSpent": 18.5
  },
  {
    "id": "CUS17658657",
    "name": "David Johnson",
    "address": "11 Welbeck Close, Burgess Hill, West Sussex, RH15 0AU",
    "phone": "07900 905477",
    "email": "marionj6@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "Text night before. Payment\nby card link. Please quote\nfor gutters, soffits and\nfascias.",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS80445190",
    "name": "Anton Kruglyakou",
    "address": "10 Bonnet Lane, Burgess Hill, RH15 0FQ",
    "phone": "07397 312186",
    "email": "banoures@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 21.0
  },
  {
    "id": "CUS5037540",
    "name": "Amanda Holland",
    "address": "106 Unicorn Way, Burgess Hill, West Sussex, RH15 0WB",
    "phone": "07969 495967",
    "email": "amanda.louise.holland@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS37423166",
    "name": "Lloyd Bradley",
    "address": "5 Grand Avenue, Hassocks, West Sussex, BN6 8DA",
    "phone": "07948 505362",
    "email": "lbradley@doctors.org.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "Has extension.",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS17230005",
    "name": "Alan Melluish",
    "address": "62 Nightingale Ln, Burgess Hill RH15, UK",
    "phone": "",
    "email": "melluishandersonmp@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Cladding Clean",
    "frequency": "Ad hoc",
    "lastDone": "2022-05-25",
    "nextDue": "",
    "notes": "",
    "jobCount": 3,
    "totalSpent": 243.7
  },
  {
    "id": "CUS90002753",
    "name": "Becca Sharrock",
    "address": "69 Sunnywood Drive, Haywards Heath, West Sussex, RH16 4PD",
    "phone": "\u202a+44\u00a07795\u00a0189524\u202c",
    "email": "beccaandchris17@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-08-28",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS77105809",
    "name": "Frances  Partridge",
    "address": "37 Queens Drive, Hassocks, West Sussex, BN6 8DF",
    "phone": "07753 456675",
    "email": "pfpartridge@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Text night before. Include 2 \nx dormers. Stand on \nneighbours (Martin) \ndoorstep to reach dormers. \nNeighbour has given \npermission but does not \nwant you to knock and ask \nhim each time, just do it. \nPay by GoCardless",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS6852633",
    "name": "Pam Cox",
    "address": "41 Avenue De Warenne, Hassocks, West Sussex, BN6 8FP",
    "phone": "\u202a+44\u00a07956\u00a0377727\u202c",
    "email": "pcox11@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS34243566",
    "name": "Marilyn Morrison",
    "address": "9 Bluebell Way, Burgess Hill, West Sussex, RH15 8UU",
    "phone": "07554 264709",
    "email": "Marilyn.morrison1941@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 8 weeks on Monday",
    "lastDone": "2025-12-08",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS7012752",
    "name": "Carly",
    "address": "36 Hurst Road, Hassocks, West Sussex, BN6 9NL",
    "phone": "\u202a+44\u00a07360\u00a0365212\u202c",
    "email": "carlyjanewatts@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-08-20",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 73.33
  },
  {
    "id": "CUS81729565",
    "name": "Allan Stone",
    "address": "7 Chestnut Close, Burgess Hill, West Sussex, RH15 8HN",
    "phone": "07715490002",
    "email": "allan.stone@mail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 36.6
  },
  {
    "id": "CUS1462322",
    "name": "Phil Prime",
    "address": "75 Dale Avenue, Hassocks, West Sussex, BN6 8LR",
    "phone": "07833661143",
    "email": "phil.prime@cancer.org.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "Text night before. Include 1 Velux",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS44436409",
    "name": "Glenn Geer",
    "address": "1 Chestnut Close, Burgess Hill, West Sussex, RH15 8HN",
    "phone": "07368\n649336",
    "email": "glenn.geer@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "New",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS73700026",
    "name": "Gary Young",
    "address": "23 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RR",
    "phone": "07510 885137",
    "email": "gary1young@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS40642521",
    "name": "Nick Willis",
    "address": "28 Potters Lane, Burgess Hill, West Sussex, RH15 9JS",
    "phone": "07715 684198",
    "email": "n.willis@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "Text night before. Please leave leaflet.\nInclude dormer.",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS18615554",
    "name": "Daya Durai",
    "address": "3 Keymer Gardens, Burgess Hill, West Sussex, RH15 0AF",
    "phone": "07424 026516",
    "email": "dayadurai201@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.83
  },
  {
    "id": "CUS58599482",
    "name": "Gillian Moore",
    "address": "14 Aphrodite Way, Burgess Hill, West Sussex, RH15 0XQ",
    "phone": "07860 171794",
    "email": "gillianmoore79@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS72718624",
    "name": "Amy Hemmings-Alexander",
    "address": "71 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AE",
    "phone": "+44 7540 399942",
    "email": "amy-hemmings@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 135.0
  },
  {
    "id": "CUS12792972",
    "name": "Rob Lloyd",
    "address": "124 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "phone": "07847 319978",
    "email": "rh.lloyd9@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-04-01",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 113.0
  },
  {
    "id": "CUS34622141",
    "name": "Hannah Albuery",
    "address": "71 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "phone": "07792654315",
    "email": "hannah.albuery@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS76681001",
    "name": "Kitty",
    "address": "47 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AD",
    "phone": "07794517625",
    "email": "kitty.nimmo@cantab.net",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "notes": "Front and side\nGf at back only",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS48017696",
    "name": "Pat Murphy",
    "address": "20 Bridge Close, Burgess Hill, West Sussex, RH15 8Pd",
    "phone": "07708 929727",
    "email": "pat1955murphy@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS69447683",
    "name": "Tom Wheatley",
    "address": "9 Weavers Close, Burgess Hill, West Sussex, RH15 0QD",
    "phone": "07736 930229",
    "email": "tomwheatley24@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2026-01-12",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS21230497",
    "name": "Luis Walters",
    "address": "6 Holmbush Close, Haywards Heath, West Sussex, RH16 4RS",
    "phone": "07837 239431",
    "email": "luiswalters1@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "",
    "assignee": "",
    "services": "Window Clean Every 6 weeks,Gutter Clearance,Facias and Sofitts,Gutter wash",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "never",
    "nextDue": "2026-02-02",
    "notes": "Was hoping for Monday 2nd February for the first appointment, he also mentioned there is paint on the windows and would like this area to be focused on to make sure it comes off.",
    "jobCount": 1,
    "totalSpent": 140.2
  },
  {
    "id": "CUS34715316",
    "name": "Cassie Walburton",
    "address": "48 Maple Drive, Burgess Hill, West Sussex, RH15 8AW",
    "phone": "07720247781",
    "email": "cassiepodesta@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.1
  },
  {
    "id": "CUS64322347",
    "name": "Charlie Mechea",
    "address": "32 Mayhouse Rd, Burgess Hill RH15 9RF, UK",
    "phone": "+44 7899 651362",
    "email": "charliemechea@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS30727465",
    "name": "Julia Robertson",
    "address": "5 The Pagets, Newick, Lewes, East Sussex, BN8 4PW",
    "phone": "07789 394287",
    "email": "juliarob1977@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Text night before. Include\nconservatory. Pay by\ncardlinK",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS78279418",
    "name": "Daniel Montero",
    "address": "35 Copley Drive, Hassocks, West Sussex, BN6 8FS",
    "phone": "+447808129542",
    "email": "danielmontero1987@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS99627099",
    "name": "Francis Teague",
    "address": "15 Nightingale Ln, Burgess Hill RH15 9HG, UK",
    "phone": "07955 508815",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "Cash",
    "jobCount": 2,
    "totalSpent": 0.0
  },
  {
    "id": "CUS15744443",
    "name": "Eddie",
    "address": "7 Quarry Cl, Burgess Hill RH15 0TJ, UK",
    "phone": "+447749569456",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-11-27",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 0.0
  },
  {
    "id": "CUS29427295",
    "name": "Paul",
    "address": "37 Marlow Drive, Haywards Heath, West Sussex, RH16 3SR",
    "phone": "\u202a+44\u00a07711\u00a0771215\u202c",
    "email": "paularkell@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS87881153",
    "name": "Gail Smith",
    "address": "The Beeches, Underhill Lane, Clayton, Hassocks, West Sussex, BN6 9PL",
    "phone": "07887 578274",
    "email": "gail@gspuk.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-07-22",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS56271775",
    "name": "Carol Salisbury",
    "address": "44 Eastdale Road, Burgess Hill, West Sussex, RH15 0NH",
    "phone": "07712 800420",
    "email": "carol@salisbury.me.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "NEW\nText night before.\nInclude garden room.\nLean over to unbolt\ngate. Pay by\nGoCardless.",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS23561188",
    "name": "Catherine Perera",
    "address": "28 Holmesdale Road, Burgess Hill, West Sussex, RH15 9JR",
    "phone": "07779 608241",
    "email": "catherineperera1@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "Include dormer and 2 x velux.",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS45155849",
    "name": "Heather And David",
    "address": "26 Junction Road, Burgess Hill, West Sussex, RH15 0JN",
    "phone": "01444 242587",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Cash \u00a330",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS52071480",
    "name": "Graham Whitehouse",
    "address": "1 Greenlands Drive, Burgess Hill, West Sussex, RH15 0AZ",
    "phone": "07568 079568",
    "email": "gwhitehouse54@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "49 49a two flats",
    "jobCount": 2,
    "totalSpent": 62.0
  },
  {
    "id": "CUS54584339",
    "name": "Kim Gorman",
    "address": "2 Aphrodite Way, Burgess Hill, West Sussex, RH15 0XQ",
    "phone": "07950 000176",
    "email": "kimsgorman@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS33440881",
    "name": "Wendy Little",
    "address": "56 Dyall Cl, Burgess Hill RH15 8UD, UK",
    "phone": "+44 7906 061683",
    "email": "wendylittle@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-04-21",
    "notes": "Inc con windows",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS97688463",
    "name": "Lucy Holford",
    "address": "38 Bridge Close, Burgess Hill, West Sussex, RH15 8PD",
    "phone": "07599 203087",
    "email": "lucy.holford@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-10-09",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS26967674",
    "name": "Brian Pate",
    "address": "5 Meadows, Hassocks BN6 8EH, UK",
    "phone": "07764 343262",
    "email": "bp1cbt@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 112.0
  },
  {
    "id": "CUS32056453",
    "name": "Paul",
    "address": "22 Semley Road, Hassocks, West Sussex, BN6 8PE",
    "phone": "07939609818",
    "email": "paul.dales@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "All windows, except the one window at front of the second floor. Flat roof access above garage doors, which I give a very quick wash down. There are 2 velux windows.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS8895960",
    "name": "Tania Chan",
    "address": "22 Hassocks Gate, Hassocks, West Sussex, BN6 9ZF",
    "phone": "07733 165821",
    "email": "tania205c@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "Text night before. Upstairs\nwindows + front door\n(apartment).",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS34945073",
    "name": "Sean McVeigh",
    "address": "1 Pangdene Close, Burgess Hill, West Sussex, RH15 9US",
    "phone": "07941 275728",
    "email": "admin.pangdene@mencap.org.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "Window Clean \u00a328",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS78179683",
    "name": "Yvette Clapperton",
    "address": "43 Royal George Road, Burgess Hill, West Sussex, RH15 9SB",
    "phone": "07936 388822",
    "email": "yvetteclapperton@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "Driveway should be clear to park",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS51441401",
    "name": "Steph Illingworth",
    "address": "56a Folders Lane, Burgess Hill, West Sussex, RH15 0DX",
    "phone": "07787 826335",
    "email": "stephillingworth66@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "We are at the end of a long drive when you get to the bottom it\u2019s the house in the right over a small bridge.\nI would like the insides done if possible less frequent but when you can fit it in thanks",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS79931028",
    "name": "Caroline Robinson",
    "address": "4 Turnberry Way Hassocks",
    "phone": "07780834691",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 15.0
  },
  {
    "id": "CUS15260935",
    "name": "Shannon Pentecost",
    "address": "64 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PH",
    "phone": "07983 634024",
    "email": "spentecost75@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS54797672",
    "name": "Tom McNaughton",
    "address": "24 Benjamin Way, Burgess Hill, Sussex, RH15 0FG",
    "phone": "07777758416",
    "email": "tomzofmcnaughton@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS49922031",
    "name": "Alison",
    "address": "49 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AD",
    "phone": "07419335104",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP CASH",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "notes": "2 small gf windows, you have to go in neighbours alley, no need to knock",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS41966257",
    "name": "Sean Leahy",
    "address": "15 Farm Cl, Hassocks BN6 8PJ, UK",
    "phone": "+44 7548 237171",
    "email": "teresaseanleahy13@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Inc garage windows\n\nCASH \u00a320",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS44828518",
    "name": "Wayne Jones",
    "address": "5 Nevill Place, Hassocks, West Sussex, BN6 8FU",
    "phone": "07764 946558",
    "email": "waynehjones31@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS2370479",
    "name": "Jenny Barrie",
    "address": "Flat 8, Dunstall Lodge, 29 Kilnwood Avenue, Burgess Hill, West Sussex, RH15 0ZD",
    "phone": "07521 645211",
    "email": "jenbarrie@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "Go down kilnwood av, it\u2019s the block of flats on the left as you go round the corner, just the back, windows highlighted",
    "jobCount": 1,
    "totalSpent": 17.5
  },
  {
    "id": "CUS51765614",
    "name": "Laurence Ramsey",
    "address": "6 Goldcrest Dr, Hassocks BN6, UK",
    "phone": "07739 187259",
    "email": "laurencejramsey59@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 26.4
  },
  {
    "id": "CUS63035797",
    "name": "Sandra Moisy",
    "address": "1 Hoadley Avenue, Burgess Hill, RH15 0RG",
    "phone": "+44 7792 044690",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.8
  },
  {
    "id": "CUS87615318",
    "name": "Lynda Brown",
    "address": "4 Griffin House, 104 Cants Lane, Burgess Hill, West Sussex, RH15 0LS",
    "phone": "07706 985683",
    "email": "lynda.s.brown@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "Our flat is first floor on the right as you look at the building. There are two windows and the Juliette balcony at the front, a window at the side and then three windows round the back.\n\nYou will have to turn the head 90 degrees to fit through the railings",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS51876744",
    "name": "Sophie Macdonald",
    "address": "2 Oakfield Lane, Plumpton Green, Lewes, Sussex, BN7 3FF",
    "phone": "07378 882286",
    "email": "soph.m.macdonald@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before. Not\nthe conservatory.",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS36225353",
    "name": "Marie Spence",
    "address": "14 Priory Rd, Hassocks BN6 8PS, UK",
    "phone": "+44 7966 722449",
    "email": "Marie.d.spence@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.8
  },
  {
    "id": "CUS60788231",
    "name": "Rachel Godfrey",
    "address": "8 Cedar Cl, Burgess Hill RH15 8EJ, UK",
    "phone": "07872 615070",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Reverse park where the directions take you, make sure you click the address and then click coordinates",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS46071154",
    "name": "Anika Joshi",
    "address": "38 Valebridge Road, Burgess Hill, West Sussex, RH15 0QY",
    "phone": "07593 801184",
    "email": "anikashah@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-11-18",
    "nextDue": "2026-02-06",
    "notes": "Cash \u00a330, go on next doors drive to the right to get the side window done, move the bins and brick to open the gate, return them when you leave",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS7863629",
    "name": "Chris Holden",
    "address": "138 Mill Road, Burgess Hill, West Sussex, RH15 8BZ",
    "phone": "07825138749",
    "email": "chrisholden25@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "Text night before. Include\none dormer, include one\nvelux. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS16817602",
    "name": "Nicky Moxham",
    "address": "10 Holmesdale Road, Burgess Hill, West Sussex, RH15 9JR",
    "phone": "07518 899230",
    "email": "nicolamoxham1@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS7267653",
    "name": "Claire Ellis",
    "address": "1 Reeves Mead, Burgess Hill, RH15 0YR",
    "phone": "07525 160420",
    "email": "claireellis0@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS37610015",
    "name": "Lynda Stevens",
    "address": "41 Clifton Road, Burgess Hill, West Sussex, RH15 8US",
    "phone": "07845918672",
    "email": "l-stevens@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS8438520",
    "name": "Charlie Gorton",
    "address": "29 Leigh Meadow, Burgess Hill Rh15 0yp",
    "phone": "07765 408637",
    "email": "gorton92@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS5820085",
    "name": "Naomi Mattock",
    "address": "7 Haynes Way, Pease Pottage, Crawley, West Sussex, RH11 9GB",
    "phone": "07552 879599",
    "email": "ayres181@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Pease Pottage",
    "assignee": "Dan",
    "services": "Window Clean - Flat",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS96087281",
    "name": "Rachel Roberts",
    "address": "2 Pondside, Haywards Heath, West Sussex, RH16 4TH",
    "phone": "07967 738905",
    "email": "rroberts86@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS76149472",
    "name": "Midge Cann",
    "address": "8 Pinehurst, Burgess Hill, West Sussex, RH15 0DQ",
    "phone": "07759 692168",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "notes": "\u00a325 cash",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS79848153",
    "name": "Joan Aylett",
    "address": "7 Wingle Tye Rd, Burgess Hill RH15 9HR, UK",
    "phone": "07891978285",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 107.5
  },
  {
    "id": "CUS95016817",
    "name": "Alan",
    "address": "15 SUNNINGDALE ROAD HASSOCKS",
    "phone": "07557277747",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "Drive round and park on his drive, do this house and no19",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS5019961",
    "name": "Chris Owen",
    "address": "23 Aphrodite Way, Burgess Hill RH15 0XQ, UK",
    "phone": "07908 682996",
    "email": "lutefisk73@gmail.com",
    "state": "active",
    "balance": 30.36,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "Park in the carpark on the left and pull the hose round to the front to do 23 and 27 then back round to the carpark to access the rears",
    "jobCount": 1,
    "totalSpent": 25.3
  },
  {
    "id": "CUS1656778",
    "name": "Helen Valler",
    "address": "1 Longhurst, Burgess Hill, West Sussex, RH15 0TG",
    "phone": "07887 857141",
    "email": "helenvaller@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS72556023",
    "name": "Louise Beale",
    "address": "9 Macnaughton Avenue, Pease Pottage, Crawley, West Sussex, RH11 9UH",
    "phone": "07497 513946",
    "email": "louisebeale66@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Pease Pottage",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS594229",
    "name": "Ashly Lewis",
    "address": "134 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "phone": "07973 789738",
    "email": "ashly@brightonbotanical.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-11",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS7554293",
    "name": "Marie Murray",
    "address": "7 Orchard Lane, Hassocks, West Sussex, BN6 8QE",
    "phone": "07732 003925",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "Price does not include the conservatory or the difficult to get to bathroom window above the door. They do have the conservatory cleaned occasionally.\n\nGet to the bathroom if you can",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS98419122",
    "name": "Nick",
    "address": "4 Capenors, Burgess Hill, West Sussex, RH15 9QL",
    "phone": "+44 7967 384025",
    "email": "Losgriffo@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS72183855",
    "name": "Caroline McCarthy",
    "address": "1 Duke of York Cottages, London Road, Sayers Common, Hassocks, West Sussex, BN6 9HY",
    "phone": "07720 885320",
    "email": "carolinejmc@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "New**text night before. Include\nbrick built office on back\nof garage. Not the\nsummer house. Pay by\ncard link. (This property is\nopposite North Star Car\nSales, next door but one\nto the pub. Please tap on\ndoor when arriving.",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS5842484",
    "name": "Gordon  McHattie",
    "address": "71 Chestnut Drive, Hassocks, West Sussex, BN6 8AZ",
    "phone": "07939 203393",
    "email": "sirgold27@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "clean Front \nonly. Include front dormer. \nPay by GoCardless. \nOccasionally will ask you to \ndo the rear as well which \nincludes the rear windows \nand easy conservatory roof \nfor extra \u00a350. Charge extra \n\u00a35 on first clean for the \nfront and an extra \u00a310 on \nfirst clean for the rear. \n(Access to rear through \nhouse - hard floors and he \nwill remove rug)",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS32532876",
    "name": "Pete",
    "address": "Homeland, Reeds Lane, Sayers Common, Hassocks, West Sussex, BN6 9JQ",
    "phone": "01273 835 769",
    "email": "psr@homelands1.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS88089435",
    "name": "Sue Summers",
    "address": "2 Chestnut Close, Burgess Hill, West Sussex, RH15 8HN",
    "phone": "07522\n907475",
    "email": "sue.summers2@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "\"Text night before. Include garage windows but not the rear garage\ndoor. Pay by card link.\"",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS60992830",
    "name": "Nazma Rahman",
    "address": "8 Bedelands Close, Burgess Hill, West Sussex, RH15 8BL",
    "phone": "07925950350",
    "email": "nazma0506@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-04-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.1
  },
  {
    "id": "CUS18807827",
    "name": "Gael",
    "address": "5 Pepper Drive, Burgess Hill, RH15 9UZ",
    "phone": "+44 7860 938573",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2022-02-22",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS67061718",
    "name": "Emily Hudson",
    "address": "8 The Wickets, Burgess Hill, West Sussex, RH15 8TG",
    "phone": "07532 290198",
    "email": "emily.rose.hudson@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS41479539",
    "name": "Becci Instrell",
    "address": "7 Norman Road, Burgess Hill, West Sussex, RH15 9BX",
    "phone": "07475\n938542",
    "email": "becciinstrell89@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Text night before. Pay\nby card link",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS58886282",
    "name": "Jorge Jacob",
    "address": "134 Unicorn Way, Burgess Hill, West Sussex, RH15 0WB",
    "phone": "07425334276",
    "email": "jorgeamjacob@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 32.5
  },
  {
    "id": "CUS25844309",
    "name": "Michelle Andrew",
    "address": "Dillions, Portland Road, Burgess Hill, West Sussex, RH15 9RL",
    "phone": "07815\n686974",
    "email": "michelleandrew62@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS5935157",
    "name": "Laura Savage",
    "address": "62 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TA",
    "phone": "07948 604972",
    "email": "laurakates@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-04-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS40957905",
    "name": "Sharon Kidner",
    "address": "16 Oathall Avenue, Haywards Heath, West Sussex, RH16 3EU",
    "phone": "",
    "email": "sharonkidner@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-05-15",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS40226441",
    "name": "Stephen Dando",
    "address": "37 Wilderness Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9XD",
    "phone": "07796 130355",
    "email": "sdandofandf@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Need a ladder to climb to reach the window one the side",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS86285624",
    "name": "Robert Monk",
    "address": "20 Malthouse Lane, Burgess Hill, West Sussex",
    "phone": "07749 226062",
    "email": "roberttalisman@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS98414334",
    "name": "Trudi Bubb",
    "address": "38 Beacon Crescent, Burgess Hill, West Sussex, RH15 0ZL",
    "phone": "07946431477",
    "email": "trudimbubb@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Garage Window",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "Text night before.\nInclude garage door\nand window. Access\nto rear garden via\ngarage. If customer is\nnot home neighbour\nin house with\nadjoining garage will\nhave garage key. Pay\nby card link",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS82231403",
    "name": "Georgia Henry",
    "address": "1 Larkspur Drive, Burgess Hill, RH15 0UL",
    "phone": "07939228927",
    "email": "gkaramichali@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS86281054",
    "name": "Oliver Clark",
    "address": "69 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "phone": "07478 801552",
    "email": "oliver.clark5015@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS56415738",
    "name": "Nicola Dawson",
    "address": "63 Ockley Way, Hassocks, West Sussex, BN6 8NF",
    "phone": "07557 887639",
    "email": "nick.dawson1967@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 21.0
  },
  {
    "id": "CUS55904933",
    "name": "Alan",
    "address": "69 Hammonds Ridge, Burgess Hill, RH15 9QW",
    "phone": "07703 595366",
    "email": "alandeacon@btopenworld.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "Inc velux above the garage",
    "jobCount": 1,
    "totalSpent": 24.2
  },
  {
    "id": "CUS98176914",
    "name": "Sue Smith",
    "address": "4 Abbots Close, Hassocks, West Sussex, BN6 8PH",
    "phone": "07941 255254",
    "email": "suedaveysmith@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS45940050",
    "name": "Kat Murphy",
    "address": "26 Courtlands, Haywards Heath, West Sussex, RH16 4JD",
    "phone": "+44 7515 444768",
    "email": "katmurphy1989@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean,Cladding Clean",
    "frequency": "Ad hoc",
    "lastDone": "2024-12-11",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 160.0
  },
  {
    "id": "CUS66830103",
    "name": "Stuart Wallis",
    "address": "1 Oakfield Lane, Plumpton Green, Lewes, Sussex, BN7 3FF",
    "phone": "07557 048082",
    "email": "stuart.wallis1977@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Facia soffit & gutter wash,Cladding Clean",
    "frequency": "Ad hoc",
    "lastDone": "never",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 25.83
  },
  {
    "id": "CUS77742612",
    "name": "Kaye Hunt",
    "address": "9 The Willows, Burgess Hill, West Sussex, RH15 8HU",
    "phone": "07885180846",
    "email": "hunt_kaye@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Access to rear garden via Rear garden gate",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS34824291",
    "name": "Amber Tweedy",
    "address": "79 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07475175984",
    "email": "amberlou2000@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-10",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS42820539",
    "name": "Liz",
    "address": "108 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "phone": "07702641628",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 97.5
  },
  {
    "id": "CUS58548834",
    "name": "Matthew",
    "address": "1 Cross Cottages, Cuckfield Road, Ansty, Haywards Heath, West Sussex, RH17 5AG",
    "phone": "+447544752115",
    "email": "matbid7@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window clean inc velux,Conservatory Roof Clean",
    "frequency": "Ad hoc",
    "lastDone": "2024-12-16",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 150.0
  },
  {
    "id": "CUS49954735",
    "name": "Nathan Taylor",
    "address": "Truslers, Truslers Hill Lane, Albourne, Hassocks, West Sussex, BN6 9DT",
    "phone": "07970 010279",
    "email": "na_taylor@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-10",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 253.32999999999998
  },
  {
    "id": "CUS94369666",
    "name": "Becky Coleman",
    "address": "110 Iden Hurst, Hurstpierpoint, Hassocks, West Sussex, BN6 9YJ",
    "phone": "07963071311",
    "email": "becky.coleman@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2024-06-21",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 110.0
  },
  {
    "id": "CUS56609898",
    "name": "Margaret Railton",
    "address": "11 Ferndale Road, Burgess Hill, West Sussex, RH15 0HQ",
    "phone": "07848\n002990",
    "email": "antandmoggs@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-03",
    "nextDue": "2026-02-23",
    "notes": "\"Text night before. Not the conservatory. Pay by card link. Can the second clean be one week early (w/c 10th November) as the have\na wedding on Monday 17th Nov at their house.\"",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS50545136",
    "name": "Sandy Middlebrook",
    "address": "4 The Close, Burgess Hill, West Sussex, RH15 0PR",
    "phone": "07971 085045",
    "email": "sandymiddlebrook83@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Text night before. Front\nonly. Knock first and if\ncan do whole house\ncharge \u00a323. Pay by\ncard link.",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS64720712",
    "name": "Lorraine",
    "address": "50 Stonepound Road, Hassocks, West Sussex, BN6 8PR",
    "phone": "07766 661 585",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Bungalow all windows",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS72331011",
    "name": "Lisa Burstow",
    "address": "6 Benjamin Way, Burgess Hill, RH15 0FG",
    "phone": "07974 353783",
    "email": "jeffmac18@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-02-17",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.3
  },
  {
    "id": "CUS17187316",
    "name": "Ron And Joy",
    "address": "30 Junction Road, Burgess Hill, West Sussex, RH15 0JN",
    "phone": "01444 235 698",
    "email": "ronsharp30@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Flat roof will need ladder",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS2130144",
    "name": "Chris Duddridge",
    "address": "Woodbarton Cottage, Ditchling Common, Ditchling, Hassocks, West Sussex, BN6 8TP",
    "phone": "07990 139159",
    "email": "christopherjduddridge@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "To get to the house, drive to the bottom of Folders Lane, turn right and then take an immediate right turn, 360 garden so can access rear of property freely.",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS11452839",
    "name": "Georgina",
    "address": "8 Five Oaks Way, Hassocks, BN6 9ZU",
    "phone": "+44 7746 351356",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "Inc garage windows and doors (in the garden) and the the white arm on the veranda, clean the back of it too",
    "jobCount": 2,
    "totalSpent": 66.0
  },
  {
    "id": "CUS93640677",
    "name": "Sophie Peskett",
    "address": "60 Curf Way, Burgess Hill RH15 0GE, UK",
    "phone": "07771 364711",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "You need long pole for 60,58,54",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS58458059",
    "name": "MrBrown",
    "address": "40 Midfields Drive, Burgess Hill, West Sussex, RH15 8EN",
    "phone": "07729674901",
    "email": "dickie.brown@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Not the\nconservatory. If customer\noccasionally wants\nconservatory done charge\nextra \u00a310. Preferably pay\nby cash (if ever a problem\nhe will set up card link). \u00a327",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS58754241",
    "name": "Nigel Shapiro",
    "address": "14 Unicorn Way, Burgess Hill, West Sussex, RH15 0UU",
    "phone": "07884041106",
    "email": "nigel@rcl2260.com",
    "state": "active",
    "balance": 29.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS67884642",
    "name": "Brendan  Sherwood",
    "address": "6 Manor Avenue, Hassocks, West Sussex, BN6 8NG",
    "phone": "07419 762762",
    "email": "brendan@sherwoods.org",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Text night before. Include 1 \nx velux (best you can) and \nthe extension. Not the \nlantern.",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS87240658",
    "name": "Fiona Ahlrichs",
    "address": "9 Rolfe Drive, Burgess Hill, West Sussex, RH15 0LA",
    "phone": "07795 508899",
    "email": "fi.ahlrichs@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 38.0
  },
  {
    "id": "CUS94435402",
    "name": "Leslie Orams",
    "address": "27 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BE",
    "phone": "07979 002909",
    "email": "lesoram@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS79332822",
    "name": "Ena Barron",
    "address": "14 Potters Lane, Burgess Hill, RH15 9HY",
    "phone": "01444 235023",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Text night before. If\ncustomer is not home,\nhand over gate and\nunbolt. Include 1 velux.\nCustomer would like to\npay cash \u00a321 as she is\npartially sighted and\ncould not manage card\nlink. CASH IN GARDEN",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS42888639",
    "name": "Claudine Lower",
    "address": "The Old Coach House, London Road, Sayers Common, Hassocks, West Sussex, BN6 9HY",
    "phone": "+44 7877 715782",
    "email": "claudinelower@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS24954289",
    "name": "Carolyn Todd",
    "address": "41 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07966 970942",
    "email": "carolynann526@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS73335910",
    "name": "Thelma Keating",
    "address": "27 Sunningdale Road, Hassocks, Sussex, BN6 9QQ",
    "phone": "07712 670611",
    "email": "thelma.keating65@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS24534254",
    "name": "Sallie White",
    "address": "27 Friars Oak Rd, Hassocks BN6 8PU, UK",
    "phone": "07884 426938",
    "email": "salliew@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS74614845",
    "name": "Heather",
    "address": "12 Downs View Rd, Hassocks BN6 8HJ, UK",
    "phone": "07733466585",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS36721675",
    "name": "Kirstyn Box",
    "address": "11 Barley Croft The Street, Albourne, Hassocks, BN6 9DN",
    "phone": "07720866145",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers No Email",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-11-18",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.0
  },
  {
    "id": "CUS65145749",
    "name": "Sue Prevett",
    "address": "Wych Cottage, Orchard Way, Warninglid, Haywards Heath, West Sussex, RH17 5ST",
    "phone": "+447753821135",
    "email": "mrs.prevett@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS44548900",
    "name": "Michael Collison",
    "address": "9 Ferndale Road, Burgess Hill, West Sussex, RH15 0HQ",
    "phone": "07850985544",
    "email": "mike@skjc.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS1839822",
    "name": "Jane",
    "address": "6 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "phone": "07921 851 394",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-11",
    "notes": "Front only 3 windows.",
    "jobCount": 1,
    "totalSpent": 12.5
  },
  {
    "id": "CUS38761887",
    "name": "Norma",
    "address": "3 West View Cottages, Lewes Road, Lindfield, Haywards Heath, West Sussex, RH16 2LJ",
    "phone": "+44 7495 640782",
    "email": "norma_nell@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-04-03",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 48.0
  },
  {
    "id": "CUS96200804",
    "name": "Lara Thwaites",
    "address": "7 Gatehouse Lane, Burgess Hill, West Sussex, RH15 9XB",
    "phone": "07922 806262",
    "email": "thwaitesss@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "notes": "Text night before.\nDirections. House\nnumber on gatepost. Pay\nby card link.",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS93799631",
    "name": "Lisa Ives",
    "address": "20 Five Oaks Way, Hassocks, BN6 9ZU",
    "phone": "07922882728",
    "email": "lisasavage@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 18 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-05-15",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS91294237",
    "name": "Sonia Nicholson",
    "address": "13 Iden Hurst, Hurstpierpoint, Hassocks BN6 9XZ, UK",
    "phone": "07973600749",
    "email": "as.nicholson@uwclub.net",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-12-05",
    "nextDue": "",
    "notes": "",
    "jobCount": 3,
    "totalSpent": 214.7
  },
  {
    "id": "CUS61848744",
    "name": "David Sayers",
    "address": "17 Victoria Close, Burgess Hill, West Sussex, RH15 9QS",
    "phone": "07711 102297",
    "email": "david.sayers64@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS14709476",
    "name": "Diana D'Alquen",
    "address": "26 Granville Drive, Hassocks, West Sussex, BN6 8GP",
    "phone": "07931 856811",
    "email": "dnfa@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS29955321",
    "name": "Kevin Lee",
    "address": "18 The Sycamores, Sayers Common, Hassocks, BN6 9XP",
    "phone": "07726 411708",
    "email": "kerbin1958@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Cash",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Cash, include velux at the back, cash left on the garden by pot by backdoor",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS88732066",
    "name": "Paul Browne",
    "address": "10 Wheelwright Lane, Burgess Hill, West Sussex, RH15 0QL",
    "phone": "07871509355",
    "email": "pgbrowne@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS83574553",
    "name": "Alex Simms",
    "address": "9 Southdowns, Plumpton Green, Lewes, East Sussex, BN7 3EB",
    "phone": "07941 827614",
    "email": "alexsimms1983@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before.\nInclude 5 x velux, rear\ndormer and extension.\nAccess to rear through\nnumber 10 garden (has\nright of way). Pay by\ncard link",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS90579549",
    "name": "Lesley",
    "address": "5 Randiddles Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9BG",
    "phone": "07743478681",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-12-13",
    "nextDue": "2026-02-11",
    "notes": "Gf windows only at the back",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS82371985",
    "name": "Kerry Lingard",
    "address": "49 Hazel Grove, Burgess Hill, RH15 0BZ",
    "phone": "07956 669300",
    "email": "kerrylingard@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-10",
    "notes": "MAKE LAST APPOINTMENT AS SHE WORKS SHIFTS",
    "jobCount": 2,
    "totalSpent": 153.0
  },
  {
    "id": "CUS31841413",
    "name": "Katherine  Cotterell",
    "address": "2 The Close, Hassocks, West Sussex, BN6 8DN",
    "phone": "07515 119096",
    "email": "katcotters@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2024-11-25",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 133.0
  },
  {
    "id": "CUS91030301",
    "name": "Helena King",
    "address": "Hickstead Lodge Cattery Hickstead Westside  Hickstead Haywards Heath West Susse, Westside, London Road, Hickstead, Haywards Heath, West Sussex, RH17 5LZ",
    "phone": "07763 690162",
    "email": "helena.m.king@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hickstead",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS32996771",
    "name": "Faye Wright",
    "address": "1 Woodpecker Close Sayers Common, Hassocks West sussex BN6 9HU",
    "phone": "07581 421947",
    "email": "fayecwright@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS67042611",
    "name": "Alan Burgess",
    "address": "15 Heron Close,Sayers common",
    "phone": "07960 028961",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers No Email",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.0
  },
  {
    "id": "CUS84123365",
    "name": "Hannah Morris",
    "address": "1 Singleton Way, Burgess Hill RH15 0BU, UK",
    "phone": "07445617550",
    "email": "hannahmorrisx99@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 8 weeks on Tuesday",
    "lastDone": "2025-10-21",
    "nextDue": "2026-02-10",
    "notes": "Inc veluxes at the front",
    "jobCount": 1,
    "totalSpent": 19.8
  },
  {
    "id": "CUS19202980",
    "name": "Hugh Wright",
    "address": "25 Chichester Way, Burgess Hill, West Sussex, RH15 0RH",
    "phone": "07595 984760",
    "email": "2e0hmw@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Text night before. Not the\ngarage. O.K. to access the\nrear garden via the garage\nif unlocked and customer is\nout. If garage is locked\naccess rear garden by\nsqueezing down the side of\nthe garage. Pay by card Link",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS11093132",
    "name": "Tony Westgarth",
    "address": "14 Beaconsfield Close, Burgess Hill, West Sussex, RH15 9AT",
    "phone": "07802\n243625",
    "email": "tonywestgarth55@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Text night before. Please keep garden gate closed ref dog.",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS24410942",
    "name": "Daniel Cooper",
    "address": "9 Bolnore Road, Haywards Heath, West Sussex, RH16 4AB",
    "phone": "07360 349282",
    "email": "danielcooper78@mac.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS30244994",
    "name": "Julie Dolan",
    "address": "6 Broad Green Avenue, Burgess Hill, West Sussex, RH15 0HA",
    "phone": "07544 573925",
    "email": "julieandrichard.dolan@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS37421337",
    "name": "Rob",
    "address": "20 Beaconsfield Close, Burgess Hill, West Sussex, RH15 9AT",
    "phone": "07791 188497",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-04-30",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 48.0
  },
  {
    "id": "CUS59408338",
    "name": "Jeanette",
    "address": "2 London Rd, Hassocks BN6 9NT, UK",
    "phone": "07759066125",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 4 weeks on Wednesday",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-04",
    "notes": "Pays CASH, knock the door",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS7828199",
    "name": "Ian Riley",
    "address": "Nenian, Colwell Road, Haywards Heath, West Sussex, RH16 4HD",
    "phone": "+44 7549 498067",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2024-12-19",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS27579434",
    "name": "Grace",
    "address": "35 The Fairway, Hassocks, Sussex, BN6 9JU",
    "phone": "+44 7970 160414",
    "email": "grace_baroni@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Garage door clean",
    "frequency": "Ad hoc",
    "lastDone": "2023-08-14",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 32.0
  },
  {
    "id": "CUS9302826",
    "name": "Emma Day",
    "address": "93 Fairfield Road, Burgess Hill, RH15 8NP",
    "phone": "07958 807558",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "Park outside the front of the house and do the front, park on the path opposite if no spaces, you will literally be 5 mins then turn on to at Mary's road to access the back, it's the small gate furtherest away down the path\nH",
    "jobCount": 2,
    "totalSpent": 99.0
  },
  {
    "id": "CUS11493229",
    "name": "Krissie Boreczek",
    "address": "41 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BH",
    "phone": "07708 299146",
    "email": "c.baillieb@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "Text night before.\nInclude 2 x dormers and\none window on\nextension. Not the 2\ninaccessible windows on\nextension. Pay by card\nlink.",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS11819818",
    "name": "Vanessa Edwards",
    "address": "16 Mill Rose Way, Burgess Hill RH15 0ZG, UK",
    "phone": "07999 627772",
    "email": "vr.edwards68@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "This one park on the path as you go around the bend and do the front then move the van through the opening to the carpark to do the back, it's the second gate from the left",
    "jobCount": 2,
    "totalSpent": 56.5
  },
  {
    "id": "CUS38367461",
    "name": "Georgia Caudell",
    "address": "6 Turnbury Hassocks BN6",
    "phone": "+44 7515 558280",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "Do this and the house opposite no 5 and 6",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS81145659",
    "name": "Anna Judson",
    "address": "40 Wentworth Road, Hassocks, BN6 9SQ",
    "phone": "07583 109456",
    "email": "annajudson@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-04-02",
    "notes": "There's Windows on the right hand side of the house\n\nCode 4068",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS1158578",
    "name": "Emily",
    "address": "48 Weald Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9SR",
    "phone": "07723220559",
    "email": "emilymelissa93@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS73489435",
    "name": "Michele",
    "address": "24 Bastable Street, Crawley, Sussex, RH10 2AB",
    "phone": "+447456007230",
    "email": "mstuk_316@msn.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Forgewood",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-04-08",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS7136530",
    "name": "Isabella Phillips",
    "address": "10 Pegasus Place, Burgess Hill, RH15 0XB",
    "phone": "07795572622",
    "email": "",
    "state": "active",
    "balance": 19.8,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS22437384",
    "name": "Maria Crudge",
    "address": "21a Ferndale Road, Burgess Hill, West Sussex, RH15 0HB",
    "phone": "07887\n631007",
    "email": "mcrudge@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-01",
    "nextDue": "2026-02-25",
    "notes": "\"Text night before. First clean NOT Thursday. Include the two windows over conservatory (will need ladder). Please use left hand side gate (if looking at house).\nPay by card link. NB\"",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS14008942",
    "name": "Emily",
    "address": "7 Siskin Close, Burgess Hill, RH15 9DH",
    "phone": "07795522666",
    "email": "ejbosullivan@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "This one park in the layby on linet lane, then 7 and 9 are along the path that goes straight down, all normal pole, check pics attached to confirm parking location, clean glass only balcony",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS76360261",
    "name": "Isvett Fernandez",
    "address": "46 Hassocks Gate, Hassocks, BN6 9ZF",
    "phone": "07513 399638",
    "email": "isvett.fernandez@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS52617048",
    "name": "Susanne",
    "address": "10 Bankside, Hassocks BN6 8EL, UK",
    "phone": "07740 648160",
    "email": "susanne.c.bell@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS1827331",
    "name": "Louise Garcia",
    "address": "17 Bonnet Ln., Burgess Hill RH15, UK",
    "phone": "+44 7748 377454",
    "email": "louise.garcia@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "Include all veluxes etc, use long pole for this but change the brush head to the white one on the short pole",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS84811498",
    "name": "Neil McColl",
    "address": "11 The Wickets, Burgess Hill, West Sussex, RH15 8TG",
    "phone": "07742 033353",
    "email": "neil.c.maccoll@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS16056690",
    "name": "Lorna Lindo",
    "address": "16 Meadow Lane, Burgess Hill",
    "phone": "07971 819886",
    "email": "lornolindo@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-04-20",
    "notes": "Text night before. Include\ndormer. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 21.67
  },
  {
    "id": "CUS50757145",
    "name": "Krzysia Terlecki",
    "address": "25 Woodpecker Crescent, Burgess Hill, West Sussex, RH15 9XY",
    "phone": "07702 742859",
    "email": "krzysia1957@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "Garden through the house. 7591 is the code for the key box by the porch if no one home",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS3436082",
    "name": "Tracey Read",
    "address": "4 Dukes Barn Mews, Lindfield, Haywards Heath, West Sussex, RH16 2GD",
    "phone": "+447821804517",
    "email": "tracey.read28@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Lindfield",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS18217868",
    "name": "Daisy Marchant",
    "address": "54 Western Road, Burgess Hill, West Sussex, RH15 8QN",
    "phone": "+447500184839",
    "email": "daisy.marchant@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS88807821",
    "name": "Katie Bird",
    "address": "21 Fitzalan Mead, Hassocks, West Sussex, BN6 8FY",
    "phone": "+447946513845",
    "email": "katieb1982@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS74580777",
    "name": "Laura  Rochford",
    "address": "60 Ockley Way, Hassocks, BN6 8NF",
    "phone": "07736350979",
    "email": "laurarochford07@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Text night before. \nInclude 2 velux.\n\nFill up after",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS63352982",
    "name": "Karen Rash",
    "address": "30 Dale Ave, Keymer, Hassocks BN6 8LP, UK",
    "phone": "07795 573320",
    "email": "rashbyname@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS11280421",
    "name": "Hazel Fordham",
    "address": "8 Wisden Avenue, Burgess Hill, West Sussex, RH15 8TL",
    "phone": "07880 644833",
    "email": "hazel_mck@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS18893531",
    "name": "Jean",
    "address": "19 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "phone": "07908 951788",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS26414848",
    "name": "Tanya Lyons",
    "address": "16 Penn Crescent, Haywards Heath, West Sussex, RH16 3HN",
    "phone": "+447469210661",
    "email": "tanyascorse@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-11-27",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS4939281",
    "name": "Yvonne Hennessy",
    "address": "24 Beacon Road, Ditchling, Hassocks, West Sussex, BN6 8UL",
    "phone": "07979 083709",
    "email": "yvonnehennessy1@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean every 12 weeks",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-18",
    "notes": "To access number 24 you need to drive down the RIGHT side driveway at number 22. \nThe customer has asked please:\n*To not park/turn around on number 22's tarmacked area (they will complain)\n*To park right up the drive of number 24, plenty of space to park",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS53036375",
    "name": "Carolann Mitchell",
    "address": "64 Adastra Avenue, Hassocks, West Sussex, BN6 8DR",
    "phone": "07904 188725",
    "email": "carolannmitchell66@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Conservatory Roof Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-03-17",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 0.0
  },
  {
    "id": "CUS69044253",
    "name": "Kelly Rose",
    "address": "77 Janes Lane, Burgess Hill, West Sussex, RH15 0QP",
    "phone": "+44 7791 722255",
    "email": "kellytamsinrose@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-04-17",
    "notes": "Knock to get acces to upstairs balcony",
    "jobCount": 2,
    "totalSpent": 85.33
  },
  {
    "id": "CUS4611146",
    "name": "Sue O'Connor",
    "address": "11 The Saffrons, Burgess Hill, RH15 8TB",
    "phone": "07912 567228",
    "email": "susan.oconnor12@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Inc con",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS18314334",
    "name": "Sam",
    "address": "3 Hassocks Gate, Hassocks BN6, UK",
    "phone": "07957591752",
    "email": "Threehassocksgate@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS83169903",
    "name": "Pamela Reeves",
    "address": "1a Clayton Avenue, Hassocks, West Sussex, BN6 8HB",
    "phone": "07931 289716",
    "email": "p2reeves@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Text night before. Include\nconservatory. Not the front\nbalcony windows. Side\nwindows above garage do\nif you can but shes not\nexpecting you to. Side gate\n- lean over and hand\nthrough gate to unlock 2 x Bolts",
    "jobCount": 1,
    "totalSpent": 44.0
  },
  {
    "id": "CUS28451423",
    "name": "Margaret Fahey",
    "address": "28 St Mary's Rd, Burgess Hill RH15 8NU, UK",
    "phone": "01444 235219",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-10-16",
    "nextDue": "2026-02-16",
    "notes": "PAYS CASH SO KNOCK THE DOOR AFTER\n\nShe is going out at 0950 so if you get there after the money will be left under the watering can in the garden \ud83d\udc4d\ud83c\udffc\n\nLONG POLE",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS81955246",
    "name": "Zoe",
    "address": "2 Foxhole Cottages, Bedlam Street, Hurstpierpoint, Hassocks, West Sussex, BN6 9EL",
    "phone": "07860 643151",
    "email": "zoebenham1@virginmedia.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS18738348",
    "name": "Sarah Barnett",
    "address": "4 Pegasus Place, Burgess Hill, West Sussex, RH15 0XB",
    "phone": "07733135384",
    "email": "sarahbarnett14@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS80014443",
    "name": "Will Entwistle",
    "address": "57 Parklands Road, Hassocks, West Sussex, BN6 8JY",
    "phone": "07568168753",
    "email": "willwentwistle@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "Text night before. Access\nrear garden via Age\nConcern car park, house\nno. on wooden gate. Pay\nby cardlink.",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS66650064",
    "name": "David Hook",
    "address": "14 Abbots Close, Hassocks, West Sussex, BN6 8PH",
    "phone": "07717585360",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan, Steve",
    "services": "Gutter Clearance",
    "frequency": "Ad hoc",
    "lastDone": "2025-09-11",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 127.0
  },
  {
    "id": "CUS8827235",
    "name": "Tamara",
    "address": "39 Kilnwood Avenue, Burgess Hill, West Sussex, RH15 0ZD",
    "phone": "07724 390040",
    "email": "twitriw@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS58649967",
    "name": "Liz Finn",
    "address": "Fermain, Malthouse Lane, Burgess Hill, West Sussex, RH15 9XA",
    "phone": "07759 992837",
    "email": "sandrachamberlain@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "Text night before.\nDirections. Next to\nSevenfields.",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS8114125",
    "name": "Jasmin Dudden",
    "address": "37 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BH",
    "phone": "07794 545515",
    "email": "jasmindudden1991@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "Text night before. Use\nside gate by front door.\nPay by card link. If\nchanges to 12 weekly\nincrease price to \u00a327\n(she has agreed).",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS72041092",
    "name": "Zo Payne",
    "address": "1Fitzalanmead, Fitzalan Mead, Hassocks, West Sussex, BN6 8FY",
    "phone": "07747 195821",
    "email": "zopayne@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS9632287",
    "name": "Lewis Roe",
    "address": "29 Leylands Park, Burgess Hill, West Sussex, RH15 8AQ",
    "phone": "07584\n294349",
    "email": "lewisroe0891@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS26882353",
    "name": "Tanya",
    "address": "56 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07726 174166",
    "email": "tanyasg@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS99145481",
    "name": "Carla Harfield",
    "address": "32 Avenue De Warenne, Hassocks, West Sussex, BN6 8FP",
    "phone": "07754 409313",
    "email": "soft_ferraz@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS24218647",
    "name": "Graham Ketley",
    "address": "Farthings, Station Road, Plumpton Green, Lewes, East Sussex, BN7 3BY",
    "phone": "07801 011818",
    "email": "graham_ketley@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before.\nClean velux as and\nwhen. Customer will\nleave garage unlocked\non receipt of text if not\nhome. Access window\nL.H. side of house from\nneighbours garden\n(see customer). Pay by\ncard link. Dir. opp\nInholmes Cottages",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS61276305",
    "name": "Caroline Davey",
    "address": "67 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RU",
    "phone": "07510\n274557",
    "email": "carrietdavey@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS83902315",
    "name": "Demi Moore",
    "address": "65 St. Andrews Road, Burgess Hill, RH15 0PJ",
    "phone": "07732 789132",
    "email": "demimoore1996@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS94795013",
    "name": "Jenny Sweet",
    "address": "1 Dunlop Close, Sayers Common, Hassocks, BN6 9SL",
    "phone": "01273 831147",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Cash",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Call night before. Include conservatory. \n\nCASH \u00a332",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS94453856",
    "name": "Nick Woodcock",
    "address": "29 Ockenden Way, Hassocks BN6 8HS, UK",
    "phone": "07902 967719",
    "email": "woody2shoes@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean inc Garden Room",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Not the greenhouse extension.",
    "jobCount": 1,
    "totalSpent": 40.8
  },
  {
    "id": "CUS85893950",
    "name": "Elsa",
    "address": "10 Gordon Rd, Burgess Hill RH15 0PX, UK",
    "phone": "07958 591169",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS46820207",
    "name": "Naomi",
    "address": "1 The Fairway, Hassocks, BN6 9JU",
    "phone": "07841528472",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "Do 1and 3 and the house opposite which is no 12",
    "jobCount": 1,
    "totalSpent": 18.0
  },
  {
    "id": "CUS66669247",
    "name": "Ben Graves",
    "address": "108 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AJ",
    "phone": "07932 785478",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS60489889",
    "name": "Tom Burnage",
    "address": "32 Folders Lane, Burgess Hill, West Sussex, RH15 0DR",
    "phone": "07393 894188",
    "email": "tburnage@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "All windows but not any velux. NO FLAT ROOF",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS68524816",
    "name": "James Taylor",
    "address": "53 Kings Dr, Hassocks BN6 8DY, UK",
    "phone": "+44 7973 560320",
    "email": "Daniel.pelling@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS12743310",
    "name": "Nick Johnston",
    "address": "13 Petworth Drive, Burgess Hill, West Sussex, RH15 8JT",
    "phone": "07879 483828",
    "email": "nick@the-johnstons.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-11-07",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS78541588",
    "name": "Ellie",
    "address": "47 Hassocks Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9QL",
    "phone": "07711840925",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-12-13",
    "nextDue": "2026-02-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 45.0
  },
  {
    "id": "CUS30381649",
    "name": "Heber And Ruth",
    "address": "131 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AF",
    "phone": "07719280677",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-08-13",
    "nextDue": "2026-02-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS66327272",
    "name": "Ben",
    "address": "14 Goosefoot Lane, Burgess Hill, RH15 0WT",
    "phone": "+44 7951 660900",
    "email": "bpwwhite@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS61781932",
    "name": "Richard White",
    "address": "29 Janes Lane, Burgess Hill, West Sussex, RH15 0QJ",
    "phone": "07391 641744",
    "email": "rgw_gis@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Text night before. Include 9\nx velux, customer advised\nsome velux may be out of\nreach. Please leave leaflet.\nIf you cannot do velux\nreduce price by \u00a31.50 per\nvelux and let me know and I\nwill reduce the invoice\nvalue.",
    "jobCount": 1,
    "totalSpent": 47.0
  },
  {
    "id": "CUS45214661",
    "name": "Nick Low",
    "address": "5 Stirling Court Road, Burgess Hill, West Sussex, RH15 0PS",
    "phone": "+447450255149",
    "email": "nlow1975@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS99073179",
    "name": "Craig Waller",
    "address": "3 Queens Drive, Hassocks, BN6 8DF",
    "phone": "07986 465759",
    "email": "wadoman@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Include 2 front velux. Include extension. Not the Juliette balcony but include the screen. Not the 2 x velux on the rear extension.",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS27137759",
    "name": "Chris Rogers",
    "address": "9 Romaine Cl, Burgess Hill RH15 0NS, UK",
    "phone": "07801 827543",
    "email": "cjrogers2005@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 31.9
  },
  {
    "id": "CUS53947311",
    "name": "Debbie Murray",
    "address": "125 Leylands Rd, Burgess Hill RH15 8JS, UK",
    "phone": "+44 7976 813657",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-08",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 47.0
  },
  {
    "id": "CUS99025129",
    "name": "Karen Ashworth",
    "address": "3 Maple Close, Burgess Hill, West Sussex, RH15 8HP",
    "phone": "07740 902501",
    "email": "karen@karenashworth.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Text night before. Include\nextension and 1 x velux.",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS76055667",
    "name": "Rachel BartlettBundy",
    "address": "27 The Quadrant, Hassocks, West Sussex, BN6 8BP",
    "phone": "07747 866457",
    "email": "house@bartlettbundy.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "Hi there we\u2019d like to change our window cleaning to just the higher ones at the front and ground floor and side of the house thanks.\nSo no nothing round the back. \nPlease can you start with that from today",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS26891612",
    "name": "Caroline",
    "address": "15 Summerhill Grange, Lindfield, Haywards Heath, West Sussex, RH16 1RQ",
    "phone": "+44 7963 341826",
    "email": "caroline@carolineeagle.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "New",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS1965523",
    "name": "Mark Potter",
    "address": "8 The Pound, Burgess Hill, West Sussex, RH15 8PF",
    "phone": "+447590402064",
    "email": "mark.potter@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS37701990",
    "name": "James Busby",
    "address": "26 Sunningdale Road, Hassocks, Sussex, BN6 9QQ",
    "phone": "07427 903060",
    "email": "jamesbusby22@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "New customer, double rinse all windows and wipe down the sills downstairs fully",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS3927149",
    "name": "Mark Burnham",
    "address": "20 Cromwell Road, Burgess Hill, West Sussex, RH15 8QH",
    "phone": "07432\n866979",
    "email": "markburnham007@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Text night before. Ladder req. Not the lantern",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS4402142",
    "name": "Geraint",
    "address": "1 Cuckfield Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9RP",
    "phone": "07771666877",
    "email": "geztek2@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS14776780",
    "name": "David Butcher",
    "address": "4 Sycamore Way, Hassocks, West Sussex, BN6 8YH",
    "phone": "07834 350101",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "All windows. Go through house to do the back. He\u2019s usually in as he mostly works from home. If not in, Jennifer has a key at no.2",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS6312576",
    "name": "Katie Hinton",
    "address": "27 Petworth Drive, Burgess Hill, West Sussex, RH15 8JT",
    "phone": "07812 009405",
    "email": "katieharris.kh1@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS81755878",
    "name": "Daniel Simpson",
    "address": "68 Folders Lane, Burgess Hill, West Sussex, RH15 0DX",
    "phone": "07974 454491",
    "email": "dansimpson1@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "Text night before. Include\nextension but not the\nJuliette balcony. NOT FRONT DOOR***",
    "jobCount": 1,
    "totalSpent": 38.0
  },
  {
    "id": "CUS46292845",
    "name": "Aaron Turner",
    "address": "138 unicorn way, Burgess hill RH15 0WB",
    "phone": "07403 998371",
    "email": "aaronturner46@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS10124185",
    "name": "Brian Yorke",
    "address": "25 Badgers Walk, Burgess Hill, West Sussex, RH15 0AE",
    "phone": "01444 243555",
    "email": "cally.strevett@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS27821610",
    "name": "Michael Hindmarsh",
    "address": "27 Aphrodite Way, Burgess Hill RH15 0XQ, UK",
    "phone": "07525 841218",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "Park in the carpark on the left and pull the hose round to the front to do 23 and 27 then back round to the carpark to access the rears",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS19299533",
    "name": "Joyce Harvey",
    "address": "25 Capenors, Burgess Hill, RH15 9QL",
    "phone": "07966 393577",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "5374100118534531 08 26 826 Rh15 9ql",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS90538582",
    "name": "Ajibola",
    "address": "5 Turnbury Way Hassocks",
    "phone": "+44 7708 419447",
    "email": "jibolso@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS83130284",
    "name": "Anne Hobbs",
    "address": "21 Perryfields, Burgess Hill, West Sussex, RH15 8TU",
    "phone": "07752 773128",
    "email": "humblist@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS77291277",
    "name": "Hannah Watson",
    "address": "7 Turnbury way hassocks",
    "phone": "07707 057937",
    "email": "Hewatson17@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS81139346",
    "name": "Natalie Pettifer",
    "address": "102 Royal George Road, Burgess Hill, West Sussex, RH15 9SL",
    "phone": "07966 681096",
    "email": "nmpettifer@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS71352836",
    "name": "Tracy Scholfield",
    "address": "12 The Maltings, Burgess Hill, West Sussex, RH15 9XF",
    "phone": "07973774119",
    "email": "tracy.scholfield@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "notes": "Text night before. Include\nconservatory. Please\nknock on door on arrival\nand close gates at all\ntimes to prevent dog\nfrom escaping. Pay by\ncard link.",
    "jobCount": 1,
    "totalSpent": 39.17
  },
  {
    "id": "CUS7454785",
    "name": "Amelie",
    "address": "52 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "phone": "+44 7462 633201",
    "email": "ame.carle@hotmail.fr",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-04-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS18931478",
    "name": "Katy Trigg",
    "address": "8 The Vineries, Burgess Hill RH15 0NF, UK",
    "phone": "07973381917",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS41666130",
    "name": "Tracey Naish",
    "address": "8 The Chestnuts, Sayers Common, Hassocks, BN6 9XJ",
    "phone": "07925 761777",
    "email": "tracey.naish@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Garden is through the gate and right to the end",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS56704696",
    "name": "Molly Williamson",
    "address": "7 Adur Road, Burgess Hill, West Sussex, RH15 0PA",
    "phone": "07896 552493",
    "email": "mollywilliamson@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS20935214",
    "name": "Tony Ramirez",
    "address": "101 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9SY",
    "phone": "07956036649",
    "email": "tony@imagesofpolo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Include\nconservatory and\nextension. Not the two\nwindows above\nextension or the velux. (If\nyou can do these two\nwindows charge extra \u00a33\nbut I dont think you can)\nPay by card link.",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS25013517",
    "name": "Karen",
    "address": "25 Semley Road, Hassocks, West Sussex, BN6 8PD",
    "phone": "07977 027972",
    "email": "kjh1066@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-12-03",
    "nextDue": "2026-02-23",
    "notes": "Front & side only. Access via 27\n\nNOT FRONT DOOR",
    "jobCount": 1,
    "totalSpent": 17.5
  },
  {
    "id": "CUS41892616",
    "name": "Charlotte Baldwin",
    "address": "8 Winifred Ratcliffe Place, Hurstpierpoint, Hassocks, BN6 9FZ",
    "phone": "+44 7753 748847",
    "email": "charlie_ryman@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-09-05",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 77.5
  },
  {
    "id": "CUS78172721",
    "name": "Ray",
    "address": "171 Cuckfield Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9RT",
    "phone": "07947 648467",
    "email": "judy.bowden@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS80401162",
    "name": "Lucy Melling",
    "address": "14 The Fairway, Hassocks, BN6 9JU",
    "phone": "+44 7763 902833",
    "email": "Lucy.Melling@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-04-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS69097589",
    "name": "Dawn Dodd",
    "address": "44 The Hawthorns, Burgess Hill, West Sussex, RH15 8RW",
    "phone": "07811\n327350",
    "email": "dawn.moore@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "Text night before. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS80711460",
    "name": "Mark Allison",
    "address": "45 Curf Way, Burgess Hill, West Sussex, RH15 0GD",
    "phone": "07799 475047",
    "email": "markallison@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-10",
    "notes": "Do the Velux on the side of the house,  cash \u00a330",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS95060497",
    "name": "Ann Marie",
    "address": "20 St Andrews Pl, Hassocks BN6, UK",
    "phone": "07950457685",
    "email": "annduddingmusic@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "Park outside 22 on the small path and do 22 and 20",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS91676586",
    "name": "Sheila Thompson",
    "address": "133a Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9SZ",
    "phone": "07517 035807",
    "email": "sheila2t@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-12-11",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Pay\nby card link. (It is the\nsmall house behind\ngreen gate. Include\nside windows from\nthe footpath.",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS66269702",
    "name": "Josie Wicks",
    "address": "Honeywood Hurstpierpoint, Hurst Road, Hassocks, West Sussex, BN6 9NL",
    "phone": "07891 161376",
    "email": "josie.wicks@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning,Conservatory Roof Clean",
    "frequency": "Ad hoc",
    "lastDone": "never",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 126.67
  },
  {
    "id": "CUS58781013",
    "name": "Nicola Fairhall",
    "address": "30 Highlands Drive, Burgess Hill, West Sussex, RH15 8JJ",
    "phone": "+447801783137",
    "email": "nickyfairhall@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Be extra thorough, had previous windy said wasn\u2019t happy with the corners of the window",
    "jobCount": 1,
    "totalSpent": 38.33
  },
  {
    "id": "CUS53359123",
    "name": "Holly Currier",
    "address": "14 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "+44 7720 827989",
    "email": "Holly.currier@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS70304300",
    "name": "Andy Croucher",
    "address": "27 The Fairway, Hassocks, BN6 9JU",
    "phone": "07722445115",
    "email": "Andy.croucher2@ntlworld.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS25303755",
    "name": "Sharon Banks",
    "address": "3 The Acorns, Oakhurst, Sayers Common, Hassocks, West Sussex, BN6 9JW",
    "phone": "07593 106371",
    "email": "sharon.adrian@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "New**",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS66843029",
    "name": "Mr Huitt",
    "address": "2 Denham Road, Burgess Hill, West Sussex, RH15 9TG",
    "phone": "01444 243975",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "Cash \u00a324",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS1961107",
    "name": "Pamela  Betsworth",
    "address": "35 Avenue  de  Warenne, Hassocks",
    "phone": "07752 819146",
    "email": "pamela880@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS37035672",
    "name": "Keith",
    "address": "4 The Orchard, Hassocks, West Sussex, BN6 8HH",
    "phone": "",
    "email": "emma.weir@dmhstallard.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Knock on his door and introduce yourself; he\u2019s in 95% of the time. Mention Colin so he knows you\u2019re genuine. He\u2019s old so give him a bit of time to answer. This one and number 15 are the easiest of the lot to clean. Less windows but you have to go through the bungalow to get to the back.",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS47325031",
    "name": "Bethany Rose",
    "address": "4 Willow Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9TL",
    "phone": "07474 897499",
    "email": "bethanycooper20@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean - Flat",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Just moved in so the frames need a good scrub",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS43774295",
    "name": "Neil Beard- Neilson",
    "address": "1 Barkdale, Burgess Hill, West Sussex, RH15 0BE",
    "phone": "07970 123292",
    "email": "neil@beard07neilson.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Text night before. Include\nside windows, best you\ncan. Not the Juliette\nbalcony. Pay by card\nlink.",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS93460529",
    "name": "Holly Phillips",
    "address": "11 Sun Close, Plumpton Green, Lewes, East Sussex, BN7 3FA",
    "phone": "07598 368974",
    "email": "hollyphillips17@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS75530685",
    "name": "Simon Clark",
    "address": "Hall House, Station Road, Plumpton Green, Lewes, East Sussex, BN7 3BS",
    "phone": "+44 7717 378058",
    "email": "sichukclark@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before. Pay by\ncard link. Roughly\nopposite village shop.",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS8623018",
    "name": "Warren Ford",
    "address": "119 Chanctonbury Road, Burgess Hill, West Sussex, RH15 9HE",
    "phone": "07879 448381",
    "email": "tazwoz2000@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS87645541",
    "name": "Christine Pilkington",
    "address": "12 The Quadrant, Hassocks, West Sussex, BN6 8BP",
    "phone": "01273 843 676",
    "email": "emma.weir@dmhstallard.com",
    "state": "active",
    "balance": 39.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-24",
    "notes": "All windows.",
    "jobCount": 1,
    "totalSpent": 32.5
  },
  {
    "id": "CUS69009288",
    "name": "Sophie Slater",
    "address": "5 Magnolia House, Emerald Road, Crawley, West Sussex, RH10 3FZ",
    "phone": "07908 962255",
    "email": "sophieslater222@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Forgewood",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-11-21",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS22062993",
    "name": "Dani Heslop",
    "address": "30 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "phone": "07536 070866",
    "email": "dani_1992@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS43388430",
    "name": "Richard",
    "address": "23 Edwin Street, Burgess Hill, West Sussex, RH15 9HT",
    "phone": "+44 7581 564188",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS92659877",
    "name": "Louise Ruffolo",
    "address": "32 The Rough, Newick, Lewes, East Sussex, BN8 4NS",
    "phone": "07736 835480",
    "email": "louisealdrich@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Text night before. All\ndoors and windows on\nhouse. Customer is\nhome every Mon-Thurs\nand sometimes on Fri.\nAccess via passageway\nif customer is home. L.H.\nside window from\nneighbours drive please\nspeak to customer first.",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS37519531",
    "name": "John Ashworth",
    "address": "11 Ann Cl, Hassocks BN6 8NB, UK",
    "phone": "07718 225055",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-11-24",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS27387978",
    "name": "Ditchling Estates",
    "address": "The Grananry Honeybourne Farm Albourne, Truslers Hill Lane, Albourne, Hassocks, West Sussex, BN6 9DU",
    "phone": "+447950671309",
    "email": "coletteg476@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-10-14",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 45.0
  },
  {
    "id": "CUS32163665",
    "name": "Katie Bambro",
    "address": "2 Jack Slaughter Lane, Hassocks, West Sussex, BN6 8GF",
    "phone": "07592212580",
    "email": "katiebambro86@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.17
  },
  {
    "id": "CUS49352292",
    "name": "Sarah Williams",
    "address": "18 Bankside, Bolney, Haywards Heath, West Sussex, RH17 5QN",
    "phone": "07922 590665",
    "email": "sazzzle@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "Lower flat all the way round",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS34706797",
    "name": "Marian Symons",
    "address": "2 Woodlands View, Green Road, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7QD",
    "phone": "07725 474304",
    "email": "marianrsymons@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Wivelsfield",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "Text night before. Pay by\ncardlink. Please leave\nleaflet. Opposite the\ngreen.",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS65828554",
    "name": "Sayful Islam",
    "address": "10 Heron Cl, Sayers Common, Hassocks BN6 9LF, UK",
    "phone": "07951 267695",
    "email": "sayful.islam@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS7236031",
    "name": "Kim Uden",
    "address": "44 Potters Lane, Burgess Hill, West Sussex, RH15 9JS",
    "phone": "07565 141949",
    "email": "kim.uden27@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS86126416",
    "name": "Mary Deveson",
    "address": "106 Marlborough Drive, Burgess Hill, West Sussex, RH15 0EU",
    "phone": "07850 307067",
    "email": "marydeveson@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "I\u2019ll leave a key for the right hand side gate under the pot to the left of the front door!\n\nPark on the drive if you can, do the front and right hand side of the house, walk back to the drive with the house and put it under the gates, walk round the back and pull the hose to do the back of the house and left hand side",
    "jobCount": 1,
    "totalSpent": 32.5
  },
  {
    "id": "CUS22416806",
    "name": "Janet Moore",
    "address": "6 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "phone": "07812213626",
    "email": "janet-m-moore@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Text night before.\nAccess to R. garden via\ngarage, customer will\nleave open if out. Pay\nby card link.",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS34265411",
    "name": "David Montero",
    "address": "1 nettle drive, burgess hill",
    "phone": "07793726018",
    "email": "davidmontero@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "1 Nettle Drive. Use RH15 0XT to get onto site. Our house is the grey one on the left hand side at the end T-Junction",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS43793741",
    "name": "Phil",
    "address": "11 Sunningdale Road Hassocks",
    "phone": "+44 7815 805117",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.6
  },
  {
    "id": "CUS91532112",
    "name": "Anne Cozens",
    "address": "30 Newick Drive, Newick, Lewes, East Sussex, BN8 4PA",
    "phone": "07523823198",
    "email": "anne.cozens@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS64226243",
    "name": "Joanna Tindall",
    "address": "11 Nevill Place, Hassocks, BN6 8FU",
    "phone": "07445 343062",
    "email": "joanna.tindall@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-10-28",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS78917386",
    "name": "Emily Wilson",
    "address": "31 Potters Lane, Burgess Hill, West Sussex, RH15 9JT",
    "phone": "07576 590471",
    "email": "steve.emily2628@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS78190698",
    "name": "Andy Cockram",
    "address": "51 Mocatta Way, Burgess Hill, West Sussex, RH15 8UR",
    "phone": "07592059106",
    "email": "rud313@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-02",
    "notes": "Text night before. Park in\nparking bay or where safe\nto do so and reach F. and B.\nInclude conservatory.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS30549662",
    "name": "Jade Ellis",
    "address": "Crabtree Lodge  Pyecombe England, Pyecombe Street, Pyecombe, Brighton, East Sussex, BN45 7EE",
    "phone": "07772 015453",
    "email": "j_aellis@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS65460719",
    "name": "Sharon Chad",
    "address": "31 Oak Tree Drive, Hassocks, BN6 8YA",
    "phone": "07840148480",
    "email": "sdachad.sc@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS70607094",
    "name": "Anne",
    "address": "45 Bonny Wood Road, Hassocks, West Sussex, BN6 8HP",
    "phone": "07800 785848",
    "email": "annie_mcknowles@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS52937972",
    "name": "Sally",
    "address": "15 Spinney Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9AR",
    "phone": "07899 991763",
    "email": "Sallycorbin53@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "All windows. Beware of the dog! It\u2019s a yorkie that\u2019ll lick you death",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS11077566",
    "name": "Ian Stevens",
    "address": "3 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "phone": "07931 588953",
    "email": "ian.j.stevens@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "New** Rear access via path side\nof house. Park on road if\nsafe to do so and access\nfront and rear without\nmoving van. Text night\nbefore.",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS41812757",
    "name": "Judith",
    "address": "34 Bridge Close, Burgess Hill, West Sussex, RH15 8PD",
    "phone": "+44 7952 063706",
    "email": "jaycjay35@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS30263505",
    "name": "Dan Rayner",
    "address": "33 The Fairway, Hassocks, Sussex, BN6 9JU",
    "phone": "+44 7711 883426",
    "email": "dan.rayner@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-11-04",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS63852574",
    "name": "Nick",
    "address": "Spring Cottage, Church Lane, Albourne, Hassocks, West Sussex, BN6 9BY",
    "phone": "07977 176552",
    "email": "wergantoma@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 52.5
  },
  {
    "id": "CUS82879591",
    "name": "Grace Jutton",
    "address": "16 Sycamore Way, Hassocks, West Sussex, BN6 8YH",
    "phone": "+44 7718 971333",
    "email": "gracejutton@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.8
  },
  {
    "id": "CUS92754843",
    "name": "Kim Cybuch",
    "address": "50 Bramber Way, Burgess Hill, West Sussex, RH15 8JX",
    "phone": "07944 864884",
    "email": "kimberleycybuch@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS53543036",
    "name": "Paul Jordan",
    "address": "7 Celandine Gardens,Burgess Hill, RH15 8ZN",
    "phone": "07578214939",
    "email": "paul.jordan33@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-09-10",
    "nextDue": "2026-03-09",
    "notes": "On the new bellway site, off Issac\u2019s lane, at the roundabout for the tip with the tip on your right go over to Haywards heath and then on the right after new traffic lights",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS69247708",
    "name": "Catherine Sandilands",
    "address": "11 Gordon Rd, Burgess Hill RH15 0PX, UK",
    "phone": "07703 535717",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-06",
    "notes": "Make sure you do the velux",
    "jobCount": 1,
    "totalSpent": 21.0
  },
  {
    "id": "CUS55121391",
    "name": "Susan Skeet",
    "address": "15 Farnham Avenue, Hassocks, West Sussex, BN6 8NR",
    "phone": "07734 645882",
    "email": "s_skeet@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Include \nextension.",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS97061403",
    "name": "Sarah McLoughlin",
    "address": "Grasmere, Malthouse Lane, Burgess Hill, West Sussex, RH15 9XA",
    "phone": "07917 658717",
    "email": "sarahellis96@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "Text night before. Include\nconservatory and 2 x\nvelux. Pay by card link.\nPlease leave leaflet.",
    "jobCount": 1,
    "totalSpent": 32.5
  },
  {
    "id": "CUS13495459",
    "name": "Lauren Roles",
    "address": "46 Bridge Close, Burgess Hill, West Sussex, RH15 8PD",
    "phone": "07535 759591",
    "email": "lauren.roles27@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "Text night before. Front\nonly if customer is out. All\nwindows if customer is\nhome, Access via front\ndoor. Customer advised\nusually home school\nholidays and other times\nafter 2pm.",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS67897793",
    "name": "Penny",
    "address": "46 The Fairway, Hassocks BN6, UK",
    "phone": "07786061825",
    "email": "",
    "state": "active",
    "balance": 2.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "Just the upstairs window cash under the buddah",
    "jobCount": 1,
    "totalSpent": 5.0
  },
  {
    "id": "CUS2866408",
    "name": "Conor Pool",
    "address": "11 Turnbury Way, Hassocks, Sussex, BN6 9QF",
    "phone": "07538262763",
    "email": "conor.pool@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS57919752",
    "name": "Fraser Hagell",
    "address": "15 Sunnywood Drive, Haywards Heath, West Sussex, RH16 4PE",
    "phone": "07733 293797",
    "email": "fraserh11@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-07-08",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS34167401",
    "name": "Beth",
    "address": "48 London Rd, Hassocks BN6 9NU, UK",
    "phone": "07759900791",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks No Email",
    "assignee": "Steve, Dan",
    "services": "Office clean,Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "Reverse up on to drive, include garden room",
    "jobCount": 1,
    "totalSpent": 31.5
  },
  {
    "id": "CUS9360525",
    "name": "Fleur Jones",
    "address": "10 Downs View Road, Hassocks, West Sussex, BN6 8HJ",
    "phone": "07810 324896",
    "email": "fleur181@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean inc Lantern",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-04-06",
    "notes": "Text night before. Include the roof lantern, ladder needed.",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS49779860",
    "name": "James Smith",
    "address": "24 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "phone": "07525 194862",
    "email": "jamesra.smith@protonmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-09-18",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS51677818",
    "name": "Nick Cherry",
    "address": "17 The Fairway, Hassocks, BN6 9JU",
    "phone": "07903 087417",
    "email": "nickcherry25@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS9564948",
    "name": "Ginette Read",
    "address": "20 Carnoustie Drive Hassocks",
    "phone": "07974204483",
    "email": "ginettemread@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Key code by back door for garage and inside garage door - 2069",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS59463173",
    "name": "Sally",
    "address": "46 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RS",
    "phone": "+44 7811 015506",
    "email": "andrea.saunders1948@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "There\u2019s a Perspex roof on both houses they need doing every other time",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS19999408",
    "name": "Liz",
    "address": "73 Hammonds Ridge, Burgess Hill, West Sussex, RH15 9QW",
    "phone": "07742 832130",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "\u00a320",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS31108544",
    "name": "Inge",
    "address": "12 St Lawrence Way, Hurstpierpoint, Hassocks BN6 9SH, UK",
    "phone": "+44 7853 137108",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Long pole, not garden room",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS90226578",
    "name": "Rosalind Cannon",
    "address": "5 Chestnut Dr, Hassocks BN6 8YF, UK",
    "phone": "07767 334133",
    "email": "rosalindgcannon@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS65402862",
    "name": "Adrian Howard",
    "address": "53 Woodsland Road, Hassocks, West Sussex, BN6 8EU",
    "phone": "+44 7766 230404",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS18635927",
    "name": "Dave Ryan",
    "address": "34 Kings Way, Burgess Hill, West Sussex, RH15 0TP",
    "phone": "01444 233947",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "Text night before to\nlandline. Garage door is\nunlocked. Cash in top\ndrawer in garage. \u00a322",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS19272852",
    "name": "Alysha",
    "address": "6 Sunningdale Road Hassocks",
    "phone": "+44 7814 531318",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "notes": "Unlock the gate if the bolts across",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS57049971",
    "name": "Peter Kluge",
    "address": "18 Maple Drive, Burgess Hill, West Sussex, RH15 8AW",
    "phone": "07896797009",
    "email": "pkluge43@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "notes": "Include conservatory.\nAccess to rear garden via\nservice road and rear gate.\nText night before.\n\nIf paying cash \u00a334",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS51380",
    "name": "Cheryl Douglas",
    "address": "213 Junction Road, Burgess Hill, West Sussex, RH15 0NX",
    "phone": "07880 701231",
    "email": "cheryldouglas35@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS27079989",
    "name": "Rebecca Noone",
    "address": "291 Junction Road, Burgess Hill, West Sussex, RH15 0PY",
    "phone": "07803 079286",
    "email": "beknoone@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS14956542",
    "name": "Jenny Hill",
    "address": "3 Great Park Meadow, Burgess Hill, RH15 0YL",
    "phone": "07454 381345",
    "email": "jengush81@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS76753245",
    "name": "Glenn",
    "address": "33 The Warren, Burgess Hill, West Sussex, RH15 0DU",
    "phone": "07540 073375",
    "email": "glenn_piper24@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS54440132",
    "name": "Joan Denley",
    "address": "28 St. Lawrence Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9SH",
    "phone": "01273834534",
    "email": "Micheal.den@btinternet.com",
    "state": "active",
    "balance": 35.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "Text night before to\nlandline. Include\nextension. Not the\nvelux. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS72280050",
    "name": "Nancy Higgins",
    "address": "32 Friars Oak Rd, Hassocks BN6 8PX, UK",
    "phone": "07946 436156",
    "email": "colhig@colhig.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Use platform in the garden to reach the back windows and 2 velux on extension BIG POLE\nVery fussy about the veluxes being clean",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS40606686",
    "name": "Gerald Nurse",
    "address": "42 Adastra Ave, Keymer, Hassocks BN6 8DL, UK",
    "phone": "07941 527443",
    "email": "gerrynurse@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "This is a returning customer after having a year of building works.",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS52892539",
    "name": "Chris Luck- Scotcher",
    "address": "22 Edwin Street, Burgess Hill, West Sussex, RH15 9HU",
    "phone": "07584122386",
    "email": "chrisluck1991@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS36191757",
    "name": "Charlotte Upton",
    "address": "2 Duke of York Cottages, London Road, Sayers Common, Hassocks, West Sussex, BN6 9HY",
    "phone": "+447889223442",
    "email": "charlotteupton@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS95489599",
    "name": "Jo White",
    "address": "10 Hollycroft, East Chiltington, Lewes, East Sussex, BN7 3AZ",
    "phone": "07814 162625",
    "email": "jowhite100@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-08-29",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS82302295",
    "name": "Clare Adams",
    "address": "13 The Fairway, Hassocks, BN6 9JU",
    "phone": "07718123997",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "KG NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "Wants it done in the morning so maybe do this first if you start at 9, garden through the garage",
    "jobCount": 2,
    "totalSpent": 27.5
  },
  {
    "id": "CUS69050406",
    "name": "Transparency Cleaning Services Limited",
    "address": "5 Shearing Dr, Burgess Hill RH15 0NA, UK",
    "phone": "07957999280",
    "email": "Info@transparencycleaning.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Hose Reels",
    "frequency": "Ad hoc",
    "lastDone": "2022-06-30",
    "nextDue": "",
    "notes": "2 x hose reel",
    "jobCount": 1,
    "totalSpent": 180.0
  },
  {
    "id": "CUS2198531",
    "name": "Clem Leneghan",
    "address": "9 Wolstonbury Close, Hurstpierpoint West Sussex BN6 9AS",
    "phone": "07989 517877",
    "email": "clemclem@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-04-01",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 78.0
  },
  {
    "id": "CUS99437239",
    "name": "Hayley Bamber",
    "address": "59 Oak Hall Park, Burgess Hill, RH15 0DA",
    "phone": "07563 530954",
    "email": "hayleybamber123@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-04-21",
    "notes": "Text night before. Include conservatory",
    "jobCount": 1,
    "totalSpent": 34.0
  },
  {
    "id": "CUS10216144",
    "name": "Hannah Lawrence",
    "address": "130 Junction Road, Burgess Hill, West Sussex, RH15 0PZ",
    "phone": "07864 331104",
    "email": "hannahcaplin1985@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "notes": "Hand over gate to open if\ncustomer is out.",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS79260323",
    "name": "Oliver Cox",
    "address": "4 Brambles, Hassocks, West Sussex, BN6 8EQ",
    "phone": "\u202a+44\u00a07494\u00a0550503\u202c",
    "email": "ojc18@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS23884771",
    "name": "Isobel Bignell",
    "address": "8 Mackie Avenue, Hassocks, West Sussex, BN6 8NL",
    "phone": "07397 286298",
    "email": "isobelbignell@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Text night before. Include \nextension. Pay by \nGoCardless. Gate stiff.",
    "jobCount": 2,
    "totalSpent": 51.0
  },
  {
    "id": "CUS13450456",
    "name": "Sarah",
    "address": "65 Goldcrest Dr, Hassocks BN6, UK",
    "phone": "+44 7596 551940",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers No Email",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.0
  },
  {
    "id": "CUS1295625",
    "name": "Joanne Lacey",
    "address": "72 Newick Drive, Newick, Lewes, East Sussex, BN8 4PB",
    "phone": "07528 330108",
    "email": "joannelacey74@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS5802254",
    "name": "Martin Doidge",
    "address": "13 London Road, Hassocks, West Sussex, BN6 9NT",
    "phone": "07941 122292",
    "email": "martin@doidge.me",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS42502364",
    "name": "Mrs Janice Lowe",
    "address": "1 Turners Mill Road, Haywards Heath, West Sussex, RH16 1NW",
    "phone": "07841 630728",
    "email": "",
    "state": "active",
    "balance": 24.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-12",
    "nextDue": "2026-02-05",
    "notes": "she is near the corner of Harlands Road, near leisure centre",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS66983206",
    "name": "Jane Dobson",
    "address": "5 Adastra Avenue, Hassocks, West Sussex, BN6 8DP",
    "phone": "07840 836633",
    "email": "r.dobson@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "notes": "Text night before. Include 4 Velux",
    "jobCount": 1,
    "totalSpent": 43.0
  },
  {
    "id": "CUS10420585",
    "name": "Charles Simmons",
    "address": "15 The Vineries, Burgess Hill, RH15 0ND",
    "phone": "07884 046249",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "Cash \u00a325",
    "jobCount": 2,
    "totalSpent": 0.0
  },
  {
    "id": "CUS72804608",
    "name": "Rebecca Whitehouse",
    "address": "43 Willowhurst, Burgess Hill RH15 0wx",
    "phone": "07930 246111",
    "email": "thatbec@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS71144104",
    "name": "Suzan Gold",
    "address": "20 Hoadley Avenue, Burgess Hill, Sussex, RH15 0RG",
    "phone": "07718746148",
    "email": "suzan.gold@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "Inc all Velux over the garage",
    "jobCount": 1,
    "totalSpent": 35.83
  },
  {
    "id": "CUS51830128",
    "name": "Olga",
    "address": "42 The Wickets, Burgess Hill, RH15 8TG",
    "phone": "07881667917",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Be careful leaded windows, inc conservatory",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS26196137",
    "name": "Ayesha Trott",
    "address": "23 Little Copse Road, Hassocks, West Sussex, BN6 8PQ",
    "phone": "07547 673856",
    "email": "ayeshatrott@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Text night before. Include\nconservatory.",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS2806322",
    "name": "Dave",
    "address": "12 Stafford Way, Hassocks, West Sussex, BN6 8QQ",
    "phone": "07903068550",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "This is one of Collins",
    "jobCount": 2,
    "totalSpent": 96.67
  },
  {
    "id": "CUS96922487",
    "name": "Adam Pitt",
    "address": "40 The Gattons, Burgess Hill, West Sussex, RH15 9SW",
    "phone": "07803175376",
    "email": "adam-pitt@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Text night before.\nInclude 3 x velux.",
    "jobCount": 2,
    "totalSpent": 98.83
  },
  {
    "id": "CUS60084887",
    "name": "Alex Cox",
    "address": "58 Curf Way, Burgess Hill RH15 0GE, UK",
    "phone": "07969 027496",
    "email": "a.s.cox92@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "You need long pole for 60,58,54\n\nVELUXES ON THE REAR ROOF",
    "jobCount": 1,
    "totalSpent": 30.8
  },
  {
    "id": "CUS50232932",
    "name": "Laurann De Verteuil",
    "address": "10 Carnoustie Drive hassocks",
    "phone": "+447864302609",
    "email": "lauranndeverteuil@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2023-11-01",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS62299669",
    "name": "Zoe Dolding",
    "address": "5 Godden Road, Newick, Lewes, East Sussex, BN8 4NE",
    "phone": "+447593932508",
    "email": "zozogb@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Newick",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "notes": "Inc 2 roof lanterns, ladder needed",
    "jobCount": 1,
    "totalSpent": 34.17
  },
  {
    "id": "CUS79640796",
    "name": "Matt Graysmark",
    "address": "33 The Vineries, Burgess Hill, West Sussex, RH15 0ND",
    "phone": "07715 399421",
    "email": "mattgraysmark@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS89662162",
    "name": "Kerry Bagshaw",
    "address": "19 Willowhurst, Burgess Hill, West Sussex, RH15 0XT",
    "phone": "07933 892183",
    "email": "kerry.bagshaw@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "Text night before.\nMaybe park near car\nport if safe to do\nso,please see\ncustomer.",
    "jobCount": 1,
    "totalSpent": 19.17
  },
  {
    "id": "CUS80659243",
    "name": "Hassocks Day Nursery & Preschool",
    "address": "Hassocks Day Nursery & Preschool The Beacon Hassocks West Sussex, Brighton Road, Hassocks, West Sussex, BN6 9LZ",
    "phone": "+44 7746 351356",
    "email": "admin@hassocksdaynurseryandpreschool.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS30277385",
    "name": "Vincent Murphy",
    "address": "1 Orchard Lane, Hassocks, West Sussex, BN6 8QE",
    "phone": "+44 7769 591591",
    "email": "vincent@vincentmurphy.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-07-11",
    "nextDue": "",
    "notes": "One off, please give the best clean possible as they want to see how good we are before booking a regular clean",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS50592237",
    "name": "Frankie Maltby",
    "address": "42 Ockley Way, Hassocks, West Sussex, BN6 8NF",
    "phone": "07917 761280",
    "email": "fmaltby@ymail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Include conservatory",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS52020860",
    "name": "Jacob Midwinter",
    "address": "7 The Acorns, Oakhurst, Sayers Common, Hassocks, West Sussex, BN6 9JW",
    "phone": "07926 208350",
    "email": "jacobmidwinter89@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-10-06",
    "nextDue": "2026-02-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS5925519",
    "name": "Rosanne",
    "address": "Hurstview, Langton Lane, Hurstpierpoint, Hassocks, BN6 9EZ",
    "phone": "07887724728",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Careful - leaded windows, use long pole / orange brush\n\nThere's windows on both sides of the property, walk all the way around\n\nUSE RIGHT HAND SIDE GATE AND SHUT IT AFTER YOU ENTER THE GARDEN",
    "jobCount": 1,
    "totalSpent": 38.5
  },
  {
    "id": "CUS67248659",
    "name": "Bruce Scrivens",
    "address": "1 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BE",
    "phone": "+44 7872 449093",
    "email": "seishin@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS55473362",
    "name": "Alastair Potts",
    "address": "1 Carnoustie Drive Bn6",
    "phone": "+44 7776 136783",
    "email": "babistair2002@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 17.5
  },
  {
    "id": "CUS30747323",
    "name": "Jenny Batchelor",
    "address": "3 Hurst Road, Hassocks, West Sussex, BN6 9NJ",
    "phone": "07917 000952",
    "email": "jennygbatchelor@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS49044616",
    "name": "Sue Ockenden",
    "address": "9 Orchard Way, Burgess Hill, West Sussex, RH15 9PB",
    "phone": "07751 242779",
    "email": "s.ockenden@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "notes": "Text night before. Include\ndormer and 2 x velux.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS2738747",
    "name": "Chris Elkins",
    "address": "Flint House, Janes Lane, Burgess Hill, West Sussex, RH15 0QJ",
    "phone": "07729 856390",
    "email": "chriselkins50@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "notes": "Text night before. Include\nconservatory and\nextension. (Window over\nextension do best you can\nfrom both sides of\nextension). Directions: This\nlittle cul-de-sac is just up\nfrom Ladymead. Pay by\ncard link.",
    "jobCount": 1,
    "totalSpent": 44.0
  },
  {
    "id": "CUS61474213",
    "name": "Barry Wenham",
    "address": "16 Woodland Avenue, Burgess Hill, West Sussex, RH15 0PE",
    "phone": "07926 749262",
    "email": "barrywenham867@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS35117585",
    "name": "David Phillips",
    "address": "3 Goldfinch Road, Burgess Hill, West Sussex, RH15 9DW",
    "phone": "07513077112",
    "email": "manxeagle@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean,Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2024-07-30",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 120.0
  },
  {
    "id": "CUS6012087",
    "name": "Simon Cooper",
    "address": "11 West Gate, Plumpton Green, Lewes, East Sussex, BN7 3BQ",
    "phone": "07870 570050",
    "email": "simonjcooper@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-11-25",
    "nextDue": "2026-02-17",
    "notes": "Text night before. Price\nreq for plastic roof in\nrear garden.",
    "jobCount": 1,
    "totalSpent": 21.67
  },
  {
    "id": "CUS64466669",
    "name": "Isabellos Preschool",
    "address": "The Church Hall, Oakhurst, Sayers Common, Hassocks, BN6 9JA",
    "phone": "0 7793 726018",
    "email": "info@isabellos.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2025-09-05",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS75295817",
    "name": "Jenny Barna",
    "address": "2 The Dymocks, Ditchling, Hassocks, West Sussex, BN6 8SU",
    "phone": "\u202a+44\u00a07808\u00a0930783\u202c",
    "email": "jcjbarna@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS71937829",
    "name": "Sarah Bonnot",
    "address": "4 Mayhouse Road, Burgess Hill, RH15 9RF",
    "phone": "07595  953815",
    "email": "sarahbtmcipd@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "Front and side of house \nonly. Text night before. \nRear of house clean if \ncustomer requests and \naccess clear. Advise",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS65721676",
    "name": "Julie Marchant",
    "address": "47 Potters Lane, Burgess Hill, RH15 9JT",
    "phone": "07947 329434",
    "email": "juliemarchant1963@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS77785107",
    "name": "Sam Leycester",
    "address": "6 Unicorn Way, Burgess Hill, RH15 0UU",
    "phone": "07745625517",
    "email": "Samanthaleycester@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 27.0
  },
  {
    "id": "CUS47134877",
    "name": "Donna Peters",
    "address": "62 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "phone": "07720 656414",
    "email": "donnapeters469@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS92430301",
    "name": "Matthew Mills",
    "address": "8 Partridge Cl, Burgess Hill RH15 0ZR, UK",
    "phone": "07867 491674",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS822436",
    "name": "Lola Lockwood",
    "address": "43 Fairfield Road, Burgess Hill, West Sussex, RH15 8QB",
    "phone": "07816\n835222",
    "email": "lola.lockwood@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS98094439",
    "name": "Rocky Hooper",
    "address": "60a Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "phone": "07412 226515",
    "email": "rockyhooper@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS93886760",
    "name": "Darren Sharp",
    "address": "The Old Mill, Station Road, Cowfold, Horsham, West Sussex, RH13 8DE",
    "phone": "\u202a+44\u00a07702\u00a0098165\u202c",
    "email": "darren.sharp@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Cowfold",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-10-22",
    "nextDue": "2026-04-08",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 66.67
  },
  {
    "id": "CUS68442424",
    "name": "Mick Macve",
    "address": "News House, London Road, Hassocks, West Sussex, BN6 9NX",
    "phone": "07788 938944",
    "email": "mickmacve@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS59456705",
    "name": "James Robertson",
    "address": "46 Wykeham Way, Burgess Hill, West Sussex, RH15 0HF",
    "phone": "01444\n232907",
    "email": "robertsonjim252@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "New",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS71179790",
    "name": "Les",
    "address": "4 Woodsland Close, Hassocks, West Sussex, BN6 8HF",
    "phone": "07840 110655",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks cash",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "All outside windows but not conservatory. One skylight in roof right hand side. Text night before and he\u2019ll unlock the gate if he goes out.",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS68079634",
    "name": "Emily Howarth",
    "address": "11 Michelbourne Close, Burgess Hill, West Sussex, RH15 9QX",
    "phone": "07939 658180",
    "email": "emilymayhowarth@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-03",
    "notes": "Text night before. Include\nconservatory and 1 x\nvelux. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS1757476",
    "name": "Kirsti Agent",
    "address": "6 Nuthatch Lane, Sayers Common, Hassocks, BN6 9LB",
    "phone": "+447835813575",
    "email": "kirstiagent7@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS75613834",
    "name": "Stuart",
    "address": "12 Gordon Rd, Burgess Hill RH15 0PX, UK",
    "phone": "07841 518958",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-10-09",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS52260525",
    "name": "Anna Lenkiewicz",
    "address": "23 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "phone": "07910 892610",
    "email": "anna.lenkiewicz@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Garden Room",
    "frequency": "every 12 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-03-09",
    "notes": "Knock the door first, Include garden room.",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS74097097",
    "name": "Emma",
    "address": "15 The Kiln, Burgess Hill, West Sussex, RH15 0LU",
    "phone": "07791 765990",
    "email": "eking.thughes@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2025-12-05",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS63800506",
    "name": "Dawn Greener",
    "address": "19 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "phone": "07900 927094",
    "email": "dgreener22@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS22447551",
    "name": "Sarah Jane",
    "address": "10 John Wood Crescent, Hassocks, West Sussex, BN6 8FQ",
    "phone": "+447708008834",
    "email": "mssarahjane85@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS42193020",
    "name": "Christine",
    "address": "Highview House, Lucastes Lane, Haywards Heath, West Sussex, RH16 1LD",
    "phone": "+44 7748 184151",
    "email": "csaxena@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 126.66
  },
  {
    "id": "CUS64776448",
    "name": "Jane Childs",
    "address": "119 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "phone": "07969066713",
    "email": "janechilds67@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-12-11",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS70767385",
    "name": "Helen And Tom",
    "address": "3 The Fairway, Hassocks, BN6 9JU",
    "phone": "07734329758",
    "email": "helen_kerrigan@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2024-06-03",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 98.0
  },
  {
    "id": "CUS4086266",
    "name": "Adela",
    "address": "41 Kings Way, Burgess Hill RH15 0TP, UK",
    "phone": "07863 299539",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS45536133",
    "name": "Scott Conroy",
    "address": "44 Avenue de Warenne, Hassocks West Sussex BN6 8GE",
    "phone": "07824 366098",
    "email": "scottconroy73@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "notes": "Ockley Park",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS74402884",
    "name": "Daphne Grime",
    "address": "Paddock Cottage, Albourne Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9ES",
    "phone": "01273 834218",
    "email": "dagrime@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP CASH",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS41262910",
    "name": "Donna Wakeford",
    "address": "1 The Meads, Norman Road, Burgess Hill, West Sussex, RH15 9BY",
    "phone": "07825 708822",
    "email": "donnawakeford@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "Round the back it is just the upstairs window, so all windows but not the sun room",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS12486918",
    "name": "Beryl Marshall",
    "address": "60 Unicorn Way, Burgess Hill, West Sussex, RH15 0UU",
    "phone": "07852 582844",
    "email": "tink1956@live.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-05-19",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 40.0
  },
  {
    "id": "CUS88790642",
    "name": "Mary Goodwin",
    "address": "3 Broad Green Avenue, Burgess Hill, West Sussex, RH15 0HA",
    "phone": "01444 235267",
    "email": "marygoodwin3@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS17148566",
    "name": "Julie Medina",
    "address": "60 Timbergate Drive, Haywards Heath, West Sussex, RH17 5LQ",
    "phone": "+447879811678",
    "email": "julie.medina21@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.33
  },
  {
    "id": "CUS41854497",
    "name": "Chris Gant",
    "address": "41 Mackie Avenue, Hassocks, BN6 8NH",
    "phone": "07748 207252",
    "email": "chrisgant63@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "Text night before. Front \nonly if out",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS94504662",
    "name": "Andrea Saunders",
    "address": "45 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RS",
    "phone": "+44 7514 811686",
    "email": "andrea.saunders1948@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "There\u2019s a Perspex roof on both houses they need doing every other time",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS34832504",
    "name": "Sue Wadey",
    "address": "29 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PJ",
    "phone": "+44 7966 439777",
    "email": "suewadey@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS45310880",
    "name": "Ben Wingrove",
    "address": "1 The Chestnuts, Sayers Common, Hassocks BN6 9XJ, UK",
    "phone": "07841848906",
    "email": "ben.wingrove84@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "Park outside No1 and do this house and 17 across the road",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS95806086",
    "name": "Liam Murray",
    "address": "5 Leigh Meadow, Burgess Hill West Sussex RH15 0YP",
    "phone": "07769 325833",
    "email": "liamsmurray@hotmail.com",
    "state": "active",
    "balance": 30.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "This is a new build on the Croft, not coming up on any maps \n\n#vat",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS459164",
    "name": "David",
    "address": "37 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AD",
    "phone": "07712 897030",
    "email": "d.bryning@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS37899641",
    "name": "Chloe  Armstrong",
    "address": "22 John Wood Crescent, Hassocks, BN6 8FQ",
    "phone": "07841380500",
    "email": "chloearmstrong2121@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS47596131",
    "name": "Rhea Salisbury",
    "address": "42 Eastdale Road, Burgess Hill, West Sussex, RH15 0NH",
    "phone": "07530 817601",
    "email": "redyball93@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "NEW\nText night before. Lean Over to unbolt gate",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS66475174",
    "name": "Jenny Goldsmith",
    "address": "29 Wickham Close, Haywards Heath, West Sussex, RH16 1UH",
    "phone": "+44 7772 05085",
    "email": "jennygoldsmith21@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS24043437",
    "name": "Tracey Paynton",
    "address": "60 Marlborough Drive, Burgess Hill, West Sussex, RH15 0EU",
    "phone": "07846 426632",
    "email": "t.paynton@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-11-07",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS36802848",
    "name": "Alex Hill",
    "address": "45 Noel Rise, Burgess Hill, West Sussex, RH15 8BU",
    "phone": "07963 194651",
    "email": "alexhill_@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "notes": "Text night before.\nInclude conservatory.",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS97545809",
    "name": "Svetlana Owen",
    "address": "19 Sunningdale Road, Hassocks, BN6 9QQ",
    "phone": "07963 091933",
    "email": "jajalana@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 19.0
  },
  {
    "id": "CUS33672491",
    "name": "Jackie Palmer",
    "address": "3 Farnlea, Burgess Hill, West Sussex, RH15 0BD",
    "phone": "07906 733386",
    "email": "jackie.palmer@openpm.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS95439530",
    "name": "Jessica Doyle",
    "address": "18 St Andrews Place, Hassocks, Sussex, BN6 9QE",
    "phone": "07716 824044",
    "email": "jessica7doyle@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Kingsland Gate2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2025-09-12",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS43359736",
    "name": "Sarah Jarvis",
    "address": "12 Foxglove Close, Burgess Hill, West Sussex, RH15 8UY",
    "phone": "+44 7736 838590",
    "email": "sarah_jarvis12@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "Inc Velux on the front and dormers at the rear inc con windows.\n\nDo no.14 rear windows from 12s garden",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS56718307",
    "name": "Emily Banfield",
    "address": "26 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "phone": "07745 304334",
    "email": "emilybanfield@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-11-21",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS94005705",
    "name": "Hazel Botting",
    "address": "29 Packham Way, Burgess Hill, West Sussex, RH15 8PR",
    "phone": "01444 236619",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-07-17",
    "nextDue": "2026-02-02",
    "notes": "Text night before to\nlandline. Pays cash.\nPreferably not\nWednesdays. This\ncustomer is blind. \u00a325",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS17327664",
    "name": "Sarah Sansom",
    "address": "52 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TA",
    "phone": "07771 968445",
    "email": "sarahsansom@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Inside Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-08-07",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 75.0
  },
  {
    "id": "CUS41179031",
    "name": "Richard Shackleton",
    "address": "25 Langridge Vale, Hassocks",
    "phone": "07725 036037",
    "email": "shackyshackleton@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS71599557",
    "name": "Katie Chambers",
    "address": "44 Woodland Avenue, Burgess Hill, West Sussex, RH15 0PE",
    "phone": "07713 405466",
    "email": "katiechambers92@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS95529980",
    "name": "Karen",
    "address": "21 Pyecombe St, Pyecombe, Brighton BN45, UK",
    "phone": "+447888766687",
    "email": "karencoops@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "Long pole, 2 veluxes at the front and dormer at the back",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS75025968",
    "name": "Margaret Negus",
    "address": "6 Blackhouse Lane, Burgess Hill, West Sussex, RH15 8BN",
    "phone": "07434 169385",
    "email": "margaret.negus@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-11-28",
    "nextDue": "2026-02-19",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS25632086",
    "name": "Kay Lane",
    "address": "4 Potters Lane, Burgess Hill, RH15 9HY",
    "phone": "07817 567285",
    "email": "kaylane57@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "Text night before. Gate is\nstiff needs a push. Pay\nby card link",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS97595570",
    "name": "Sue McVey",
    "address": "Fieldview Corner Station Approach/. Faygate., Carylls Lea, Faygate Lane, Faygate, Horsham, West Sussex, RH12 4SJ",
    "phone": "07796 046284",
    "email": "sue.mcvey@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Faygate",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS14925899",
    "name": "Jordan Ralph",
    "address": "7 Nuthatch Lane, Sayers Common, Hassocks, BN6 9LB",
    "phone": "07939 842134",
    "email": "jordpr7@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS98629392",
    "name": "Katie",
    "address": "27 Ockenden Way, Hassocks, West Sussex, BN6 8HS",
    "phone": "07854 987806",
    "email": "katie.french78@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS30872778",
    "name": "Rebecca",
    "address": "17 Berrylands Farm, Sayers Common, Hassocks, BN6 9XH",
    "phone": "+44 7918 990268",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers No Email",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.5
  },
  {
    "id": "CUS678476",
    "name": "Chris",
    "address": "19 Scrase Close, Burgess Hill, West Sussex, RH15 0YY",
    "phone": "+44 7756 261758",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "Drive into Scrase close, it\u2019s the flats at the end on the left, The top right flat when you walk round to the door, front side and rear, rear extend the pole over the fence.",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS68066788",
    "name": "Jean Osborne",
    "address": "8 Strood Gate, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7RY",
    "phone": "07979590931",
    "email": "mikeosborne2000@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Wivelsfield",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-11-19",
    "nextDue": "2026-02-17",
    "notes": "Text night before. Tap on\ndoor when you get there\nso she can secure dog.\nPay by cardlin",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS54753489",
    "name": "Laura Keen",
    "address": "7 Woods Ground, Eastern Road, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7QG",
    "phone": "07377 292447",
    "email": "lkeen047@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Wivelsfield",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS80814316",
    "name": "Henry Hayward",
    "address": "50 Brookway, Burgess Hill, West Sussex, RH15 0LN",
    "phone": "07568464659",
    "email": "hens.e.bin@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "Cash \u00a331",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS23986837",
    "name": "Colin Cooper",
    "address": "7 Glendale Road, Burgess Hill, West Sussex, RH15 0EJ",
    "phone": "07421\n389314",
    "email": "colintcooper@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "Text night before. Not front top R.H. side window. (difficult\naccess) Pay by card link.",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS83564736",
    "name": "David Harkin",
    "address": "163 Chanctonbury Road, Burgess Hill, West Sussex, RH15 9HF",
    "phone": "07944 181287",
    "email": "davidharkin_no7@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS11734817",
    "name": "Dawn Thompson Poulton",
    "address": "55 Folders Ln, Burgess Hill RH15 0DY, UK",
    "phone": "07779 321530",
    "email": "shelovesshoes@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "",
    "assignee": "",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2021-11-04",
    "nextDue": "",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 108.0
  },
  {
    "id": "CUS41173767",
    "name": "Graham Tate",
    "address": "6 Stafford Way, Hassocks, West Sussex, BN6 8QQ",
    "phone": "07714761346",
    "email": "spudtate@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-12-03",
    "nextDue": "2026-02-25",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 31.0
  },
  {
    "id": "CUS21278518",
    "name": "James Vaile",
    "address": "15 Grand Ave, Hassocks BN6, UK",
    "phone": "07803828676",
    "email": "Jamesvaile8@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS58440241",
    "name": "Vikki",
    "address": "16 Culpepper, Burgess Hill, RH15 8UB",
    "phone": "+44 7742 104142",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-04-24",
    "notes": "NOT CONSERVATORY",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS43263257",
    "name": "Lawrence Harris",
    "address": "43 Pangdene Close, Burgess Hill, West Sussex, RH15 9US",
    "phone": "07904 655698",
    "email": "lch_76@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 264.0
  },
  {
    "id": "CUS37231699",
    "name": "Geoff King",
    "address": "40 Nightingale Way, Sayers Common, Hassocks, West Sussex, BN6 9HP",
    "phone": "07872 801137",
    "email": "geoff.king82@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "NEW PLEASE KNOCK\nInclude 2 \nx velux and 1 x dormer.",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS8456060",
    "name": "Denise Dell",
    "address": "17 Iden Hurst, Hurstpierpoint, Hassocks BN6 9XZ, UK",
    "phone": "07735278092",
    "email": "lawrence@theotherdell.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS3637204",
    "name": "James Matcham",
    "address": "Ardra, Oakwood Road, Burgess Hill, West Sussex, RH15 0HU",
    "phone": "01444\n241805",
    "email": "0",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "notes": "\"Text night before to landline. Cash in brown bow by front door.\nDirections: This house is the last house on the\nleft. Please use the side gate between the house\nand garage. Please\"",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS54605192",
    "name": "Carole Benson",
    "address": "2 Greenlands Place\nWolstonbury House, Burgess Hill, West Sussex, RH15 0AJ",
    "phone": "07854 236444",
    "email": "caroleannebenson123@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-16",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 54.17
  },
  {
    "id": "CUS80591631",
    "name": "Rob",
    "address": "56, Goldcrest Drive, Hassocks, Sussex, BN6 9EH",
    "phone": "07707 314018",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers2",
    "assignee": "Dan",
    "services": "Window Clean front only",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-12-18",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS40622267",
    "name": "John Webb",
    "address": "158 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TD",
    "phone": "07596096679",
    "email": "john.webb66@btinternet.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Text night before. Not the\nupstairs window behind\ngarage. Knock first, if out\nkey will be in flower pot\nby front door for garage\ndoor. Post through front door\n\nPlease be aware you\u2019ll need to slightly lift the garage door to lock it afterwards.",
    "jobCount": 1,
    "totalSpent": 32.5
  },
  {
    "id": "CUS38882981",
    "name": "Simon",
    "address": "77 Larkspur Drive, Burgess Hill, West Sussex, RH15 0UL",
    "phone": "07502 224156",
    "email": "sim_2125@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "Text night before. Include\n2 x dormers and 2 x\nvelux . Lean over gate to\nunbolt. Knock first.\n(There is a dog called\nDexter who may be in\ngarden, hes excitable but\nfriendly - make sure he\ndoesnt escape).",
    "jobCount": 1,
    "totalSpent": 26.67
  },
  {
    "id": "CUS40916534",
    "name": "Jane Drew",
    "address": "13 Oak Hall Park, Burgess Hill, West Sussex, RH15 0DH",
    "phone": "07840 365672",
    "email": "jdmalikids@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Text night before. Knock\nfirst to secure dog. Use\nside gate to right of\nfront door if looking at\nhouse. Pay by card link.",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS31069468",
    "name": "Rob",
    "address": "11 Priory Road, Hassocks, West Sussex, BN6 8PS",
    "phone": "07974075357",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "All windows, flat roof",
    "jobCount": 1,
    "totalSpent": 22.5
  },
  {
    "id": "CUS72939239",
    "name": "Stephen Macarthy",
    "address": "9 Coopers Close, Burgess Hill, West Sussex, RH15 8AN",
    "phone": "07785\n103209",
    "email": "ssmaccarthy@aol.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "text night before. Include conservatory. Customer unhappy with last window cleaner because windows and frames were not  cleaned properly. Price req for conservatory roof\nand velux x 2. Pay by card link",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS37972500",
    "name": "Alex Spencer",
    "address": "12 Batt Street, Burgess Hill, RH15 0XF",
    "phone": "07835 177209",
    "email": "alexmspencer17@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS9567588",
    "name": "Patricia Addinell",
    "address": "25 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PJ",
    "phone": "07802 524523",
    "email": "patriciaaddinell@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "Text night before. Include\nconservatory but not\nconservatory roof. Side\ngate is unlocked. Please be\ncareful of Georgian bars as\nthey are fragile. If one\ncomes off just tell her and\nshe will glue it back on",
    "jobCount": 3,
    "totalSpent": 207.0
  },
  {
    "id": "CUS459195",
    "name": "Ian Woods",
    "address": "13 The Kiln, Burgess Hill, West Sussex, RH15 0LU",
    "phone": "07935 380723",
    "email": "ianw69049@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS11151009",
    "name": "Simon Cowley",
    "address": "4 Pyecombe St, Pyecombe, Brighton BN45 7EB, UK",
    "phone": "+44 7734 785925",
    "email": "",
    "state": "active",
    "balance": 23.76,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "Inc veluxes, there\u2019s windows on the side as you walk round to the garden",
    "jobCount": 1,
    "totalSpent": 19.8
  },
  {
    "id": "CUS8541373",
    "name": "Heather Holland",
    "address": "34 Dunstall Farm Road, Burgess Hill, RH15 8BJ",
    "phone": "07936 357945",
    "email": "heatherholland86@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "Reverse on to drive if no one home, very slippery out the back, very fussy with cobwebs etc",
    "jobCount": 1,
    "totalSpent": 24.0
  },
  {
    "id": "CUS24831488",
    "name": "John Frew",
    "address": "136 Unicorn Way, Burgess Hill, West Sussex, RH15 0UU",
    "phone": "07519641754",
    "email": "allanfrew.oldschool@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS18026368",
    "name": "Jane Davis",
    "address": "65 Nightingale Lane, Burgess Hill, West Sussex, RH15 9JH",
    "phone": "07597 086156",
    "email": "janedavisnov@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Text night before. Pay by\ncash. \u00a326",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS72469083",
    "name": "Bev Wright",
    "address": "21 Chestnut Drive, Hassocks, West Sussex, BN6 8AZ",
    "phone": "07730 771309",
    "email": "bellejustme1952@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-10",
    "nextDue": "2026-03-04",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS79672998",
    "name": "Lucy Boxall",
    "address": "31 Chichester Way, Burgess Hill RH15 0RH, UK",
    "phone": "07391 552769",
    "email": "lucy.boxall30@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "notes": "31 is in the corner",
    "jobCount": 1,
    "totalSpent": 25.3
  },
  {
    "id": "CUS67132147",
    "name": "Eleanor St. John",
    "address": "17 Kings Ride, Burgess Hill, RH15 0HL",
    "phone": "+447592131270",
    "email": "elliehstjohn@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Office clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "Happy Paws Spay-Neuter\n\nPark on double yellows outside the shop, takes 10 mins",
    "jobCount": 2,
    "totalSpent": 50.6
  },
  {
    "id": "CUS41499527",
    "name": "Dominic Hodge",
    "address": "1 Bonnet Lane, Burgess Hill, Sussex, RH15 0FP",
    "phone": "07986 085510",
    "email": "dominichodge@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.0
  },
  {
    "id": "CUS23429138",
    "name": "Martin Horner",
    "address": "31 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "phone": "07398 761555",
    "email": "martincheam@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS71458683",
    "name": "Jon English",
    "address": "29 Lewes Road, Haywards Heath, West Sussex, RH17 7SP",
    "phone": "+44 7768 455569",
    "email": "jon@englishtenor.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-08-04",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 80.0
  },
  {
    "id": "CUS4150808",
    "name": "Haitham Al-Omari",
    "address": "35 Clifton Road, Burgess Hill, West Sussex, RH15 8US",
    "phone": "07545 157884",
    "email": "haitham1995@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "Ad hoc",
    "lastDone": "2024-11-18",
    "nextDue": "",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 50.0
  },
  {
    "id": "CUS28180013",
    "name": "Davina Griffiths",
    "address": "16a Royal George Road, Burgess Hill, West Sussex, RH15 9SD",
    "phone": "07398 235390",
    "email": "davinagriffiths@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS24911253",
    "name": "Stuart Wright",
    "address": "Flat 14, Pine Trees Court, Pine Trees, Hassocks, West Sussex, BN6 8NW",
    "phone": "07445 331561",
    "email": "stuartpeterwright@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS24623776",
    "name": "Chris Evans",
    "address": "16 Edwin St, Burgess Hill RH15 9HU, UK",
    "phone": "07958189144",
    "email": "chrisevans1001@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "frequency": "Ad hoc",
    "lastDone": "2024-11-06",
    "nextDue": "",
    "notes": "F&S inc Garage",
    "jobCount": 2,
    "totalSpent": 112.0
  },
  {
    "id": "CUS93564068",
    "name": "Zoltan Bryant",
    "address": "12 St. Georges Place, Hurstpierpoint, Hassocks, West Sussex, BN6 9QT",
    "phone": "+44 7979 426410",
    "email": "zoltanb@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS62906960",
    "name": "Martin Packham",
    "address": "18 Payton Drive, Burgess Hill, West Sussex, RH15 9UU",
    "phone": "07704 464461",
    "email": "mapackham@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS34768479",
    "name": "Ann McBryar",
    "address": "12 Greenlands Close, Burgess Hill, West Sussex, RH15 0AR",
    "phone": "07731 865195",
    "email": "cmcbryar@talktalk.net",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "notes": "One of\nthe side windows is only\naccessible from\nneighbours drive and is a\ndifficult angle but do best\nyou can. Not the velux.\nPay by card link. Landline\nnumber. 01444 233708",
    "jobCount": 1,
    "totalSpent": 29.0
  },
  {
    "id": "CUS67192201",
    "name": "Ted",
    "address": "27 Semley Road, Hassocks, West Sussex, BN6 8PD",
    "phone": "07946564439",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Dan",
    "services": "Conservatory Roof Clean",
    "frequency": "Ad hoc",
    "lastDone": "2025-05-07",
    "nextDue": "",
    "notes": "",
    "jobCount": 3,
    "totalSpent": 206.7
  },
  {
    "id": "CUS12085608",
    "name": "Simon Ellery",
    "address": "1 Strawlands, Plumpton Green, Lewes, East Sussex, BN7 3DB",
    "phone": "07753 760124",
    "email": "simon.ellery@virginmedia.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Plumpton",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "notes": "Text night before.\nInclude extension. Pay\nby card link. Directions:\nThis is the 4th or 5th\nhouse down on left.",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS83771588",
    "name": "Caroline Gillespie",
    "address": "37 The Warren, Burgess Hill, RH15 0DU",
    "phone": "07712 110789",
    "email": "carolinegillespie@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS46354352",
    "name": "Kerry Viljoen",
    "address": "96 Woodland Avenue, Burgess Hill, West Sussex, RH15 0PE",
    "phone": "07866449619",
    "email": "kerryviljoen@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "notes": "Text night before.\nLadder needed. Knock\nfirst to secure dog. If out\ncode is 2005 Pay by\ncard link. Charge extra\n\u00a35 on first clean.",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS6398259",
    "name": "Debbie Griffith",
    "address": "17 West Park Crescent, Burgess Hill, West Sussex, RH15 9TF",
    "phone": "07872 188340",
    "email": "d.kennard2@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS15477798",
    "name": "Jo Crouch",
    "address": "73 Ockley Lane, Hassocks, West Sussex, BN6 8NT",
    "phone": "07745 246040",
    "email": "jojocrouch@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "notes": "Text night before. Use side \ngate by the dustbins.\n\nClimb on extension to reach window above.",
    "jobCount": 1,
    "totalSpent": 35.0
  },
  {
    "id": "CUS55521716",
    "name": "Emma Jolley",
    "address": "13 Gordon Road, Burgess Hill, West Sussex, RH15 0PX",
    "phone": "07745 917619",
    "email": "emma_jolley@yahoo.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 33.33
  },
  {
    "id": "CUS30980334",
    "name": "Allan Walkden",
    "address": "23 Culpepper, Burgess Hill, West Sussex, RH15 8UB",
    "phone": "+44 7808 877004",
    "email": "allanwalkden@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 132.5
  },
  {
    "id": "CUS78584932",
    "name": "Florence Bartley",
    "address": "63 Holmesdale Road, Burgess Hill, RH15 9JP",
    "phone": "07925 832402",
    "email": "bartleyflorence@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "Long pole, there's veluxes on the front, reverse on to the drive",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS87898713",
    "name": "David Edwards",
    "address": "29 Queens Drive, Hassocks, West Sussex, BN6 8DF",
    "phone": "07544 911229",
    "email": "david.edwards58@talktalk.net",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Include \nconservatory and 1 x velux. \nInclude window over \nconservatory. Not the two \nvelux on the other side. \nPay by GoCardless.\n\nThe side gate has no lock, but does have a field gate catch which can fool people.\nWe will be going out at 4pm, other than that we should be in.\nMy son will no doubt be in even if we are out,",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS38593363",
    "name": "Sophie Ross",
    "address": "30 Stonepound Rd, Hassocks BN6 8PR, UK",
    "phone": "07983 305869",
    "email": "15sophieross20@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-04-01",
    "notes": "LONG POLE",
    "jobCount": 1,
    "totalSpent": 42.0
  },
  {
    "id": "CUS38895884",
    "name": "Robert Pryce",
    "address": "Flat H, Alderley House, 18 Chandlers Field Drive, Haywards Heath, West Sussex, RH16 4UT",
    "phone": "07454 205301",
    "email": "9prycer@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "notes": "Hi. We are on the top floor. At the front it\u2019s the 2 balcony doors and windows either side. To the left of the balcony is a single window, and round the back where the resident car park is, the top bedroom window",
    "jobCount": 1,
    "totalSpent": 17.5
  },
  {
    "id": "CUS98364937",
    "name": "Barbara Mason",
    "address": "5a Leyfield, Albourne, Hassocks, West Sussex, BN6 9DA",
    "phone": "07501 845991",
    "email": "b.mason2014@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "Text night before. Include\nextension but not the\nlantern. Friendly dogs\nroaming (make sure gate\nis kept shut). Tap on door\nwhen you arrive to secure\ndogs if they are in. Pay by\ncardlink.",
    "jobCount": 1,
    "totalSpent": 33.0
  },
  {
    "id": "CUS46077151",
    "name": "Roberta Johnson",
    "address": "7 Daisyfields,  Burgess Hill,  RH15 0YB",
    "phone": "+44 7918 913339",
    "email": "roberta_johnson@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.83
  },
  {
    "id": "CUS68300910",
    "name": "Kim Murphy",
    "address": "32 St. Peters Road, Burgess Hill, West Sussex, RH15 8JL",
    "phone": "+44 7890 266493",
    "email": "Kim90walker@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Perfect Properties",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "frequency": "Ad hoc",
    "lastDone": "2025-08-12",
    "nextDue": "",
    "notes": "One off, wants a thorough clean",
    "jobCount": 1,
    "totalSpent": 41.67
  },
  {
    "id": "CUS80851072",
    "name": "Rachel Copper",
    "address": "127 Highbank, Haywards Heath, West Sussex, RH16 4TT",
    "phone": "07718 990252",
    "email": "rachelsmiles15@yahoo.com",
    "state": "active",
    "balance": 36.0,
    "zone": "Haywards Heath",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "notes": "have confirmed with my neighbour that the gate will be open, so you can access the back windows. It is a bit stiff, but it just needs a shove.",
    "jobCount": 1,
    "totalSpent": 16.67
  },
  {
    "id": "CUS76921421",
    "name": "Sophie Charles- Simpson",
    "address": "38 Holmesdale Road, Burgess Hill, West Sussex, RH15 9JR",
    "phone": "07842 765544",
    "email": "sophie_lowton_5@hotmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "Include 2x velux.",
    "jobCount": 1,
    "totalSpent": 26.0
  },
  {
    "id": "CUS38736146",
    "name": "Barry Bilsby",
    "address": "74 Orchard Road, Burgess Hill, West Sussex, RH15 9PL",
    "phone": "07809 426224",
    "email": "barryb28@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 23.33
  },
  {
    "id": "CUS62100238",
    "name": "Cheri McCarthy",
    "address": "1 Tindal Crescent, Burgess Hill, West Sussex, RH15 0XN",
    "phone": "07765 258031",
    "email": "cherimc69@icloud.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.83
  },
  {
    "id": "CUS60631445",
    "name": "Wendy",
    "address": "22 St. Andrews Place, Hassocks, Sussex, BN6 9QE",
    "phone": "07740194809",
    "email": "",
    "state": "active",
    "balance": 26.4,
    "zone": "KG NO EMAIL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "notes": "Park outside 22 on the small path and do 22 and 20",
    "jobCount": 1,
    "totalSpent": 22.0
  },
  {
    "id": "CUS15040552",
    "name": "Jan Laker",
    "address": "109 Maple Drive, Burgess Hill, West Sussex, RH15 8AP",
    "phone": "07813 613367",
    "email": "janandpeg@me.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Friday",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 18.33
  },
  {
    "id": "CUS16498718",
    "name": "Bridget Murray",
    "address": "21 The Close, Burgess Hill, West Sussex, RH15 0PR",
    "phone": "07861 470300",
    "email": "murray2130@googlemail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2025-11-07",
    "nextDue": "2026-02-04",
    "notes": "You can park in their disabled bay.",
    "jobCount": 1,
    "totalSpent": 28.0
  },
  {
    "id": "CUS98939341",
    "name": "David Foster",
    "address": "22 Silverdale Road, Burgess Hill, West Sussex, RH15 0EF",
    "phone": "07515\n338135",
    "email": "daveafoster@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Tuesday",
    "lastDone": "2026-01-08",
    "nextDue": "2026-03-24",
    "notes": "\"Text night before. All windows and doors except the two over the flat roof extension.\nInclude high window on front of garage. Pay by card link.\"",
    "jobCount": 1,
    "totalSpent": 66.67
  },
  {
    "id": "CUS51444064",
    "name": "Martina",
    "address": "2 Packham Gardens, Hurstpierpoint, Hassocks BN6 9YU, UK",
    "phone": "07508868015",
    "email": "martina.stringer@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2025-07-03",
    "nextDue": "2026-03-11",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 115.0
  },
  {
    "id": "CUS65841118",
    "name": "Kerry Keenan",
    "address": "10 Nuthatch Lane, Hassocks, Sussex, BN6 9LB",
    "phone": "07811 763994",
    "email": "kkeenan2@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean front only",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS5526572",
    "name": "Tim Minor",
    "address": "12 Kings Drive, Hassocks, West Sussex, BN6 8DZ",
    "phone": "07791 421917",
    "email": "tim.minor@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "frequency": "every 6 weeks on Wednesday",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS6224133",
    "name": "Louisa Arnold",
    "address": "2 Woodpecker Close, sayers common, Bn6",
    "phone": "07540\u00a0139674\u202c",
    "email": "louisaarnold4@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Sayers Common",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 12 weeks on Thursday",
    "lastDone": "2025-12-19",
    "nextDue": "2026-03-12",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 30.0
  },
  {
    "id": "CUS16316226",
    "name": "Caroline",
    "address": "82 Willow Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9TJ",
    "phone": "07546 402281",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 25.0
  },
  {
    "id": "CUS30085028",
    "name": "Neil Upton",
    "address": "31 Orchard Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9UB",
    "phone": "+44 7860 541743",
    "email": "neilupton1971@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hurstpierpoint",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Thursday",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "notes": "Include 8 veluxes, new customer",
    "jobCount": 1,
    "totalSpent": 45.0
  },
  {
    "id": "CUS87821283",
    "name": "Adam Mayes",
    "address": "14 Foxglove Close, Burgess Hill, West Sussex, RH15 8UY",
    "phone": "+44 7936 695454",
    "email": "adam.mayes@hotmail.co.uk",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "To clean the rear do it from next doors garden no.12\n\n0229 - key box",
    "jobCount": 1,
    "totalSpent": 20.0
  },
  {
    "id": "CUS91058314",
    "name": "Shane  Pentecost",
    "address": "20 Bramber Way, Burgess Hill, West Sussex, RH15 8JX",
    "phone": "07368 273781",
    "email": "victoria.pentecost@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 3",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 104.0
  },
  {
    "id": "CUS81866316",
    "name": "Tony Gibson",
    "address": "5 Oak Tree Drive, Hassocks, West Sussex, BN6 8YA",
    "phone": "01273044127",
    "email": "TonyBGibson@outlook.com",
    "state": "active",
    "balance": 0.0,
    "zone": "Hassocks",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "frequency": "every 12 weeks on Wednesday",
    "lastDone": "2026-01-21",
    "nextDue": "2026-04-15",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 36.0
  },
  {
    "id": "CUS35954816",
    "name": "Karen Noble",
    "address": "7 Capenors, Burgess Hill, West Sussex, RH15 9QL",
    "phone": "07949 023458",
    "email": "karen.noble@sky.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "notes": "",
    "jobCount": 2,
    "totalSpent": 151.67000000000002
  },
  {
    "id": "CUS58963577",
    "name": "Anna Brownlie",
    "address": "28 Cold Waltham Lane, Burgess Hill, West Sussex, RH15 0EH",
    "phone": "07747 1324433",
    "email": "annambrownlie@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 4",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS17333335",
    "name": "Jude Sharpin",
    "address": "69 Chanctonbury Rd, Burgess Hill RH15 9EX, UK",
    "phone": "07780 334369",
    "email": "y66jud@gmail.com",
    "state": "active",
    "balance": 35.0,
    "zone": "BH Zone 2",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Tuesday",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "notes": "",
    "jobCount": 1,
    "totalSpent": 29.17
  },
  {
    "id": "CUS53119800",
    "name": "Barry Stevens",
    "address": "12 Pinehurst, Burgess Hill, West Sussex, RH15 0DQ",
    "phone": "07739 645439",
    "email": "pinehurst.bs@gmail.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 2",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-09",
    "nextDue": "2026-03-09",
    "notes": "Text night before. Not the\nconservatory. Pay by\ncash. When asked do\nconservatory for\nadditional \u00a310. Please\nleave leaflet. Cash \u00a323",
    "jobCount": 1,
    "totalSpent": 0.0
  },
  {
    "id": "CUS41636251",
    "name": "Dan",
    "address": "106 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AJ",
    "phone": "07515004635",
    "email": "",
    "state": "active",
    "balance": 0.0,
    "zone": "HPP NO EMAIL",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 2 months on the 11th",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "notes": "Gate Code 1568",
    "jobCount": 1,
    "totalSpent": 27.5
  },
  {
    "id": "CUS43875580",
    "name": "Imogen Mercer",
    "address": "5 South Drive, Burgess Hill, West Sussex, RH15 9PY",
    "phone": "07477146151",
    "email": "imogen_kim@yahoo.com",
    "state": "active",
    "balance": 0.0,
    "zone": "BH Zone 1",
    "assignee": "Steve",
    "services": "Window Clean",
    "frequency": "every 6 weeks on Monday",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "notes": "**NEW**",
    "jobCount": 1,
    "totalSpent": 25.0
  }
];

export const csvJobs = [
  {
    "id": "JOB000000",
    "customerRef": "CUS27861086",
    "customerName": "John Hall",
    "address": "3 Langridge Way, Burgess Hill RH15 8TN, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 25.3,
    "duration": "00:45",
    "notes": "Include velux on side extension",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 33
  },
  {
    "id": "JOB000001",
    "customerRef": "CUS17118657",
    "customerName": "Carol Mason",
    "address": "41 The Wickets, Burgess Hill, West Sussex, RH15 8TG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000002",
    "customerRef": "CUS8260453",
    "customerName": "Sami Dawes",
    "address": "117 Icarus Avenue, Burgess Hill, RH15 0UW",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "When you see numbers like 101, 117 is down a path on the left.\n\nPark the van after the low 100 numbers on the left and pull the hose past 117 down to the flats to give you enough to go in the garden",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 29
  },
  {
    "id": "JOB000004",
    "customerRef": "CUS86628487",
    "customerName": "Peter",
    "address": "91 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 16.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 35
  },
  {
    "id": "JOB000005",
    "customerRef": "CUS86628487",
    "customerName": "Peter",
    "address": "91 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "assignee": "",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 60.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2023-07-26",
    "nextDue": "2026-02-02",
    "frequency": "every 6 months on the 2nd",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 3
  },
  {
    "id": "JOB000008",
    "customerRef": "CUS38475085",
    "customerName": "Jo Harris",
    "address": "120 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 36.0,
    "duration": "00:30",
    "notes": "Text night before.\nInclude 2 x velux. Pay\nby GoCardless",
    "lastDone": "2026-01-05",
    "nextDue": "2026-03-30",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB000009",
    "customerRef": "CUS21724915",
    "customerName": "Mike Fox",
    "address": "24 Sunningdale Road, Hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 25,
    "done": 25
  },
  {
    "id": "JOB000012",
    "customerRef": "CUS72420019",
    "customerName": "Jamie Mendoza",
    "address": "1 Capenors, Burgess Hill RH15 9QL, UK",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 100.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-02-07",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000013",
    "customerRef": "CUS72420019",
    "customerName": "Jamie Mendoza",
    "address": "1 Capenors, Burgess Hill RH15 9QL, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 28.6,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 33
  },
  {
    "id": "JOB000014",
    "customerRef": "CUS51457707",
    "customerName": "Sarah",
    "address": "4 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Inc Con. Cash \u00a330",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 12
  },
  {
    "id": "JOB000015",
    "customerRef": "CUS26247199",
    "customerName": "Lisa",
    "address": "1 London Rd, Hassocks BN6 9NT, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Cash under the mat by the back door",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 25
  },
  {
    "id": "JOB000018",
    "customerRef": "CUS32202600",
    "customerName": "Sasha OConnor",
    "address": "57 Larkspur Drive, Burgess Hill, West Sussex, RH15 0UL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000019",
    "customerRef": "CUS68436421",
    "customerName": "Shaun",
    "address": "17 St Andrews Place Hassocks BN6",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 17.6,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 45,
    "done": 42
  },
  {
    "id": "JOB000020",
    "customerRef": "CUS3349883",
    "customerName": "Warwick Hart",
    "address": "30 Meadow Lane, Burgess Hill, West Sussex, RH15 9JA",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 23.0,
    "duration": "00:30",
    "notes": "Garden through garage",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 12
  },
  {
    "id": "JOB000021",
    "customerRef": "CUS2102327",
    "customerName": "Steve Parish",
    "address": "154 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 38.33,
    "duration": "00:30",
    "notes": "Text night before. Include\nextension and velux on\nextension roof. Pay by\ncard linK",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000022",
    "customerRef": "CUS46858439",
    "customerName": "Sue Taplin",
    "address": "11 The Rowans, Burgess Hill, West Sussex, RH15 8UZ",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 31.67,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory. Pay by card\nlink.",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000023",
    "customerRef": "CUS93559748",
    "customerName": "Reece Massen",
    "address": "3 Michelbourne Close, Burgess Hill, West Sussex, RH15 9QX",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 2",
    "price": 29.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB000024",
    "customerRef": "CUS69398698",
    "customerName": "Rebecca Young",
    "address": "21 The Maltings, Burgess Hill, West Sussex, RH15 9XF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 21.67,
    "duration": "00:30",
    "notes": "Text night before.  Knock first to secure dog. Use side gate to right of front door as you're looking at house.  Pay by card link. Please leave leaflet.",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000025",
    "customerRef": "CUS59645278",
    "customerName": "Jacqui Bush",
    "address": "39 The Ridings, Burgess Hill, West Sussex, RH15 0PL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000026",
    "customerRef": "CUS37465770",
    "customerName": "Linda Surridge",
    "address": "3 Nuthatch Lane, Hassocks, Sussex, BN6 9LB",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 20
  },
  {
    "id": "JOB000027",
    "customerRef": "CUS5298781",
    "customerName": "Alex Munn",
    "address": "52 Nightingale Way, Sayers Common, Hassocks, West Sussex, BN6 9HP",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000028",
    "customerRef": "CUS58405955",
    "customerName": "Becca Egan",
    "address": "28 Nightingale Way, Sayers Common, Hassocks, BN6 9HP",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 23
  },
  {
    "id": "JOB000030",
    "customerRef": "CUS65868109",
    "customerName": "Pauline Bruce",
    "address": "22 Mackie Avenue, Hassocks, West Sussex, BN6 8NL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Not the \nvelux.",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000035",
    "customerRef": "CUS21139658",
    "customerName": "Anthony Bailey",
    "address": "18 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 22.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000036",
    "customerRef": "CUS12846407",
    "customerName": "Liz Crews",
    "address": "7 Paynters Way, Newick, Lewes, East Sussex, BN8 4PH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000037",
    "customerRef": "CUS4041597",
    "customerName": "Jayne Carr",
    "address": "1 Shepherds Mead, Burgess Hill, West Sussex, RH15 8AS",
    "assignee": "Steve",
    "services": "Facias and Sofitts,Gutter Cleaning",
    "zone": "Perfect Properties",
    "price": 133.34,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-21",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000038",
    "customerRef": "CUS4041597",
    "customerName": "Jayne Carr",
    "address": "1 Shepherds Mead, Burgess Hill, West Sussex, RH15 8AS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Front\nand side only. Access to\nrear through house if in\nand then do whole house\nbut not the garage.\n\nLET ME KNOW WHEN WHOLE HOUSE IS DONE BEFORE SWIPING IT COMPLETED",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000039",
    "customerRef": "CUS64568892",
    "customerName": "Karen Keys",
    "address": "46 Marlborough Drive, Burgess Hill, West Sussex, RH15 0EU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-03-16",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 10
  },
  {
    "id": "JOB000041",
    "customerRef": "CUS1145995",
    "customerName": "A. Martinez",
    "address": "57 Noel Rise, Burgess Hill, West Sussex, RH15 8BU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 19.17,
    "duration": "00:30",
    "notes": "Text night before.\nInclude front porch. Pay\nby cash or cardlink.\nPlease quote for gutters,\nsoffits and fascias",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000042",
    "customerRef": "CUS60976935",
    "customerName": "Sarah Herbert",
    "address": "38 Withy Bush, Burgess Hill RH15 8TT, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 17.6,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 32
  },
  {
    "id": "JOB000043",
    "customerRef": "CUS60976935",
    "customerName": "Sarah Herbert",
    "address": "38 Withy Bush, Burgess Hill RH15 8TT, UK",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "Include conservatory gutters",
    "lastDone": "2024-02-07",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000044",
    "customerRef": "CUS46213489",
    "customerName": "Mark Salway",
    "address": "18 Beacon Crescent, Burgess Hill, West Sussex, RH15 0ZL",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Garage Door",
    "zone": "BH Zone 4",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Text night before.\nInclude garage door\nand window. Pay by\ncard link.",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000045",
    "customerRef": "CUS57505767",
    "customerName": "Pauline",
    "address": "34 Stonepound Road, Hassocks, BN6 8PR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:45",
    "notes": "LONG POLE",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 35
  },
  {
    "id": "JOB000048",
    "customerRef": "CUS87170270",
    "customerName": "Lynda Parr",
    "address": "13 Stonepound Rd, Hassocks BN6 8PN, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 24.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 33
  },
  {
    "id": "JOB000050",
    "customerRef": "CUS36425723",
    "customerName": "Lisa Sainty",
    "address": "101 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "assignee": "Dan",
    "services": "Window Clean,Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 66.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-03",
    "nextDue": "",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000051",
    "customerRef": "CUS27887678",
    "customerName": "Miranda Wilsnagh",
    "address": "112 Avenue De Warenne, Hassocks, West Sussex, BN6 8GE",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 2
  },
  {
    "id": "JOB000052",
    "customerRef": "CUS32990547",
    "customerName": "Abbie Holford",
    "address": "11 The Warren, Burgess Hill, RH15 0DU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 23
  },
  {
    "id": "JOB000053",
    "customerRef": "CUS25844230",
    "customerName": "Sue Ford- Jones",
    "address": "9 The Vineries, Burgess Hill, West Sussex, RH15 0ND",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000054",
    "customerRef": "CUS78902188",
    "customerName": "Susan Thompson",
    "address": "19 Midfields Drive, Burgess Hill, West Sussex, RH15 8EN",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory (not the\nconservatory roof). Pay\nby card link.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 12
  },
  {
    "id": "JOB000055",
    "customerRef": "CUS34429823",
    "customerName": "Linda Mills",
    "address": "6 Chestnuts Close, Lindfield, Haywards Heath, West Sussex, RH16 2AU",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Lindfield",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000056",
    "customerRef": "CUS10179541",
    "customerName": "Rich",
    "address": "39 Royal George Road, Burgess Hill, West Sussex, RH15 9SB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 33.33,
    "duration": "00:30",
    "notes": "In most of the day apart from School drop off",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000057",
    "customerRef": "CUS93764737",
    "customerName": "Cathy Burt",
    "address": "40 Woodsland Rd, Hassocks BN6 8HG, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 19.8,
    "duration": "00:30",
    "notes": "You have to extend the small pole a few sections to reach the side of the house above the kitchen",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 36
  },
  {
    "id": "JOB000059",
    "customerRef": "CUS49523215",
    "customerName": "Joanne Collinson",
    "address": "7d West Street, Burgess Hill, West Sussex, RH15 8NN",
    "assignee": "Steve, Dan",
    "services": "Window Clean every 12 weeks,Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 36.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-20",
    "nextDue": "2026-04-14",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000061",
    "customerRef": "CUS18241188",
    "customerName": "Dee Mackenzie",
    "address": "7 Potters Lane, Burgess Hill, West Sussex, RH15 9HX",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Not the garden room",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 15
  },
  {
    "id": "JOB000062",
    "customerRef": "CUS73333985",
    "customerName": "Jim Bridger",
    "address": "49 Goldcrest Dr, Hassocks BN6, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 32.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 31
  },
  {
    "id": "JOB000063",
    "customerRef": "CUS88094977",
    "customerName": "Emanuela Litchfield",
    "address": "79 Larkspur Drive, Burgess Hill, West Sussex, RH15 0UL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before. Include 2 dormers and 2 velux. Pay by card link.",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000066",
    "customerRef": "CUS80071634",
    "customerName": "Robin Flynn",
    "address": "110 Mill Road, Burgess Hill, West Sussex, RH15 8BZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 33.0,
    "duration": "00:30",
    "notes": "This is a home for disabled people. Knock the door if the gates locked.",
    "lastDone": "2025-12-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000068",
    "customerRef": "CUS63170421",
    "customerName": "Gemma Eaton",
    "address": "2 The Hawthorns, Burgess Hill, West Sussex, RH15 8RL",
    "assignee": "Dan, Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000071",
    "customerRef": "CUS17773448",
    "customerName": "Jan Wright",
    "address": "47 Bonny Wood Rd, Hassocks BN6 8HP, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 36.0,
    "duration": "00:30",
    "notes": "janwright133@gmail.com",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 27
  },
  {
    "id": "JOB000072",
    "customerRef": "CUS17773448",
    "customerName": "Jan Wright",
    "address": "47 Bonny Wood Rd, Hassocks BN6 8HP, UK",
    "assignee": "Steve",
    "services": "Conservatory Clean",
    "zone": "Perfect Properties",
    "price": 60.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-02-27",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000073",
    "customerRef": "CUS69002839",
    "customerName": "Samantha Hardwick",
    "address": "Little Washbrook Farm  Hurstpierpoint Xx, Brighton Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9EF",
    "assignee": "Dan",
    "services": "Annex Clean inc all Velux",
    "zone": "Perfect Properties",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-08",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000074",
    "customerRef": "CUS69002839",
    "customerName": "Samantha Hardwick",
    "address": "Little Washbrook Farm  Hurstpierpoint Xx, Brighton Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9EF",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows,Window clean inc velux",
    "zone": "Hurstpierpoint",
    "price": 38.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-22",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 4
  },
  {
    "id": "JOB000075",
    "customerRef": "CUS58075726",
    "customerName": "Sarah Louise Stenning",
    "address": "11 Pierce Place, Hurstpierpoint, Hassocks, West Sussex, BN6 9YL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000077",
    "customerRef": "CUS54118",
    "customerName": "John Ware",
    "address": "25 Stonefield Way, Burgess Hill, West Sussex, RH15 8DW",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before. Side\ngate to side of house. No\nrear. Pay by card link.",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000078",
    "customerRef": "CUS57729697",
    "customerName": "Linda  Richards",
    "address": "1 St. Christophers Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9UX",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Text night before. Not the \nJuliette balcony at the \nfront. Pays cash until he \nknows you better then \nwill do GoCardless. \u00a325",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB000079",
    "customerRef": "CUS42334453",
    "customerName": "Laura",
    "address": "89 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 17.6,
    "duration": "00:40",
    "notes": "Hey Dan, just to let you know the back gate is unlocked but it gets a bit stiff so you have to give it a bit of a firm shove to open it \u263a\ufe0f",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 37
  },
  {
    "id": "JOB000080",
    "customerRef": "CUS42334453",
    "customerName": "Laura",
    "address": "89 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "assignee": "",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2022-09-26",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000081",
    "customerRef": "CUS48793146",
    "customerName": "Johanna Swirski",
    "address": "47 Downsview Drive, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7RN",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Wivelsfield",
    "price": 26.67,
    "duration": "00:30",
    "notes": "Not conservatory",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000082",
    "customerRef": "CUS90018854",
    "customerName": "Sophia  Untersteggaber",
    "address": "4 Packham Way, Burgess Hill, West Sussex, RH15 8PE",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 15
  },
  {
    "id": "JOB000083",
    "customerRef": "CUS9021515",
    "customerName": "Emily Miller",
    "address": "1 Bishops Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9XU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000084",
    "customerRef": "CUS64664964",
    "customerName": "Derek Louw",
    "address": "48 Manor Rd, Burgess Hill RH15 0NL, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 16.5,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-10-10",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 24
  },
  {
    "id": "JOB000086",
    "customerRef": "CUS66812560",
    "customerName": "Pat Gannon",
    "address": "13 Pierce Place, Hurstpierpoint, Hassocks, BN6 9YL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 24.2,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 24
  },
  {
    "id": "JOB000089",
    "customerRef": "CUS42843630",
    "customerName": "Connor",
    "address": "13 Hamfield Dr, Hassocks BN6 9ZW, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-04-15",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 20
  },
  {
    "id": "JOB000090",
    "customerRef": "CUS93107632",
    "customerName": "Fiona",
    "address": "12 The Street, Albourne, Hassocks, West Sussex, BN6 9DL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-19",
    "nextDue": "2026-02-10",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 3
  },
  {
    "id": "JOB000091",
    "customerRef": "CUS35055576",
    "customerName": "Rebecca Marriner",
    "address": "42 St Andrews Rd, Burgess Hill RH15 0LU, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 17.6,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-21",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 22
  },
  {
    "id": "JOB000092",
    "customerRef": "CUS26432144",
    "customerName": "Neale Austin",
    "address": "1 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "assignee": "",
    "services": "Facias and Sofitts",
    "zone": "",
    "price": 140.0,
    "duration": "00:45",
    "notes": "\u00a335 per sidex4",
    "lastDone": "2022-03-09",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000093",
    "customerRef": "CUS26432144",
    "customerName": "Neale Austin",
    "address": "1 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "assignee": "",
    "services": "Gutter Clearance",
    "zone": "",
    "price": 120.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2022-03-09",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000094",
    "customerRef": "CUS26432144",
    "customerName": "Neale Austin",
    "address": "1 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 38.0,
    "duration": "00:45",
    "notes": "Reach over if gate is locked",
    "lastDone": "2025-12-01",
    "nextDue": "2026-02-23",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000095",
    "customerRef": "CUS82287230",
    "customerName": "Stefan",
    "address": "49 Charlwood Gardens, Burgess Hill, West Sussex, RH15 0RD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-04-17",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000096",
    "customerRef": "CUS52686823",
    "customerName": "Amy Ciambriello",
    "address": "43 Oak Hall Park, Burgess Hill, West Sussex, RH15 0DH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000097",
    "customerRef": "CUS97965570",
    "customerName": "Annie",
    "address": "4C Stanford Avenue, Hassocks, West Sussex, BN6 8JH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 15.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-04-01",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000098",
    "customerRef": "CUS44167258",
    "customerName": "Anna Whitesaid",
    "address": "2 Nuthatch Lane, Sayers Common, Hassocks, BN6 9LB",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 24
  },
  {
    "id": "JOB000099",
    "customerRef": "CUS2761221",
    "customerName": "Eileen Lawson",
    "address": "174 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "zone": "Hurstpierpoint",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000100",
    "customerRef": "CUS50562943",
    "customerName": "Jonathan Sinnatt",
    "address": "48 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "never",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 0
  },
  {
    "id": "JOB000102",
    "customerRef": "CUS52396966",
    "customerName": "Matthew Parisi",
    "address": "127 Manor Road, Burgess Hill, West Sussex, RH15 0NG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Not the\nconservatory",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000104",
    "customerRef": "CUS16903790",
    "customerName": "Caroline Cleaver",
    "address": "12 The Fairway, Hassocks BN6, UK",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 35.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 34
  },
  {
    "id": "JOB000105",
    "customerRef": "CUS68654676",
    "customerName": "Steven Smith",
    "address": "16 Tinchurch Drive, Burgess Hill, West Sussex, RH15 0XJ",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-07-17",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000106",
    "customerRef": "CUS59292240",
    "customerName": "Andy",
    "address": "51 SUNNINGDALE ROAD HASSOCKS",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Park outside 29 and do 51 Sunningdale and\n36 Wentworth, 29 the fairway",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 30
  },
  {
    "id": "JOB000107",
    "customerRef": "CUS56757894",
    "customerName": "Peter Raynes",
    "address": "11 Dunstall Farm Road, Burgess Hill, West Sussex, RH15 8AX",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 14
  },
  {
    "id": "JOB000110",
    "customerRef": "CUS99330001",
    "customerName": "Pam Manning",
    "address": "18 Culpepper, Burgess Hill RH15 8UB, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Leaded windows - orange brush",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 30
  },
  {
    "id": "JOB000111",
    "customerRef": "CUS78412920",
    "customerName": "Joan",
    "address": "16 The Gattons, Burgess Hill, RH15 9SW",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-11-24",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 12
  },
  {
    "id": "JOB000112",
    "customerRef": "CUS67729570",
    "customerName": "Nikki",
    "address": "43 Chancellors Park, Hassocks, West Sussex, BN6 8EY",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "zone": "Hassocks",
    "price": 37.5,
    "duration": "00:30",
    "notes": "All windows. Roof with velux. You may be able to do them from the ground. I never tried because it looked easier to use a ladder.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB000113",
    "customerRef": "CUS5694532",
    "customerName": "Tom Read",
    "address": "22 Chapel Road, Plumpton Green, Lewes, East Sussex, BN7 3DD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 22.5,
    "duration": "00:30",
    "notes": "Text night before. Pay by card link",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000115",
    "customerRef": "CUS68051489",
    "customerName": "Olga Forster",
    "address": "16 Grand Avenue, Hassocks, West Sussex, BN6 8DB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Not sky\nlight in dining room.\nInclude dormer and 2\nvelux.\n\nCash \u00a345",
    "lastDone": "2026-01-09",
    "nextDue": "2026-04-03",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 5
  },
  {
    "id": "JOB000116",
    "customerRef": "CUS69371947",
    "customerName": "Eleanor Watson",
    "address": "1 Hurst Wickham Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9AL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 33.33,
    "duration": "00:30",
    "notes": "New please give a thorough clean",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000118",
    "customerRef": "CUS53578590",
    "customerName": "Grant Foulks",
    "address": "14 Nye Road, Burgess Hill, West Sussex, RH15 0JY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000119",
    "customerRef": "CUS8370677",
    "customerName": "John Wilson",
    "address": "58 Friars Oak Road, Hassocks, West Sussex, BN6 8PY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000120",
    "customerRef": "CUS73137730",
    "customerName": "Anne Malkin",
    "address": "82 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000121",
    "customerRef": "CUS37881519",
    "customerName": "Dan Gibbs",
    "address": "12 The Acorns, Burgess Hill RH15 8UW, UK",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-16",
    "nextDue": "2026-03-10",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 15
  },
  {
    "id": "JOB000122",
    "customerRef": "CUS37881519",
    "customerName": "Dan Gibbs",
    "address": "12 The Acorns, Burgess Hill RH15 8UW, UK",
    "assignee": "Dan",
    "services": "Gutter Clearance,Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 184.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-07-14",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000123",
    "customerRef": "CUS5199779",
    "customerName": "Sarah Hicking-Botham",
    "address": "4 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 29.0,
    "duration": "00:45",
    "notes": "Not window above extension, you can reach the bathroom window from the left side, do the garden office as well, reach over gate to unlock, please do up after \ud83d\udc4d\ud83c\udffb",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 21
  },
  {
    "id": "JOB000126",
    "customerRef": "CUS90066056",
    "customerName": "Kerry Cameron",
    "address": "35 Leigh meadow, Burgess Hill RH15 0YP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.33,
    "duration": "00:30",
    "notes": "Gate Code is 2013, please close on the way out\n\nSmall window round to the left of front door",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000127",
    "customerRef": "CUS99940122",
    "customerName": "Kelly Holdstock",
    "address": "64 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000128",
    "customerRef": "CUS79843999",
    "customerName": "Matt Tucker",
    "address": "5 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 24.0,
    "duration": "00:30",
    "notes": "Text night before.\nInclude 1 x velux.",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB000129",
    "customerRef": "CUS98750489",
    "customerName": "Ros March",
    "address": "60 Oldaker Road, Newick, Lewes, East Sussex, BN8 4LP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 21.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000131",
    "customerRef": "CUS83928724",
    "customerName": "John Logan",
    "address": "39 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000133",
    "customerRef": "CUS59944558",
    "customerName": "Karen",
    "address": "19 St Andrews Place Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 19.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 36
  },
  {
    "id": "JOB000134",
    "customerRef": "CUS33982618",
    "customerName": "Tony Oliver",
    "address": "10 Woodpecker Crescent, Burgess Hill, West Sussex, RH15 9XY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 30.0,
    "duration": "00:30",
    "notes": "**NEW**",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000135",
    "customerRef": "CUS71940084",
    "customerName": "Nicki Brooks",
    "address": "2 Stroudley Drive, Burgess Hill, RH15 0ZT",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 35.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000137",
    "customerRef": "CUS43379086",
    "customerName": "Victoria Kib",
    "address": "3 Sunningdale Drive Hassocks",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 70.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-02-06",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000138",
    "customerRef": "CUS43379086",
    "customerName": "Victoria Kib",
    "address": "3 Sunningdale Drive Hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 25.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-07-11",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000141",
    "customerRef": "CUS61946561",
    "customerName": "Michael Vaile",
    "address": "1 Field Villas, Mill Road, Burgess Hill, West Sussex, RH15 8DB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Include\ncladding above front\nupstairs bay window.\nCharge extra \u00a35 on first\nvisit. Directions: The lane to\nthis property is inbetween\nnumbers 161 and 163 NB\nThere are two properties\nnumbered 1 in this lane and\nneither of them are the first\nhouse. This house is 1 Field\nVillas.",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000142",
    "customerRef": "CUS15860207",
    "customerName": "Di Goss",
    "address": "68 Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Include\nconservatory",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 14
  },
  {
    "id": "JOB000143",
    "customerRef": "CUS24804153",
    "customerName": "David MORECROFT",
    "address": "49 SUNNINGDALE ROAD HASSOCKS",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 26.0,
    "duration": "00:30",
    "notes": "Include the velux on the extension, do it from the road",
    "lastDone": "2026-01-10",
    "nextDue": "2026-04-03",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 27
  },
  {
    "id": "JOB000144",
    "customerRef": "CUS74900012",
    "customerName": "Kelly Wilson",
    "address": "62 Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 25.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000147",
    "customerRef": "CUS31362179",
    "customerName": "Bryon Todd",
    "address": "10 Penland Close, Haywards Heath, West Sussex, RH16 1PR",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000148",
    "customerRef": "CUS84656736",
    "customerName": "John Newton",
    "address": "21 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000149",
    "customerRef": "CUS92191063",
    "customerName": "Linda Ashby",
    "address": "20 Dale Ave, Keymer, Hassocks BN6 8LP, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 26.4,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 26
  },
  {
    "id": "JOB000151",
    "customerRef": "CUS10673520",
    "customerName": "Steve Hunt",
    "address": "1 Thistle Place Burgess Hill RH15 0WZ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000152",
    "customerRef": "CUS1350304",
    "customerName": "Richard Mills",
    "address": "8 John Wood Crescent, Hassocks, BN6 8FQ",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 21,
    "done": 20
  },
  {
    "id": "JOB000154",
    "customerRef": "CUS50309563",
    "customerName": "Vanessa Lilley",
    "address": "39 Sycamore Drive, Burgess Hill, West Sussex, RH15 0GG",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 15
  },
  {
    "id": "JOB000155",
    "customerRef": "CUS17687582",
    "customerName": "Sam Hinks",
    "address": "109a Keymer Road, Hassocks, West Sussex, BN6 8QL",
    "assignee": "Steve, Dan",
    "services": "Window Clean - Flat",
    "zone": "Hassocks2",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Main window on the ground to the right of the green front door , down the side of the building the remaining windows are at the back",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000156",
    "customerRef": "CUS61843464",
    "customerName": "Amy Rogerson",
    "address": "79 Parklands Road, Hassocks, West Sussex, BN6 8JY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 23.0,
    "duration": "00:30",
    "notes": "Text night before. Access\nto rear via service path\nfrom Age Concern\ncarpark (via Dale Ave)\n(Age concern have said\nyou can use their car park\nwhilst doing) When asked\nif you can do it from the\nground do the rear\nskylight for additional\n\u00a315. DO NOT GO ONTO\nTHE ROOF. If you cannot\ndo it she will continue\ndoing this skylight from\nher bedroom window. Pay\nby card lin",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000159",
    "customerRef": "CUS41324630",
    "customerName": "Dudley Kemp",
    "address": "7 Firtoft Close, Burgess Hill, West Sussex, RH15 8EE",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Text night before. Not 2\nrear windows above flat\nroof. Include\nconservatory.",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 10
  },
  {
    "id": "JOB000160",
    "customerRef": "CUS12455128",
    "customerName": "Rachel Joyce",
    "address": "12 Grand Avenue, Hassocks, West Sussex, BN6 8DA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 29.0,
    "duration": "00:30",
    "notes": "Text night before. Include \nextension but not extension \nroof windows. Not the \nvelux",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 15
  },
  {
    "id": "JOB000161",
    "customerRef": "CUS42533250",
    "customerName": "Ross French",
    "address": "62 Dunstall Farm Road, Burgess Hill, West Sussex, RH15 8BJ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000162",
    "customerRef": "CUS75676050",
    "customerName": "Theresa Guise",
    "address": "2 The Willows, Burgess Hill, West Sussex, RH15 8HU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 38.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory. The side\nwindows on one side do\nbest you can",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000163",
    "customerRef": "CUS99375023",
    "customerName": "Jenni Jolley",
    "address": "28 Chancellors Park, Hassocks, West Sussex, BN6 8EZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 13
  },
  {
    "id": "JOB000165",
    "customerRef": "CUS73254533",
    "customerName": "Stuart Allen",
    "address": "2 Farnlea, Burgess Hill, West Sussex, RH15 0BD",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 37.5,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory, 2 x velux,\nextension and front\nporch. Not the\nconservatory roof. Pay\nby card link.",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000166",
    "customerRef": "CUS11167425",
    "customerName": "Michael  Randell",
    "address": "22 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 23.0,
    "duration": "00:30",
    "notes": "Text night before. Not the \nJuliette balcony at the \nfront. Pays cash until he \nknows you better then \nwill do GoCardless. \u00a323",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000167",
    "customerRef": "CUS76696662",
    "customerName": "Sarah Jane",
    "address": "9 The Fairway Hassocks",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 20.0,
    "duration": "00:40",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 43,
    "done": 40
  },
  {
    "id": "JOB000169",
    "customerRef": "CUS80507119",
    "customerName": "Med Haynes",
    "address": "6 Highfields, Brighton Road, Warninglid, Haywards Heath, West Sussex, RH17 5SY",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 130.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-08-22",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000170",
    "customerRef": "CUS76126318",
    "customerName": "Jenny Larter",
    "address": "23 Rolfe Dr, Burgess Hill RH15 0LA, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 16.5,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 29
  },
  {
    "id": "JOB000173",
    "customerRef": "CUS73912334",
    "customerName": "John Bayfield",
    "address": "33 Downscroft, Burgess Hill, RH15 0UF",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-06-28",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000174",
    "customerRef": "CUS73912334",
    "customerName": "John Bayfield",
    "address": "33 Downscroft, Burgess Hill, RH15 0UF",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "zone": "BH Zone 3",
    "price": 17.6,
    "duration": "00:30",
    "notes": "FRONT AND BOTH SIDES ONLY",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000176",
    "customerRef": "CUS37020178",
    "customerName": "Clint Pike",
    "address": "5 Green View, Orchard Road, Burgess Hill, RH15 9PA",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 21
  },
  {
    "id": "JOB000177",
    "customerRef": "CUS71273094",
    "customerName": "Adrian Franks",
    "address": "7 Partridge Cl, Burgess Hill RH15 0ZR, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 22.0,
    "duration": "00:30",
    "notes": "Small velux on the left side is included",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 28
  },
  {
    "id": "JOB000180",
    "customerRef": "CUS36524602",
    "customerName": "Stacey Jones",
    "address": "6 Heath Close, Sayers Common, Hassocks, West Sussex, BN6 9XL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000182",
    "customerRef": "CUS810231",
    "customerName": "Caroline Green",
    "address": "11 Farlington Avenue, Haywards Heath, West Sussex, RH16 3EZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000183",
    "customerRef": "CUS57316109",
    "customerName": "Liz Horton",
    "address": "34 Goldcrest Dr, Hassocks BN6, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 31
  },
  {
    "id": "JOB000184",
    "customerRef": "CUS68071108",
    "customerName": "Keith",
    "address": "2 Hurst Wickham Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9AL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 40.0,
    "duration": "00:30",
    "notes": "All windows",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000186",
    "customerRef": "CUS13106583",
    "customerName": "Ken Berreen",
    "address": "36 Stirling Court Road, Burgess Hill, West Sussex, RH15 0PT",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 4",
    "price": 25.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000188",
    "customerRef": "CUS4832401",
    "customerName": "Ellie Eastwood",
    "address": "17 Ockley Way, Hassocks BN6 8NE, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 25,
    "done": 25
  },
  {
    "id": "JOB000189",
    "customerRef": "CUS46323373",
    "customerName": "Katie",
    "address": "11 Chichester Way, Burgess Hill, West Sussex, RH15 0RH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 22.0,
    "duration": "00:30",
    "notes": "Park on drive between the two houses",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 19
  },
  {
    "id": "JOB000190",
    "customerRef": "CUS57104210",
    "customerName": "Grant Carter",
    "address": "1 Pierce Place, Hurstpierpoint, Hassocks, BN6 9YL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 40.7,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB000191",
    "customerRef": "CUS40370973",
    "customerName": "Jonny",
    "address": "2 Stonepound Court, BN6 9NT",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Pays CASH, knock the door",
    "lastDone": "2025-09-30",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 51,
    "done": 47
  },
  {
    "id": "JOB000192",
    "customerRef": "CUS40370973",
    "customerName": "Jonny",
    "address": "2 Stonepound Court, BN6 9NT",
    "assignee": "",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 60.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2022-02-25",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000193",
    "customerRef": "CUS56089836",
    "customerName": "Julie Hamilton",
    "address": "25 Shearing Dr, Burgess Hill RH15 0NA, UK",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-07-28",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000194",
    "customerRef": "CUS32884874",
    "customerName": "Max Ife",
    "address": "25 Dale Avenue, Hassocks, West Sussex, BN6 8LP",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 26.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-25",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 9
  },
  {
    "id": "JOB000199",
    "customerRef": "CUS15942324",
    "customerName": "Anne",
    "address": "1 Woodsland Close, Hassocks, West Sussex, BN6 8HF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-29",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 8
  },
  {
    "id": "JOB000200",
    "customerRef": "CUS74597018",
    "customerName": "Cenk Ozkan",
    "address": "24 St. Lawrence Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9SH",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hurstpierpoint",
    "price": 40.0,
    "duration": "00:30",
    "notes": "Text night before.\nInclude conservatory.\npay by card link.",
    "lastDone": "2025-09-25",
    "nextDue": "2026-03-05",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000201",
    "customerRef": "CUS11040743",
    "customerName": "Samuel Tucknott",
    "address": "11 Payton Drive, Burgess Hill, West Sussex, RH15 9UU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000202",
    "customerRef": "CUS49129284",
    "customerName": "Jane Lindsay-Stewart",
    "address": "54 Curf Way, Burgess Hill RH15 0GE, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.6,
    "duration": "00:30",
    "notes": "You need long pole for 60,58,54",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 26
  },
  {
    "id": "JOB000203",
    "customerRef": "CUS4999992",
    "customerName": "Katie",
    "address": "14 Five Oaks Way, Hassocks, BN6 9ZU",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 19.8,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-02",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000204",
    "customerRef": "CUS71508235",
    "customerName": "Sandra Palmer",
    "address": "46 Priory Road, Burgess Hill, RH15 9HB",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:45",
    "notes": "Cash \u00a322, NOT front door just front and back",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 24
  },
  {
    "id": "JOB000205",
    "customerRef": "CUS37790078",
    "customerName": "Alan Lea",
    "address": "30 Poveys Close, Burgess Hill, West Sussex, RH15 9TB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Pay by\ncash (under top tile by\nback door). \u00a325",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000206",
    "customerRef": "CUS52448139",
    "customerName": "Andrew Sinden",
    "address": "33 Withy Bush, Burgess Hill, West Sussex, RH15 8TT",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 33.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-06-02",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000207",
    "customerRef": "CUS20849380",
    "customerName": "Carole Bailey-Carthew",
    "address": "35 Blackthorns, Hurstpierpoint, Hassocks, West Sussex, BN6 9TF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 12
  },
  {
    "id": "JOB000208",
    "customerRef": "CUS3939018",
    "customerName": "Edmund Herbert",
    "address": "3 Weald Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9SR",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "zone": "Hurstpierpoint",
    "price": 40.0,
    "duration": "00:30",
    "notes": "Text night before. Include\n3 velux. Include dormer.\nNot the lantern. Ladder\nreq. for rear window. Pay\nby card link.",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-11",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000209",
    "customerRef": "CUS26535353",
    "customerName": "Pippa Dowden",
    "address": "14 Rhea Close, Burgess Hill, West Sussex, RH15 0XR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-03",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 2
  },
  {
    "id": "JOB000210",
    "customerRef": "CUS60533983",
    "customerName": "Ignatius Dube",
    "address": "78 Stonefield Way, Burgess Hill, West Sussex, RH15 8SG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000211",
    "customerRef": "CUS34142782",
    "customerName": "Amanda Licks",
    "address": "42 Wentworth Road, Hassocks, BN6 9SQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 24
  },
  {
    "id": "JOB000212",
    "customerRef": "CUS86818561",
    "customerName": "Rose",
    "address": "13 The Street, Albourne, Hassocks, West Sussex, BN6 9DN",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers No Email",
    "price": 15.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-19",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 5
  },
  {
    "id": "JOB000213",
    "customerRef": "CUS98702259",
    "customerName": "Tiff",
    "address": "2 Hassocks Gate, Hassocks, West Sussex, BN6 9ZF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 33.33,
    "duration": "00:30",
    "notes": "This is the daughter of the guy next door who pays cash, give the windows a thorough scrub and rinse down.\n\nInc all velux on the roof and extension",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000214",
    "customerRef": "CUS918141",
    "customerName": "Kirsty Innes",
    "address": "16 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RR",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 60.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-04",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000215",
    "customerRef": "CUS48265612",
    "customerName": "Peter Benham",
    "address": "48 Dale Avenue, Hassocks, BN6 8LS",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Not velux. Include conservatory. Text night before.\n\nThere\u2019s a window round the side you have to go on next doors drive and include all sides of conservatory if the bushes have been cut back",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 20
  },
  {
    "id": "JOB000216",
    "customerRef": "CUS87124308",
    "customerName": "John Wise",
    "address": "11 Newick Drive, Newick, Lewes, East Sussex, BN8 4NY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000217",
    "customerRef": "CUS50315970",
    "customerName": "Stacey Ingham",
    "address": "187 Chanctonbury Rd, Burgess Hill RH15 9HF, UK",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 31.0,
    "duration": "00:45",
    "notes": "Reach over to unlock gate",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 33
  },
  {
    "id": "JOB000219",
    "customerRef": "CUS63227517",
    "customerName": "Hannah Green",
    "address": "6 Goosefoot Lane, Burgess Hill RH15 0WT",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000223",
    "customerRef": "CUS55437289",
    "customerName": "Ray Fogwill",
    "address": "39 The Warren, Burgess Hill, West Sussex, RH15 0DU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 27.0,
    "duration": "00:30",
    "notes": "Text night before. Flick the\ncatch to open side gate.\nPay by cardlink",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000224",
    "customerRef": "CUS95272850",
    "customerName": "Karen Kilby",
    "address": "46 Nightingale Way, Sayers Common, Hassocks, BN6 9HP",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Sayers Cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Cash \u00a320",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 26,
    "done": 25
  },
  {
    "id": "JOB000225",
    "customerRef": "CUS39263466",
    "customerName": "Matt Morgan",
    "address": "55 The Quadrant, Hassocks, BN6 8BS",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "zone": "Hassocks",
    "price": 29.5,
    "duration": "00:45",
    "notes": "C1478X gate code \n\nDo the window above conservatory and conservatory at the back",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 32
  },
  {
    "id": "JOB000227",
    "customerRef": "CUS81851636",
    "customerName": "Jess Johnson",
    "address": "Flintstones Annex  Haywards Heath, Cuckfield Road, Ansty, Haywards Heath, West Sussex, RH17 5AL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hickstead",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000229",
    "customerRef": "CUS3398733",
    "customerName": "Weslee",
    "address": "7 Carnoustie Drive Hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 18.0,
    "duration": "00:45",
    "notes": "Please knock the door and ask for the gate to be opened",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 38,
    "done": 33
  },
  {
    "id": "JOB000230",
    "customerRef": "CUS52851475",
    "customerName": "Sandra Allen",
    "address": "20 Orchard Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9UB",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000232",
    "customerRef": "CUS93604743",
    "customerName": "Brendan Seymour",
    "address": "24 Junction Road, Burgess Hill, West Sussex, RH15 0JD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 34.0,
    "duration": "00:30",
    "notes": "Include extension, small dormer and 2 x velux\nNot the extension skylight",
    "lastDone": "2025-12-09",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000233",
    "customerRef": "CUS55914376",
    "customerName": "Hannah Page",
    "address": "27 Brougham Lane, Pease Pottage, Crawley, West Sussex, RH11 9GP",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Pease Pottage",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000234",
    "customerRef": "CUS18492278",
    "customerName": "Sian Scott",
    "address": "35 Fairlea Cl, Burgess Hill RH15 8ND, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 16.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000235",
    "customerRef": "CUS61972678",
    "customerName": "Joanne Aldridge",
    "address": "10 Cheales Close, Haywards Heath, West Sussex, RH16 4XA",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000236",
    "customerRef": "CUS53281854",
    "customerName": "Steven Kelly",
    "address": "44 Wheelwright Lane, Burgess Hill, West Sussex, RH15 0QL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before,\nPlease do not call\nbefore 9am. Not the\nconservatory.",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000237",
    "customerRef": "CUS93282510",
    "customerName": "Sheila Maskell",
    "address": "4 Field Close, Burgess Hill, West Sussex, RH15 8PP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Park at\nend of row of bungalows\nif safe to do so and\nreach front and then\nback by rear path. Pay\nby card link.",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000239",
    "customerRef": "CUS77002805",
    "customerName": "Joseph Mullin",
    "address": "41 St. Marys Road, Burgess Hill, West Sussex, RH15 8NU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 60.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-03-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000241",
    "customerRef": "CUS96786262",
    "customerName": "Salwa",
    "address": "6 Dr Denman Crescent, Hurstpierpoint, Hassocks, BN6 9ZE",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:45",
    "notes": "Knock and ask to plug extension lead in",
    "lastDone": "2024-02-01",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000242",
    "customerRef": "CUS96786262",
    "customerName": "Salwa",
    "address": "6 Dr Denman Crescent, Hurstpierpoint, Hassocks, BN6 9ZE",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Park on drive, include the garage gutters too in the gutter clearing",
    "lastDone": "2025-12-18",
    "nextDue": "2026-03-12",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 23
  },
  {
    "id": "JOB000243",
    "customerRef": "CUS96786262",
    "customerName": "Salwa",
    "address": "6 Dr Denman Crescent, Hurstpierpoint, Hassocks, BN6 9ZE",
    "assignee": "Dan, Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-12-04",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000244",
    "customerRef": "CUS45078397",
    "customerName": "Will Woodward",
    "address": "52 Kemps, Hurstpierpoint, Hassocks, West Sussex, BN6 9UE",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hurstpierpoint",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before.\nInclude conservatory.\nThis property has velux\nand balcony windows.\nDo what you can (he\naccepts you cant do\ncertain bits). Pay by\ncard link. Please leave\nleaflet",
    "lastDone": "2026-01-22",
    "nextDue": "2026-04-16",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000245",
    "customerRef": "CUS204725",
    "customerName": "Sally & Terry",
    "address": "8 Carnoustie Drive Hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 42,
    "done": 42
  },
  {
    "id": "JOB000247",
    "customerRef": "CUS83153882",
    "customerName": "Patrick",
    "address": "Millway Cottage, Ockley Lane, Hassocks, BN6 8NU",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 55.0,
    "duration": "00:50",
    "notes": "Call the alternative number to open the gate",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB000249",
    "customerRef": "CUS31323574",
    "customerName": "Chris Goodwin",
    "address": "14 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BD",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000250",
    "customerRef": "CUS84759390",
    "customerName": "Florence Ruby",
    "address": "121 Royal George Road, Burgess Hill, West Sussex, RH15 9SJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 31.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-08",
    "nextDue": "2026-03-02",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000251",
    "customerRef": "CUS11845320",
    "customerName": "Tom Brooks",
    "address": "47 Charlwood Road, Burgess Hill, West Sussex, RH15 0RJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nrear door and window of\ngarage.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000252",
    "customerRef": "CUS44326110",
    "customerName": "Caroline Bennet",
    "address": "10 Swallow Rest, Burgess Hill, West Sussex, RH15 9XS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 21.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-08",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 4
  },
  {
    "id": "JOB000254",
    "customerRef": "CUS75034664",
    "customerName": "Chris Currie",
    "address": "70 Iden Hurst, Hurstpierpoint, Hassocks, West Sussex, BN6 9YJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 4
  },
  {
    "id": "JOB000255",
    "customerRef": "CUS37647424",
    "customerName": "Des Mellicar- Bowman",
    "address": "121 Mill Road, Burgess Hill, West Sussex, RH15 8AY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 24.17,
    "duration": "00:30",
    "notes": "night before.\nCustomer advised that\nhe was not happy with\nprev. window cleaner\nbecause they were not\nthere long enough to do\na good job, and didnt do\na good job. Pay by card\nlink",
    "lastDone": "2025-11-28",
    "nextDue": "2026-02-19",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000256",
    "customerRef": "CUS26929448",
    "customerName": "Laurie Tilley",
    "address": "2 Heron Close, Sayers Common, Hassocks, Sussex, BN6 9LF",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000257",
    "customerRef": "CUS48767381",
    "customerName": "Steve Thorne- Farrar",
    "address": "2 Fitzalan Mead, Hassocks, West Sussex, BN6 8FY",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 13
  },
  {
    "id": "JOB000258",
    "customerRef": "CUS19010389",
    "customerName": "Gemma",
    "address": "11 Wheatsheaf Cl, Burgess Hill RH15 8UT, UK",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 17.0,
    "duration": "00:30",
    "notes": "Turn on to wheatshef and its half way down, turn left onto the little road to park by the garages",
    "lastDone": "2025-12-16",
    "nextDue": "2026-03-10",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 12
  },
  {
    "id": "JOB000259",
    "customerRef": "CUS3021803",
    "customerName": "Teresa Sayers",
    "address": "50 Priory Road, Burgess Hill, West Sussex, RH15 9HB",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory",
    "zone": "BH Zone 2",
    "price": 27.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory (one side\nonly).",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 13
  },
  {
    "id": "JOB000260",
    "customerRef": "CUS67188877",
    "customerName": "Sacha Murray",
    "address": "40 Coulstock Road, Burgess Hill, West Sussex, RH15 9XH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000261",
    "customerRef": "CUS58045039",
    "customerName": "Danny Sadd",
    "address": "38 Fairfield Road, Burgess Hill, West Sussex, RH15 8QQ",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000262",
    "customerRef": "CUS60693572",
    "customerName": "Sarah",
    "address": "100 Unicorn Way, Burgess Hill, West Sussex, RH15 0WB",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000264",
    "customerRef": "CUS61798319",
    "customerName": "Norma Hurst",
    "address": "Copper Beeches, Keymer Road, Keymer, Hassocks, BN6 8QU",
    "assignee": "",
    "services": "Facias and Sofitts,Gutter Cleaning",
    "zone": "Perfect Properties",
    "price": 160.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-10",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000265",
    "customerRef": "CUS61798319",
    "customerName": "Norma Hurst",
    "address": "Copper Beeches, Keymer Road, Keymer, Hassocks, BN6 8QU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 77.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-08-07",
    "nextDue": "2026-02-12",
    "frequency": "every 3 months on the 12th",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 14
  },
  {
    "id": "JOB000266",
    "customerRef": "CUS61798319",
    "customerName": "Norma Hurst",
    "address": "Copper Beeches, Keymer Road, Keymer, Hassocks, BN6 8QU",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 120.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-02-06",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000267",
    "customerRef": "CUS63060081",
    "customerName": "Brian Deacon",
    "address": "37 Newick Drive, Newick, Lewes, East Sussex, BN8 4NY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Park at the garages at the back of the shops, the house is the last one on the left and gate is by the garages, pull the hose through to the front via the side",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000268",
    "customerRef": "CUS68295315",
    "customerName": "Richard Drew",
    "address": "48 Foxglove Close, Burgess Hill, West Sussex, RH15 8UY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before. On the\nside door do glass only.",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000269",
    "customerRef": "CUS74407753",
    "customerName": "Indre Speicyte",
    "address": "12 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "never",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 0
  },
  {
    "id": "JOB000270",
    "customerRef": "CUS78720879",
    "customerName": "James Phillips",
    "address": "1 Great Park Meadow, Burgess Hill RH15 0YL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000272",
    "customerRef": "CUS99767002",
    "customerName": "Elaine Mills",
    "address": "2 Ravenswood, Hassocks BN6 8JB, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 32
  },
  {
    "id": "JOB000274",
    "customerRef": "CUS36943106",
    "customerName": "Gillian Hopkins",
    "address": "29 Charlwood Gardens, Burgess Hill, West Sussex, RH15 0RD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Back\ngate is stiff, lift and push.\nAccess rear garden via\npath. Pay by card link",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 9
  },
  {
    "id": "JOB000275",
    "customerRef": "CUS63541493",
    "customerName": "Ian Lundberg",
    "address": "10 Brown Twins Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9XT",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Gate code 5263",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000277",
    "customerRef": "CUS16113334",
    "customerName": "Leslie Plaisted",
    "address": "7 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 42,
    "done": 39
  },
  {
    "id": "JOB000281",
    "customerRef": "CUS49569848",
    "customerName": "Andrew Foster",
    "address": "20 Ockley Way, Hassocks, West Sussex, BN6 8NE",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Text night before. Include \nconservatory. Access to \nrear via side gate (will give \nyou key code on first visit)\n\n1391 key code and there\u2019s a key for the back gate",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000282",
    "customerRef": "CUS88730067",
    "customerName": "Laura Clark",
    "address": "16 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 36
  },
  {
    "id": "JOB000283",
    "customerRef": "CUS53844991",
    "customerName": "Pamela Short",
    "address": "25 The Quadrant, Hassocks, West Sussex, BN6 8BP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Not the\nconservatory. First clean\npreferably Monday or\nTuesday. Pay by cash.",
    "lastDone": "2025-11-14",
    "nextDue": "2026-03-10",
    "frequency": "every 8 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 10
  },
  {
    "id": "JOB000284",
    "customerRef": "CUS1404711",
    "customerName": "Chris",
    "address": "40 The Fairway, Hassocks BN6, UK",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-24",
    "nextDue": "2026-04-03",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000285",
    "customerRef": "CUS59220175",
    "customerName": "Brady Knight",
    "address": "6 Michelbourne Close, Burgess Hill, West Sussex, RH15 9QX",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 22.0,
    "duration": "00:30",
    "notes": "Text night before. Not the\nwindows over the cut\nthrough. Pay by card link.",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000287",
    "customerRef": "CUS21992919",
    "customerName": "Louisa",
    "address": "15 Icarus Avenue, Burgess Hill, RH15 0UW",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-01-31",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000288",
    "customerRef": "CUS21992919",
    "customerName": "Louisa",
    "address": "15 Icarus Avenue, Burgess Hill, RH15 0UW",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB000292",
    "customerRef": "CUS57248225",
    "customerName": "Jacky Hayes",
    "address": "105 Orchard Road, Burgess Hill, West Sussex, RH15 9PH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000293",
    "customerRef": "CUS33296406",
    "customerName": "Lee Panther",
    "address": "35 Kemps, Hurstpierpoint, Hassocks, West Sussex, BN6 9UF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before. Not the\nlarge lean-to on L.H.\nside. Include door and\nwindows inside lean-to if\npractical. Pay by card\nlink.",
    "lastDone": "2025-09-24",
    "nextDue": "2026-03-11",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000294",
    "customerRef": "CUS71747749",
    "customerName": "Karen Yellands",
    "address": "16 Wellman grove, hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 32.5,
    "duration": "00:30",
    "notes": "Text night before.\nCustomer advised\nstandard of work of\nprevious window\ncleaner was very poor.",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000299",
    "customerRef": "CUS62770327",
    "customerName": "Christine Cooper",
    "address": "36 Dale Avenue, Hassocks, West Sussex, BN6 8LP",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000300",
    "customerRef": "CUS49538570",
    "customerName": "John Elliott",
    "address": "11 Lamb Lane, Hurstpierpoint, Hassocks, Sussex, BN6 9ZA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 36.67,
    "duration": "00:30",
    "notes": "Text night before.\nCustomer advised last\nwindow cleaner\nunsatisfactory re\ncleaning of sills etc.\nPay by card link.",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000301",
    "customerRef": "CUS49538570",
    "customerName": "John Elliott",
    "address": "11 Lamb Lane, Hurstpierpoint, Hassocks, Sussex, BN6 9ZA",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 90.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-18",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000302",
    "customerRef": "CUS37666783",
    "customerName": "Emily Welsh",
    "address": "13 Blackhouse Lane, Burgess Hill, West Sussex, RH15 8BN",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Text night before. Please\nsend text night before\n(as usual) and text in\nmorning with approx.\ntime (within a couple of\nhours). Pay by card link.\nPlease leave leaflet.",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000305",
    "customerRef": "CUS26236165",
    "customerName": "Susan Knight",
    "address": "14 Barnside Avenue, Burgess Hill, RH15 0JU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000306",
    "customerRef": "CUS26236165",
    "customerName": "Susan Knight",
    "address": "14 Barnside Avenue, Burgess Hill, RH15 0JU",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 125.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-08-01",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000307",
    "customerRef": "CUS26236165",
    "customerName": "Susan Knight",
    "address": "14 Barnside Avenue, Burgess Hill, RH15 0JU",
    "assignee": "Steve",
    "services": "Gutter Cleaning",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:30",
    "notes": "Wash the outside off all guttering",
    "lastDone": "2024-07-30",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000308",
    "customerRef": "CUS61469612",
    "customerName": "Trina Murishwar",
    "address": "72 Nightingale Lane, Burgess Hill, RH15 9JJ",
    "assignee": "Steve",
    "services": "Cladding Clean",
    "zone": "Perfect Properties",
    "price": 40.0,
    "duration": "00:30",
    "notes": "Cleaning of the white cladding at the front of the property.",
    "lastDone": "2025-06-04",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 1
  },
  {
    "id": "JOB000309",
    "customerRef": "CUS61469612",
    "customerName": "Trina Murishwar",
    "address": "72 Nightingale Lane, Burgess Hill, RH15 9JJ",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean front only",
    "zone": "BH Zone 2",
    "price": 17.6,
    "duration": "00:30",
    "notes": "Front only",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 27
  },
  {
    "id": "JOB000310",
    "customerRef": "CUS72737525",
    "customerName": "Chris Buckley",
    "address": "5 Carnoustie Drive Hassocks BN6",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 17.6,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 44,
    "done": 39
  },
  {
    "id": "JOB000311",
    "customerRef": "CUS70502489",
    "customerName": "Carole Small",
    "address": "36 Mackie Avenue, Hassocks, BN6 8NN",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Not conservatory, orange brush leaded windows",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 22
  },
  {
    "id": "JOB000312",
    "customerRef": "CUS92014780",
    "customerName": "Andy Seamark",
    "address": "57 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000313",
    "customerRef": "CUS60568941",
    "customerName": "Citiguard Security Ltd",
    "address": "Ockley Park, hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Citiguard",
    "price": 2266.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-31",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000315",
    "customerRef": "CUS55916769",
    "customerName": "Sarita Premley",
    "address": "Oak Tree Cottage Ditton Place, Brantridge Lane, Balcombe, Haywards Heath, West Sussex, RH17 6JR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Must be at the property starting work at 8",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000317",
    "customerRef": "CUS57500879",
    "customerName": "Brian Smith",
    "address": "17 Orchard Way, Burgess Hill, West Sussex, RH15 9PB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:30",
    "notes": "CASH",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000319",
    "customerRef": "CUS83019150",
    "customerName": "Steve Tingley",
    "address": "2 Carnoustie hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Gardens through the garage",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 29
  },
  {
    "id": "JOB000320",
    "customerRef": "CUS80491335",
    "customerName": "Gareth Harper",
    "address": "6 Leigh Meadow, Burgess Hill",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 26.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-16",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000321",
    "customerRef": "CUS51024789",
    "customerName": "Sean Honey",
    "address": "14 Kymer Gardens, Hassocks, West Sussex, BN6 8QZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 38.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-18",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000322",
    "customerRef": "CUS42999449",
    "customerName": "Paula Pitt",
    "address": "77 Sycamore Drive, Burgess Hill, West Sussex, RH15 0GG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 1
  },
  {
    "id": "JOB000323",
    "customerRef": "CUS17353515",
    "customerName": "Jonathan Garnham",
    "address": "59 Parklands Road in Hassocks, BN6 8JY",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "zone": "Hassocks",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-02",
    "nextDue": "2026-02-24",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000325",
    "customerRef": "CUS27318429",
    "customerName": "Peter Woodhams",
    "address": "135 Manor Road, Burgess Hill, West Sussex, RH15 0NG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 23.0,
    "duration": "00:30",
    "notes": "Text to landline the\nnight before. Lean over\nto unbolt gate. Pay by\nGoCardless. Friendly\ndog in garden",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB000326",
    "customerRef": "CUS29760972",
    "customerName": "Lloyd",
    "address": "179 Cuckfield Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9RT",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Front and side, ground and 1st floor. Flat roof at back 1st and 2nd floor. Ground floor at back plus quick clean office at end of garden.",
    "lastDone": "2026-01-22",
    "nextDue": "2026-04-16",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000327",
    "customerRef": "CUS28840429",
    "customerName": "Jonny",
    "address": "4 St Andrews Place Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-13",
    "nextDue": "2026-02-06",
    "frequency": "every 8 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 25,
    "done": 25
  },
  {
    "id": "JOB000328",
    "customerRef": "CUS19251834",
    "customerName": "Caroline Stark",
    "address": "1 Jack Slaughter Lane, Hassocks, West Sussex, BN6 8GF",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 5
  },
  {
    "id": "JOB000329",
    "customerRef": "CUS51092120",
    "customerName": "Julie",
    "address": "39 Birch Way, Hassocks, West Sussex, BN6 8YJ",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-10-13",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 44,
    "done": 34
  },
  {
    "id": "JOB000331",
    "customerRef": "CUS71484356",
    "customerName": "Poppy Friar",
    "address": "128 Western Road, Haywards Heath, West Sussex, RH16 3LN",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 30.0,
    "duration": "00:30",
    "notes": "\u00a336",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000332",
    "customerRef": "CUS66730180",
    "customerName": "John Southorn",
    "address": "5 Furzeland Way, Sayers Common, Hassocks, West Sussex, BN6 9JB",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "New** Not garage. Not velux.\nText night before. Happy\nto pay with card but\nwould like a little help to\nset it up. \u00a320 cash",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000333",
    "customerRef": "CUS4001476",
    "customerName": "Gill",
    "address": "12 Goosefoot Lane, Burgess Hill, West Sussex, RH15 0WT",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000335",
    "customerRef": "CUS638135",
    "customerName": "Esra Oner",
    "address": "28 Priory Rd, Hassocks BN6 8PS, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 38.5,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 33
  },
  {
    "id": "JOB000337",
    "customerRef": "CUS32838676",
    "customerName": "Andrew Walker",
    "address": "21 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 16.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 35
  },
  {
    "id": "JOB000339",
    "customerRef": "CUS56159851",
    "customerName": "Richard Harris",
    "address": "24 Leveller Road, Newick, Lewes, East Sussex, BN8 4PL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-04",
    "nextDue": "2026-02-26",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000340",
    "customerRef": "CUS30948843",
    "customerName": "Bryan Belton",
    "address": "39 Northway, Burgess Hill, West Sussex, RH15 0PW",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Not before 9am",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000344",
    "customerRef": "CUS27981203",
    "customerName": "Elizabeth Johnson",
    "address": "7 Sycamore Way, Hassocks, West Sussex, BN6 8YH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 3
  },
  {
    "id": "JOB000346",
    "customerRef": "CUS93653726",
    "customerName": "James Barron",
    "address": "21 Avenue  de  Warenne, Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 28.0,
    "duration": "00:30",
    "notes": "Text night before. Include \ndormer and 2 x velux. Pay \nonline. Please knock when \nyou get there so they can \nput dog in if he's out",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000349",
    "customerRef": "CUS28101471",
    "customerName": "Dominic Tree",
    "address": "5 Powell Road, Newick, Lewes, East Sussex, BN8 4LS",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000351",
    "customerRef": "CUS33657194",
    "customerName": "PureGym Ltd",
    "address": "Puregym, 208 London Road, Burgess Hill, RH15 9RD",
    "assignee": "Steve",
    "services": "Signage Clean",
    "zone": "Perfect Properties",
    "price": 100.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-01-31",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000352",
    "customerRef": "CUS33657194",
    "customerName": "PureGym Ltd",
    "address": "Puregym, 208 London Road, Burgess Hill, RH15 9RD",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 99.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-03",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 57,
    "done": 51
  },
  {
    "id": "JOB000353",
    "customerRef": "CUS61966098",
    "customerName": "Betty Hills",
    "address": "1 Oldlands Avenue, Hassocks, West Sussex, BN6 8DJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Pays cash \u00a325",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000356",
    "customerRef": "CUS18320231",
    "customerName": "HELEN GARRETT",
    "address": "17 Bridgers Mill, Haywards Heath, West Sussex, RH16 1TF",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 66.66,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000357",
    "customerRef": "CUS7237067",
    "customerName": "Chris Lisle",
    "address": "187 Maple Drive, Burgess Hill, West Sussex, RH15 8DF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000358",
    "customerRef": "CUS32449806",
    "customerName": "Peter King",
    "address": "42 Victoria Close, Burgess Hill, West Sussex, RH15 9QS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Text night before. Include glass porch at rear of house.",
    "lastDone": "2026-01-26",
    "nextDue": "2026-04-20",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000360",
    "customerRef": "CUS19062808",
    "customerName": "Ross",
    "address": "25 Janes Lane, Burgess Hill, West Sussex, RH15 0QJ",
    "assignee": "Steve",
    "services": "Window Clean inc Garden Room",
    "zone": "BH Zone 3",
    "price": 22.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000361",
    "customerRef": "CUS48927088",
    "customerName": "Richard Jukes",
    "address": "21 Coulstock Road, Burgess Hill, West Sussex, RH15 9XH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000363",
    "customerRef": "CUS74195293",
    "customerName": "Josephine Messina-Persad",
    "address": "4 Magnolia Court, Albourne, Hassocks, West Sussex, BN6 9FY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000364",
    "customerRef": "CUS69883320",
    "customerName": "Jan Goddard",
    "address": "9 Gloucester Place, Littlehampton, West Sussex, BN17 7AF",
    "assignee": "",
    "services": "One-Off Window Cleaning",
    "zone": "",
    "price": 40.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "never",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 0,
    "done": 0
  },
  {
    "id": "JOB000369",
    "customerRef": "CUS21321500",
    "customerName": "Mick Bartlett",
    "address": "15 Sylvan Close, Haywards Heath, West Sussex, RH16 3SG",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-21",
    "frequency": "every 6 weeks on Saturday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000370",
    "customerRef": "CUS27363303",
    "customerName": "Darren Longley",
    "address": "11 Rastrick Close, Burgess Hill, West Sussex, RH15 9UW",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB000371",
    "customerRef": "CUS26209144",
    "customerName": "Julie Sadler",
    "address": "9 Newick Drive, Newick, Lewes, East Sussex, BN8 4NY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-04-09",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000372",
    "customerRef": "CUS71592050",
    "customerName": "Michael",
    "address": "48 Livingstone Road, Burgess Hill, West Sussex, RH15 8QP",
    "assignee": "Steve",
    "services": "Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-06",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000373",
    "customerRef": "CUS71592050",
    "customerName": "Michael",
    "address": "48 Livingstone Road, Burgess Hill, West Sussex, RH15 8QP",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000374",
    "customerRef": "CUS62050541",
    "customerName": "Sarah Lawson",
    "address": "26 Leylands Park, Burgess Hill, West Sussex, RH15 8AH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000375",
    "customerRef": "CUS71673109",
    "customerName": "Charlotte Kedian",
    "address": "67 Goldcrest Dr, Hassocks BN6, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers No Email",
    "price": 18.7,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 29
  },
  {
    "id": "JOB000376",
    "customerRef": "CUS89934231",
    "customerName": "Stacie Skeen-Clark",
    "address": "30 Highlands, Ardingly Road, Cuckfield, Haywards Heath, West Sussex, RH17 5HL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000377",
    "customerRef": "CUS25046450",
    "customerName": "Simon Marchant",
    "address": "11 Little Copse Rd, Hassocks BN6 8PG, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 23.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 34
  },
  {
    "id": "JOB000378",
    "customerRef": "CUS10012866",
    "customerName": "James Nicholls",
    "address": "3 Talbot Mead, Hurstpierpoint, Hassocks BN6 9TJ, UK",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "zone": "Hurstpierpoint",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Knock the door and access to the garden is through the garage \n\nLong pole",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 24
  },
  {
    "id": "JOB000379",
    "customerRef": "CUS40381086",
    "customerName": "Susan Jones",
    "address": "Oakwood Farm, North Common Road, North Chailey, Lewes, East Sussex, BN8 4ED",
    "assignee": "",
    "services": "One-Off Window Cleaning",
    "zone": "",
    "price": 68.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "never",
    "nextDue": "2026-02-03",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 0,
    "done": 0
  },
  {
    "id": "JOB000380",
    "customerRef": "CUS31322107",
    "customerName": "Diane King",
    "address": "33 The Gattons, Burgess Hill, West Sussex, RH15 9SW",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 28.0,
    "duration": "00:30",
    "notes": "**KNOCK BEFORE***Text night before. Not the\nconservatory or the velux.\nDo conservatory for extra\n\u00a39 when asked",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000381",
    "customerRef": "CUS18130430",
    "customerName": "Tim Griffiths",
    "address": "30 The Warren, Burgess Hill, West Sussex, RH15 0DZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 34.0,
    "duration": "00:30",
    "notes": "Not the Velux",
    "lastDone": "2025-12-01",
    "nextDue": "2026-02-23",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000384",
    "customerRef": "CUS48911675",
    "customerName": "Pauline Ratcliffe",
    "address": "57 East View Fields, Plumpton Green, Lewes, East Sussex, BN7 3EF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Text night before.\nCustomer will leave\nwalkway unlocked on\nL.H. side of house on\nreceipt of text if not\nhome. Pay by card link",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000385",
    "customerRef": "CUS46483870",
    "customerName": "Gemma",
    "address": "32 Marle Avenue, Burgess Hill, West Sussex, RH15 8JG",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 28.0,
    "duration": "00:30",
    "notes": "Back gate has little flip lock you can see\n\nInc con",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 13
  },
  {
    "id": "JOB000386",
    "customerRef": "CUS60553441",
    "customerName": "Robbie",
    "address": "4 Carnoustie Drive, Hassocks, BN6 9PB",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean inc Garage Window",
    "zone": "Kingsland Gate",
    "price": 20.83,
    "duration": "00:30",
    "notes": "CASH \u00a325 inc garage window",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 45,
    "done": 43
  },
  {
    "id": "JOB000387",
    "customerRef": "CUS5637867",
    "customerName": "Megan Tatum",
    "address": "7, The Birches, Southdowns Park, Haywards Heath, West Sussex, RH16 4XJ",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-15",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000389",
    "customerRef": "CUS36257044",
    "customerName": "Mark Lamber",
    "address": "5 Friars Cl, Hassocks BN6 8PL, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 32.0,
    "duration": "00:45",
    "notes": "Orange brush leaded windows",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 30
  },
  {
    "id": "JOB000390",
    "customerRef": "CUS33904967",
    "customerName": "Marc Edwards",
    "address": "Flat 15, Stockwell Court, London Road, Burgess Hill, West Sussex, RH15 9RS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Flat directly above every care shop, photo attached, will need a good going over",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 12
  },
  {
    "id": "JOB000391",
    "customerRef": "CUS22675573",
    "customerName": "Sue Lamber",
    "address": "58 Freeks Lane, Burgess Hill, West Sussex, RH15 8DG",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "zone": "BH Zone 3",
    "price": 16.0,
    "duration": "00:30",
    "notes": "Front only",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000392",
    "customerRef": "CUS52258813",
    "customerName": "Robin Aldridge",
    "address": "22 Haywards Road, Haywards Heath, West Sussex, RH16 4HT",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000393",
    "customerRef": "CUS90364231",
    "customerName": "Michael Jenney",
    "address": "32 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000394",
    "customerRef": "CUS5521865",
    "customerName": "Samy",
    "address": "10 The Fairway Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 17.6,
    "duration": "00:40",
    "notes": "",
    "lastDone": "2025-12-12",
    "nextDue": "2026-02-06",
    "frequency": "every 8 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 23
  },
  {
    "id": "JOB000396",
    "customerRef": "CUS16548610",
    "customerName": "Amanda Murray",
    "address": "1 Bridge Cottages, East Grinstead Road, North Chailey, Lewes, East Sussex, BN8 4DB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Chailey",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Not the guest house out the back",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000400",
    "customerRef": "CUS85687386",
    "customerName": "Susie",
    "address": "2 Little Copse Road, Hassocks, BN6 8PG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:45",
    "notes": "Cash \u00a330",
    "lastDone": "2025-11-24",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 22
  },
  {
    "id": "JOB000402",
    "customerRef": "CUS75403661",
    "customerName": "Sue Baldwin",
    "address": "Weald Cottage, Whitemans Green, Cuckfield, Haywards Heath, West Sussex, RH17 5BX",
    "assignee": "Steve",
    "services": "Window Clean every 12 weeks",
    "zone": "Haywards Heath",
    "price": 34.17,
    "duration": "00:30",
    "notes": "she needs to be home on the day of the clean, so is reliant on the text/email night before",
    "lastDone": "2025-11-27",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 1
  },
  {
    "id": "JOB000406",
    "customerRef": "CUS65464369",
    "customerName": "Silvy",
    "address": "90 Avenue De Warenne, Hassocks, West Sussex, BN6 8GE",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000409",
    "customerRef": "CUS6888609",
    "customerName": "Clare",
    "address": "15 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-28",
    "nextDue": "2026-02-20",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 25,
    "done": 23
  },
  {
    "id": "JOB000410",
    "customerRef": "CUS6271420",
    "customerName": "Lorraine Tracy",
    "address": "11 South Cl, Burgess Hill RH15 9PZ, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 27.5,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 31,
    "done": 30
  },
  {
    "id": "JOB000411",
    "customerRef": "CUS65507860",
    "customerName": "Tara Edwards",
    "address": "40 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 19.17,
    "duration": "00:30",
    "notes": "Text night before.\nAccess to rear garden\nvia path on L.H. side.",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000413",
    "customerRef": "CUS29420240",
    "customerName": "Catherine Laslett",
    "address": "73 Downs View Rd, Hassocks BN6 8HY, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 34.1,
    "duration": "00:30",
    "notes": "Include velux. Not juliet windows. Text night before.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 23
  },
  {
    "id": "JOB000414",
    "customerRef": "CUS55810021",
    "customerName": "Denise",
    "address": "41 Woodsland Road, Hassocks, West Sussex, BN6 8HG",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "zone": "Hassocks",
    "price": 18.5,
    "duration": "00:30",
    "notes": "They\u2019re having building work done at the back at the moment. Front only",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000420",
    "customerRef": "CUS17658657",
    "customerName": "David Johnson",
    "address": "11 Welbeck Close, Burgess Hill, West Sussex, RH15 0AU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.0,
    "duration": "00:30",
    "notes": "Text night before. Payment\nby card link. Please quote\nfor gutters, soffits and\nfascias.",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000421",
    "customerRef": "CUS80445190",
    "customerName": "Anton Kruglyakou",
    "address": "10 Bonnet Lane, Burgess Hill, RH15 0FQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 21.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB000422",
    "customerRef": "CUS5037540",
    "customerName": "Amanda Holland",
    "address": "106 Unicorn Way, Burgess Hill, West Sussex, RH15 0WB",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000424",
    "customerRef": "CUS37423166",
    "customerName": "Lloyd Bradley",
    "address": "5 Grand Avenue, Hassocks, West Sussex, BN6 8DA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Has extension.",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000425",
    "customerRef": "CUS17230005",
    "customerName": "Alan Melluish",
    "address": "62 Nightingale Ln, Burgess Hill RH15, UK",
    "assignee": "",
    "services": "Cladding Clean",
    "zone": "Perfect Properties",
    "price": 25.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2022-05-25",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000426",
    "customerRef": "CUS17230005",
    "customerName": "Alan Melluish",
    "address": "62 Nightingale Ln, Burgess Hill RH15, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 18.7,
    "duration": "00:45",
    "notes": "Knock the door",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 31
  },
  {
    "id": "JOB000427",
    "customerRef": "CUS17230005",
    "customerName": "Alan Melluish",
    "address": "62 Nightingale Ln, Burgess Hill RH15, UK",
    "assignee": "Dan",
    "services": "Gutter Clearance,Cladding Clean,Facia soffit & gutter wash",
    "zone": "Perfect Properties",
    "price": 200.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-03-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000428",
    "customerRef": "CUS90002753",
    "customerName": "Becca Sharrock",
    "address": "69 Sunnywood Drive, Haywards Heath, West Sussex, RH16 4PD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-28",
    "nextDue": "2026-02-05",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 1
  },
  {
    "id": "JOB000431",
    "customerRef": "CUS77105809",
    "customerName": "Frances  Partridge",
    "address": "37 Queens Drive, Hassocks, West Sussex, BN6 8DF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Text night before. Include 2 \nx dormers. Stand on \nneighbours (Martin) \ndoorstep to reach dormers. \nNeighbour has given \npermission but does not \nwant you to knock and ask \nhim each time, just do it. \nPay by GoCardless",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000432",
    "customerRef": "CUS6852633",
    "customerName": "Pam Cox",
    "address": "41 Avenue De Warenne, Hassocks, West Sussex, BN6 8FP",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 10
  },
  {
    "id": "JOB000433",
    "customerRef": "CUS34243566",
    "customerName": "Marilyn Morrison",
    "address": "9 Bluebell Way, Burgess Hill, West Sussex, RH15 8UU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-08",
    "nextDue": "2026-02-02",
    "frequency": "every 8 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000434",
    "customerRef": "CUS7012752",
    "customerName": "Carly",
    "address": "36 Hurst Road, Hassocks, West Sussex, BN6 9NL",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 73.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-20",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000435",
    "customerRef": "CUS81729565",
    "customerName": "Allan Stone",
    "address": "7 Chestnut Close, Burgess Hill, West Sussex, RH15 8HN",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 36.6,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000436",
    "customerRef": "CUS1462322",
    "customerName": "Phil Prime",
    "address": "75 Dale Avenue, Hassocks, West Sussex, BN6 8LR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 31.0,
    "duration": "00:30",
    "notes": "Text night before. Include 1 Velux",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000437",
    "customerRef": "CUS44436409",
    "customerName": "Glenn Geer",
    "address": "1 Chestnut Close, Burgess Hill, West Sussex, RH15 8HN",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 22.5,
    "duration": "00:30",
    "notes": "New",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000440",
    "customerRef": "CUS73700026",
    "customerName": "Gary Young",
    "address": "23 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000442",
    "customerRef": "CUS40642521",
    "customerName": "Nick Willis",
    "address": "28 Potters Lane, Burgess Hill, West Sussex, RH15 9JS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Text night before. Please leave leaflet.\nInclude dormer.",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000443",
    "customerRef": "CUS18615554",
    "customerName": "Daya Durai",
    "address": "3 Keymer Gardens, Burgess Hill, West Sussex, RH15 0AF",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 2",
    "price": 30.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000445",
    "customerRef": "CUS58599482",
    "customerName": "Gillian Moore",
    "address": "14 Aphrodite Way, Burgess Hill, West Sussex, RH15 0XQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000447",
    "customerRef": "CUS72718624",
    "customerName": "Amy Hemmings-Alexander",
    "address": "71 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AE",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "zone": "Hurstpierpoint",
    "price": 40.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 11
  },
  {
    "id": "JOB000448",
    "customerRef": "CUS72718624",
    "customerName": "Amy Hemmings-Alexander",
    "address": "71 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AE",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-11-28",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000449",
    "customerRef": "CUS12792972",
    "customerName": "Rob Lloyd",
    "address": "124 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 72.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-01",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000450",
    "customerRef": "CUS12792972",
    "customerName": "Rob Lloyd",
    "address": "124 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 41.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-05",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000451",
    "customerRef": "CUS34622141",
    "customerName": "Hannah Albuery",
    "address": "71 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-03-09",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000452",
    "customerRef": "CUS76681001",
    "customerName": "Kitty",
    "address": "47 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Front and side\nGf at back only",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000453",
    "customerRef": "CUS48017696",
    "customerName": "Pat Murphy",
    "address": "20 Bridge Close, Burgess Hill, West Sussex, RH15 8Pd",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000454",
    "customerRef": "CUS69447683",
    "customerName": "Tom Wheatley",
    "address": "9 Weavers Close, Burgess Hill, West Sussex, RH15 0QD",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 40.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000455",
    "customerRef": "CUS21230497",
    "customerName": "Luis Walters",
    "address": "6 Holmbush Close, Haywards Heath, West Sussex, RH16 4RS",
    "assignee": "",
    "services": "Window Clean Every 6 weeks,Gutter Clearance,Facias and Sofitts,Gutter wash",
    "zone": "",
    "price": 140.2,
    "duration": "00:30",
    "notes": "Was hoping for Monday 2nd February for the first appointment, he also mentioned there is paint on the windows and would like this area to be focused on to make sure it comes off.",
    "lastDone": "never",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 0,
    "done": 0
  },
  {
    "id": "JOB000456",
    "customerRef": "CUS34715316",
    "customerName": "Cassie Walburton",
    "address": "48 Maple Drive, Burgess Hill, West Sussex, RH15 8AW",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 24.1,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000457",
    "customerRef": "CUS64322347",
    "customerName": "Charlie Mechea",
    "address": "32 Mayhouse Rd, Burgess Hill RH15 9RF, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 17.6,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 30
  },
  {
    "id": "JOB000458",
    "customerRef": "CUS30727465",
    "customerName": "Julia Robertson",
    "address": "5 The Pagets, Newick, Lewes, East Sussex, BN8 4PW",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Newick",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory. Pay by\ncardlinK",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000459",
    "customerRef": "CUS78279418",
    "customerName": "Daniel Montero",
    "address": "35 Copley Drive, Hassocks, West Sussex, BN6 8FS",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000460",
    "customerRef": "CUS99627099",
    "customerName": "Francis Teague",
    "address": "15 Nightingale Ln, Burgess Hill RH15 9HG, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:45",
    "notes": "Cash",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 32
  },
  {
    "id": "JOB000461",
    "customerRef": "CUS99627099",
    "customerName": "Francis Teague",
    "address": "15 Nightingale Ln, Burgess Hill RH15 9HG, UK",
    "assignee": "Dan",
    "services": "Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-08-22",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000465",
    "customerRef": "CUS15744443",
    "customerName": "Eddie",
    "address": "7 Quarry Cl, Burgess Hill RH15 0TJ, UK",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-11-27",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000466",
    "customerRef": "CUS15744443",
    "customerName": "Eddie",
    "address": "7 Quarry Cl, Burgess Hill RH15 0TJ, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 0.0,
    "duration": "00:45",
    "notes": "\u00a330 cash",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000468",
    "customerRef": "CUS29427295",
    "customerName": "Paul",
    "address": "37 Marlow Drive, Haywards Heath, West Sussex, RH16 3SR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000470",
    "customerRef": "CUS87881153",
    "customerName": "Gail Smith",
    "address": "The Beeches, Underhill Lane, Clayton, Hassocks, West Sussex, BN6 9PL",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-07-22",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000471",
    "customerRef": "CUS56271775",
    "customerName": "Carol Salisbury",
    "address": "44 Eastdale Road, Burgess Hill, West Sussex, RH15 0NH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 29.0,
    "duration": "00:30",
    "notes": "NEW\nText night before.\nInclude garden room.\nLean over to unbolt\ngate. Pay by\nGoCardless.",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB000473",
    "customerRef": "CUS23561188",
    "customerName": "Catherine Perera",
    "address": "28 Holmesdale Road, Burgess Hill, West Sussex, RH15 9JR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 29.0,
    "duration": "00:30",
    "notes": "Include dormer and 2 x velux.",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 14
  },
  {
    "id": "JOB000476",
    "customerRef": "CUS45155849",
    "customerName": "Heather And David",
    "address": "26 Junction Road, Burgess Hill, West Sussex, RH15 0JN",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Cash \u00a330",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000478",
    "customerRef": "CUS52071480",
    "customerName": "Graham Whitehouse",
    "address": "49 Fairfield Road, Burgess Hill, West Sussex, RH15 8QB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 28.0,
    "duration": "00:30",
    "notes": "49 49a two flats",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 15
  },
  {
    "id": "JOB000479",
    "customerRef": "CUS52071480",
    "customerName": "Graham Whitehouse",
    "address": "1 Greenlands Drive, Burgess Hill, West Sussex, RH15 0AZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 34.0,
    "duration": "00:30",
    "notes": "Not the velux but include all other\ndoors and windows.",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000480",
    "customerRef": "CUS54584339",
    "customerName": "Kim Gorman",
    "address": "2 Aphrodite Way, Burgess Hill, West Sussex, RH15 0XQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000481",
    "customerRef": "CUS33440881",
    "customerName": "Wendy Little",
    "address": "56 Dyall Cl, Burgess Hill RH15 8UD, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 27.5,
    "duration": "00:45",
    "notes": "Inc con windows",
    "lastDone": "2026-01-28",
    "nextDue": "2026-04-21",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 14
  },
  {
    "id": "JOB000482",
    "customerRef": "CUS97688463",
    "customerName": "Lucy Holford",
    "address": "38 Bridge Close, Burgess Hill, West Sussex, RH15 8PD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 26.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-09",
    "nextDue": "2026-02-02",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000483",
    "customerRef": "CUS26967674",
    "customerName": "Brian Pate",
    "address": "5 Meadows, Hassocks BN6 8EH, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 32.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 30
  },
  {
    "id": "JOB000484",
    "customerRef": "CUS26967674",
    "customerName": "Brian Pate",
    "address": "5 Meadows, Hassocks BN6 8EH, UK",
    "assignee": "Dan",
    "services": "Gutter Cleaning",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-06-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000485",
    "customerRef": "CUS32056453",
    "customerName": "Paul",
    "address": "22 Semley Road, Hassocks, West Sussex, BN6 8PE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 35.0,
    "duration": "00:30",
    "notes": "All windows, except the one window at front of the second floor. Flat roof access above garage doors, which I give a very quick wash down. There are 2 velux windows.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000486",
    "customerRef": "CUS8895960",
    "customerName": "Tania Chan",
    "address": "22 Hassocks Gate, Hassocks, West Sussex, BN6 9ZF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before. Upstairs\nwindows + front door\n(apartment).",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000487",
    "customerRef": "CUS34945073",
    "customerName": "Sean McVeigh",
    "address": "1 Pangdene Close, Burgess Hill, West Sussex, RH15 9US",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Window Clean \u00a328",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB000488",
    "customerRef": "CUS78179683",
    "customerName": "Yvette Clapperton",
    "address": "43 Royal George Road, Burgess Hill, West Sussex, RH15 9SB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 23.0,
    "duration": "00:30",
    "notes": "Driveway should be clear to park",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 12
  },
  {
    "id": "JOB000489",
    "customerRef": "CUS51441401",
    "customerName": "Steph Illingworth",
    "address": "56a Folders Lane, Burgess Hill, West Sussex, RH15 0DX",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "We are at the end of a long drive when you get to the bottom it\u2019s the house in the right over a small bridge.\nI would like the insides done if possible less frequent but when you can fit it in thanks",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000490",
    "customerRef": "CUS79931028",
    "customerName": "Caroline Robinson",
    "address": "4 Turnberry Way Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 15.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 26
  },
  {
    "id": "JOB000491",
    "customerRef": "CUS15260935",
    "customerName": "Shannon Pentecost",
    "address": "64 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PH",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000493",
    "customerRef": "CUS54797672",
    "customerName": "Tom McNaughton",
    "address": "24 Benjamin Way, Burgess Hill, Sussex, RH15 0FG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000496",
    "customerRef": "CUS49922031",
    "customerName": "Alison",
    "address": "49 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP CASH",
    "price": 0.0,
    "duration": "00:30",
    "notes": "2 small gf windows, you have to go in neighbours alley, no need to knock",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000497",
    "customerRef": "CUS41966257",
    "customerName": "Sean Leahy",
    "address": "15 Farm Cl, Hassocks BN6 8PJ, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Inc garage windows\n\nCASH \u00a320",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 26,
    "done": 22
  },
  {
    "id": "JOB000498",
    "customerRef": "CUS44828518",
    "customerName": "Wayne Jones",
    "address": "5 Nevill Place, Hassocks, West Sussex, BN6 8FU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000499",
    "customerRef": "CUS2370479",
    "customerName": "Jenny Barrie",
    "address": "Flat 8, Dunstall Lodge, 29 Kilnwood Avenue, Burgess Hill, West Sussex, RH15 0ZD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 17.5,
    "duration": "00:30",
    "notes": "Go down kilnwood av, it\u2019s the block of flats on the left as you go round the corner, just the back, windows highlighted",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000500",
    "customerRef": "CUS51765614",
    "customerName": "Laurence Ramsey",
    "address": "6 Goldcrest Dr, Hassocks BN6, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 26.4,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 29
  },
  {
    "id": "JOB000501",
    "customerRef": "CUS63035797",
    "customerName": "Sandra Moisy",
    "address": "1 Hoadley Avenue, Burgess Hill, RH15 0RG",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 19.8,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 30
  },
  {
    "id": "JOB000503",
    "customerRef": "CUS87615318",
    "customerName": "Lynda Brown",
    "address": "4 Griffin House, 104 Cants Lane, Burgess Hill, West Sussex, RH15 0LS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Our flat is first floor on the right as you look at the building. There are two windows and the Juliette balcony at the front, a window at the side and then three windows round the back.\n\nYou will have to turn the head 90 degrees to fit through the railings",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000505",
    "customerRef": "CUS51876744",
    "customerName": "Sophie Macdonald",
    "address": "2 Oakfield Lane, Plumpton Green, Lewes, Sussex, BN7 3FF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Text night before. Not\nthe conservatory.",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000506",
    "customerRef": "CUS36225353",
    "customerName": "Marie Spence",
    "address": "14 Priory Rd, Hassocks BN6 8PS, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 19.8,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 26
  },
  {
    "id": "JOB000508",
    "customerRef": "CUS60788231",
    "customerName": "Rachel Godfrey",
    "address": "8 Cedar Cl, Burgess Hill RH15 8EJ, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 16.5,
    "duration": "00:45",
    "notes": "Reverse park where the directions take you, make sure you click the address and then click coordinates",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 27
  },
  {
    "id": "JOB000509",
    "customerRef": "CUS46071154",
    "customerName": "Anika Joshi",
    "address": "38 Valebridge Road, Burgess Hill, West Sussex, RH15 0QY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Cash \u00a330, go on next doors drive to the right to get the side window done, move the bins and brick to open the gate, return them when you leave",
    "lastDone": "2025-11-18",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 9
  },
  {
    "id": "JOB000510",
    "customerRef": "CUS7863629",
    "customerName": "Chris Holden",
    "address": "138 Mill Road, Burgess Hill, West Sussex, RH15 8BZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 23.33,
    "duration": "00:30",
    "notes": "Text night before. Include\none dormer, include one\nvelux. Pay by card link.",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000511",
    "customerRef": "CUS16817602",
    "customerName": "Nicky Moxham",
    "address": "10 Holmesdale Road, Burgess Hill, West Sussex, RH15 9JR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 16
  },
  {
    "id": "JOB000512",
    "customerRef": "CUS7267653",
    "customerName": "Claire Ellis",
    "address": "1 Reeves Mead, Burgess Hill, RH15 0YR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000514",
    "customerRef": "CUS37610015",
    "customerName": "Lynda Stevens",
    "address": "41 Clifton Road, Burgess Hill, West Sussex, RH15 8US",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000515",
    "customerRef": "CUS8438520",
    "customerName": "Charlie Gorton",
    "address": "29 Leigh Meadow, Burgess Hill Rh15 0yp",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000516",
    "customerRef": "CUS5820085",
    "customerName": "Naomi Mattock",
    "address": "7 Haynes Way, Pease Pottage, Crawley, West Sussex, RH11 9GB",
    "assignee": "Dan",
    "services": "Window Clean - Flat",
    "zone": "Pease Pottage",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000518",
    "customerRef": "CUS96087281",
    "customerName": "Rachel Roberts",
    "address": "2 Pondside, Haywards Heath, West Sussex, RH16 4TH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000519",
    "customerRef": "CUS76149472",
    "customerName": "Midge Cann",
    "address": "8 Pinehurst, Burgess Hill, West Sussex, RH15 0DQ",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:30",
    "notes": "\u00a325 cash",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 13
  },
  {
    "id": "JOB000520",
    "customerRef": "CUS79848153",
    "customerName": "Joan Aylett",
    "address": "7 Wingle Tye Rd, Burgess Hill RH15 9HR, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 27.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000521",
    "customerRef": "CUS79848153",
    "customerName": "Joan Aylett",
    "address": "7 Wingle Tye Rd, Burgess Hill RH15 9HR, UK",
    "assignee": "",
    "services": "Gutter Cleaning",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2023-09-27",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000523",
    "customerRef": "CUS95016817",
    "customerName": "Alan",
    "address": "15 SUNNINGDALE ROAD HASSOCKS",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Drive round and park on his drive, do this house and no19",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 24
  },
  {
    "id": "JOB000524",
    "customerRef": "CUS5019961",
    "customerName": "Chris Owen",
    "address": "23 Aphrodite Way, Burgess Hill RH15 0XQ, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.3,
    "duration": "00:30",
    "notes": "Park in the carpark on the left and pull the hose round to the front to do 23 and 27 then back round to the carpark to access the rears",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 29
  },
  {
    "id": "JOB000525",
    "customerRef": "CUS1656778",
    "customerName": "Helen Valler",
    "address": "1 Longhurst, Burgess Hill, West Sussex, RH15 0TG",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 4",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000526",
    "customerRef": "CUS72556023",
    "customerName": "Louise Beale",
    "address": "9 Macnaughton Avenue, Pease Pottage, Crawley, West Sussex, RH11 9UH",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Pease Pottage",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000527",
    "customerRef": "CUS594229",
    "customerName": "Ashly Lewis",
    "address": "134 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-11",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 5
  },
  {
    "id": "JOB000528",
    "customerRef": "CUS7554293",
    "customerName": "Marie Murray",
    "address": "7 Orchard Lane, Hassocks, West Sussex, BN6 8QE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Price does not include the conservatory or the difficult to get to bathroom window above the door. They do have the conservatory cleaned occasionally.\n\nGet to the bathroom if you can",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 8
  },
  {
    "id": "JOB000529",
    "customerRef": "CUS98419122",
    "customerName": "Nick",
    "address": "4 Capenors, Burgess Hill, West Sussex, RH15 9QL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000530",
    "customerRef": "CUS72183855",
    "customerName": "Caroline McCarthy",
    "address": "1 Duke of York Cottages, London Road, Sayers Common, Hassocks, West Sussex, BN6 9HY",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 27.0,
    "duration": "00:30",
    "notes": "New**text night before. Include\nbrick built office on back\nof garage. Not the\nsummer house. Pay by\ncard link. (This property is\nopposite North Star Car\nSales, next door but one\nto the pub. Please tap on\ndoor when arriving.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000531",
    "customerRef": "CUS5842484",
    "customerName": "Gordon  McHattie",
    "address": "71 Chestnut Drive, Hassocks, West Sussex, BN6 8AZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "clean Front \nonly. Include front dormer. \nPay by GoCardless. \nOccasionally will ask you to \ndo the rear as well which \nincludes the rear windows \nand easy conservatory roof \nfor extra \u00a350. Charge extra \n\u00a35 on first clean for the \nfront and an extra \u00a310 on \nfirst clean for the rear. \n(Access to rear through \nhouse - hard floors and he \nwill remove rug)",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000532",
    "customerRef": "CUS32532876",
    "customerName": "Pete",
    "address": "Homeland, Reeds Lane, Sayers Common, Hassocks, West Sussex, BN6 9JQ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 27.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000533",
    "customerRef": "CUS88089435",
    "customerName": "Sue Summers",
    "address": "2 Chestnut Close, Burgess Hill, West Sussex, RH15 8HN",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "\"Text night before. Include garage windows but not the rear garage\ndoor. Pay by card link.\"",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000534",
    "customerRef": "CUS60992830",
    "customerName": "Nazma Rahman",
    "address": "8 Bedelands Close, Burgess Hill, West Sussex, RH15 8BL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 29.1,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-04-20",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000535",
    "customerRef": "CUS18807827",
    "customerName": "Gael",
    "address": "5 Pepper Drive, Burgess Hill, RH15 9UZ",
    "assignee": "",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2022-02-22",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000536",
    "customerRef": "CUS67061718",
    "customerName": "Emily Hudson",
    "address": "8 The Wickets, Burgess Hill, West Sussex, RH15 8TG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000537",
    "customerRef": "CUS41479539",
    "customerName": "Becci Instrell",
    "address": "7 Norman Road, Burgess Hill, West Sussex, RH15 9BX",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Text night before. Pay\nby card link",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000538",
    "customerRef": "CUS58886282",
    "customerName": "Jorge Jacob",
    "address": "134 Unicorn Way, Burgess Hill, West Sussex, RH15 0WB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 32.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000539",
    "customerRef": "CUS25844309",
    "customerName": "Michelle Andrew",
    "address": "Dillions, Portland Road, Burgess Hill, West Sussex, RH15 9RL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000540",
    "customerRef": "CUS5935157",
    "customerName": "Laura Savage",
    "address": "62 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TA",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-04-16",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000543",
    "customerRef": "CUS40957905",
    "customerName": "Sharon Kidner",
    "address": "16 Oathall Avenue, Haywards Heath, West Sussex, RH16 3EU",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-15",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000544",
    "customerRef": "CUS40226441",
    "customerName": "Stephen Dando",
    "address": "37 Wilderness Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9XD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 24.17,
    "duration": "00:30",
    "notes": "Need a ladder to climb to reach the window one the side",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000546",
    "customerRef": "CUS86285624",
    "customerName": "Robert Monk",
    "address": "20 Malthouse Lane, Burgess Hill, West Sussex",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000547",
    "customerRef": "CUS98414334",
    "customerName": "Trudi Bubb",
    "address": "38 Beacon Crescent, Burgess Hill, West Sussex, RH15 0ZL",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Garage Window",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before.\nInclude garage door\nand window. Access\nto rear garden via\ngarage. If customer is\nnot home neighbour\nin house with\nadjoining garage will\nhave garage key. Pay\nby card link",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000548",
    "customerRef": "CUS82231403",
    "customerName": "Georgia Henry",
    "address": "1 Larkspur Drive, Burgess Hill, RH15 0UL",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 21,
    "done": 18
  },
  {
    "id": "JOB000549",
    "customerRef": "CUS86281054",
    "customerName": "Oliver Clark",
    "address": "69 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 13
  },
  {
    "id": "JOB000550",
    "customerRef": "CUS56415738",
    "customerName": "Nicola Dawson",
    "address": "63 Ockley Way, Hassocks, West Sussex, BN6 8NF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 21.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB000551",
    "customerRef": "CUS55904933",
    "customerName": "Alan",
    "address": "69 Hammonds Ridge, Burgess Hill, RH15 9QW",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 24.2,
    "duration": "00:45",
    "notes": "Inc velux above the garage",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 27
  },
  {
    "id": "JOB000553",
    "customerRef": "CUS98176914",
    "customerName": "Sue Smith",
    "address": "4 Abbots Close, Hassocks, West Sussex, BN6 8PH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000555",
    "customerRef": "CUS45940050",
    "customerName": "Kat Murphy",
    "address": "26 Courtlands, Haywards Heath, West Sussex, RH16 4JD",
    "assignee": "Dan",
    "services": "Window Clean,Cladding Clean",
    "zone": "Perfect Properties",
    "price": 160.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-12-11",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000556",
    "customerRef": "CUS66830103",
    "customerName": "Stuart Wallis",
    "address": "1 Oakfield Lane, Plumpton Green, Lewes, Sussex, BN7 3FF",
    "assignee": "",
    "services": "Facia soffit & gutter wash,Cladding Clean",
    "zone": "Perfect Properties",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "never",
    "nextDue": "2026-02-02",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 0,
    "done": 0
  },
  {
    "id": "JOB000557",
    "customerRef": "CUS66830103",
    "customerName": "Stuart Wallis",
    "address": "1 Oakfield Lane, Plumpton Green, Lewes, Sussex, BN7 3FF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Text night before.\nInclude drinks bar in\ngarden. Pay by card\nlink. Please knock first\nto secure dogs. Please\nquote for gutters, sofitts\nand fascia.",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000558",
    "customerRef": "CUS77742612",
    "customerName": "Kaye Hunt",
    "address": "9 The Willows, Burgess Hill, West Sussex, RH15 8HU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Access to rear garden via Rear garden gate",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000559",
    "customerRef": "CUS34824291",
    "customerName": "Amber Tweedy",
    "address": "79 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 25.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-10",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 7
  },
  {
    "id": "JOB000560",
    "customerRef": "CUS42820539",
    "customerName": "Liz",
    "address": "108 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 27.5,
    "duration": "00:60",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 36
  },
  {
    "id": "JOB000561",
    "customerRef": "CUS42820539",
    "customerName": "Liz",
    "address": "108 Iden Hurst, Hurstpierpoint, Hassocks BN6, UK",
    "assignee": "Dan",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 70.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-06-24",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000562",
    "customerRef": "CUS58548834",
    "customerName": "Matthew",
    "address": "1 Cross Cottages, Cuckfield Road, Ansty, Haywards Heath, West Sussex, RH17 5AG",
    "assignee": "Dan",
    "services": "Window clean inc velux,Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 150.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-12-16",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000563",
    "customerRef": "CUS49954735",
    "customerName": "Nathan Taylor",
    "address": "Truslers, Truslers Hill Lane, Albourne, Hassocks, West Sussex, BN6 9DT",
    "assignee": "Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 33.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-10",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000564",
    "customerRef": "CUS49954735",
    "customerName": "Nathan Taylor",
    "address": "Truslers, Truslers Hill Lane, Albourne, Hassocks, West Sussex, BN6 9DT",
    "assignee": "Dan & Steve",
    "services": "Gutter, facia, soffit wash,Gutter Clearance",
    "zone": "Hurstpierpoint",
    "price": 220.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-02",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000565",
    "customerRef": "CUS94369666",
    "customerName": "Becky Coleman",
    "address": "110 Iden Hurst, Hurstpierpoint, Hassocks, West Sussex, BN6 9YJ",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-06-21",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000566",
    "customerRef": "CUS94369666",
    "customerName": "Becky Coleman",
    "address": "110 Iden Hurst, Hurstpierpoint, Hassocks, West Sussex, BN6 9YJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Windows on all sides of the house, this is a new customer",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000567",
    "customerRef": "CUS56609898",
    "customerName": "Margaret Railton",
    "address": "11 Ferndale Road, Burgess Hill, West Sussex, RH15 0HQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 23.33,
    "duration": "00:30",
    "notes": "\"Text night before. Not the conservatory. Pay by card link. Can the second clean be one week early (w/c 10th November) as the have\na wedding on Monday 17th Nov at their house.\"",
    "lastDone": "2025-12-03",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000568",
    "customerRef": "CUS50545136",
    "customerName": "Sandy Middlebrook",
    "address": "4 The Close, Burgess Hill, West Sussex, RH15 0PR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Text night before. Front\nonly. Knock first and if\ncan do whole house\ncharge \u00a323. Pay by\ncard link.",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000569",
    "customerRef": "CUS64720712",
    "customerName": "Lorraine",
    "address": "50 Stonepound Road, Hassocks, West Sussex, BN6 8PR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Bungalow all windows",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB000570",
    "customerRef": "CUS72331011",
    "customerName": "Lisa Burstow",
    "address": "6 Benjamin Way, Burgess Hill, RH15 0FG",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "",
    "price": 25.3,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-02-17",
    "nextDue": "",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 20
  },
  {
    "id": "JOB000571",
    "customerRef": "CUS17187316",
    "customerName": "Ron And Joy",
    "address": "30 Junction Road, Burgess Hill, West Sussex, RH15 0JN",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Flat roof will need ladder",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000573",
    "customerRef": "CUS2130144",
    "customerName": "Chris Duddridge",
    "address": "Woodbarton Cottage, Ditchling Common, Ditchling, Hassocks, West Sussex, BN6 8TP",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "To get to the house, drive to the bottom of Folders Lane, turn right and then take an immediate right turn, 360 garden so can access rear of property freely.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000574",
    "customerRef": "CUS11452839",
    "customerName": "Georgina",
    "address": "8 Five Oaks Way, Hassocks, BN6 9ZU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 41.0,
    "duration": "00:45",
    "notes": "Inc garage windows and doors (in the garden) and the the white arm on the veranda, clean the back of it too",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 32
  },
  {
    "id": "JOB000575",
    "customerRef": "CUS11452839",
    "customerName": "Georgina",
    "address": "8 Five Oaks Way, Hassocks, BN6 9ZU",
    "assignee": "Steve",
    "services": "Top floor facias",
    "zone": "Perfect Properties",
    "price": 25.0,
    "duration": "00:30",
    "notes": "The very top 3rd floor facias on the dormer",
    "lastDone": "2024-02-09",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000576",
    "customerRef": "CUS93640677",
    "customerName": "Sophie Peskett",
    "address": "60 Curf Way, Burgess Hill RH15 0GE, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 27.5,
    "duration": "00:45",
    "notes": "You need long pole for 60,58,54",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 33
  },
  {
    "id": "JOB000577",
    "customerRef": "CUS58458059",
    "customerName": "MrBrown",
    "address": "40 Midfields Drive, Burgess Hill, West Sussex, RH15 8EN",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Not the\nconservatory. If customer\noccasionally wants\nconservatory done charge\nextra \u00a310. Preferably pay\nby cash (if ever a problem\nhe will set up card link). \u00a327",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 12
  },
  {
    "id": "JOB000579",
    "customerRef": "CUS58754241",
    "customerName": "Nigel Shapiro",
    "address": "14 Unicorn Way, Burgess Hill, West Sussex, RH15 0UU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000580",
    "customerRef": "CUS67884642",
    "customerName": "Brendan  Sherwood",
    "address": "6 Manor Avenue, Hassocks, West Sussex, BN6 8NG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 31.0,
    "duration": "00:30",
    "notes": "Text night before. Include 1 \nx velux (best you can) and \nthe extension. Not the \nlantern.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB000581",
    "customerRef": "CUS87240658",
    "customerName": "Fiona Ahlrichs",
    "address": "9 Rolfe Drive, Burgess Hill, West Sussex, RH15 0LA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 38.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000582",
    "customerRef": "CUS94435402",
    "customerName": "Leslie Orams",
    "address": "27 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BE",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000583",
    "customerRef": "CUS79332822",
    "customerName": "Ena Barron",
    "address": "14 Potters Lane, Burgess Hill, RH15 9HY",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. If\ncustomer is not home,\nhand over gate and\nunbolt. Include 1 velux.\nCustomer would like to\npay cash \u00a321 as she is\npartially sighted and\ncould not manage card\nlink. CASH IN GARDEN",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000584",
    "customerRef": "CUS42888639",
    "customerName": "Claudine Lower",
    "address": "The Old Coach House, London Road, Sayers Common, Hassocks, West Sussex, BN6 9HY",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 40.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000585",
    "customerRef": "CUS24954289",
    "customerName": "Carolyn Todd",
    "address": "41 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000586",
    "customerRef": "CUS73335910",
    "customerName": "Thelma Keating",
    "address": "27 Sunningdale Road, Hassocks, Sussex, BN6 9QQ",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000587",
    "customerRef": "CUS24534254",
    "customerName": "Sallie White",
    "address": "27 Friars Oak Rd, Hassocks BN6 8PU, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 29
  },
  {
    "id": "JOB000588",
    "customerRef": "CUS74614845",
    "customerName": "Heather",
    "address": "12 Downs View Rd, Hassocks BN6 8HJ, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 28
  },
  {
    "id": "JOB000590",
    "customerRef": "CUS36721675",
    "customerName": "Kirstyn Box",
    "address": "11 Barley Croft The Street, Albourne, Hassocks, BN6 9DN",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Sayers No Email",
    "price": 18.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-18",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 33
  },
  {
    "id": "JOB000591",
    "customerRef": "CUS65145749",
    "customerName": "Sue Prevett",
    "address": "Wych Cottage, Orchard Way, Warninglid, Haywards Heath, West Sussex, RH17 5ST",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 33.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000592",
    "customerRef": "CUS44548900",
    "customerName": "Michael Collison",
    "address": "9 Ferndale Road, Burgess Hill, West Sussex, RH15 0HQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000594",
    "customerRef": "CUS1839822",
    "customerName": "Jane",
    "address": "6 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "zone": "Hurstpierpoint",
    "price": 12.5,
    "duration": "00:30",
    "notes": "Front only 3 windows.",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-11",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000595",
    "customerRef": "CUS38761887",
    "customerName": "Norma",
    "address": "3 West View Cottages, Lewes Road, Lindfield, Haywards Heath, West Sussex, RH16 2LJ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 48.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-03",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000596",
    "customerRef": "CUS96200804",
    "customerName": "Lara Thwaites",
    "address": "7 Gatehouse Lane, Burgess Hill, West Sussex, RH15 9XB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 24.17,
    "duration": "00:30",
    "notes": "Text night before.\nDirections. House\nnumber on gatepost. Pay\nby card link.",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000597",
    "customerRef": "CUS93799631",
    "customerName": "Lisa Ives",
    "address": "20 Five Oaks Way, Hassocks, BN6 9ZU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-05-15",
    "frequency": "every 18 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB000598",
    "customerRef": "CUS91294237",
    "customerName": "Sonia Nicholson",
    "address": "13 Iden Hurst, Hurstpierpoint, Hassocks BN6 9XZ, UK",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-12-05",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000599",
    "customerRef": "CUS91294237",
    "customerName": "Sonia Nicholson",
    "address": "13 Iden Hurst, Hurstpierpoint, Hassocks BN6 9XZ, UK",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 29.7,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 34
  },
  {
    "id": "JOB000600",
    "customerRef": "CUS91294237",
    "customerName": "Sonia Nicholson",
    "address": "13 Iden Hurst, Hurstpierpoint, Hassocks BN6 9XZ, UK",
    "assignee": "",
    "services": "Gutter Cleaning",
    "zone": "Perfect Properties",
    "price": 90.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2022-02-22",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000602",
    "customerRef": "CUS61848744",
    "customerName": "David Sayers",
    "address": "17 Victoria Close, Burgess Hill, West Sussex, RH15 9QS",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000603",
    "customerRef": "CUS14709476",
    "customerName": "Diana D'Alquen",
    "address": "26 Granville Drive, Hassocks, West Sussex, BN6 8GP",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hassocks",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000604",
    "customerRef": "CUS29955321",
    "customerName": "Kevin Lee",
    "address": "18 The Sycamores, Sayers Common, Hassocks, BN6 9XP",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Cash, include velux at the back, cash left on the garden by pot by backdoor",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000605",
    "customerRef": "CUS88732066",
    "customerName": "Paul Browne",
    "address": "10 Wheelwright Lane, Burgess Hill, West Sussex, RH15 0QL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000607",
    "customerRef": "CUS83574553",
    "customerName": "Alex Simms",
    "address": "9 Southdowns, Plumpton Green, Lewes, East Sussex, BN7 3EB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Text night before.\nInclude 5 x velux, rear\ndormer and extension.\nAccess to rear through\nnumber 10 garden (has\nright of way). Pay by\ncard link",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000608",
    "customerRef": "CUS90579549",
    "customerName": "Lesley",
    "address": "5 Randiddles Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9BG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Gf windows only at the back",
    "lastDone": "2025-12-13",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000609",
    "customerRef": "CUS82371985",
    "customerName": "Kerry Lingard",
    "address": "49 Hazel Grove, Burgess Hill, RH15 0BZ",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 28.0,
    "duration": "00:30",
    "notes": "MAKE LAST APPOINTMENT AS SHE WORKS SHIFTS",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 22
  },
  {
    "id": "JOB000610",
    "customerRef": "CUS82371985",
    "customerName": "Kerry Lingard",
    "address": "49 Hazel Grove, Burgess Hill, RH15 0BZ",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 125.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-07-08",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000611",
    "customerRef": "CUS31841413",
    "customerName": "Katherine  Cotterell",
    "address": "2 The Close, Hassocks, West Sussex, BN6 8DN",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-11-25",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000612",
    "customerRef": "CUS31841413",
    "customerName": "Katherine  Cotterell",
    "address": "2 The Close, Hassocks, West Sussex, BN6 8DN",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 38.0,
    "duration": "00:30",
    "notes": "Include \nconservatory and 3 x velux \nand dormer. Pay by \nGoCardless",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000613",
    "customerRef": "CUS91030301",
    "customerName": "Helena King",
    "address": "Hickstead Lodge Cattery Hickstead Westside  Hickstead Haywards Heath West Susse, Westside, London Road, Hickstead, Haywards Heath, West Sussex, RH17 5LZ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hickstead",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000614",
    "customerRef": "CUS32996771",
    "customerName": "Faye Wright",
    "address": "1 Woodpecker Close Sayers Common, Hassocks West sussex BN6 9HU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers2",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000615",
    "customerRef": "CUS67042611",
    "customerName": "Alan Burgess",
    "address": "15 Heron Close,Sayers common",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers No Email",
    "price": 19.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 28
  },
  {
    "id": "JOB000617",
    "customerRef": "CUS84123365",
    "customerName": "Hannah Morris",
    "address": "1 Singleton Way, Burgess Hill RH15 0BU, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 19.8,
    "duration": "00:45",
    "notes": "Inc veluxes at the front",
    "lastDone": "2025-10-21",
    "nextDue": "2026-02-10",
    "frequency": "every 8 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 21
  },
  {
    "id": "JOB000618",
    "customerRef": "CUS19202980",
    "customerName": "Hugh Wright",
    "address": "25 Chichester Way, Burgess Hill, West Sussex, RH15 0RH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Text night before. Not the\ngarage. O.K. to access the\nrear garden via the garage\nif unlocked and customer is\nout. If garage is locked\naccess rear garden by\nsqueezing down the side of\nthe garage. Pay by card Link",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000619",
    "customerRef": "CUS11093132",
    "customerName": "Tony Westgarth",
    "address": "14 Beaconsfield Close, Burgess Hill, West Sussex, RH15 9AT",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before. Please keep garden gate closed ref dog.",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000620",
    "customerRef": "CUS24410942",
    "customerName": "Daniel Cooper",
    "address": "9 Bolnore Road, Haywards Heath, West Sussex, RH16 4AB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000622",
    "customerRef": "CUS30244994",
    "customerName": "Julie Dolan",
    "address": "6 Broad Green Avenue, Burgess Hill, West Sussex, RH15 0HA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 27.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 11
  },
  {
    "id": "JOB000623",
    "customerRef": "CUS37421337",
    "customerName": "Rob",
    "address": "20 Beaconsfield Close, Burgess Hill, West Sussex, RH15 9AT",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 48.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-30",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000624",
    "customerRef": "CUS59408338",
    "customerName": "Jeanette",
    "address": "2 London Rd, Hassocks BN6 9NT, UK",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Pays CASH, knock the door",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-04",
    "frequency": "every 4 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 48,
    "done": 39
  },
  {
    "id": "JOB000625",
    "customerRef": "CUS7828199",
    "customerName": "Ian Riley",
    "address": "Nenian, Colwell Road, Haywards Heath, West Sussex, RH16 4HD",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-12-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000628",
    "customerRef": "CUS27579434",
    "customerName": "Grace",
    "address": "35 The Fairway, Hassocks, Sussex, BN6 9JU",
    "assignee": "",
    "services": "Garage door clean",
    "zone": "Perfect Properties",
    "price": 10.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2023-08-14",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000629",
    "customerRef": "CUS27579434",
    "customerName": "Grace",
    "address": "35 The Fairway, Hassocks, Sussex, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000630",
    "customerRef": "CUS9302826",
    "customerName": "Emma Day",
    "address": "93 Fairfield Road, Burgess Hill, RH15 8NP",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 19.0,
    "duration": "00:45",
    "notes": "Park outside the front of the house and do the front, park on the path opposite if no spaces, you will literally be 5 mins then turn on to at Mary's road to access the back, it's the small gate furtherest away down the path\nH",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 29
  },
  {
    "id": "JOB000631",
    "customerRef": "CUS9302826",
    "customerName": "Emma Day",
    "address": "93 Fairfield Road, Burgess Hill, RH15 8NP",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-10",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000632",
    "customerRef": "CUS11493229",
    "customerName": "Krissie Boreczek",
    "address": "41 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BH",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 23.33,
    "duration": "00:30",
    "notes": "Text night before.\nInclude 2 x dormers and\none window on\nextension. Not the 2\ninaccessible windows on\nextension. Pay by card\nlink.",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000633",
    "customerRef": "CUS11819818",
    "customerName": "Vanessa Edwards",
    "address": "16 Mill Rose Way, Burgess Hill RH15 0ZG, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 16.5,
    "duration": "00:45",
    "notes": "This one park on the path as you go around the bend and do the front then move the van through the opening to the carpark to do the back, it's the second gate from the left",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 33,
    "done": 32
  },
  {
    "id": "JOB000634",
    "customerRef": "CUS11819818",
    "customerName": "Vanessa Edwards",
    "address": "16 Mill Rose Way, Burgess Hill RH15 0ZG, UK",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 40.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-02-07",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000635",
    "customerRef": "CUS38367461",
    "customerName": "Georgia Caudell",
    "address": "6 Turnbury Hassocks BN6",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 20.0,
    "duration": "00:45",
    "notes": "Do this and the house opposite no 5 and 6",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 34
  },
  {
    "id": "JOB000636",
    "customerRef": "CUS81145659",
    "customerName": "Anna Judson",
    "address": "40 Wentworth Road, Hassocks, BN6 9SQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:30",
    "notes": "There's Windows on the right hand side of the house\n\nCode 4068",
    "lastDone": "2026-01-08",
    "nextDue": "2026-04-02",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 23
  },
  {
    "id": "JOB000638",
    "customerRef": "CUS1158578",
    "customerName": "Emily",
    "address": "48 Weald Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9SR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000639",
    "customerRef": "CUS73489435",
    "customerName": "Michele",
    "address": "24 Bastable Street, Crawley, Sussex, RH10 2AB",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Forgewood",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-04-08",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000640",
    "customerRef": "CUS7136530",
    "customerName": "Isabella Phillips",
    "address": "10 Pegasus Place, Burgess Hill, RH15 0XB",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 16.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 37
  },
  {
    "id": "JOB000641",
    "customerRef": "CUS22437384",
    "customerName": "Maria Crudge",
    "address": "21a Ferndale Road, Burgess Hill, West Sussex, RH15 0HB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.33,
    "duration": "00:30",
    "notes": "\"Text night before. First clean NOT Thursday. Include the two windows over conservatory (will need ladder). Please use left hand side gate (if looking at house).\nPay by card link. NB\"",
    "lastDone": "2025-12-01",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000642",
    "customerRef": "CUS14008942",
    "customerName": "Emily",
    "address": "7 Siskin Close, Burgess Hill, RH15 9DH",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 17.6,
    "duration": "00:30",
    "notes": "This one park in the layby on linet lane, then 7 and 9 are along the path that goes straight down, all normal pole, check pics attached to confirm parking location, clean glass only balcony",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 34
  },
  {
    "id": "JOB000643",
    "customerRef": "CUS76360261",
    "customerName": "Isvett Fernandez",
    "address": "46 Hassocks Gate, Hassocks, BN6 9ZF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000644",
    "customerRef": "CUS52617048",
    "customerName": "Susanne",
    "address": "10 Bankside, Hassocks BN6 8EL, UK",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 33.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 12
  },
  {
    "id": "JOB000645",
    "customerRef": "CUS1827331",
    "customerName": "Louise Garcia",
    "address": "17 Bonnet Ln., Burgess Hill RH15, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 27.5,
    "duration": "00:45",
    "notes": "Include all veluxes etc, use long pole for this but change the brush head to the white one on the short pole",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 43,
    "done": 43
  },
  {
    "id": "JOB000646",
    "customerRef": "CUS84811498",
    "customerName": "Neil McColl",
    "address": "11 The Wickets, Burgess Hill, West Sussex, RH15 8TG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000650",
    "customerRef": "CUS16056690",
    "customerName": "Lorna Lindo",
    "address": "16 Meadow Lane, Burgess Hill",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 21.67,
    "duration": "00:30",
    "notes": "Text night before. Include\ndormer. Pay by card link.",
    "lastDone": "2026-01-26",
    "nextDue": "2026-04-20",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000652",
    "customerRef": "CUS50757145",
    "customerName": "Krzysia Terlecki",
    "address": "25 Woodpecker Crescent, Burgess Hill, West Sussex, RH15 9XY",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Garden through the house. 7591 is the code for the key box by the porch if no one home",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000655",
    "customerRef": "CUS3436082",
    "customerName": "Tracey Read",
    "address": "4 Dukes Barn Mews, Lindfield, Haywards Heath, West Sussex, RH16 2GD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Lindfield",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000656",
    "customerRef": "CUS18217868",
    "customerName": "Daisy Marchant",
    "address": "54 Western Road, Burgess Hill, West Sussex, RH15 8QN",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000657",
    "customerRef": "CUS88807821",
    "customerName": "Katie Bird",
    "address": "21 Fitzalan Mead, Hassocks, West Sussex, BN6 8FY",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-19",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000659",
    "customerRef": "CUS74580777",
    "customerName": "Laura  Rochford",
    "address": "60 Ockley Way, Hassocks, BN6 8NF",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Text night before. \nInclude 2 velux.\n\nFill up after",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 20
  },
  {
    "id": "JOB000660",
    "customerRef": "CUS63352982",
    "customerName": "Karen Rash",
    "address": "30 Dale Ave, Keymer, Hassocks BN6 8LP, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean front only",
    "zone": "Hassocks",
    "price": 16.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 25
  },
  {
    "id": "JOB000661",
    "customerRef": "CUS11280421",
    "customerName": "Hazel Fordham",
    "address": "8 Wisden Avenue, Burgess Hill, West Sussex, RH15 8TL",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000662",
    "customerRef": "CUS18893531",
    "customerName": "Jean",
    "address": "19 Manor Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9UG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 8
  },
  {
    "id": "JOB000663",
    "customerRef": "CUS26414848",
    "customerName": "Tanya Lyons",
    "address": "16 Penn Crescent, Haywards Heath, West Sussex, RH16 3HN",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-27",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000664",
    "customerRef": "CUS4939281",
    "customerName": "Yvonne Hennessy",
    "address": "24 Beacon Road, Ditchling, Hassocks, West Sussex, BN6 8UL",
    "assignee": "Steve",
    "services": "Window Clean every 12 weeks",
    "zone": "Hassocks",
    "price": 29.17,
    "duration": "00:30",
    "notes": "To access number 24 you need to drive down the RIGHT side driveway at number 22. \nThe customer has asked please:\n*To not park/turn around on number 22's tarmacked area (they will complain)\n*To park right up the drive of number 24, plenty of space to park",
    "lastDone": "2025-11-26",
    "nextDue": "2026-02-18",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000665",
    "customerRef": "CUS53036375",
    "customerName": "Carolann Mitchell",
    "address": "64 Adastra Avenue, Hassocks, West Sussex, BN6 8DR",
    "assignee": "",
    "services": "Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-03-17",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000666",
    "customerRef": "CUS53036375",
    "customerName": "Carolann Mitchell",
    "address": "64 Adastra Avenue, Hassocks, West Sussex, BN6 8DR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Include\n2 windows at rear of\ngarage.",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000669",
    "customerRef": "CUS69044253",
    "customerName": "Kelly Rose",
    "address": "77 Janes Lane, Burgess Hill, West Sussex, RH15 0QP",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "zone": "BH Zone 3",
    "price": 58.33,
    "duration": "00:30",
    "notes": "Knock to get acces to upstairs balcony",
    "lastDone": "2026-01-23",
    "nextDue": "2026-04-17",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 2
  },
  {
    "id": "JOB000670",
    "customerRef": "CUS69044253",
    "customerName": "Kelly Rose",
    "address": "77 Janes Lane, Burgess Hill, West Sussex, RH15 0QP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "",
    "price": 27.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-02-04",
    "nextDue": "",
    "frequency": "every 8 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000673",
    "customerRef": "CUS4611146",
    "customerName": "Sue O'Connor",
    "address": "11 The Saffrons, Burgess Hill, RH15 8TB",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 33.0,
    "duration": "00:45",
    "notes": "Inc con",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 34
  },
  {
    "id": "JOB000675",
    "customerRef": "CUS18314334",
    "customerName": "Sam",
    "address": "3 Hassocks Gate, Hassocks BN6, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB000676",
    "customerRef": "CUS83169903",
    "customerName": "Pamela Reeves",
    "address": "1a Clayton Avenue, Hassocks, West Sussex, BN6 8HB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 44.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory. Not the front\nbalcony windows. Side\nwindows above garage do\nif you can but shes not\nexpecting you to. Side gate\n- lean over and hand\nthrough gate to unlock 2 x Bolts",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB000677",
    "customerRef": "CUS28451423",
    "customerName": "Margaret Fahey",
    "address": "28 St Mary's Rd, Burgess Hill RH15 8NU, UK",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:45",
    "notes": "PAYS CASH SO KNOCK THE DOOR AFTER\n\nShe is going out at 0950 so if you get there after the money will be left under the watering can in the garden \ud83d\udc4d\ud83c\udffc\n\nLONG POLE",
    "lastDone": "2025-10-16",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 27
  },
  {
    "id": "JOB000678",
    "customerRef": "CUS81955246",
    "customerName": "Zoe",
    "address": "2 Foxhole Cottages, Bedlam Street, Hurstpierpoint, Hassocks, West Sussex, BN6 9EL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 4
  },
  {
    "id": "JOB000679",
    "customerRef": "CUS18738348",
    "customerName": "Sarah Barnett",
    "address": "4 Pegasus Place, Burgess Hill, West Sussex, RH15 0XB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 7
  },
  {
    "id": "JOB000683",
    "customerRef": "CUS80014443",
    "customerName": "Will Entwistle",
    "address": "57 Parklands Road, Hassocks, West Sussex, BN6 8JY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:30",
    "notes": "Text night before. Access\nrear garden via Age\nConcern car park, house\nno. on wooden gate. Pay\nby cardlink.",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000684",
    "customerRef": "CUS66650064",
    "customerName": "David Hook",
    "address": "14 Abbots Close, Hassocks, West Sussex, BN6 8PH",
    "assignee": "Dan, Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 100.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-11",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000685",
    "customerRef": "CUS66650064",
    "customerName": "David Hook",
    "address": "14 Abbots Close, Hassocks, West Sussex, BN6 8PH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 27.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 19
  },
  {
    "id": "JOB000686",
    "customerRef": "CUS8827235",
    "customerName": "Tamara",
    "address": "39 Kilnwood Avenue, Burgess Hill, West Sussex, RH15 0ZD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-10",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000687",
    "customerRef": "CUS58649967",
    "customerName": "Liz Finn",
    "address": "Fermain, Malthouse Lane, Burgess Hill, West Sussex, RH15 9XA",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.83,
    "duration": "00:30",
    "notes": "Text night before.\nDirections. Next to\nSevenfields.",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000688",
    "customerRef": "CUS8114125",
    "customerName": "Jasmin Dudden",
    "address": "37 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BH",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Text night before. Use\nside gate by front door.\nPay by card link. If\nchanges to 12 weekly\nincrease price to \u00a327\n(she has agreed).",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000690",
    "customerRef": "CUS72041092",
    "customerName": "Zo Payne",
    "address": "1Fitzalanmead, Fitzalan Mead, Hassocks, West Sussex, BN6 8FY",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000691",
    "customerRef": "CUS9632287",
    "customerName": "Lewis Roe",
    "address": "29 Leylands Park, Burgess Hill, West Sussex, RH15 8AQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000692",
    "customerRef": "CUS26882353",
    "customerName": "Tanya",
    "address": "56 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000694",
    "customerRef": "CUS99145481",
    "customerName": "Carla Harfield",
    "address": "32 Avenue De Warenne, Hassocks, West Sussex, BN6 8FP",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000696",
    "customerRef": "CUS24218647",
    "customerName": "Graham Ketley",
    "address": "Farthings, Station Road, Plumpton Green, Lewes, East Sussex, BN7 3BY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before.\nClean velux as and\nwhen. Customer will\nleave garage unlocked\non receipt of text if not\nhome. Access window\nL.H. side of house from\nneighbours garden\n(see customer). Pay by\ncard link. Dir. opp\nInholmes Cottages",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000700",
    "customerRef": "CUS61276305",
    "customerName": "Caroline Davey",
    "address": "67 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000701",
    "customerRef": "CUS83902315",
    "customerName": "Demi Moore",
    "address": "65 St. Andrews Road, Burgess Hill, RH15 0PJ",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 21,
    "done": 21
  },
  {
    "id": "JOB000702",
    "customerRef": "CUS94795013",
    "customerName": "Jenny Sweet",
    "address": "1 Dunlop Close, Sayers Common, Hassocks, BN6 9SL",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Call night before. Include conservatory. \n\nCASH \u00a332",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000703",
    "customerRef": "CUS94453856",
    "customerName": "Nick Woodcock",
    "address": "29 Ockenden Way, Hassocks BN6 8HS, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean inc Garden Room",
    "zone": "Hassocks",
    "price": 40.8,
    "duration": "00:30",
    "notes": "Not the greenhouse extension.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 25
  },
  {
    "id": "JOB000704",
    "customerRef": "CUS85893950",
    "customerName": "Elsa",
    "address": "10 Gordon Rd, Burgess Hill RH15 0PX, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 29
  },
  {
    "id": "JOB000705",
    "customerRef": "CUS46820207",
    "customerName": "Naomi",
    "address": "1 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 18.0,
    "duration": "00:30",
    "notes": "Do 1and 3 and the house opposite which is no 12",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 36
  },
  {
    "id": "JOB000706",
    "customerRef": "CUS66669247",
    "customerName": "Ben Graves",
    "address": "108 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 22.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 6
  },
  {
    "id": "JOB000708",
    "customerRef": "CUS60489889",
    "customerName": "Tom Burnage",
    "address": "32 Folders Lane, Burgess Hill, West Sussex, RH15 0DR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "All windows but not any velux. NO FLAT ROOF",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB000709",
    "customerRef": "CUS68524816",
    "customerName": "James Taylor",
    "address": "53 Kings Dr, Hassocks BN6 8DY, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks No Email",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 29
  },
  {
    "id": "JOB000710",
    "customerRef": "CUS12743310",
    "customerName": "Nick Johnston",
    "address": "13 Petworth Drive, Burgess Hill, West Sussex, RH15 8JT",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 35.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-07",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 16
  },
  {
    "id": "JOB000711",
    "customerRef": "CUS78541588",
    "customerName": "Ellie",
    "address": "47 Hassocks Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9QL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 45.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-13",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000712",
    "customerRef": "CUS30381649",
    "customerName": "Heber And Ruth",
    "address": "131 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 35.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-13",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 5
  },
  {
    "id": "JOB000713",
    "customerRef": "CUS66327272",
    "customerName": "Ben",
    "address": "14 Goosefoot Lane, Burgess Hill, RH15 0WT",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000714",
    "customerRef": "CUS61781932",
    "customerName": "Richard White",
    "address": "29 Janes Lane, Burgess Hill, West Sussex, RH15 0QJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 47.0,
    "duration": "00:30",
    "notes": "Text night before. Include 9\nx velux, customer advised\nsome velux may be out of\nreach. Please leave leaflet.\nIf you cannot do velux\nreduce price by \u00a31.50 per\nvelux and let me know and I\nwill reduce the invoice\nvalue.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000715",
    "customerRef": "CUS45214661",
    "customerName": "Nick Low",
    "address": "5 Stirling Court Road, Burgess Hill, West Sussex, RH15 0PS",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000716",
    "customerRef": "CUS99073179",
    "customerName": "Craig Waller",
    "address": "3 Queens Drive, Hassocks, BN6 8DF",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Include 2 front velux. Include extension. Not the Juliette balcony but include the screen. Not the 2 x velux on the rear extension.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 23
  },
  {
    "id": "JOB000717",
    "customerRef": "CUS27137759",
    "customerName": "Chris Rogers",
    "address": "9 Romaine Cl, Burgess Hill RH15 0NS, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 31.9,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 27
  },
  {
    "id": "JOB000719",
    "customerRef": "CUS53947311",
    "customerName": "Debbie Murray",
    "address": "28 Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-08",
    "nextDue": "",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 10
  },
  {
    "id": "JOB000720",
    "customerRef": "CUS53947311",
    "customerName": "Debbie Murray",
    "address": "125 Leylands Rd, Burgess Hill RH15 8JS, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 31
  },
  {
    "id": "JOB000721",
    "customerRef": "CUS99025129",
    "customerName": "Karen Ashworth",
    "address": "3 Maple Close, Burgess Hill, West Sussex, RH15 8HP",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nextension and 1 x velux.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000723",
    "customerRef": "CUS76055667",
    "customerName": "Rachel BartlettBundy",
    "address": "27 The Quadrant, Hassocks, West Sussex, BN6 8BP",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "zone": "Hassocks",
    "price": 24.0,
    "duration": "00:30",
    "notes": "Hi there we\u2019d like to change our window cleaning to just the higher ones at the front and ground floor and side of the house thanks.\nSo no nothing round the back. \nPlease can you start with that from today",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 12
  },
  {
    "id": "JOB000724",
    "customerRef": "CUS26891612",
    "customerName": "Caroline",
    "address": "15 Summerhill Grange, Lindfield, Haywards Heath, West Sussex, RH16 1RQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 35.0,
    "duration": "00:30",
    "notes": "New",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000725",
    "customerRef": "CUS1965523",
    "customerName": "Mark Potter",
    "address": "8 The Pound, Burgess Hill, West Sussex, RH15 8PF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000726",
    "customerRef": "CUS37701990",
    "customerName": "James Busby",
    "address": "26 Sunningdale Road, Hassocks, Sussex, BN6 9QQ",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.0,
    "duration": "00:30",
    "notes": "New customer, double rinse all windows and wipe down the sills downstairs fully",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000727",
    "customerRef": "CUS3927149",
    "customerName": "Mark Burnham",
    "address": "20 Cromwell Road, Burgess Hill, West Sussex, RH15 8QH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 22.5,
    "duration": "00:30",
    "notes": "Text night before. Ladder req. Not the lantern",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000729",
    "customerRef": "CUS4402142",
    "customerName": "Geraint",
    "address": "1 Cuckfield Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9RP",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 22.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000730",
    "customerRef": "CUS14776780",
    "customerName": "David Butcher",
    "address": "4 Sycamore Way, Hassocks, West Sussex, BN6 8YH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "All windows. Go through house to do the back. He\u2019s usually in as he mostly works from home. If not in, Jennifer has a key at no.2",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 7
  },
  {
    "id": "JOB000731",
    "customerRef": "CUS6312576",
    "customerName": "Katie Hinton",
    "address": "27 Petworth Drive, Burgess Hill, West Sussex, RH15 8JT",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 24.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB000732",
    "customerRef": "CUS81755878",
    "customerName": "Daniel Simpson",
    "address": "68 Folders Lane, Burgess Hill, West Sussex, RH15 0DX",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 38.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nextension but not the\nJuliette balcony. NOT FRONT DOOR***",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000734",
    "customerRef": "CUS46292845",
    "customerName": "Aaron Turner",
    "address": "138 unicorn way, Burgess hill RH15 0WB",
    "assignee": "Steve, Dan",
    "services": "Window clean inc velux",
    "zone": "BH Zone 4",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000735",
    "customerRef": "CUS10124185",
    "customerName": "Brian Yorke",
    "address": "25 Badgers Walk, Burgess Hill, West Sussex, RH15 0AE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 13
  },
  {
    "id": "JOB000736",
    "customerRef": "CUS27821610",
    "customerName": "Michael Hindmarsh",
    "address": "27 Aphrodite Way, Burgess Hill RH15 0XQ, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:45",
    "notes": "Park in the carpark on the left and pull the hose round to the front to do 23 and 27 then back round to the carpark to access the rears",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 35
  },
  {
    "id": "JOB000740",
    "customerRef": "CUS19299533",
    "customerName": "Joyce Harvey",
    "address": "25 Capenors, Burgess Hill, RH15 9QL",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "5374100118534531 08 26 826 Rh15 9ql",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 22
  },
  {
    "id": "JOB000741",
    "customerRef": "CUS90538582",
    "customerName": "Ajibola",
    "address": "5 Turnbury Way Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 32
  },
  {
    "id": "JOB000742",
    "customerRef": "CUS83130284",
    "customerName": "Anne Hobbs",
    "address": "21 Perryfields, Burgess Hill, West Sussex, RH15 8TU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000743",
    "customerRef": "CUS77291277",
    "customerName": "Hannah Watson",
    "address": "7 Turnbury way hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 33
  },
  {
    "id": "JOB000744",
    "customerRef": "CUS81139346",
    "customerName": "Natalie Pettifer",
    "address": "102 Royal George Road, Burgess Hill, West Sussex, RH15 9SL",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000745",
    "customerRef": "CUS71352836",
    "customerName": "Tracy Scholfield",
    "address": "12 The Maltings, Burgess Hill, West Sussex, RH15 9XF",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 39.17,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory. Please\nknock on door on arrival\nand close gates at all\ntimes to prevent dog\nfrom escaping. Pay by\ncard link.",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000746",
    "customerRef": "CUS7454785",
    "customerName": "Amelie",
    "address": "52 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 27.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-04-02",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000747",
    "customerRef": "CUS18931478",
    "customerName": "Katy Trigg",
    "address": "8 The Vineries, Burgess Hill RH15 0NF, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 34
  },
  {
    "id": "JOB000748",
    "customerRef": "CUS41666130",
    "customerName": "Tracey Naish",
    "address": "8 The Chestnuts, Sayers Common, Hassocks, BN6 9XJ",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Garden is through the gate and right to the end",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000749",
    "customerRef": "CUS56704696",
    "customerName": "Molly Williamson",
    "address": "7 Adur Road, Burgess Hill, West Sussex, RH15 0PA",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000750",
    "customerRef": "CUS20935214",
    "customerName": "Tony Ramirez",
    "address": "101 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9SY",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hurstpierpoint",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory and\nextension. Not the two\nwindows above\nextension or the velux. (If\nyou can do these two\nwindows charge extra \u00a33\nbut I dont think you can)\nPay by card link.",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000751",
    "customerRef": "CUS25013517",
    "customerName": "Karen",
    "address": "25 Semley Road, Hassocks, West Sussex, BN6 8PD",
    "assignee": "Steve",
    "services": "Window Clean front only",
    "zone": "Hassocks",
    "price": 17.5,
    "duration": "00:30",
    "notes": "Front & side only. Access via 27\n\nNOT FRONT DOOR",
    "lastDone": "2025-12-03",
    "nextDue": "2026-02-23",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 4
  },
  {
    "id": "JOB000753",
    "customerRef": "CUS41892616",
    "customerName": "Charlotte Baldwin",
    "address": "2 Pierce Place, Hurstpierpoint, Hassocks, West Sussex, BN6 9YL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-05",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000754",
    "customerRef": "CUS41892616",
    "customerName": "Charlotte Baldwin",
    "address": "8 Winifred Ratcliffe Place, Hurstpierpoint, Hassocks, BN6 9FZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 27.5,
    "duration": "00:60",
    "notes": "Real stickler for cobwebs round the frames, often has born poo on the side windows through the second gate in the garden",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 40,
    "done": 36
  },
  {
    "id": "JOB000755",
    "customerRef": "CUS78172721",
    "customerName": "Ray",
    "address": "171 Cuckfield Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9RT",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 8
  },
  {
    "id": "JOB000756",
    "customerRef": "CUS80401162",
    "customerName": "Lucy Melling",
    "address": "14 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-04-02",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 19
  },
  {
    "id": "JOB000757",
    "customerRef": "CUS69097589",
    "customerName": "Dawn Dodd",
    "address": "44 The Hawthorns, Burgess Hill, West Sussex, RH15 8RW",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "Text night before. Pay by card link.",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000758",
    "customerRef": "CUS80711460",
    "customerName": "Mark Allison",
    "address": "45 Curf Way, Burgess Hill, West Sussex, RH15 0GD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Do the Velux on the side of the house,  cash \u00a330",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-10",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000759",
    "customerRef": "CUS95060497",
    "customerName": "Ann Marie",
    "address": "20 St Andrews Pl, Hassocks BN6, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Park outside 22 on the small path and do 22 and 20",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 31
  },
  {
    "id": "JOB000761",
    "customerRef": "CUS91676586",
    "customerName": "Sheila Thompson",
    "address": "133a Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9SZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Text night before. Pay\nby card link. (It is the\nsmall house behind\ngreen gate. Include\nside windows from\nthe footpath.",
    "lastDone": "2025-12-11",
    "nextDue": "2026-03-05",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000762",
    "customerRef": "CUS66269702",
    "customerName": "Josie Wicks",
    "address": "Honeywood Hurstpierpoint, Hurst Road, Hassocks, West Sussex, BN6 9NL",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning,Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 126.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "never",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 0
  },
  {
    "id": "JOB000764",
    "customerRef": "CUS58781013",
    "customerName": "Nicola Fairhall",
    "address": "30 Highlands Drive, Burgess Hill, West Sussex, RH15 8JJ",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 38.33,
    "duration": "00:30",
    "notes": "Be extra thorough, had previous windy said wasn\u2019t happy with the corners of the window",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000765",
    "customerRef": "CUS53359123",
    "customerName": "Holly Currier",
    "address": "14 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000766",
    "customerRef": "CUS70304300",
    "customerName": "Andy Croucher",
    "address": "27 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 23
  },
  {
    "id": "JOB000767",
    "customerRef": "CUS25303755",
    "customerName": "Sharon Banks",
    "address": "3 The Acorns, Oakhurst, Sayers Common, Hassocks, West Sussex, BN6 9JW",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "New**",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000768",
    "customerRef": "CUS66843029",
    "customerName": "Mr Huitt",
    "address": "2 Denham Road, Burgess Hill, West Sussex, RH15 9TG",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Cash \u00a324",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000769",
    "customerRef": "CUS1961107",
    "customerName": "Pamela  Betsworth",
    "address": "35 Avenue  de  Warenne, Hassocks",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB000770",
    "customerRef": "CUS37035672",
    "customerName": "Keith",
    "address": "4 The Orchard, Hassocks, West Sussex, BN6 8HH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Knock on his door and introduce yourself; he\u2019s in 95% of the time. Mention Colin so he knows you\u2019re genuine. He\u2019s old so give him a bit of time to answer. This one and number 15 are the easiest of the lot to clean. Less windows but you have to go through the bungalow to get to the back.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000771",
    "customerRef": "CUS47325031",
    "customerName": "Bethany Rose",
    "address": "4 Willow Gardens, Hurstpierpoint, Hassocks, West Sussex, BN6 9TL",
    "assignee": "Steve",
    "services": "Window Clean - Flat",
    "zone": "Hurstpierpoint",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Just moved in so the frames need a good scrub",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000772",
    "customerRef": "CUS43774295",
    "customerName": "Neil Beard- Neilson",
    "address": "1 Barkdale, Burgess Hill, West Sussex, RH15 0BE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 22.5,
    "duration": "00:30",
    "notes": "Text night before. Include\nside windows, best you\ncan. Not the Juliette\nbalcony. Pay by card\nlink.",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000773",
    "customerRef": "CUS93460529",
    "customerName": "Holly Phillips",
    "address": "11 Sun Close, Plumpton Green, Lewes, East Sussex, BN7 3FA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000774",
    "customerRef": "CUS75530685",
    "customerName": "Simon Clark",
    "address": "Hall House, Station Road, Plumpton Green, Lewes, East Sussex, BN7 3BS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 23.33,
    "duration": "00:30",
    "notes": "Text night before. Pay by\ncard link. Roughly\nopposite village shop.",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000775",
    "customerRef": "CUS8623018",
    "customerName": "Warren Ford",
    "address": "119 Chanctonbury Road, Burgess Hill, West Sussex, RH15 9HE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000776",
    "customerRef": "CUS87645541",
    "customerName": "Christine Pilkington",
    "address": "12 The Quadrant, Hassocks, West Sussex, BN6 8BP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 32.5,
    "duration": "00:30",
    "notes": "All windows.",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 9
  },
  {
    "id": "JOB000777",
    "customerRef": "CUS69009288",
    "customerName": "Sophie Slater",
    "address": "5 Magnolia House, Emerald Road, Crawley, West Sussex, RH10 3FZ",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Forgewood",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-21",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000778",
    "customerRef": "CUS22062993",
    "customerName": "Dani Heslop",
    "address": "30 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000779",
    "customerRef": "CUS43388430",
    "customerName": "Richard",
    "address": "23 Edwin Street, Burgess Hill, West Sussex, RH15 9HT",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 20,
    "done": 20
  },
  {
    "id": "JOB000780",
    "customerRef": "CUS92659877",
    "customerName": "Louise Ruffolo",
    "address": "32 The Rough, Newick, Lewes, East Sussex, BN8 4NS",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 20.83,
    "duration": "00:30",
    "notes": "Text night before. All\ndoors and windows on\nhouse. Customer is\nhome every Mon-Thurs\nand sometimes on Fri.\nAccess via passageway\nif customer is home. L.H.\nside window from\nneighbours drive please\nspeak to customer first.",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000781",
    "customerRef": "CUS37519531",
    "customerName": "John Ashworth",
    "address": "11 Ann Cl, Hassocks BN6 8NB, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-11-24",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 31
  },
  {
    "id": "JOB000785",
    "customerRef": "CUS27387978",
    "customerName": "Ditchling Estates",
    "address": "Honeybourne Farm, Truslers Hill Lane, Albourne, Hassocks, West Sussex, BN6 9DU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-14",
    "nextDue": "2026-02-16",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000786",
    "customerRef": "CUS27387978",
    "customerName": "Ditchling Estates",
    "address": "The Grananry Honeybourne Farm Albourne, Truslers Hill Lane, Albourne, Hassocks, West Sussex, BN6 9DU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-10",
    "nextDue": "2026-03-30",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000787",
    "customerRef": "CUS32163665",
    "customerName": "Katie Bambro",
    "address": "2 Jack Slaughter Lane, Hassocks, West Sussex, BN6 8GF",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 24.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000788",
    "customerRef": "CUS49352292",
    "customerName": "Sarah Williams",
    "address": "18 Bankside, Bolney, Haywards Heath, West Sussex, RH17 5QN",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Lower flat all the way round",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000789",
    "customerRef": "CUS34706797",
    "customerName": "Marian Symons",
    "address": "2 Woodlands View, Green Road, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7QD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Wivelsfield",
    "price": 26.0,
    "duration": "00:30",
    "notes": "Text night before. Pay by\ncardlink. Please leave\nleaflet. Opposite the\ngreen.",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 9
  },
  {
    "id": "JOB000791",
    "customerRef": "CUS65828554",
    "customerName": "Sayful Islam",
    "address": "10 Heron Cl, Sayers Common, Hassocks BN6 9LF, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 32
  },
  {
    "id": "JOB000792",
    "customerRef": "CUS7236031",
    "customerName": "Kim Uden",
    "address": "44 Potters Lane, Burgess Hill, West Sussex, RH15 9JS",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 24.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000794",
    "customerRef": "CUS86126416",
    "customerName": "Mary Deveson",
    "address": "106 Marlborough Drive, Burgess Hill, West Sussex, RH15 0EU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 32.5,
    "duration": "00:30",
    "notes": "I\u2019ll leave a key for the right hand side gate under the pot to the left of the front door!\n\nPark on the drive if you can, do the front and right hand side of the house, walk back to the drive with the house and put it under the gates, walk round the back and pull the hose to do the back of the house and left hand side",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000795",
    "customerRef": "CUS22416806",
    "customerName": "Janet Moore",
    "address": "6 Wentworth Road, Hassocks, West Sussex, BN6 9SQ",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate2",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Text night before.\nAccess to R. garden via\ngarage, customer will\nleave open if out. Pay\nby card link.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000796",
    "customerRef": "CUS34265411",
    "customerName": "David Montero",
    "address": "1 nettle drive, burgess hill",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 33.33,
    "duration": "00:30",
    "notes": "1 Nettle Drive. Use RH15 0XT to get onto site. Our house is the grey one on the left hand side at the end T-Junction",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 44,
    "done": 42
  },
  {
    "id": "JOB000797",
    "customerRef": "CUS43793741",
    "customerName": "Phil",
    "address": "11 Sunningdale Road Hassocks",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 17.6,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB000798",
    "customerRef": "CUS91532112",
    "customerName": "Anne Cozens",
    "address": "30 Newick Drive, Newick, Lewes, East Sussex, BN8 4PA",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 22.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000799",
    "customerRef": "CUS64226243",
    "customerName": "Joanna Tindall",
    "address": "11 Nevill Place, Hassocks, BN6 8FU",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-28",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 6
  },
  {
    "id": "JOB000801",
    "customerRef": "CUS78917386",
    "customerName": "Emily Wilson",
    "address": "31 Potters Lane, Burgess Hill, West Sussex, RH15 9JT",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 8
  },
  {
    "id": "JOB000802",
    "customerRef": "CUS78190698",
    "customerName": "Andy Cockram",
    "address": "51 Mocatta Way, Burgess Hill, West Sussex, RH15 8UR",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Text night before. Park in\nparking bay or where safe\nto do so and reach F. and B.\nInclude conservatory.",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 5
  },
  {
    "id": "JOB000805",
    "customerRef": "CUS30549662",
    "customerName": "Jade Ellis",
    "address": "Crabtree Lodge  Pyecombe England, Pyecombe Street, Pyecombe, Brighton, East Sussex, BN45 7EE",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-24",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 7
  },
  {
    "id": "JOB000807",
    "customerRef": "CUS65460719",
    "customerName": "Sharon Chad",
    "address": "31 Oak Tree Drive, Hassocks, BN6 8YA",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 22
  },
  {
    "id": "JOB000808",
    "customerRef": "CUS70607094",
    "customerName": "Anne",
    "address": "45 Bonny Wood Road, Hassocks, West Sussex, BN6 8HP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000809",
    "customerRef": "CUS52937972",
    "customerName": "Sally",
    "address": "15 Spinney Close, Hurstpierpoint, Hassocks, West Sussex, BN6 9AR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 24.0,
    "duration": "00:30",
    "notes": "All windows. Beware of the dog! It\u2019s a yorkie that\u2019ll lick you death",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 8
  },
  {
    "id": "JOB000811",
    "customerRef": "CUS11077566",
    "customerName": "Ian Stevens",
    "address": "3 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "New** Rear access via path side\nof house. Park on road if\nsafe to do so and access\nfront and rear without\nmoving van. Text night\nbefore.",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB000812",
    "customerRef": "CUS41812757",
    "customerName": "Judith",
    "address": "34 Bridge Close, Burgess Hill, West Sussex, RH15 8PD",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000815",
    "customerRef": "CUS30263505",
    "customerName": "Dan Rayner",
    "address": "33 The Fairway, Hassocks, Sussex, BN6 9JU",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-04",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000817",
    "customerRef": "CUS63852574",
    "customerName": "Nick",
    "address": "Spring Cottage, Church Lane, Albourne, Hassocks, West Sussex, BN6 9BY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 52.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000818",
    "customerRef": "CUS82879591",
    "customerName": "Grace Jutton",
    "address": "16 Sycamore Way, Hassocks, West Sussex, BN6 8YH",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 20.8,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 6
  },
  {
    "id": "JOB000819",
    "customerRef": "CUS92754843",
    "customerName": "Kim Cybuch",
    "address": "50 Bramber Way, Burgess Hill, West Sussex, RH15 8JX",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 26.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000820",
    "customerRef": "CUS53543036",
    "customerName": "Paul Jordan",
    "address": "7 Celandine Gardens,Burgess Hill, RH15 8ZN",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 29.17,
    "duration": "00:30",
    "notes": "On the new bellway site, off Issac\u2019s lane, at the roundabout for the tip with the tip on your right go over to Haywards heath and then on the right after new traffic lights",
    "lastDone": "2025-09-10",
    "nextDue": "2026-03-09",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000821",
    "customerRef": "CUS69247708",
    "customerName": "Catherine Sandilands",
    "address": "11 Gordon Rd, Burgess Hill RH15 0PX, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 21.0,
    "duration": "00:45",
    "notes": "Make sure you do the velux",
    "lastDone": "2025-11-10",
    "nextDue": "2026-02-06",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 15
  },
  {
    "id": "JOB000822",
    "customerRef": "CUS55121391",
    "customerName": "Susan Skeet",
    "address": "15 Farnham Avenue, Hassocks, West Sussex, BN6 8NR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 27.0,
    "duration": "00:30",
    "notes": "Include \nextension.",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000823",
    "customerRef": "CUS97061403",
    "customerName": "Sarah McLoughlin",
    "address": "Grasmere, Malthouse Lane, Burgess Hill, West Sussex, RH15 9XA",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 32.5,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory and 2 x\nvelux. Pay by card link.\nPlease leave leaflet.",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB000824",
    "customerRef": "CUS13495459",
    "customerName": "Lauren Roles",
    "address": "46 Bridge Close, Burgess Hill, West Sussex, RH15 8PD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before. Front\nonly if customer is out. All\nwindows if customer is\nhome, Access via front\ndoor. Customer advised\nusually home school\nholidays and other times\nafter 2pm.",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000825",
    "customerRef": "CUS67897793",
    "customerName": "Penny",
    "address": "46 The Fairway, Hassocks BN6, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean front only",
    "zone": "Kingsland Gate",
    "price": 5.0,
    "duration": "00:30",
    "notes": "Just the upstairs window cash under the buddah",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 11
  },
  {
    "id": "JOB000826",
    "customerRef": "CUS2866408",
    "customerName": "Conor Pool",
    "address": "11 Turnbury Way, Hassocks, Sussex, BN6 9QF",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate2",
    "price": 19.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000827",
    "customerRef": "CUS57919752",
    "customerName": "Fraser Hagell",
    "address": "15 Sunnywood Drive, Haywards Heath, West Sussex, RH16 4PE",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-07-08",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000828",
    "customerRef": "CUS34167401",
    "customerName": "Beth",
    "address": "48 London Rd, Hassocks BN6 9NU, UK",
    "assignee": "Steve, Dan",
    "services": "Office clean,Window Clean",
    "zone": "Hassocks No Email",
    "price": 31.5,
    "duration": "00:30",
    "notes": "Reverse up on to drive, include garden room",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 35
  },
  {
    "id": "JOB000834",
    "customerRef": "CUS9360525",
    "customerName": "Fleur Jones",
    "address": "10 Downs View Road, Hassocks, West Sussex, BN6 8HJ",
    "assignee": "Steve",
    "services": "Window Clean inc Lantern",
    "zone": "Hassocks",
    "price": 50.0,
    "duration": "00:30",
    "notes": "Text night before. Include the roof lantern, ladder needed.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-04-06",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 14
  },
  {
    "id": "JOB000835",
    "customerRef": "CUS49779860",
    "customerName": "James Smith",
    "address": "24 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-18",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000836",
    "customerRef": "CUS51677818",
    "customerName": "Nick Cherry",
    "address": "17 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 34
  },
  {
    "id": "JOB000837",
    "customerRef": "CUS9564948",
    "customerName": "Ginette Read",
    "address": "20 Carnoustie Drive Hassocks",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Key code by back door for garage and inside garage door - 2069",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 31
  },
  {
    "id": "JOB000839",
    "customerRef": "CUS59463173",
    "customerName": "Sally",
    "address": "46 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 24.0,
    "duration": "00:30",
    "notes": "There\u2019s a Perspex roof on both houses they need doing every other time",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000841",
    "customerRef": "CUS19999408",
    "customerName": "Liz",
    "address": "73 Hammonds Ridge, Burgess Hill, West Sussex, RH15 9QW",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:30",
    "notes": "\u00a320",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000842",
    "customerRef": "CUS31108544",
    "customerName": "Inge",
    "address": "12 St Lawrence Way, Hurstpierpoint, Hassocks BN6 9SH, UK",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Long pole, not garden room",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 34
  },
  {
    "id": "JOB000843",
    "customerRef": "CUS90226578",
    "customerName": "Rosalind Cannon",
    "address": "5 Chestnut Dr, Hassocks BN6 8YF, UK",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 32
  },
  {
    "id": "JOB000844",
    "customerRef": "CUS65402862",
    "customerName": "Adrian Howard",
    "address": "53 Woodsland Road, Hassocks, West Sussex, BN6 8EU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000845",
    "customerRef": "CUS18635927",
    "customerName": "Dave Ryan",
    "address": "34 Kings Way, Burgess Hill, West Sussex, RH15 0TP",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before to\nlandline. Garage door is\nunlocked. Cash in top\ndrawer in garage. \u00a322",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB000846",
    "customerRef": "CUS19272852",
    "customerName": "Alysha",
    "address": "6 Sunningdale Road Hassocks ",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 20.0,
    "duration": "00:45",
    "notes": "Unlock the gate if the bolts across",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 31,
    "done": 31
  },
  {
    "id": "JOB000848",
    "customerRef": "CUS57049971",
    "customerName": "Peter Kluge",
    "address": "18 Maple Drive, Burgess Hill, West Sussex, RH15 8AW",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 28.33,
    "duration": "00:30",
    "notes": "Include conservatory.\nAccess to rear garden via\nservice road and rear gate.\nText night before.\n\nIf paying cash \u00a334",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 4
  },
  {
    "id": "JOB000849",
    "customerRef": "CUS51380",
    "customerName": "Cheryl Douglas",
    "address": "213 Junction Road, Burgess Hill, West Sussex, RH15 0NX",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000850",
    "customerRef": "CUS27079989",
    "customerName": "Rebecca Noone",
    "address": "291 Junction Road, Burgess Hill, West Sussex, RH15 0PY",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 3",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000851",
    "customerRef": "CUS14956542",
    "customerName": "Jenny Hill",
    "address": "3 Great Park Meadow, Burgess Hill, RH15 0YL",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000852",
    "customerRef": "CUS76753245",
    "customerName": "Glenn",
    "address": "33 The Warren, Burgess Hill, West Sussex, RH15 0DU",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 4",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-20",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000853",
    "customerRef": "CUS54440132",
    "customerName": "Joan Denley",
    "address": "28 St. Lawrence Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9SH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 29.17,
    "duration": "00:30",
    "notes": "Text night before to\nlandline. Include\nextension. Not the\nvelux. Pay by card link.",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000855",
    "customerRef": "CUS72280050",
    "customerName": "Nancy Higgins",
    "address": "32 Friars Oak Rd, Hassocks BN6 8PX, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Use platform in the garden to reach the back windows and 2 velux on extension BIG POLE\nVery fussy about the veluxes being clean",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 33
  },
  {
    "id": "JOB000857",
    "customerRef": "CUS40606686",
    "customerName": "Gerald Nurse",
    "address": "42 Adastra Ave, Keymer, Hassocks BN6 8DL, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "This is a returning customer after having a year of building works.",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 19,
    "done": 18
  },
  {
    "id": "JOB000858",
    "customerRef": "CUS52892539",
    "customerName": "Chris Luck- Scotcher",
    "address": "22 Edwin Street, Burgess Hill, West Sussex, RH15 9HU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000859",
    "customerRef": "CUS36191757",
    "customerName": "Charlotte Upton",
    "address": "2 Duke of York Cottages, London Road, Sayers Common, Hassocks, West Sussex, BN6 9HY",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000860",
    "customerRef": "CUS95489599",
    "customerName": "Jo White",
    "address": "10 Hollycroft, East Chiltington, Lewes, East Sussex, BN7 3AZ",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-29",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000861",
    "customerRef": "CUS82302295",
    "customerName": "Clare Adams",
    "address": "13 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 17.5,
    "duration": "00:30",
    "notes": "Wants it done in the morning so maybe do this first if you start at 9, garden through the garage",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 36
  },
  {
    "id": "JOB000862",
    "customerRef": "CUS82302295",
    "customerName": "Clare Adams",
    "address": "13 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Steve",
    "services": "Garage door clean",
    "zone": "Perfect Properties",
    "price": 10.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-01-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000863",
    "customerRef": "CUS69050406",
    "customerName": "Transparency Cleaning Services Limited",
    "address": "5 Shearing Dr, Burgess Hill RH15 0NA, UK",
    "assignee": "",
    "services": "Hose Reels",
    "zone": "Perfect Properties",
    "price": 180.0,
    "duration": "00:45",
    "notes": "2 x hose reel",
    "lastDone": "2022-06-30",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000865",
    "customerRef": "CUS2198531",
    "customerName": "Clem Leneghan",
    "address": "9 Wolstonbury Close, Hurstpierpoint West Sussex BN6 9AS",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 78.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-01",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000867",
    "customerRef": "CUS99437239",
    "customerName": "Hayley Bamber",
    "address": "59 Oak Hall Park, Burgess Hill, RH15 0DA",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 34.0,
    "duration": "00:30",
    "notes": "Text night before. Include conservatory",
    "lastDone": "2026-01-31",
    "nextDue": "2026-04-21",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 14
  },
  {
    "id": "JOB000868",
    "customerRef": "CUS10216144",
    "customerName": "Hannah Lawrence",
    "address": "130 Junction Road, Burgess Hill, West Sussex, RH15 0PZ",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Hand over gate to open if\ncustomer is out.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 10
  },
  {
    "id": "JOB000869",
    "customerRef": "CUS79260323",
    "customerName": "Oliver Cox",
    "address": "4 Brambles, Hassocks, West Sussex, BN6 8EQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000870",
    "customerRef": "CUS23884771",
    "customerName": "Isobel Bignell",
    "address": "8 Mackie Avenue, Hassocks, West Sussex, BN6 8NL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 26.0,
    "duration": "00:30",
    "notes": "Text night before. Include \nextension. Pay by \nGoCardless. Gate stiff.",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 16
  },
  {
    "id": "JOB000871",
    "customerRef": "CUS23884771",
    "customerName": "Isobel Bignell",
    "address": "8 Mackie Avenue, Hassocks, West Sussex, BN6 8NL",
    "assignee": "Steve",
    "services": "Cladding Clean",
    "zone": "Perfect Properties",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-17",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000875",
    "customerRef": "CUS13450456",
    "customerName": "Sarah",
    "address": "65 Goldcrest Dr, Hassocks BN6, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers No Email",
    "price": 19.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 31,
    "done": 30
  },
  {
    "id": "JOB000876",
    "customerRef": "CUS1295625",
    "customerName": "Joanne Lacey",
    "address": "72 Newick Drive, Newick, Lewes, East Sussex, BN8 4PB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Newick",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000877",
    "customerRef": "CUS5802254",
    "customerName": "Martin Doidge",
    "address": "13 London Road, Hassocks, West Sussex, BN6 9NT",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hassocks",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000879",
    "customerRef": "CUS42502364",
    "customerName": "Mrs Janice Lowe",
    "address": "1 Turners Mill Road, Haywards Heath, West Sussex, RH16 1NW",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 20.0,
    "duration": "00:30",
    "notes": "she is near the corner of Harlands Road, near leisure centre",
    "lastDone": "2025-11-12",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 1
  },
  {
    "id": "JOB000880",
    "customerRef": "CUS66983206",
    "customerName": "Jane Dobson",
    "address": "5 Adastra Avenue, Hassocks, West Sussex, BN6 8DP",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 43.0,
    "duration": "00:30",
    "notes": "Text night before. Include 4 Velux",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000881",
    "customerRef": "CUS10420585",
    "customerName": "Charles Simmons",
    "address": "15 The Vineries, Burgess Hill, RH15 0ND",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 0.0,
    "duration": "00:45",
    "notes": "Cash \u00a325",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 33
  },
  {
    "id": "JOB000882",
    "customerRef": "CUS10420585",
    "customerName": "Charles Simmons",
    "address": "15 The Vineries, Burgess Hill, RH15 0ND",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 0.0,
    "duration": "00:30",
    "notes": "CASH \u00a395",
    "lastDone": "2024-11-12",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000883",
    "customerRef": "CUS72804608",
    "customerName": "Rebecca Whitehouse",
    "address": "43 Willowhurst, Burgess Hill RH15 0wx",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000888",
    "customerRef": "CUS71144104",
    "customerName": "Suzan Gold",
    "address": "20 Hoadley Avenue, Burgess Hill, Sussex, RH15 0RG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 35.83,
    "duration": "00:30",
    "notes": "Inc all Velux over the garage",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000889",
    "customerRef": "CUS51830128",
    "customerName": "Olga",
    "address": "42 The Wickets, Burgess Hill, RH15 8TG",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Be careful leaded windows, inc conservatory",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 34,
    "done": 25
  },
  {
    "id": "JOB000890",
    "customerRef": "CUS26196137",
    "customerName": "Ayesha Trott",
    "address": "23 Little Copse Road, Hassocks, West Sussex, BN6 8PQ",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hassocks",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 12
  },
  {
    "id": "JOB000891",
    "customerRef": "CUS2806322",
    "customerName": "Dave",
    "address": "12 Stafford Way, Hassocks, West Sussex, BN6 8QQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 17.5,
    "duration": "00:30",
    "notes": "This is one of Collins",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000892",
    "customerRef": "CUS2806322",
    "customerName": "Dave",
    "address": "12 Stafford Way, Hassocks, West Sussex, BN6 8QQ",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 79.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-16",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000893",
    "customerRef": "CUS96922487",
    "customerName": "Adam Pitt",
    "address": "40 The Gattons, Burgess Hill, West Sussex, RH15 9SW",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "zone": "BH Zone 1",
    "price": 28.0,
    "duration": "00:30",
    "notes": "Text night before.\nInclude 3 x velux.",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 10
  },
  {
    "id": "JOB000894",
    "customerRef": "CUS96922487",
    "customerName": "Adam Pitt",
    "address": "40 The Gattons, Burgess Hill, West Sussex, RH15 9SW",
    "assignee": "Steve",
    "services": "Solar Panel Clean",
    "zone": "Perfect Properties",
    "price": 70.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-01",
    "nextDue": "",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000895",
    "customerRef": "CUS60084887",
    "customerName": "Alex Cox",
    "address": "58 Curf Way, Burgess Hill RH15 0GE, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.8,
    "duration": "00:30",
    "notes": "You need long pole for 60,58,54\n\nVELUXES ON THE REAR ROOF",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB000896",
    "customerRef": "CUS50232932",
    "customerName": "Laurann De Verteuil",
    "address": "10 Carnoustie Drive hassocks",
    "assignee": "",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 25.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2023-11-01",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000898",
    "customerRef": "CUS62299669",
    "customerName": "Zoe Dolding",
    "address": "5 Godden Road, Newick, Lewes, East Sussex, BN8 4NE",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory",
    "zone": "Newick",
    "price": 34.17,
    "duration": "00:30",
    "notes": "Inc 2 roof lanterns, ladder needed",
    "lastDone": "2026-01-17",
    "nextDue": "2026-02-26",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000899",
    "customerRef": "CUS79640796",
    "customerName": "Matt Graysmark",
    "address": "33 The Vineries, Burgess Hill, West Sussex, RH15 0ND",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000900",
    "customerRef": "CUS89662162",
    "customerName": "Kerry Bagshaw",
    "address": "19 Willowhurst, Burgess Hill, West Sussex, RH15 0XT",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 19.17,
    "duration": "00:30",
    "notes": "Text night before.\nMaybe park near car\nport if safe to do\nso,please see\ncustomer.",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000901",
    "customerRef": "CUS80659243",
    "customerName": "Hassocks Day Nursery & Preschool",
    "address": "Hassocks Day Nursery & Preschool The Beacon Hassocks West Sussex, Brighton Road, Hassocks, West Sussex, BN6 9LZ",
    "assignee": "Steve",
    "services": "Window clean inc velux",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000902",
    "customerRef": "CUS30277385",
    "customerName": "Vincent Murphy",
    "address": "1 Orchard Lane, Hassocks, West Sussex, BN6 8QE",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "One off, please give the best clean possible as they want to see how good we are before booking a regular clean",
    "lastDone": "2025-07-11",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000903",
    "customerRef": "CUS50592237",
    "customerName": "Frankie Maltby",
    "address": "42 Ockley Way, Hassocks, West Sussex, BN6 8NF",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hassocks",
    "price": 31.0,
    "duration": "00:30",
    "notes": "Include conservatory",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB000904",
    "customerRef": "CUS52020860",
    "customerName": "Jacob Midwinter",
    "address": "7 The Acorns, Oakhurst, Sayers Common, Hassocks, West Sussex, BN6 9JW",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-06",
    "nextDue": "2026-02-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 10
  },
  {
    "id": "JOB000906",
    "customerRef": "CUS5925519",
    "customerName": "Rosanne",
    "address": "Hurstview, Langton Lane, Hurstpierpoint, Hassocks, BN6 9EZ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 38.5,
    "duration": "00:60",
    "notes": "Careful - leaded windows, use long pole / orange brush\n\nThere's windows on both sides of the property, walk all the way around\n\nUSE RIGHT HAND SIDE GATE AND SHUT IT AFTER YOU ENTER THE GARDEN",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 37,
    "done": 35
  },
  {
    "id": "JOB000908",
    "customerRef": "CUS67248659",
    "customerName": "Bruce Scrivens",
    "address": "1 St. Wilfrids Road, Burgess Hill, West Sussex, RH15 8BE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000909",
    "customerRef": "CUS55473362",
    "customerName": "Alastair Potts",
    "address": "1 Carnoustie Drive Bn6",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 17.5,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 30
  },
  {
    "id": "JOB000911",
    "customerRef": "CUS30747323",
    "customerName": "Jenny Batchelor",
    "address": "3 Hurst Road, Hassocks, West Sussex, BN6 9NJ",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hassocks",
    "price": 33.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000912",
    "customerRef": "CUS49044616",
    "customerName": "Sue Ockenden",
    "address": "9 Orchard Way, Burgess Hill, West Sussex, RH15 9PB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Text night before. Include\ndormer and 2 x velux.",
    "lastDone": "2026-01-19",
    "nextDue": "2026-04-13",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 7
  },
  {
    "id": "JOB000913",
    "customerRef": "CUS2738747",
    "customerName": "Chris Elkins",
    "address": "Flint House, Janes Lane, Burgess Hill, West Sussex, RH15 0QJ",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 44.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory and\nextension. (Window over\nextension do best you can\nfrom both sides of\nextension). Directions: This\nlittle cul-de-sac is just up\nfrom Ladymead. Pay by\ncard link.",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000915",
    "customerRef": "CUS61474213",
    "customerName": "Barry Wenham",
    "address": "16 Woodland Avenue, Burgess Hill, West Sussex, RH15 0PE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000917",
    "customerRef": "CUS35117585",
    "customerName": "David Phillips",
    "address": "3 Goldfinch Road, Burgess Hill, West Sussex, RH15 9DW",
    "assignee": "Dan",
    "services": "Window Clean,Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 100.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-07-30",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000918",
    "customerRef": "CUS35117585",
    "customerName": "David Phillips",
    "address": "3 Goldfinch Road, Burgess Hill, West Sussex, RH15 9DW",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Flat pics attached, do the Juliette balcony glass too but not doors behind it.",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000920",
    "customerRef": "CUS6012087",
    "customerName": "Simon Cooper",
    "address": "11 West Gate, Plumpton Green, Lewes, East Sussex, BN7 3BQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 21.67,
    "duration": "00:30",
    "notes": "Text night before. Price\nreq for plastic roof in\nrear garden.",
    "lastDone": "2025-11-25",
    "nextDue": "2026-02-17",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000921",
    "customerRef": "CUS64466669",
    "customerName": "Isabellos Preschool",
    "address": "The Church Hall, Oakhurst, Sayers Common, Hassocks, BN6 9JA",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 22.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-05",
    "nextDue": "2026-02-20",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 18
  },
  {
    "id": "JOB000922",
    "customerRef": "CUS75295817",
    "customerName": "Jenny Barna",
    "address": "2 The Dymocks, Ditchling, Hassocks, West Sussex, BN6 8SU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-04-07",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 4
  },
  {
    "id": "JOB000925",
    "customerRef": "CUS71937829",
    "customerName": "Sarah Bonnot",
    "address": "4 Mayhouse Road, Burgess Hill, RH15 9RF",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean front only",
    "zone": "BH Zone 2",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Front and side of house \nonly. Text night before. \nRear of house clean if \ncustomer requests and \naccess clear. Advise",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 24
  },
  {
    "id": "JOB000926",
    "customerRef": "CUS65721676",
    "customerName": "Julie Marchant",
    "address": "47 Potters Lane, Burgess Hill, RH15 9JT",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 24.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 20
  },
  {
    "id": "JOB000927",
    "customerRef": "CUS77785107",
    "customerName": "Sam Leycester",
    "address": "6 Unicorn Way, Burgess Hill, RH15 0UU",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 27.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 29,
    "done": 29
  },
  {
    "id": "JOB000928",
    "customerRef": "CUS47134877",
    "customerName": "Donna Peters",
    "address": "62 Barton Way, Hassocks, West Sussex, BN6 8FR",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 6
  },
  {
    "id": "JOB000931",
    "customerRef": "CUS92430301",
    "customerName": "Matthew Mills",
    "address": "8 Partridge Cl, Burgess Hill RH15 0ZR, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 35
  },
  {
    "id": "JOB000932",
    "customerRef": "CUS822436",
    "customerName": "Lola Lockwood",
    "address": "43 Fairfield Road, Burgess Hill, West Sussex, RH15 8QB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000933",
    "customerRef": "CUS98094439",
    "customerName": "Rocky Hooper",
    "address": "60a Dunstall Avenue, Burgess Hill, West Sussex, RH15 8PH",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000934",
    "customerRef": "CUS93886760",
    "customerName": "Darren Sharp",
    "address": "The Old Mill, Station Road, Cowfold, Horsham, West Sussex, RH13 8DE",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Cowfold",
    "price": 66.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-10-22",
    "nextDue": "2026-04-08",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000935",
    "customerRef": "CUS68442424",
    "customerName": "Mick Macve",
    "address": "News House, London Road, Hassocks, West Sussex, BN6 9NX",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hassocks",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-24",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000936",
    "customerRef": "CUS59456705",
    "customerName": "James Robertson",
    "address": "46 Wykeham Way, Burgess Hill, West Sussex, RH15 0HF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "New",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000938",
    "customerRef": "CUS71179790",
    "customerName": "Les",
    "address": "4 Woodsland Close, Hassocks, West Sussex, BN6 8HF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks cash",
    "price": 0.0,
    "duration": "00:30",
    "notes": "All outside windows but not conservatory. One skylight in roof right hand side. Text night before and he\u2019ll unlock the gate if he goes out.",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 9
  },
  {
    "id": "JOB000939",
    "customerRef": "CUS68079634",
    "customerName": "Emily Howarth",
    "address": "11 Michelbourne Close, Burgess Hill, West Sussex, RH15 9QX",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 2",
    "price": 29.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory and 1 x\nvelux. Pay by card link.",
    "lastDone": "2025-11-11",
    "nextDue": "2026-02-03",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000940",
    "customerRef": "CUS1757476",
    "customerName": "Kirsti Agent",
    "address": "6 Nuthatch Lane, Sayers Common, Hassocks, BN6 9LB",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB000941",
    "customerRef": "CUS75613834",
    "customerName": "Stuart",
    "address": "12 Gordon Rd, Burgess Hill RH15 0PX, UK",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-10-09",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 25
  },
  {
    "id": "JOB000943",
    "customerRef": "CUS52260525",
    "customerName": "Anna Lenkiewicz",
    "address": "23 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Garden Room",
    "zone": "BH Zone 4",
    "price": 31.0,
    "duration": "00:30",
    "notes": "Knock the door first, Include garden room.",
    "lastDone": "2025-12-15",
    "nextDue": "2026-03-09",
    "frequency": "every 12 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000944",
    "customerRef": "CUS74097097",
    "customerName": "Emma",
    "address": "15 The Kiln, Burgess Hill, West Sussex, RH15 0LU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-05",
    "nextDue": "2026-02-27",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000945",
    "customerRef": "CUS63800506",
    "customerName": "Dawn Greener",
    "address": "19 Caffin Gardens, Burgess Hill, West Sussex, RH15 0QZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000947",
    "customerRef": "CUS22447551",
    "customerName": "Sarah Jane",
    "address": "10 John Wood Crescent, Hassocks, West Sussex, BN6 8FQ",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB000948",
    "customerRef": "CUS42193020",
    "customerName": "Christine",
    "address": "Highview House, Lucastes Lane, Haywards Heath, West Sussex, RH16 1LD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000949",
    "customerRef": "CUS42193020",
    "customerName": "Christine",
    "address": "Highview House, Lucastes Lane, Haywards Heath, West Sussex, RH16 1LD",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning,Veranda Clean",
    "zone": "Perfect Properties",
    "price": 98.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-07-30",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000950",
    "customerRef": "CUS64776448",
    "customerName": "Jane Childs",
    "address": "119 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-11",
    "nextDue": "2026-03-05",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB000953",
    "customerRef": "CUS70767385",
    "customerName": "Helen And Tom",
    "address": "3 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-06-03",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000954",
    "customerRef": "CUS70767385",
    "customerName": "Helen And Tom",
    "address": "3 The Fairway, Hassocks, BN6 9JU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 18.0,
    "duration": "00:45",
    "notes": "Do 1and 3 and the house opposite which is no 12",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 38,
    "done": 38
  },
  {
    "id": "JOB000956",
    "customerRef": "CUS4086266",
    "customerName": "Adela",
    "address": "41 Kings Way, Burgess Hill RH15 0TP, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 29
  },
  {
    "id": "JOB000957",
    "customerRef": "CUS45536133",
    "customerName": "Scott Conroy",
    "address": "44 Avenue de Warenne, Hassocks West Sussex BN6 8GE",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 28.0,
    "duration": "00:30",
    "notes": "Ockley Park",
    "lastDone": "2025-11-20",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 8
  },
  {
    "id": "JOB000958",
    "customerRef": "CUS74402884",
    "customerName": "Daphne Grime",
    "address": "Paddock Cottage, Albourne Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9ES",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "HPP CASH",
    "price": 0.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB000959",
    "customerRef": "CUS41262910",
    "customerName": "Donna Wakeford",
    "address": "1 The Meads, Norman Road, Burgess Hill, West Sussex, RH15 9BY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Round the back it is just the upstairs window, so all windows but not the sun room",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000960",
    "customerRef": "CUS12486918",
    "customerName": "Beryl Marshall",
    "address": "60 Unicorn Way, Burgess Hill, West Sussex, RH15 0UU",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 40.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-19",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000961",
    "customerRef": "CUS88790642",
    "customerName": "Mary Goodwin",
    "address": "3 Broad Green Avenue, Burgess Hill, West Sussex, RH15 0HA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 33.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB000962",
    "customerRef": "CUS17148566",
    "customerName": "Julie Medina",
    "address": "60 Timbergate Drive, Haywards Heath, West Sussex, RH17 5LQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 28.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000964",
    "customerRef": "CUS41854497",
    "customerName": "Chris Gant",
    "address": "41 Mackie Avenue, Hassocks, BN6 8NH",
    "assignee": "Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 26.0,
    "duration": "00:30",
    "notes": "Text night before. Front \nonly if out",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 21
  },
  {
    "id": "JOB000967",
    "customerRef": "CUS94504662",
    "customerName": "Andrea Saunders",
    "address": "45 Dumbrills Close, Burgess Hill, West Sussex, RH15 8RS",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory",
    "zone": "BH Zone 3",
    "price": 0.0,
    "duration": "00:30",
    "notes": "There\u2019s a Perspex roof on both houses they need doing every other time",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000968",
    "customerRef": "CUS34832504",
    "customerName": "Sue Wadey",
    "address": "29 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000972",
    "customerRef": "CUS45310880",
    "customerName": "Ben Wingrove",
    "address": "1 The Chestnuts, Sayers Common, Hassocks BN6 9XJ, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 22.0,
    "duration": "00:30",
    "notes": "Park outside No1 and do this house and 17 across the road",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 44,
    "done": 40
  },
  {
    "id": "JOB000973",
    "customerRef": "CUS95806086",
    "customerName": "Liam Murray",
    "address": "5 Leigh Meadow, Burgess Hill West Sussex RH15 0YP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "This is a new build on the Croft, not coming up on any maps \n\n#vat",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000974",
    "customerRef": "CUS459164",
    "customerName": "David",
    "address": "37 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 35.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB000975",
    "customerRef": "CUS37899641",
    "customerName": "Chloe  Armstrong",
    "address": "22 John Wood Crescent, Hassocks, BN6 8FQ",
    "assignee": "Dan, Dan & Steve, Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-17",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 21,
    "done": 21
  },
  {
    "id": "JOB000976",
    "customerRef": "CUS47596131",
    "customerName": "Rhea Salisbury",
    "address": "42 Eastdale Road, Burgess Hill, West Sussex, RH15 0NH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 26.0,
    "duration": "00:30",
    "notes": "NEW\nText night before. Lean Over to unbolt gate",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB000978",
    "customerRef": "CUS66475174",
    "customerName": "Jenny Goldsmith",
    "address": "29 Wickham Close, Haywards Heath, West Sussex, RH16 1UH",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Haywards Heath",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB000979",
    "customerRef": "CUS24043437",
    "customerName": "Tracey Paynton",
    "address": "60 Marlborough Drive, Burgess Hill, West Sussex, RH15 0EU",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-07",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000980",
    "customerRef": "CUS36802848",
    "customerName": "Alex Hill",
    "address": "45 Noel Rise, Burgess Hill, West Sussex, RH15 8BU",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Text night before.\nInclude conservatory.",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB000981",
    "customerRef": "CUS97545809",
    "customerName": "Svetlana Owen",
    "address": "19 Sunningdale Road, Hassocks, BN6 9QQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Kingsland Gate",
    "price": 19.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 24,
    "done": 24
  },
  {
    "id": "JOB000982",
    "customerRef": "CUS33672491",
    "customerName": "Jackie Palmer",
    "address": "3 Farnlea, Burgess Hill, West Sussex, RH15 0BD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 2
  },
  {
    "id": "JOB000983",
    "customerRef": "CUS95439530",
    "customerName": "Jessica Doyle",
    "address": "18 St Andrews Place, Hassocks, Sussex, BN6 9QE",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Kingsland Gate2",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-12",
    "nextDue": "2026-03-06",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 3
  },
  {
    "id": "JOB000984",
    "customerRef": "CUS43359736",
    "customerName": "Sarah Jarvis",
    "address": "12 Foxglove Close, Burgess Hill, West Sussex, RH15 8UY",
    "assignee": "Steve, Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "Inc Velux on the front and dormers at the rear inc con windows.\n\nDo no.14 rear windows from 12s garden",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000986",
    "customerRef": "CUS56718307",
    "customerName": "Emily Banfield",
    "address": "26 Dunlop Close, Sayers Common, Hassocks, West Sussex, BN6 9SL",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Sayers Common",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-21",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 1
  },
  {
    "id": "JOB000989",
    "customerRef": "CUS94005705",
    "customerName": "Hazel Botting",
    "address": "29 Packham Way, Burgess Hill, West Sussex, RH15 8PR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before to\nlandline. Pays cash.\nPreferably not\nWednesdays. This\ncustomer is blind. \u00a325",
    "lastDone": "2025-07-17",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 8
  },
  {
    "id": "JOB000990",
    "customerRef": "CUS17327664",
    "customerName": "Sarah Sansom",
    "address": "52 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TA",
    "assignee": "Steve",
    "services": "Inside Window Clean",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-07",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000991",
    "customerRef": "CUS17327664",
    "customerName": "Sarah Sansom",
    "address": "52 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TA",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB000992",
    "customerRef": "CUS41179031",
    "customerName": "Richard Shackleton",
    "address": "25 Langridge Vale, Hassocks",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Hassocks2",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB000993",
    "customerRef": "CUS71599557",
    "customerName": "Katie Chambers",
    "address": "44 Woodland Avenue, Burgess Hill, West Sussex, RH15 0PE",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 3",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000994",
    "customerRef": "CUS95529980",
    "customerName": "Karen",
    "address": "21 Pyecombe St, Pyecombe, Brighton BN45, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Long pole, 2 veluxes at the front and dormer at the back",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 26
  },
  {
    "id": "JOB000995",
    "customerRef": "CUS75025968",
    "customerName": "Margaret Negus",
    "address": "6 Blackhouse Lane, Burgess Hill, West Sussex, RH15 8BN",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-11-28",
    "nextDue": "2026-02-19",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB000997",
    "customerRef": "CUS25632086",
    "customerName": "Kay Lane",
    "address": "4 Potters Lane, Burgess Hill, RH15 9HY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Text night before. Gate is\nstiff needs a push. Pay\nby card link",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000998",
    "customerRef": "CUS97595570",
    "customerName": "Sue McVey",
    "address": "Fieldview Corner Station Approach/. Faygate., Carylls Lea, Faygate Lane, Faygate, Horsham, West Sussex, RH12 4SJ",
    "assignee": "Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "Faygate",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB000999",
    "customerRef": "CUS14925899",
    "customerName": "Jordan Ralph",
    "address": "7 Nuthatch Lane, Sayers Common, Hassocks, BN6 9LB",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 25.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 32
  },
  {
    "id": "JOB001000",
    "customerRef": "CUS98629392",
    "customerName": "Katie",
    "address": "27 Ockenden Way, Hassocks, West Sussex, BN6 8HS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 17
  },
  {
    "id": "JOB001002",
    "customerRef": "CUS30872778",
    "customerName": "Rebecca",
    "address": "17 Berrylands Farm, Sayers Common, Hassocks, BN6 9XH",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "Sayers No Email",
    "price": 16.5,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 34
  },
  {
    "id": "JOB001004",
    "customerRef": "CUS678476",
    "customerName": "Chris",
    "address": "19 Scrase Close, Burgess Hill, West Sussex, RH15 0YY",
    "assignee": "Steve, Dan",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 4",
    "price": 16.67,
    "duration": "00:30",
    "notes": "Drive into Scrase close, it\u2019s the flats at the end on the left, The top right flat when you walk round to the door, front side and rear, rear extend the pole over the fence.",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001008",
    "customerRef": "CUS68066788",
    "customerName": "Jean Osborne",
    "address": "8 Strood Gate, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7RY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Wivelsfield",
    "price": 29.0,
    "duration": "00:30",
    "notes": "Text night before. Tap on\ndoor when you get there\nso she can secure dog.\nPay by cardlin",
    "lastDone": "2025-11-19",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 10
  },
  {
    "id": "JOB001009",
    "customerRef": "CUS54753489",
    "customerName": "Laura Keen",
    "address": "7 Woods Ground, Eastern Road, Wivelsfield Green, Haywards Heath, West Sussex, RH17 7QG",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Wivelsfield",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001010",
    "customerRef": "CUS80814316",
    "customerName": "Henry Hayward",
    "address": "50 Brookway, Burgess Hill, West Sussex, RH15 0LN",
    "assignee": "Dan, Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 4",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Cash \u00a331",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001011",
    "customerRef": "CUS23986837",
    "customerName": "Colin Cooper",
    "address": "7 Glendale Road, Burgess Hill, West Sussex, RH15 0EJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Text night before. Not front top R.H. side window. (difficult\naccess) Pay by card link.",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001013",
    "customerRef": "CUS83564736",
    "customerName": "David Harkin",
    "address": "163 Chanctonbury Road, Burgess Hill, West Sussex, RH15 9HF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB001014",
    "customerRef": "CUS11734817",
    "customerName": "Dawn Thompson Poulton",
    "address": "55 Folders Ln, Burgess Hill RH15 0DY, UK",
    "assignee": "",
    "services": "Facias and Sofitts",
    "zone": "",
    "price": 75.0,
    "duration": "00:60",
    "notes": "",
    "lastDone": "2021-11-04",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001015",
    "customerRef": "CUS11734817",
    "customerName": "Dawn Thompson Poulton",
    "address": "55 Folders Ln, Burgess Hill RH15 0DY, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 33.0,
    "duration": "00:60",
    "notes": "Gate 1547",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 27,
    "done": 25
  },
  {
    "id": "JOB001016",
    "customerRef": "CUS41173767",
    "customerName": "Graham Tate",
    "address": "6 Stafford Way, Hassocks, West Sussex, BN6 8QQ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 31.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-03",
    "nextDue": "2026-02-25",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB001017",
    "customerRef": "CUS21278518",
    "customerName": "James Vaile",
    "address": "15 Grand Ave, Hassocks BN6, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-09",
    "nextDue": "2026-02-20",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 30,
    "done": 30
  },
  {
    "id": "JOB001020",
    "customerRef": "CUS58440241",
    "customerName": "Vikki",
    "address": "16 Culpepper, Burgess Hill, RH15 8UB",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 27.5,
    "duration": "00:45",
    "notes": "NOT CONSERVATORY",
    "lastDone": "2026-01-30",
    "nextDue": "2026-04-24",
    "frequency": "every 12 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 25,
    "done": 24
  },
  {
    "id": "JOB001022",
    "customerRef": "CUS43263257",
    "customerName": "Lawrence Harris",
    "address": "43 Pangdene Close, Burgess Hill, West Sussex, RH15 9US",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 34.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB001023",
    "customerRef": "CUS43263257",
    "customerName": "Lawrence Harris",
    "address": "43 Pangdene Close, Burgess Hill, West Sussex, RH15 9US",
    "assignee": "Dan",
    "services": "Gutter Clearance,Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 230.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-03-26",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001024",
    "customerRef": "CUS37231699",
    "customerName": "Geoff King",
    "address": "40 Nightingale Way, Sayers Common, Hassocks, West Sussex, BN6 9HP",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 29.0,
    "duration": "00:30",
    "notes": "NEW PLEASE KNOCK\nInclude 2 \nx velux and 1 x dormer.",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 14
  },
  {
    "id": "JOB001025",
    "customerRef": "CUS8456060",
    "customerName": "Denise Dell",
    "address": "17 Iden Hurst, Hurstpierpoint, Hassocks BN6 9XZ, UK",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 20.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 35,
    "done": 28
  },
  {
    "id": "JOB001026",
    "customerRef": "CUS3637204",
    "customerName": "James Matcham",
    "address": "Ardra, Oakwood Road, Burgess Hill, West Sussex, RH15 0HU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 24.0,
    "duration": "00:30",
    "notes": "\"Text night before to landline. Cash in brown bow by front door.\nDirections: This house is the last house on the\nleft. Please use the side gate between the house\nand garage. Please\"",
    "lastDone": "2026-01-14",
    "nextDue": "2026-02-25",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001027",
    "customerRef": "CUS54605192",
    "customerName": "Carole Benson",
    "address": "2 Greenlands Place\nWolstonbury House, Burgess Hill, West Sussex, RH15 0AJ",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 2",
    "price": 54.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-16",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001028",
    "customerRef": "CUS80591631",
    "customerName": "Rob",
    "address": "56, Goldcrest Drive, Hassocks, Sussex, BN6 9EH",
    "assignee": "Dan",
    "services": "Window Clean front only",
    "zone": "Sayers2",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-18",
    "nextDue": "2026-03-12",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001029",
    "customerRef": "CUS40622267",
    "customerName": "John Webb",
    "address": "158 Western Road, Hurstpierpoint, Hassocks, West Sussex, BN6 9TD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 32.5,
    "duration": "00:30",
    "notes": "Text night before. Not the\nupstairs window behind\ngarage. Knock first, if out\nkey will be in flower pot\nby front door for garage\ndoor. Post through front door\n\nPlease be aware you\u2019ll need to slightly lift the garage door to lock it afterwards.",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB001030",
    "customerRef": "CUS38882981",
    "customerName": "Simon",
    "address": "77 Larkspur Drive, Burgess Hill, West Sussex, RH15 0UL",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 26.67,
    "duration": "00:30",
    "notes": "Text night before. Include\n2 x dormers and 2 x\nvelux . Lean over gate to\nunbolt. Knock first.\n(There is a dog called\nDexter who may be in\ngarden, hes excitable but\nfriendly - make sure he\ndoesnt escape).",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001031",
    "customerRef": "CUS40916534",
    "customerName": "Jane Drew",
    "address": "13 Oak Hall Park, Burgess Hill, West Sussex, RH15 0DH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 20.0,
    "duration": "00:30",
    "notes": "Text night before. Knock\nfirst to secure dog. Use\nside gate to right of\nfront door if looking at\nhouse. Pay by card link.",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB001032",
    "customerRef": "CUS31069468",
    "customerName": "Rob",
    "address": "11 Priory Road, Hassocks, West Sussex, BN6 8PS",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 22.5,
    "duration": "00:30",
    "notes": "All windows, flat roof",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 8
  },
  {
    "id": "JOB001033",
    "customerRef": "CUS72939239",
    "customerName": "Stephen Macarthy",
    "address": "9 Coopers Close, Burgess Hill, West Sussex, RH15 8AN",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 3",
    "price": 30.0,
    "duration": "00:30",
    "notes": "text night before. Include conservatory. Customer unhappy with last window cleaner because windows and frames were not  cleaned properly. Price req for conservatory roof\nand velux x 2. Pay by card link",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001034",
    "customerRef": "CUS37972500",
    "customerName": "Alex Spencer",
    "address": "12 Batt Street, Burgess Hill, RH15 0XF",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 21,
    "done": 21
  },
  {
    "id": "JOB001035",
    "customerRef": "CUS9567588",
    "customerName": "Patricia Addinell",
    "address": "25 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 38.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nconservatory but not\nconservatory roof. Side\ngate is unlocked. Please be\ncareful of Georgian bars as\nthey are fragile. If one\ncomes off just tell her and\nshe will glue it back on",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB001036",
    "customerRef": "CUS9567588",
    "customerName": "Patricia Addinell",
    "address": "25 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PJ",
    "assignee": "Steve",
    "services": "Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 65.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-08",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001037",
    "customerRef": "CUS9567588",
    "customerName": "Patricia Addinell",
    "address": "25 St. Andrews Road, Burgess Hill, West Sussex, RH15 0PJ",
    "assignee": "Steve",
    "services": "Gutter wash",
    "zone": "Perfect Properties",
    "price": 104.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-09-23",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001038",
    "customerRef": "CUS459195",
    "customerName": "Ian Woods",
    "address": "13 The Kiln, Burgess Hill, West Sussex, RH15 0LU",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 13
  },
  {
    "id": "JOB001039",
    "customerRef": "CUS11151009",
    "customerName": "Simon Cowley",
    "address": "4 Pyecombe St, Pyecombe, Brighton BN45 7EB, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 19.8,
    "duration": "00:45",
    "notes": "Inc veluxes, there\u2019s windows on the side as you walk round to the garden",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 31,
    "done": 23
  },
  {
    "id": "JOB001040",
    "customerRef": "CUS8541373",
    "customerName": "Heather Holland",
    "address": "34 Dunstall Farm Road, Burgess Hill, RH15 8BJ",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 24.0,
    "duration": "00:45",
    "notes": "Reverse on to drive if no one home, very slippery out the back, very fussy with cobwebs etc",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 31,
    "done": 31
  },
  {
    "id": "JOB001042",
    "customerRef": "CUS24831488",
    "customerName": "John Frew",
    "address": "136 Unicorn Way, Burgess Hill, West Sussex, RH15 0UU",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB001045",
    "customerRef": "CUS18026368",
    "customerName": "Jane Davis",
    "address": "65 Nightingale Lane, Burgess Hill, West Sussex, RH15 9JH",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Pay by\ncash. \u00a326",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 11
  },
  {
    "id": "JOB001047",
    "customerRef": "CUS72469083",
    "customerName": "Bev Wright",
    "address": "21 Chestnut Drive, Hassocks, West Sussex, BN6 8AZ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-10",
    "nextDue": "2026-03-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 11
  },
  {
    "id": "JOB001048",
    "customerRef": "CUS79672998",
    "customerName": "Lucy Boxall",
    "address": "31 Chichester Way, Burgess Hill RH15 0RH, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.3,
    "duration": "00:30",
    "notes": "31 is in the corner",
    "lastDone": "2026-01-23",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 28
  },
  {
    "id": "JOB001049",
    "customerRef": "CUS67132147",
    "customerName": "Eleanor St. John",
    "address": "14 Station Road, Burgess Hill, West Sussex, RH15 9DE",
    "assignee": "Steve, Dan",
    "services": "Office clean",
    "zone": "BH Zone 2",
    "price": 25.3,
    "duration": "00:30",
    "notes": "Happy Paws Spay-Neuter\n\nPark on double yellows outside the shop, takes 10 mins",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 15
  },
  {
    "id": "JOB001050",
    "customerRef": "CUS67132147",
    "customerName": "Eleanor St. John",
    "address": "17 Kings Ride, Burgess Hill, RH15 0HL",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "",
    "price": 25.3,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-04-22",
    "nextDue": "",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 21,
    "done": 18
  },
  {
    "id": "JOB001054",
    "customerRef": "CUS41499527",
    "customerName": "Dominic Hodge",
    "address": "1 Bonnet Lane, Burgess Hill, Sussex, RH15 0FP",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 23.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB001055",
    "customerRef": "CUS23429138",
    "customerName": "Martin Horner",
    "address": "31 Icarus Avenue, Burgess Hill, West Sussex, RH15 0UW",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 16.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-13",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001056",
    "customerRef": "CUS71458683",
    "customerName": "Jon English",
    "address": "29 Lewes Road, Haywards Heath, West Sussex, RH17 7SP",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-08-04",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001057",
    "customerRef": "CUS4150808",
    "customerName": "Haitham Al-Omari",
    "address": "35 Clifton Road, Burgess Hill, West Sussex, RH15 8US",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Perfect Properties",
    "price": 50.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-11-18",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001060",
    "customerRef": "CUS28180013",
    "customerName": "Davina Griffiths",
    "address": "16a Royal George Road, Burgess Hill, West Sussex, RH15 9SD",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-05",
    "nextDue": "2026-02-16",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB001061",
    "customerRef": "CUS24911253",
    "customerName": "Stuart Wright",
    "address": "Flat 14, Pine Trees Court, Pine Trees, Hassocks, West Sussex, BN6 8NW",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-13",
    "nextDue": "2026-02-24",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB001063",
    "customerRef": "CUS24623776",
    "customerName": "Chris Evans",
    "address": "16 Edwin St, Burgess Hill RH15 9HU, UK",
    "assignee": "Steve",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 90.0,
    "duration": "00:30",
    "notes": "F&S inc Garage",
    "lastDone": "2024-11-06",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001064",
    "customerRef": "CUS24623776",
    "customerName": "Chris Evans",
    "address": "16 Edwin St, Burgess Hill RH15 9HU, UK",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 22.0,
    "duration": "00:30",
    "notes": "Windows on both sides of the house, cash should be left in garden by backdoor",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-26",
    "frequency": "every 4 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 32,
    "done": 30
  },
  {
    "id": "JOB001065",
    "customerRef": "CUS93564068",
    "customerName": "Zoltan Bryant",
    "address": "12 St. Georges Place, Hurstpierpoint, Hassocks, West Sussex, BN6 9QT",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hurstpierpoint",
    "price": 33.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 13,
    "done": 8
  },
  {
    "id": "JOB001066",
    "customerRef": "CUS62906960",
    "customerName": "Martin Packham",
    "address": "18 Payton Drive, Burgess Hill, West Sussex, RH15 9UU",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  },
  {
    "id": "JOB001067",
    "customerRef": "CUS34768479",
    "customerName": "Ann McBryar",
    "address": "12 Greenlands Close, Burgess Hill, West Sussex, RH15 0AR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 29.0,
    "duration": "00:30",
    "notes": "One of\nthe side windows is only\naccessible from\nneighbours drive and is a\ndifficult angle but do best\nyou can. Not the velux.\nPay by card link. Landline\nnumber. 01444 233708",
    "lastDone": "2026-01-31",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 16,
    "done": 16
  },
  {
    "id": "JOB001068",
    "customerRef": "CUS67192201",
    "customerName": "Ted",
    "address": "27 Semley Road, Hassocks, West Sussex, BN6 8PD",
    "assignee": "Dan",
    "services": "Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 66.7,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-05-07",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001069",
    "customerRef": "CUS67192201",
    "customerName": "Ted",
    "address": "27 Semley Road, Hassocks, West Sussex, BN6 8PD",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 110.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-30",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001070",
    "customerRef": "CUS67192201",
    "customerName": "Ted",
    "address": "27 Semley Road, Hassocks, West Sussex, BN6 8PD",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "Don\u2019t do front door as it leaks. I do it occasionally but give them a scrim to put behind the door. His side gate is locked, but he\u2019ll leave it unlocked for you if he knows you\u2019re coming.\nThe drive is usually free and I do 25 and 29 from there.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB001073",
    "customerRef": "CUS12085608",
    "customerName": "Simon Ellery",
    "address": "1 Strawlands, Plumpton Green, Lewes, East Sussex, BN7 3DB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Plumpton",
    "price": 23.33,
    "duration": "00:30",
    "notes": "Text night before.\nInclude extension. Pay\nby card link. Directions:\nThis is the 4th or 5th\nhouse down on left.",
    "lastDone": "2026-01-06",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 3
  },
  {
    "id": "JOB001076",
    "customerRef": "CUS83771588",
    "customerName": "Caroline Gillespie",
    "address": "37 The Warren, Burgess Hill, RH15 0DU",
    "assignee": "Steve, Dan & Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 28.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-16",
    "nextDue": "2026-02-27",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 23,
    "done": 22
  },
  {
    "id": "JOB001077",
    "customerRef": "CUS46354352",
    "customerName": "Kerry Viljoen",
    "address": "96 Woodland Avenue, Burgess Hill, West Sussex, RH15 0PE",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 25.83,
    "duration": "00:30",
    "notes": "Text night before.\nLadder needed. Knock\nfirst to secure dog. If out\ncode is 2005 Pay by\ncard link. Charge extra\n\u00a35 on first clean.",
    "lastDone": "2025-12-19",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001079",
    "customerRef": "CUS6398259",
    "customerName": "Debbie Griffith",
    "address": "17 West Park Crescent, Burgess Hill, West Sussex, RH15 9TF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001081",
    "customerRef": "CUS15477798",
    "customerName": "Jo Crouch",
    "address": "73 Ockley Lane, Hassocks, West Sussex, BN6 8NT",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 35.0,
    "duration": "00:30",
    "notes": "Text night before. Use side \ngate by the dustbins.\n\nClimb on extension to reach window above.",
    "lastDone": "2026-01-12",
    "nextDue": "2026-02-23",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 17
  },
  {
    "id": "JOB001083",
    "customerRef": "CUS55521716",
    "customerName": "Emma Jolley",
    "address": "13 Gordon Road, Burgess Hill, West Sussex, RH15 0PX",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 33.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-23",
    "nextDue": "2026-02-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001084",
    "customerRef": "CUS30980334",
    "customerName": "Allan Walkden",
    "address": "23 Culpepper, Burgess Hill, West Sussex, RH15 8UB",
    "assignee": "Dan",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "BH Zone 1",
    "price": 37.5,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 7
  },
  {
    "id": "JOB001085",
    "customerRef": "CUS30980334",
    "customerName": "Allan Walkden",
    "address": "23 Culpepper, Burgess Hill, West Sussex, RH15 8UB",
    "assignee": "Dan",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 95.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-04-15",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001086",
    "customerRef": "CUS78584932",
    "customerName": "Florence Bartley",
    "address": "63 Holmesdale Road, Burgess Hill, RH15 9JP",
    "assignee": "Steve, Dan, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 26.0,
    "duration": "00:30",
    "notes": "Long pole, there's veluxes on the front, reverse on to the drive",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 22,
    "done": 20
  },
  {
    "id": "JOB001087",
    "customerRef": "CUS87898713",
    "customerName": "David Edwards",
    "address": "29 Queens Drive, Hassocks, West Sussex, BN6 8DF",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Include \nconservatory and 1 x velux. \nInclude window over \nconservatory. Not the two \nvelux on the other side. \nPay by GoCardless.\n\nThe side gate has no lock, but does have a field gate catch which can fool people.\nWe will be going out at 4pm, other than that we should be in.\nMy son will no doubt be in even if we are out,",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB001088",
    "customerRef": "CUS38593363",
    "customerName": "Sophie Ross",
    "address": "30 Stonepound Rd, Hassocks BN6 8PR, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hassocks",
    "price": 42.0,
    "duration": "00:45",
    "notes": "LONG POLE",
    "lastDone": "2026-01-07",
    "nextDue": "2026-04-01",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 24
  },
  {
    "id": "JOB001089",
    "customerRef": "CUS38895884",
    "customerName": "Robert Pryce",
    "address": "Flat H, Alderley House, 18 Chandlers Field Drive, Haywards Heath, West Sussex, RH16 4UT",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Haywards Heath",
    "price": 17.5,
    "duration": "00:30",
    "notes": "Hi. We are on the top floor. At the front it\u2019s the 2 balcony doors and windows either side. To the left of the balcony is a single window, and round the back where the resident car park is, the top bedroom window",
    "lastDone": "2025-12-22",
    "nextDue": "2026-02-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001090",
    "customerRef": "CUS98364937",
    "customerName": "Barbara Mason",
    "address": "5a Leyfield, Albourne, Hassocks, West Sussex, BN6 9DA",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 33.0,
    "duration": "00:30",
    "notes": "Text night before. Include\nextension but not the\nlantern. Friendly dogs\nroaming (make sure gate\nis kept shut). Tap on door\nwhen you arrive to secure\ndogs if they are in. Pay by\ncardlink.",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 12,
    "done": 11
  },
  {
    "id": "JOB001092",
    "customerRef": "CUS46077151",
    "customerName": "Roberta Johnson",
    "address": "7 Daisyfields,  Burgess Hill,  RH15 0YB",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 20.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-28",
    "nextDue": "2026-03-11",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001095",
    "customerRef": "CUS68300910",
    "customerName": "Kim Murphy",
    "address": "32 St. Peters Road, Burgess Hill, West Sussex, RH15 8JL",
    "assignee": "Steve",
    "services": "One-Off Window Cleaning",
    "zone": "Perfect Properties",
    "price": 41.67,
    "duration": "00:30",
    "notes": "One off, wants a thorough clean",
    "lastDone": "2025-08-12",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001096",
    "customerRef": "CUS80851072",
    "customerName": "Rachel Copper",
    "address": "127 Highbank, Haywards Heath, West Sussex, RH16 4TT",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Haywards Heath",
    "price": 16.67,
    "duration": "00:30",
    "notes": "have confirmed with my neighbour that the gate will be open, so you can access the back windows. It is a bit stiff, but it just needs a shove.",
    "lastDone": "2026-01-10",
    "nextDue": "2026-02-17",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB001097",
    "customerRef": "CUS76921421",
    "customerName": "Sophie Charles- Simpson",
    "address": "38 Holmesdale Road, Burgess Hill, West Sussex, RH15 9JR",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 26.0,
    "duration": "00:30",
    "notes": "Include 2x velux.",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 17,
    "done": 16
  },
  {
    "id": "JOB001098",
    "customerRef": "CUS38736146",
    "customerName": "Barry Bilsby",
    "address": "74 Orchard Road, Burgess Hill, West Sussex, RH15 9PL",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 1",
    "price": 23.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-19",
    "nextDue": "2026-03-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001100",
    "customerRef": "CUS62100238",
    "customerName": "Cheri McCarthy",
    "address": "1 Tindal Crescent, Burgess Hill, West Sussex, RH15 0XN",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 25.83,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB001103",
    "customerRef": "CUS60631445",
    "customerName": "Wendy",
    "address": "22 St. Andrews Place, Hassocks, Sussex, BN6 9QE",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "KG NO EMAIL",
    "price": 22.0,
    "duration": "00:45",
    "notes": "Park outside 22 on the small path and do 22 and 20",
    "lastDone": "2026-01-08",
    "nextDue": "2026-02-19",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 36,
    "done": 36
  },
  {
    "id": "JOB001104",
    "customerRef": "CUS15040552",
    "customerName": "Jan Laker",
    "address": "109 Maple Drive, Burgess Hill, West Sussex, RH15 8AP",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "BH Zone 3",
    "price": 18.33,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-12",
    "nextDue": "2026-03-06",
    "frequency": "every 6 weeks on Friday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 1
  },
  {
    "id": "JOB001105",
    "customerRef": "CUS16498718",
    "customerName": "Bridget Murray",
    "address": "21 The Close, Burgess Hill, West Sussex, RH15 0PR",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 28.0,
    "duration": "00:30",
    "notes": "You can park in their disabled bay.",
    "lastDone": "2025-11-07",
    "nextDue": "2026-02-04",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 15,
    "done": 14
  },
  {
    "id": "JOB001106",
    "customerRef": "CUS98939341",
    "customerName": "David Foster",
    "address": "22 Silverdale Road, Burgess Hill, West Sussex, RH15 0EF",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 66.67,
    "duration": "00:30",
    "notes": "\"Text night before. All windows and doors except the two over the flat roof extension.\nInclude high window on front of garage. Pay by card link.\"",
    "lastDone": "2026-01-08",
    "nextDue": "2026-03-24",
    "frequency": "every 12 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB001107",
    "customerRef": "CUS51444064",
    "customerName": "Martina",
    "address": "2 Packham Gardens, Hurstpierpoint, Hassocks BN6 9YU, UK",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 35.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2025-07-03",
    "nextDue": "2026-03-11",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 9
  },
  {
    "id": "JOB001108",
    "customerRef": "CUS51444064",
    "customerName": "Martina",
    "address": "2 Packham Gardens, Hurstpierpoint, Hassocks BN6 9YU, UK",
    "assignee": "Dan",
    "services": "Facias and Sofitts",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:45",
    "notes": "",
    "lastDone": "2024-06-13",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 2,
    "done": 2
  },
  {
    "id": "JOB001109",
    "customerRef": "CUS65841118",
    "customerName": "Kerry Keenan",
    "address": "10 Nuthatch Lane, Hassocks, Sussex, BN6 9LB",
    "assignee": "Dan",
    "services": "Window Clean front only",
    "zone": "Sayers Common",
    "price": 20.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-29",
    "nextDue": "2026-03-12",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 10,
    "done": 10
  },
  {
    "id": "JOB001110",
    "customerRef": "CUS5526572",
    "customerName": "Tim Minor",
    "address": "12 Kings Drive, Hassocks, West Sussex, BN6 8DZ",
    "assignee": "Steve",
    "services": "Window Clean Every 6 weeks",
    "zone": "Hassocks",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-07",
    "nextDue": "2026-02-18",
    "frequency": "every 6 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 3,
    "done": 3
  },
  {
    "id": "JOB001111",
    "customerRef": "CUS6224133",
    "customerName": "Louisa Arnold",
    "address": "2 Woodpecker Close, sayers common, Bn6",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "Sayers Common",
    "price": 30.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-19",
    "nextDue": "2026-03-12",
    "frequency": "every 12 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 9,
    "done": 9
  },
  {
    "id": "JOB001113",
    "customerRef": "CUS16316226",
    "customerName": "Caroline",
    "address": "82 Willow Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9TJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 14,
    "done": 14
  },
  {
    "id": "JOB001114",
    "customerRef": "CUS30085028",
    "customerName": "Neil Upton",
    "address": "31 Orchard Way, Hurstpierpoint, Hassocks, West Sussex, BN6 9UB",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "Hurstpierpoint",
    "price": 45.0,
    "duration": "00:30",
    "notes": "Include 8 veluxes, new customer",
    "lastDone": "2026-01-22",
    "nextDue": "2026-03-05",
    "frequency": "every 6 weeks on Thursday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB001115",
    "customerRef": "CUS87821283",
    "customerName": "Adam Mayes",
    "address": "14 Foxglove Close, Burgess Hill, West Sussex, RH15 8UY",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 20.0,
    "duration": "00:30",
    "notes": "To clean the rear do it from next doors garden no.12\n\n0229 - key box",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 8,
    "done": 8
  },
  {
    "id": "JOB001116",
    "customerRef": "CUS91058314",
    "customerName": "Shane  Pentecost",
    "address": "20 Bramber Way, Burgess Hill, West Sussex, RH15 8JX",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 3",
    "price": 24.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-24",
    "nextDue": "2026-03-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 18,
    "done": 18
  },
  {
    "id": "JOB001117",
    "customerRef": "CUS91058314",
    "customerName": "Shane  Pentecost",
    "address": "20 Bramber Way, Burgess Hill, West Sussex, RH15 8JX",
    "assignee": "Steve",
    "services": "Gutter Clearance",
    "zone": "Perfect Properties",
    "price": 80.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2024-02-07",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001119",
    "customerRef": "CUS81866316",
    "customerName": "Tony Gibson",
    "address": "5 Oak Tree Drive, Hassocks, West Sussex, BN6 8YA",
    "assignee": "Steve",
    "services": "Window Clean inc Conservatory Windows",
    "zone": "Hassocks",
    "price": 36.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-21",
    "nextDue": "2026-04-15",
    "frequency": "every 12 weeks on Wednesday",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB001120",
    "customerRef": "CUS35954816",
    "customerName": "Karen Noble",
    "address": "7 Capenors, Burgess Hill, West Sussex, RH15 9QL",
    "assignee": "Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 25.0,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-12-20",
    "nextDue": "2026-02-03",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 5,
    "done": 5
  },
  {
    "id": "JOB001121",
    "customerRef": "CUS35954816",
    "customerName": "Karen Noble",
    "address": "7 Capenors, Burgess Hill, West Sussex, RH15 9QL",
    "assignee": "Dan",
    "services": "One-Off Window Cleaning,Conservatory Roof Clean",
    "zone": "Perfect Properties",
    "price": 126.67,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2025-06-11",
    "nextDue": "",
    "frequency": "Ad hoc",
    "isAdhoc": true,
    "occurrences": 1,
    "done": 1
  },
  {
    "id": "JOB001122",
    "customerRef": "CUS58963577",
    "customerName": "Anna Brownlie",
    "address": "28 Cold Waltham Lane, Burgess Hill, West Sussex, RH15 0EH",
    "assignee": "Dan, Steve",
    "services": "Window Clean",
    "zone": "BH Zone 4",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-26",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 6,
    "done": 6
  },
  {
    "id": "JOB001123",
    "customerRef": "CUS17333335",
    "customerName": "Jude Sharpin",
    "address": "69 Chanctonbury Rd, Burgess Hill RH15 9EX, UK",
    "assignee": "Dan, Steve, Dan & Steve",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 29.17,
    "duration": "00:30",
    "notes": "",
    "lastDone": "2026-01-30",
    "nextDue": "2026-03-10",
    "frequency": "every 6 weeks on Tuesday",
    "isAdhoc": false,
    "occurrences": 28,
    "done": 27
  },
  {
    "id": "JOB001124",
    "customerRef": "CUS53119800",
    "customerName": "Barry Stevens",
    "address": "12 Pinehurst, Burgess Hill, West Sussex, RH15 0DQ",
    "assignee": "Steve, Dan",
    "services": "Window Clean",
    "zone": "BH Zone 2",
    "price": 0.0,
    "duration": "00:30",
    "notes": "Text night before. Not the\nconservatory. Pay by\ncash. When asked do\nconservatory for\nadditional \u00a310. Please\nleave leaflet. Cash \u00a323",
    "lastDone": "2025-12-09",
    "nextDue": "2026-03-09",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 4,
    "done": 4
  },
  {
    "id": "JOB001126",
    "customerRef": "CUS41636251",
    "customerName": "Dan",
    "address": "106 College Lane, Hurstpierpoint, Hassocks, West Sussex, BN6 9AJ",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "HPP NO EMAIL",
    "price": 27.5,
    "duration": "00:30",
    "notes": "Gate Code 1568",
    "lastDone": "2025-12-11",
    "nextDue": "2026-02-11",
    "frequency": "every 2 months on the 11th",
    "isAdhoc": false,
    "occurrences": 7,
    "done": 7
  },
  {
    "id": "JOB001127",
    "customerRef": "CUS43875580",
    "customerName": "Imogen Mercer",
    "address": "5 South Drive, Burgess Hill, West Sussex, RH15 9PY",
    "assignee": "Steve",
    "services": "Window Clean",
    "zone": "BH Zone 1",
    "price": 25.0,
    "duration": "00:30",
    "notes": "**NEW**",
    "lastDone": "2025-12-15",
    "nextDue": "2026-02-02",
    "frequency": "every 6 weeks on Monday",
    "isAdhoc": false,
    "occurrences": 11,
    "done": 11
  }
];

export const csvRounds = [
  {
    "name": "BH Zone 1",
    "activeJobs": 81,
    "adHoc": 0,
    "monthlyRecurring": 1181.6230916666666,
    "annualRecurring": 14179.477099999998
  },
  {
    "name": "BH Zone 2",
    "activeJobs": 63,
    "adHoc": 0,
    "monthlyRecurring": 979.9409916666668,
    "annualRecurring": 11759.291899999998
  },
  {
    "name": "BH Zone 3",
    "activeJobs": 81,
    "adHoc": 0,
    "monthlyRecurring": 1340.3788333333332,
    "annualRecurring": 16084.545999999998
  },
  {
    "name": "BH Zone 4",
    "activeJobs": 123,
    "adHoc": 0,
    "monthlyRecurring": 2076.8602499999997,
    "annualRecurring": 24922.323000000008
  },
  {
    "name": "Chailey",
    "activeJobs": 1,
    "adHoc": 0,
    "monthlyRecurring": 18.662174999999998,
    "annualRecurring": 223.94609999999997
  },
  {
    "name": "Citiguard",
    "activeJobs": 1,
    "adHoc": 2266.0,
    "monthlyRecurring": 0,
    "annualRecurring": 0
  },
  {
    "name": "Cowfold",
    "activeJobs": 1,
    "adHoc": 0,
    "monthlyRecurring": 24.056758333333335,
    "annualRecurring": 288.6811
  },
  {
    "name": "Faygate",
    "activeJobs": 1,
    "adHoc": 0,
    "monthlyRecurring": 15.049674999999999,
    "annualRecurring": 180.59609999999998
  },
  {
    "name": "Forgewood",
    "activeJobs": 2,
    "adHoc": 0,
    "monthlyRecurring": 21.064908333333335,
    "annualRecurring": 252.77890000000002
  },
  {
    "name": "HPP CASH",
    "activeJobs": 2,
    "adHoc": 0,
    "monthlyRecurring": 0.0,
    "annualRecurring": 0.0
  },
  {
    "name": "HPP NO EMAIL",
    "activeJobs": 10,
    "adHoc": 0,
    "monthlyRecurring": 164.35925,
    "annualRecurring": 1972.311
  },
  {
    "name": "Hassocks",
    "activeJobs": 106,
    "adHoc": 0,
    "monthlyRecurring": 1977.8927166666665,
    "annualRecurring": 23734.712599999995
  },
  {
    "name": "Hassocks No Email",
    "activeJobs": 9,
    "adHoc": 0,
    "monthlyRecurring": 166.81566666666666,
    "annualRecurring": 2001.788
  },
  {
    "name": "Hassocks cash",
    "activeJobs": 13,
    "adHoc": 0,
    "monthlyRecurring": 0.0,
    "annualRecurring": 0.0
  },
  {
    "name": "Hassocks2",
    "activeJobs": 22,
    "adHoc": 0,
    "monthlyRecurring": 361.242775,
    "annualRecurring": 4334.913300000001
  },
  {
    "name": "Haywards Heath",
    "activeJobs": 23,
    "adHoc": 0,
    "monthlyRecurring": 401.26073333333346,
    "annualRecurring": 4815.128800000001
  },
  {
    "name": "Hickstead",
    "activeJobs": 2,
    "adHoc": 0,
    "monthlyRecurring": 28.900000000000002,
    "annualRecurring": 346.8
  },
  {
    "name": "Hurstpierpoint",
    "activeJobs": 54,
    "adHoc": 220.0,
    "monthlyRecurring": 971.6836166666668,
    "annualRecurring": 11660.203399999999
  },
  {
    "name": "KG NO EMAIL",
    "activeJobs": 15,
    "adHoc": 0,
    "monthlyRecurring": 201.4861666666667,
    "annualRecurring": 2417.834
  },
  {
    "name": "Kingsland Gate",
    "activeJobs": 33,
    "adHoc": 25.0,
    "monthlyRecurring": 438.8117833333333,
    "annualRecurring": 5265.741399999999
  },
  {
    "name": "Kingsland Gate2",
    "activeJobs": 3,
    "adHoc": 0,
    "monthlyRecurring": 41.53333333333333,
    "annualRecurring": 498.4
  },
  {
    "name": "Lindfield",
    "activeJobs": 2,
    "adHoc": 0,
    "monthlyRecurring": 27.09375,
    "annualRecurring": 325.125
  },
  {
    "name": "Newick",
    "activeJobs": 12,
    "adHoc": 0,
    "monthlyRecurring": 182.71185,
    "annualRecurring": 2192.5422
  },
  {
    "name": "Pease Pottage",
    "activeJobs": 3,
    "adHoc": 0,
    "monthlyRecurring": 39.137825,
    "annualRecurring": 469.6539
  },
  {
    "name": "Perfect Properties",
    "activeJobs": 95,
    "adHoc": 6853.87,
    "monthlyRecurring": 83.7269,
    "annualRecurring": 1004.7228
  },
  {
    "name": "Plumpton",
    "activeJobs": 10,
    "adHoc": 0,
    "monthlyRecurring": 148.09985833333332,
    "annualRecurring": 1777.1983
  },
  {
    "name": "Sayers Cash",
    "activeJobs": 6,
    "adHoc": 0,
    "monthlyRecurring": 0.0,
    "annualRecurring": 0.0
  },
  {
    "name": "Sayers Common",
    "activeJobs": 32,
    "adHoc": 0,
    "monthlyRecurring": 562.2235333333333,
    "annualRecurring": 6746.6824
  },
  {
    "name": "Sayers No Email",
    "activeJobs": 6,
    "adHoc": 0,
    "monthlyRecurring": 76.7295,
    "annualRecurring": 920.7539999999999
  },
  {
    "name": "Sayers2",
    "activeJobs": 2,
    "adHoc": 0,
    "monthlyRecurring": 26.483516666666667,
    "annualRecurring": 317.80219999999997
  },
  {
    "name": "Wivelsfield",
    "activeJobs": 4,
    "adHoc": 0,
    "monthlyRecurring": 77.069075,
    "annualRecurring": 924.8289
  }
];

// Zone color mapping - Squeegee matching colors
export const zoneColors = {
  // Worthing Rounds (matching Squeegee)
  'Worthing - East': '#f97316',      // Orange (WE)
  'Worthing-East': '#f97316',        // Orange (WE) - alternate format
  'Worthing East': '#f97316',        // Orange (WE) - alternate format
  'Worthing - West': '#ec4899',      // Pink/Magenta (WW)
  'Worthing-West': '#ec4899',        // Pink/Magenta (WW)
  'Worthing West': '#ec4899',        // Pink/Magenta (WW)
  'Worthing North': '#eab308',       // Yellow (WN)
  'Worthing-North': '#eab308',       // Yellow (WN)
  
  // Other Squeegee rounds
  'Angmering': '#8b5cf6',            // Purple (AN)
  'Ashington': '#ec4899',            // Pink/Magenta (AS)
  'Climping': '#ec4899',             // Pink/Magenta (CL)
  'Commercial': '#8b5cf6',           // Purple (C)
  'Durrington': '#8b5cf6',           // Purple (D)
  'East Preston': '#14b8a6',         // Teal (EP)
  'Ferring': '#ef4444',              // Red (FE)
  'Findon': '#84cc16',               // Olive/Yellow-green (FI)
  'Goring': '#22c55e',               // Green (GO)
  'Lancing': '#60a5fa',              // Light Blue (LA)
  'Littlehampton': '#8b5cf6',        // Purple (LI)
  'Littlehampton - one off': '#14b8a6', // Teal (LO)
  'One Off jobs': '#8b5cf6',         // Purple (OJ)
  'Rustington': '#8b5cf6',           // Purple (RU)
  'Rustington One Off': '#ec4899',   // Pink/Magenta (RO)
  'Sompting': '#ec4899',             // Pink/Magenta (SO)
  'Steyning': '#f9a8d4',             // Light Pink (ST)
  'Wick A': '#14b8a6',               // Teal (WA)
  'Wick B': '#3b82f6',               // Blue (WB)
  'Yapton': '#eab308',               // Yellow (YA)
  
  // BH Zones (keep existing)
  'BH Zone 1': '#3b82f6',
  'BH Zone 2': '#8b5cf6',
  'BH Zone 3': '#ec4899',
  'BH Zone 4': '#f97316',
  
  // Hassocks area
  'Hassocks': '#10b981',
  'Hassocks2': '#14b8a6',
  'Hassocks No Email': '#0d9488',
  'Hassocks cash': '#059669',
  
  // Hurstpierpoint area
  'Hurstpierpoint': '#06b6d4',
  'HPP CASH': '#0891b2',
  'HPP NO EMAIL': '#0e7490',
  
  // Other areas
  'Lindfield': '#6366f1',
  'Haywards Heath': '#84cc16',
  'Perfect Properties': '#f59e0b',
  'Sayers Common': '#ef4444',
  'Sayers2': '#dc2626',
  'Sayers Cash': '#b91c1c',
  'Sayers No Email': '#991b1b',
  'Kingsland Gate': '#a855f7',
  'Kingsland Gate2': '#9333ea',
  'KG NO EMAIL': '#7c3aed',
  'Chailey': '#22d3d1',
  'Citiguard': '#f472b6',
  'Cowfold': '#fb923c',
  'Faygate': '#a3e635',
  'Forgewood': '#4ade80',
  'Handcross': '#2dd4bf',
  'Henfield': '#818cf8',
  'Hickstead': '#c084fc',
  'Newick': '#f87171',
  'Pease Pottage': '#fbbf24',
  'Plumpton': '#34d399',
  'Wivelsfield': '#60a5fa',
  'default': '#64748b'
};

// Assignee avatars
export const assigneeColors = {
  'Steve': '#3b82f6',
  'Dan': '#10b981',
  'Dan, Steve': '#8b5cf6',
  'Steve, Dan': '#8b5cf6',
  'Dan & Steve': '#8b5cf6',
  'default': '#64748b'
};
